<template>
  <div id="svgFarm" style="width: 100%" v-if="this.getRealTime && this.getFarm">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 966 719"
    >
      <defs>
        <mask
          id="mask"
          x="470.07"
          y="-0.69"
          width="91.63"
          height="226.75"
          maskUnits="userSpaceOnUse"
        >
          <polygon
            class="cls-1"
            points="561.7 173.16 470.07 226.06 470.07 52.21 561.7 -0.69 561.7 173.16"
          />
        </mask>
        <mask
          id="mask-2"
          x="374.52"
          y="61.25"
          width="91.63"
          height="226.75"
          maskUnits="userSpaceOnUse"
        >
          <polygon
            class="cls-1"
            points="466.15 235.1 374.52 288 374.52 114.15 466.15 61.25 466.15 235.1"
          />
        </mask>
        <mask
          id="mask-3"
          x="282.5"
          y="114.48"
          width="91.63"
          height="226.75"
          maskUnits="userSpaceOnUse"
        >
          <polygon
            class="cls-1"
            points="374.12 288.33 282.5 341.23 282.5 167.38 374.12 114.48 374.12 288.33"
          />
        </mask>
        <mask
          id="mask-4"
          x="190.11"
          y="168.4"
          width="91.63"
          height="226.75"
          maskUnits="userSpaceOnUse"
        >
          <polygon
            class="cls-1"
            points="281.74 342.25 190.11 395.15 190.11 221.3 281.74 168.4 281.74 342.25"
          />
        </mask>
        <mask
          id="mask-5"
          x="98.5"
          y="221.62"
          width="91.63"
          height="226.75"
          maskUnits="userSpaceOnUse"
        >
          <polygon
            class="cls-1"
            points="190.13 395.47 98.5 448.37 98.5 274.52 190.13 221.62 190.13 395.47"
          />
        </mask>
        <mask
          id="mask-6"
          x="559.1"
          y="6.79"
          width="306.9"
          height="352.04"
          maskUnits="userSpaceOnUse"
        >
          <polygon
            class="cls-1"
            points="866 358.83 559.1 180.64 559.1 6.79 866 184.98 866 358.83"
          />
        </mask>
        <clipPath id="clip-path">
          <path
            class="cls-2"
            d="M577.73,191.32v-3c0,.77-.57,1.55-1.72,2.13v3C577.16,192.87,577.73,192.09,577.73,191.32Z"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <path
            class="cls-3"
            d="M530,191.93v3c0,.77.56,1.53,1.69,2.1v-3C530.56,193.45,530,192.69,530,191.93Z"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <path
            class="cls-5"
            d="M546.12,201.45v3a10.16,10.16,0,0,0,8.26,0v-3A10.24,10.24,0,0,1,546.12,201.45Z"
          />
        </clipPath>
        <clipPath id="clip-path-4">
          <path
            class="cls-2"
            d="M577.73,187.86l-.11-41.72c0,.77-.57,1.54-1.72,2.13L576,190C577.16,189.41,577.73,188.63,577.73,187.86Z"
          />
        </clipPath>
        <clipPath id="clip-path-5">
          <path
            class="cls-3"
            d="M529.89,149.78l.11,41.73c0,.76.56,1.52,1.69,2.1l-.11-41.73C530.45,151.31,529.89,150.54,529.89,149.78Z"
          />
        </clipPath>
        <clipPath id="clip-path-6">
          <path
            class="cls-5"
            d="M546,159.3l.11,41.72a10.16,10.16,0,0,0,8.26,0l-.11-41.72A10.16,10.16,0,0,1,546,159.3Z"
          />
        </clipPath>
        <clipPath id="clip-path-7">
          <path
            class="cls-4"
            d="M529.78,142l.11,7.2c0,.76.56,1.52,1.69,2.1l-.11-7.2C530.34,143.56,529.78,142.8,529.78,142Z"
          />
        </clipPath>
        <clipPath id="clip-path-8">
          <path
            class="cls-4"
            d="M577.62,145.6l-.11-3.57c0,.78-.57,1.55-1.72,2.14l.11,3.56C577.05,147.14,577.62,146.37,577.62,145.6Z"
          />
        </clipPath>
        <clipPath id="clip-path-9">
          <path
            class="cls-4"
            d="M545.91,155.2l.11,3.56a10.24,10.24,0,0,0,8.26,0l-.11-3.56A10.24,10.24,0,0,1,545.91,155.2Z"
          />
        </clipPath>
        <clipPath id="clip-path-10">
          <path
            class="cls-4"
            d="M552.78,152.32v.73c0,.14.1.28.31.38a1.76,1.76,0,0,0,1.49,0c.21-.1.32-.24.32-.38v-.73c0,.14-.1.28-.31.39a1.86,1.86,0,0,1-1.5,0A.48.48,0,0,1,552.78,152.32Z"
          />
        </clipPath>
        <clipPath id="clip-path-11">
          <path
            class="cls-4"
            d="M549.46,154.07v.72c0,.14.1.28.31.39a1.84,1.84,0,0,0,1.49,0c.21-.11.31-.25.31-.39v-.73c0,.14-.11.28-.31.39a1.86,1.86,0,0,1-1.5,0C549.57,154.34,549.46,154.2,549.46,154.07Z"
          />
        </clipPath>
        <clipPath id="clip-path-12">
          <path
            class="cls-4"
            d="M526.74,298.05c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.21.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21s1.11-.62,1.41-.72.4-.82.7-1.12.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.3-.82.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient"
          x1="-3612.27"
          y1="1201.25"
          x2="-3611.86"
          y2="1201.25"
          gradientTransform="translate(69597.65 -83056.18) rotate(-31.96) scale(28.44)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#709941" />
          <stop offset="0.4" stop-color="#648936" />
          <stop offset="0.51" stop-color="#608332" />
          <stop offset="1" stop-color="#5f8231" />
        </linearGradient>
        <clipPath id="clip-path-13">
          <path
            class="cls-4"
            d="M513.81,299.2a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.51-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8H515a1.16,1.16,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-2"
          x1="-3650.33"
          y1="1097.37"
          x2="-3649.92"
          y2="1097.37"
          gradientTransform="translate(106812.81 21559.54) rotate(28.04) scale(28.44)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9cc666" />
          <stop offset="0.18" stop-color="#9cc666" />
          <stop offset="0.27" stop-color="#93bd5e" />
          <stop offset="0.51" stop-color="#80a94e" />
          <stop offset="0.76" stop-color="#749d44" />
          <stop offset="1" stop-color="#709941" />
          <stop offset="1" stop-color="#231f20" />
        </linearGradient>
        <clipPath id="clip-path-14">
          <path
            class="cls-4"
            d="M498.48,284c-.1,0-.1.1-.2.11-.41.2-.6.71-.91.81s-.91.22-1.21.42-.39.81-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a9,9,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.91-.32,1-.72a2.52,2.52,0,0,1,.4-1.22c.2-.31.7-.61.9-.92s-.11-.91,0-1.21.49-.72.59-1.22-.31-.81-.32-1.22.3-.81.3-1.21c0-.1-.11-.1-.11-.2a1.18,1.18,0,0,0-1-.7,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-3"
          x1="-3612.85"
          y1="1200.3"
          x2="-3612.44"
          y2="1200.3"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-15">
          <path
            class="cls-4"
            d="M485.54,285.22a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.22.71.6.92.9.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11a7.12,7.12,0,0,0,1.53.69c.41.2.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.4.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.81-.72-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-4"
          x1="-3651.44"
          y1="1097.39"
          x2="-3651.03"
          y2="1097.39"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-16">
          <path
            class="cls-4"
            d="M511.7,291.12c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.71-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-5"
          x1="-3612.58"
          y1="1200.76"
          x2="-3612.17"
          y2="1200.76"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-17">
          <path
            class="cls-4"
            d="M498.76,292.17a.35.35,0,0,0-.1.2c-.09.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.91.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.71-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.91-.11-.91-.41-1.21-.82-.39-1.12-.69-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8H500a1.2,1.2,0,0,0-1.21.73"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-6"
          x1="-3650.91"
          y1="1097.4"
          x2="-3650.5"
          y2="1097.4"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-18">
          <path
            class="cls-4"
            d="M541.23,290.32c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.3-.09.91-.29,1.21s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.61.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.39-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a2.08,2.08,0,0,0-1.53-.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-7"
          x1="-3611.69"
          y1="1201.29"
          x2="-3611.28"
          y2="1201.29"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-19">
          <path
            class="cls-4"
            d="M528.4,291.46a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.29-.62-.71-1-.8h-.31c-.6,0-1.11.21-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-8"
          x1="-3650"
          y1="1096.89"
          x2="-3649.6"
          y2="1096.89"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-20">
          <path
            class="cls-4"
            d="M555.21,282.29c-.1,0-.1.1-.2.1-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-9"
          x1="-3611.12"
          y1="1201.31"
          x2="-3610.71"
          y2="1201.31"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-21">
          <path
            class="cls-4"
            d="M542.27,283.33a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.46,1.46,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-10"
          x1="-3649.7"
          y1="1096.41"
          x2="-3649.3"
          y2="1096.41"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-22">
          <path
            class="cls-4"
            d="M569.09,274.35c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.21.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.9-.32,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.3-.82.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-11"
          x1="-3610.56"
          y1="1201.32"
          x2="-3610.15"
          y2="1201.32"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-23">
          <path
            class="cls-4"
            d="M556.05,275.5a.3.3,0,0,0-.09.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-12"
          x1="-3649.41"
          y1="1095.93"
          x2="-3649"
          y2="1095.93"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-24">
          <path
            class="cls-4"
            d="M583.27,265.81c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.31-.1.91-.29,1.22s-.71.61-.91.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.71-.11,1-.21s1.1-.62,1.41-.72.39-.82.69-1.12.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21a6.63,6.63,0,0,0,.59-1.22c0-.41-.31-.81-.31-1.22s.29-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-13"
          x1="-3609.98"
          y1="1201.34"
          x2="-3609.57"
          y2="1201.34"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-25">
          <path
            class="cls-4"
            d="M570.33,267.06a.3.3,0,0,0-.09.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-14"
          x1="-3649.1"
          y1="1095.44"
          x2="-3648.7"
          y2="1095.44"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-26">
          <path
            class="cls-4"
            d="M446.58,343.59c-.11,0-.1.1-.21.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71-.09.92-.29,1.22-.7.62-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.12,1.62.3.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22a9.39,9.39,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.91-.31,1-.72c.3-.3.09-.91.4-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,1.93,1.93,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-15"
          x1="-3615.5"
          y1="1201.11"
          x2="-3615.1"
          y2="1201.11"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-27">
          <path
            class="cls-4"
            d="M433.64,344.73a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1,1.12.5,1.53.69.71.1,1,.2l.72.7.3-.21-.32-.91c.1-.4.3-.61.3-1a8.77,8.77,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.19,1.19,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-16"
          x1="-3652.06"
          y1="1100.11"
          x2="-3651.66"
          y2="1100.11"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-28">
          <path
            class="cls-4"
            d="M418.31,329.51c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21s1.1-.62,1.41-.72.39-.81.69-1.12.91-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-17"
          x1="-3616.08"
          y1="1200.17"
          x2="-3615.68"
          y2="1200.17"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-29">
          <path
            class="cls-4"
            d="M405.37,330.65a.35.35,0,0,0-.1.2c-.09.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.1,1,.19l.72.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.41-.8-.72-1.11a6,6,0,0,0-1.22-.29c-.4-.19-.61-.7-1-.8h-.3c-.71,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-18"
          x1="-3653.18"
          y1="1100.13"
          x2="-3652.77"
          y2="1100.13"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-30">
          <path
            class="cls-4"
            d="M431.53,336.56c-.1,0-.1.1-.2.1-.4.2-.6.71-.9.82a5.76,5.76,0,0,0-1.21.41c-.3.21-.4.82-.7,1.12s-.9.42-1,.72-.09.91-.29,1.22-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.39-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-19"
          x1="-3615.82"
          y1="1200.62"
          x2="-3615.41"
          y2="1200.62"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-31">
          <path
            class="cls-4"
            d="M418.59,337.7a.3.3,0,0,0-.09.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.11a5.85,5.85,0,0,0-1.22-.29c-.4-.19-.61-.7-1-.8h-.3a1.18,1.18,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-20"
          x1="-3652.65"
          y1="1100.14"
          x2="-3652.24"
          y2="1100.14"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-32">
          <path
            class="cls-4"
            d="M461.06,335.75c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.11,1.62.31.6.42.9l-.3,1,.41.19.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.71c.3-.31.09-.92.39-1.22s.71-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.31-.8-.32-1.21.3-.81.29-1.21c0-.11-.1-.1-.1-.21a1.2,1.2,0,0,0-1-.69,1.1,1.1,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-21"
          x1="-3614.92"
          y1="1201.15"
          x2="-3614.52"
          y2="1201.15"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-33">
          <path
            class="cls-4"
            d="M448.23,337a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.3,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.32-.91c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.91,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.71-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.62-.7-1-.8h-.3c-.71,0-1.12.22-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-22"
          x1="-3651.74"
          y1="1099.63"
          x2="-3651.33"
          y2="1099.63"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-34">
          <path
            class="cls-4"
            d="M475.15,327.72c-.11,0-.1.1-.21.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.39.82-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.12,1.62.3.6.41.91l-.29,1,.4.2.7-.72c.41-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.91-.31,1-.72c.3-.31.1-.91.4-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7l-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-23"
          x1="-3614.36"
          y1="1201.17"
          x2="-3613.95"
          y2="1201.17"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-35">
          <path
            class="cls-4"
            d="M462.11,328.86a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.91.9.12.91.52,1.21.82.3,1.12.6.41.8.72,1.1,1.12.5,1.53.69.7.1,1,.2l.71.7.31-.21-.32-.91c.1-.4.3-.61.3-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.29,1.29,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-24"
          x1="-3651.44"
          y1="1099.15"
          x2="-3651.03"
          y2="1099.15"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-36">
          <path
            class="cls-4"
            d="M488.93,319.89c-.11,0-.1.1-.21.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71c-.3.31-.09.92-.29,1.22s-.7.62-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22a9.39,9.39,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.91-.31,1-.72.1-.91.4-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,3.09,3.09,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-25"
          x1="-3613.8"
          y1="1201.19"
          x2="-3613.39"
          y2="1201.19"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-37">
          <path
            class="cls-4"
            d="M475.89,321a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.41.8.72,1.1,1.12.5,1.53.7.7.09,1,.19l.71.7.31-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-26"
          x1="-3651.14"
          y1="1098.67"
          x2="-3650.73"
          y2="1098.67"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-38">
          <path
            class="cls-4"
            d="M503.1,311.35c-.1,0-.1.1-.2.1-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.71-.61.9-.92-.11-.91,0-1.21a6.93,6.93,0,0,0,.6-1.22c0-.41-.31-.81-.32-1.21s.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-27"
          x1="-3613.22"
          y1="1201.2"
          x2="-3612.81"
          y2="1201.2"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-39">
          <path
            class="cls-4"
            d="M490.17,312.49a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.3-1a9.73,9.73,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1.26,1.26,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-28"
          x1="-3650.84"
          y1="1098.17"
          x2="-3650.43"
          y2="1098.17"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-40">
          <path
            class="cls-4"
            d="M526.09,273.78c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.39-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.9,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.55,1.55,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-29"
          x1="-3611.83"
          y1="1200.51"
          x2="-3611.42"
          y2="1200.51"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-41">
          <path
            class="cls-4"
            d="M513.26,275a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.91.9.12.91.52,1.21.82.3,1.12.6.41.8.72,1.1a6.67,6.67,0,0,0,1.53.69c.4.2.7.1,1,.2l.71.7.31-.21-.32-.9c.1-.41.3-.62.3-1a8.78,8.78,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.06,1.06,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-30"
          x1="-3650.75"
          y1="1096.63"
          x2="-3650.34"
          y2="1096.63"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-42">
          <path
            class="cls-4"
            d="M497.93,259.8c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.9.21-1.21.41-.39.82-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21s1.1-.62,1.4-.72.4-.81.7-1.12.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2.07,2.07,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-31"
          x1="-3612.41"
          y1="1199.57"
          x2="-3612"
          y2="1199.57"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-43">
          <path
            class="cls-4"
            d="M484.89,260.94a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.82-.29,1.22.51.7.71,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1a6.67,6.67,0,0,0,1.53.69c.4.2.71.1,1,.2l.72.7.3-.21-.31-.91c.09-.4.29-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5,5,0,0,0-1.22-.29c-.41-.2-.61-.71-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-32"
          x1="-3651.86"
          y1="1096.65"
          x2="-3651.45"
          y2="1096.65"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-44">
          <path
            class="cls-4"
            d="M511.05,266.75c-.1,0-.1.1-.2.1-.41.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21a8.94,8.94,0,0,1,1.41-.72c.3-.21.39-.81.69-1.12s.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,1.13,1.13,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-33"
          x1="-3612.15"
          y1="1200.02"
          x2="-3611.74"
          y2="1200.02"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-45">
          <path
            class="cls-4"
            d="M498.21,268a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.59,6.59,0,0,0,1.52.69c.41.2.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.22-.3-.61-.7-1-.79h-.3c-.61,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-34"
          x1="-3651.33"
          y1="1096.66"
          x2="-3650.92"
          y2="1096.66"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-46">
          <path
            class="cls-4"
            d="M540.68,266c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72a5.53,5.53,0,0,1-.29,1.22c-.2.3-.7.61-.9.92s.11.9,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.71c.3-.31.09-.92.39-1.22s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-35"
          x1="-3611.25"
          y1="1200.55"
          x2="-3610.84"
          y2="1200.55"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-47">
          <path
            class="cls-4"
            d="M527.75,267.18a.39.39,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.21.72.6.92.91.11.9.52,1.2.81.3,1.12.6.41.81.72,1.11a7.26,7.26,0,0,0,1.52.69c.41.2.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.11-.41-.51-.71-.62-1.11s.09-.91,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.32,5.32,0,0,0-1.21-.29c-.41-.2-.62-.7-1-.8H529a1.29,1.29,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-36"
          x1="-3650.42"
          y1="1096.14"
          x2="-3650.01"
          y2="1096.14"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-48">
          <path
            class="cls-4"
            d="M554.66,258c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82a5.28,5.28,0,0,0-1.21.42c-.3.2-.4.81-.7,1.12s-.9.41-1,.71a5.28,5.28,0,0,1-.29,1.22c-.2.31-.7.62-.9.92s.11.91,0,1.22-.5.71-.49,1.21.11,1.22.11,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.22s.71-.61.9-.91-.11-.91,0-1.22.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-37"
          x1="-3610.69"
          y1="1200.57"
          x2="-3610.28"
          y2="1200.57"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-49">
          <path
            class="cls-4"
            d="M541.73,259.15a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.28,1.28,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-38"
          x1="-3650.12"
          y1="1095.66"
          x2="-3649.71"
          y2="1095.66"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-50">
          <path
            class="cls-4"
            d="M568.44,250.08c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22s1.11-.61,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.9,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.55,1.55,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-39"
          x1="-3610.13"
          y1="1200.59"
          x2="-3609.72"
          y2="1200.59"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-51">
          <path
            class="cls-4"
            d="M555.51,251.32a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.22s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1a7.29,7.29,0,0,0,1.52.7c.41.19.71.09,1,.19l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.29-.62-.71-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-40"
          x1="-3649.83"
          y1="1095.19"
          x2="-3649.42"
          y2="1095.19"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-52">
          <path
            class="cls-4"
            d="M582.72,241.64c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.9-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-41"
          x1="-3609.54"
          y1="1200.6"
          x2="-3609.14"
          y2="1200.6"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-53">
          <path
            class="cls-4"
            d="M569.78,242.68a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8H571a1.18,1.18,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-42"
          x1="-3649.52"
          y1="1094.69"
          x2="-3649.12"
          y2="1094.69"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-54">
          <path
            class="cls-4"
            d="M446.13,319.21c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71c-.3.31-.09.92-.29,1.22s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22s1.11-.61,1.41-.72.4-.81.7-1.12.91-.31,1-.72c.3-.3.1-.91.4-1.22s.7-.61.9-.92-.11-.9,0-1.21a7.36,7.36,0,0,0,.59-1.22c0-.4-.31-.81-.32-1.21s.3-.81.3-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,1.93,1.93,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-43"
          x1="-3615.06"
          y1="1200.38"
          x2="-3614.66"
          y2="1200.38"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-55">
          <path
            class="cls-4"
            d="M433.19,320.45a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.22s-.3.81-.29,1.21.51.71.71,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1,1.12.5,1.53.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.92,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5,5,0,0,0-1.22-.29c-.41-.2-.61-.71-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-44"
          x1="-3652.48"
          y1="1099.36"
          x2="-3652.07"
          y2="1099.36"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-56">
          <path
            class="cls-4"
            d="M417.86,305.23c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.71c-.3.31-.1.92-.29,1.22s-.71.62-.91.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.61.41.91l-.29,1,.41.2.7-.71c.4-.21.71-.11,1-.22a9.39,9.39,0,0,1,1.41-.72c.3-.2.39-.81.69-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-45"
          x1="-3615.64"
          y1="1199.43"
          x2="-3615.24"
          y2="1199.43"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-57">
          <path
            class="cls-4"
            d="M404.92,306.27a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.1,1,.2l.71.7.3-.21-.41-.8c.1-.41.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.92,4.92,0,0,0-1.22-.29c-.4-.2-.61-.71-1-.8H406a1,1,0,0,0-1.11.62"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-46"
          x1="-3653.59"
          y1="1099.38"
          x2="-3653.18"
          y2="1099.38"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-58">
          <path
            class="cls-4"
            d="M431.08,312.18c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21a6.93,6.93,0,0,0,.6-1.22c0-.41-.32-.81-.32-1.21s.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-47"
          x1="-3615.38"
          y1="1199.89"
          x2="-3614.97"
          y2="1199.89"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-59">
          <path
            class="cls-4"
            d="M418.15,313.42a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.53.69.7.1,1,.2l.71.7.31-.21-.32-.91c.1-.4.3-.61.3-1a9.73,9.73,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31c-.6,0-1.11.21-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-48"
          x1="-3653.06"
          y1="1099.39"
          x2="-3652.65"
          y2="1099.39"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-60">
          <path
            class="cls-4"
            d="M460.72,311.47c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a10,10,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.91-.31,1-.71c.3-.31.1-.92.4-1.22s.7-.62.9-.92-.11-.91,0-1.22.49-.71.59-1.22-.31-.8-.32-1.21.3-.81.3-1.21c0-.11-.11-.1-.11-.21a1.19,1.19,0,0,0-1-.69,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-49"
          x1="-3614.48"
          y1="1200.42"
          x2="-3614.08"
          y2="1200.42"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-61">
          <path
            class="cls-4"
            d="M447.78,312.61a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.21.71.6.92.91.11.9.52,1.2.81.3,1.11.6.42.8.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21a6.39,6.39,0,0,1-1.12-.69c-.31-.2-.42-.81-.72-1.11s-.92-.19-1.22-.29-.61-.7-1-.8H449a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-50"
          x1="-3652.16"
          y1="1098.88"
          x2="-3651.75"
          y2="1098.88"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-62">
          <path
            class="cls-4"
            d="M474.7,303.44c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71c-.3.31-.09.92-.29,1.22s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.71-.71c.4-.21.7-.11,1-.22a11.06,11.06,0,0,1,1.41-.72c.31-.2.4-.81.7-1.12s.91-.31,1-.72a2.56,2.56,0,0,1,.4-1.22c.2-.3.7-.61.9-.92s-.11-.9,0-1.21.49-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3.09,3.09,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-51"
          x1="-3613.92"
          y1="1200.43"
          x2="-3613.51"
          y2="1200.43"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-63">
          <path
            class="cls-4"
            d="M461.66,304.58a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.22s-.3.81-.3,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1a7.14,7.14,0,0,0,1.53.7c.4.19.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.11-.7-.42-.8-.72-1.1-.92-.2-1.22-.29-.62-.71-1-.8h-.3a1.15,1.15,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-52"
          x1="-3651.86"
          y1="1098.4"
          x2="-3651.45"
          y2="1098.4"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-64">
          <path
            class="cls-4"
            d="M488.48,295.51c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71a5.28,5.28,0,0,1-.29,1.22c-.2.31-.7.62-.9.92s.11.91,0,1.22-.5.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22a11.06,11.06,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.91-.31,1-.72c.3-.3.1-.91.4-1.22s.7-.61.9-.92-.11-.9,0-1.21.49-.71.59-1.22-.31-.81-.32-1.21.3-.81.3-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3.09,3.09,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-53"
          x1="-3613.36"
          y1="1200.46"
          x2="-3612.95"
          y2="1200.46"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-65">
          <path
            class="cls-4"
            d="M475.44,296.65a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.22s-.29.81-.29,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1,1.12.5,1.53.7.71.09,1,.19l.72.7.3-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.29-.62-.71-1-.8h-.31a1.15,1.15,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-54"
          x1="-3651.56"
          y1="1097.92"
          x2="-3651.15"
          y2="1097.92"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-66">
          <path
            class="cls-4"
            d="M502.65,287c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.71-.61.91-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7c-.4-.1-.4-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-55"
          x1="-3612.78"
          y1="1200.47"
          x2="-3612.37"
          y2="1200.47"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-67">
          <path
            class="cls-4"
            d="M489.72,288.11a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.91.9.12.91.52,1.21.82.29,1.12.59.41.81.72,1.11,1.12.49,1.53.69.7.1,1,.19l.71.71.31-.21-.32-.91c.1-.4.3-.61.3-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.3-.62-.7-1-.8h-.31a1.27,1.27,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-56"
          x1="-3651.26"
          y1="1097.42"
          x2="-3650.85"
          y2="1097.42"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-68">
          <path
            class="cls-4"
            d="M526.14,248.38c-.1,0-.1.1-.2.1-.41.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21s1.1-.62,1.4-.73.4-.81.7-1.12.91-.31,1-.71c.3-.31.09-.92.39-1.22s.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.21c0-.11-.1-.1-.11-.21a1.19,1.19,0,0,0-1-.69,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-57"
          x1="-3611.36"
          y1="1199.75"
          x2="-3610.95"
          y2="1199.75"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-69">
          <path
            class="cls-4"
            d="M513.2,249.52a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3c-.71.11-1,.32-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-58"
          x1="-3651.17"
          y1="1095.84"
          x2="-3650.76"
          y2="1095.84"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-70">
          <path
            class="cls-4"
            d="M497.87,234.3c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.3-.09.91-.29,1.21s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.61.31.61.42.91l-.3,1,.41.19.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.69,1.41,1.41,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-59"
          x1="-3611.94"
          y1="1198.81"
          x2="-3611.53"
          y2="1198.81"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-71">
          <path
            class="cls-4"
            d="M484.94,235.54a.39.39,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1a6.81,6.81,0,0,0,1.52.7c.41.2.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.91,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-60"
          x1="-3652.28"
          y1="1095.86"
          x2="-3651.87"
          y2="1095.86"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-72">
          <path
            class="cls-4"
            d="M511.1,241.45c-.1,0-.1.1-.21.1-.4.21-.59.72-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.19.7-.71c.41-.21.71-.11,1-.21s1.11-.62,1.41-.73.4-.81.7-1.12.91-.31,1-.71c.3-.31.1-.92.4-1.22s.7-.62.9-.92-.11-.91,0-1.22a6.59,6.59,0,0,0,.6-1.22c0-.4-.31-.8-.32-1.21s.3-.81.29-1.21c0-.11-.1-.1-.1-.21a1.19,1.19,0,0,0-1-.69,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-61"
          x1="-3611.68"
          y1="1199.26"
          x2="-3611.27"
          y2="1199.26"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-73">
          <path
            class="cls-4"
            d="M498.16,242.49a.35.35,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1a7.14,7.14,0,0,0,1.53.7c.4.19.71.09,1,.19l.72.7.3-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1.2,1.2,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-62"
          x1="-3651.75"
          y1="1095.87"
          x2="-3651.34"
          y2="1095.87"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-74">
          <path
            class="cls-4"
            d="M540.73,240.64c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.21.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21s1.1-.62,1.41-.72.39-.82.69-1.12.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-63"
          x1="-3610.78"
          y1="1199.79"
          x2="-3610.37"
          y2="1199.79"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-75">
          <path
            class="cls-4"
            d="M527.79,241.79a.35.35,0,0,0-.1.2c-.09.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.92.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.1,1,.19l.72.7.3-.2-.31-.91c.09-.4.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8H529c-.71,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-64"
          x1="-3650.84"
          y1="1095.36"
          x2="-3650.43"
          y2="1095.36"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-76">
          <path
            class="cls-4"
            d="M554.71,232.61c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.31.3-.1.91-.3,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.7-.11,1-.21a9,9,0,0,1,1.41-.73c.3-.2.39-.81.69-1.12s.91-.31,1-.71.09-.92.39-1.22.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.21c0-.1-.1-.1-.1-.21a1.22,1.22,0,0,0-1-.69,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-65"
          x1="-3610.21"
          y1="1199.81"
          x2="-3609.8"
          y2="1199.81"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-77">
          <path
            class="cls-4"
            d="M541.77,233.75a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.09.91.11,1.21.71.6.92.91.11.9.52,1.2.81.3,1.12.6.41.8.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.22-.71-.6-.91-.9-.12-.91-.42-1.21-.82-.39-1.12-.69-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8H543c-.61,0-1.11.22-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-66"
          x1="-3650.54"
          y1="1094.88"
          x2="-3650.13"
          y2="1094.88"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-78">
          <path
            class="cls-4"
            d="M568.39,224.68c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.71-.72c.4-.21.7-.11,1-.21a8.46,8.46,0,0,1,1.4-.72c.31-.21.4-.82.7-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.62.9-.92-.11-.91,0-1.21.5-.72.59-1.23-.31-.8-.31-1.21.29-.81.29-1.21c0-.1-.11-.1-.11-.2a1.18,1.18,0,0,0-1-.7,1.09,1.09,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-67"
          x1="-3609.65"
          y1="1199.83"
          x2="-3609.25"
          y2="1199.83"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-79">
          <path
            class="cls-4"
            d="M555.55,225.82a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.09,1.09,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-68"
          x1="-3650.25"
          y1="1094.4"
          x2="-3649.84"
          y2="1094.4"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-80">
          <path
            class="cls-4"
            d="M582.77,216.24c-.1,0-.1.1-.2.1-.41.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72a4.84,4.84,0,0,1-.29,1.21c-.2.31-.7.62-.9.92s.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21a9,9,0,0,1,1.41-.73c.3-.2.39-.81.69-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.19,1.19,0,0,0-1-.69,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-69"
          x1="-3609.07"
          y1="1199.85"
          x2="-3608.66"
          y2="1199.85"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-81">
          <path
            class="cls-4"
            d="M569.73,217.38a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1a6.69,6.69,0,0,0,1.53.7c.41.2.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.92-.19-1.22-.29-.61-.7-1-.8h-.3a1.16,1.16,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-70"
          x1="-3649.94"
          y1="1093.9"
          x2="-3649.54"
          y2="1093.9"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-82">
          <path
            class="cls-4"
            d="M445.87,293.81c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.2,1.2,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-71"
          x1="-3614.6"
          y1="1199.62"
          x2="-3614.19"
          y2="1199.62"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-83">
          <path
            class="cls-4"
            d="M432.93,295.06a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-72"
          x1="-3652.91"
          y1="1098.58"
          x2="-3652.5"
          y2="1098.58"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-84">
          <path
            class="cls-4"
            d="M417.6,279.73c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.11,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-73"
          x1="-3615.18"
          y1="1198.67"
          x2="-3614.77"
          y2="1198.67"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-85">
          <path
            class="cls-4"
            d="M404.67,281a.35.35,0,0,0-.1.2c-.1.4.31.81.31,1.21s-.29.81-.29,1.22.52.7.72,1.1-.09.91.12,1.22.71.6.91.9.12.91.52,1.21.82.29,1.12.59.41.81.72,1.11a7.12,7.12,0,0,0,1.53.69c.4.2.7.09,1,.19l.71.7.31-.2-.32-.91c.1-.4.3-.61.3-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.51-.71-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-74"
          x1="-3654.02"
          y1="1098.6"
          x2="-3653.61"
          y2="1098.6"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-86">
          <path
            class="cls-4"
            d="M430.83,286.78c-.11,0-.1.1-.21.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.91-.32,1-.72c.3-.31.1-.91.4-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.31-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.18,1.18,0,0,0-1-.7,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-75"
          x1="-3614.92"
          y1="1199.13"
          x2="-3614.51"
          y2="1199.13"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-87">
          <path
            class="cls-4"
            d="M417.89,287.92a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.3,1.22.52.7.72,1.1-.09.91.12,1.21.71.6.92.91.11.91.51,1.21.82.29,1.12.59.42.81.72,1.11a7.12,7.12,0,0,0,1.53.69c.4.2.71.09,1,.19l.72.7.3-.2-.32-.91c.1-.41.3-.61.3-1a8.66,8.66,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.91-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.71-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.62-.7-1-.8h-.3a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-76"
          x1="-3653.49"
          y1="1098.61"
          x2="-3653.08"
          y2="1098.61"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-88">
          <path
            class="cls-4"
            d="M460.46,286c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.71c.4-.21.7-.11,1-.22a8.94,8.94,0,0,1,1.41-.72c.3-.21.39-.81.69-1.12s.91-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-77"
          x1="-3614.02"
          y1="1199.66"
          x2="-3613.61"
          y2="1199.66"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-89">
          <path
            class="cls-4"
            d="M447.52,287.22a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1a6.4,6.4,0,0,0,1.52.69c.41.2.71.1,1,.2l.72.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.22-.29-.61-.71-1-.8h-.3c-.61,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-78"
          x1="-3652.58"
          y1="1098.09"
          x2="-3652.18"
          y2="1098.09"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-90">
          <path
            class="cls-4"
            d="M474.44,277.94c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.91.42-1,.72c-.31.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.22.29-.81.29-1.21c0-.1-.1-.1-.11-.2a1.18,1.18,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-79"
          x1="-3613.45"
          y1="1199.67"
          x2="-3613.04"
          y2="1199.67"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-91">
          <path
            class="cls-4"
            d="M461.4,279.19a.35.35,0,0,0-.1.2c-.09.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.92.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.1,1,.19l.72.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-80"
          x1="-3652.28"
          y1="1097.61"
          x2="-3651.87"
          y2="1097.61"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-92">
          <path
            class="cls-4"
            d="M488.22,270.11c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82a5.57,5.57,0,0,0-1.21.41c-.3.21-.4.82-.7,1.12s-.91.42-1,.72c-.31.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a14.6,14.6,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-81"
          x1="-3612.89"
          y1="1199.69"
          x2="-3612.49"
          y2="1199.69"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-93">
          <path
            class="cls-4"
            d="M475.18,271.26a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.92.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.1,1,.19l.72.7.3-.2-.31-.91c.09-.4.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-82"
          x1="-3651.99"
          y1="1097.14"
          x2="-3651.58"
          y2="1097.14"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-94">
          <path
            class="cls-4"
            d="M502.4,261.67c-.1,0-.1.11-.2.11-.41.2-.6.71-.91.81s-.9.22-1.2.42-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a8.46,8.46,0,0,1,1.4-.72c.31-.21.4-.82.7-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.11-.1-.11-.2a1.2,1.2,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-83"
          x1="-3612.31"
          y1="1199.71"
          x2="-3611.9"
          y2="1199.71"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-95">
          <path
            class="cls-4"
            d="M489.46,262.71a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.21.71.6.92.91.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a7.88,7.88,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.91-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.92-.19-1.22-.29-.61-.7-1-.8h-.3a1.31,1.31,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-84"
          x1="-3651.68"
          y1="1096.64"
          x2="-3651.28"
          y2="1096.64"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-96">
          <path
            class="cls-4"
            d="M368.84,389.7c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21s1.11-.62,1.41-.72.4-.82.7-1.12.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-85"
          x1="-3618.68"
          y1="1201.04"
          x2="-3618.27"
          y2="1201.04"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-97">
          <path
            class="cls-4"
            d="M355.9,390.84a.34.34,0,0,0-.09.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.91-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.31a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-86"
          x1="-3653.71"
          y1="1102.82"
          x2="-3653.31"
          y2="1102.82"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-98">
          <path
            class="cls-4"
            d="M340.58,375.62c-.1,0-.1.1-.21.1-.4.21-.59.72-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.91-.31,1-.71.1-.92.4-1.22.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.31-.8-.32-1.21.3-.81.29-1.21c0-.11-.1-.1-.1-.21a1.19,1.19,0,0,0-1-.69,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-87"
          x1="-3619.26"
          y1="1200.1"
          x2="-3618.85"
          y2="1200.1"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-99">
          <path
            class="cls-4"
            d="M327.64,376.86a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.21.71.6.92.91.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a7.88,7.88,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.91-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-88"
          x1="-3654.83"
          y1="1102.85"
          x2="-3654.42"
          y2="1102.85"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-100">
          <path
            class="cls-4"
            d="M353.8,382.77c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.7-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.22.29-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-89"
          x1="-3619"
          y1="1200.55"
          x2="-3618.59"
          y2="1200.55"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-101">
          <path
            class="cls-4"
            d="M340.86,383.81a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-90"
          x1="-3654.3"
          y1="1102.86"
          x2="-3653.89"
          y2="1102.86"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-102">
          <path
            class="cls-4"
            d="M383.33,382c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.39-.81.69-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.9,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a2.08,2.08,0,0,0-1.53-.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-91"
          x1="-3618.1"
          y1="1201.08"
          x2="-3617.69"
          y2="1201.08"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-103">
          <path
            class="cls-4"
            d="M370.5,383.11a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.35,5.35,0,0,0-1.21-.3c-.41-.19-.62-.7-1-.79h-.31c-.6,0-1.11.21-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-92"
          x1="-3653.39"
          y1="1102.34"
          x2="-3652.98"
          y2="1102.34"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-104">
          <path
            class="cls-4"
            d="M397.31,373.93c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21s1.11-.62,1.41-.72.39-.82.7-1.12.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.3-.82.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-93"
          x1="-3617.54"
          y1="1201.1"
          x2="-3617.13"
          y2="1201.1"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-105">
          <path
            class="cls-4"
            d="M384.37,375a.35.35,0,0,0-.1.2c-.09.4.32.8.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.91-.11-.9-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.49,1.49,0,0,0-1.21.73"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-94"
          x1="-3653.09"
          y1="1101.86"
          x2="-3652.68"
          y2="1101.86"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-106">
          <path
            class="cls-4"
            d="M411.19,366c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.9-.32,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-95"
          x1="-3616.98"
          y1="1201.12"
          x2="-3616.57"
          y2="1201.12"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-107">
          <path
            class="cls-4"
            d="M398.15,367.15a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-96"
          x1="-3652.79"
          y1="1101.39"
          x2="-3652.38"
          y2="1101.39"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-108">
          <path
            class="cls-4"
            d="M425.37,357.46c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.3-.1.91-.3,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.71-.11,1-.21s1.1-.62,1.41-.73.39-.81.69-1.12.91-.31,1-.71c.3-.31.09-.92.39-1.22s.7-.62.9-.92-.11-.91,0-1.22a6.05,6.05,0,0,0,.59-1.22c0-.4-.31-.8-.31-1.21s.29-.81.29-1.21c0-.11-.1-.1-.1-.21a1.22,1.22,0,0,0-1-.69,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-97"
          x1="-3616.39"
          y1="1201.13"
          x2="-3615.99"
          y2="1201.13"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-109">
          <path
            class="cls-4"
            d="M412.43,358.7a.39.39,0,0,0-.1.21c-.09.4.32.8.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.21.72.6.92.91.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.91-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.06,1.06,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-98"
          x1="-3652.49"
          y1="1100.89"
          x2="-3652.08"
          y2="1100.89"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-110">
          <path
            class="cls-4"
            d="M368.19,365.43c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.39-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.13,1.13,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-99"
          x1="-3618.25"
          y1="1200.31"
          x2="-3617.84"
          y2="1200.31"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-111">
          <path
            class="cls-4"
            d="M355.36,366.67a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.53.69.7.1,1,.2l.71.7.31-.21-.32-.91c.1-.4.3-.61.3-1a9.73,9.73,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.35,5.35,0,0,0-1.21-.3c-.41-.19-.62-.7-1-.79h-.31a1.06,1.06,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-100"
          x1="-3654.13"
          y1="1102.08"
          x2="-3653.72"
          y2="1102.08"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-112">
          <path
            class="cls-4"
            d="M340,351.44c-.1,0-.1.11-.2.11-.41.2-.6.71-.91.82s-.9.21-1.21.41-.39.82-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.21.12,1.62.31.6.41.91l-.29,1,.4.2.71-.72c.4-.2.7-.1,1-.21s1.1-.62,1.4-.72.4-.82.7-1.12.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2.81,2.81,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-101"
          x1="-3618.83"
          y1="1199.36"
          x2="-3618.42"
          y2="1199.36"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-113">
          <path
            class="cls-4"
            d="M327,352.59a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.81-.3,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11,1.12.49,1.53.69.71.1,1,.19l.72.71.3-.21-.31-.91c.09-.4.29-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.11a6.16,6.16,0,0,0-1.22-.29c-.41-.19-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-102"
          x1="-3655.24"
          y1="1102.11"
          x2="-3654.84"
          y2="1102.11"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-114">
          <path
            class="cls-4"
            d="M353.15,358.39c-.1,0-.1.11-.2.11-.41.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.21.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a9.3,9.3,0,0,1,1.4-.72c.31-.21.4-.82.7-1.12s.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,1.41,1.41,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-103"
          x1="-3618.57"
          y1="1199.82"
          x2="-3618.16"
          y2="1199.82"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-115">
          <path
            class="cls-4"
            d="M340.31,359.64a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3c-.61,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-104"
          x1="-3654.72"
          y1="1102.11"
          x2="-3654.31"
          y2="1102.11"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-116">
          <path
            class="cls-4"
            d="M382.78,357.69c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72-.09.91-.29,1.21-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.61.31.61.42.91l-.3,1,.41.19.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.69,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-105"
          x1="-3617.67"
          y1="1200.35"
          x2="-3617.26"
          y2="1200.35"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-117">
          <path
            class="cls-4"
            d="M369.85,358.83a.3.3,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.7.71.09,1,.19l.71.7.3-.21-.31-.9c.1-.41.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.91,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.7-.41-.8-.72-1.1a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.31a1.28,1.28,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-106"
          x1="-3653.81"
          y1="1101.6"
          x2="-3653.4"
          y2="1101.6"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-118">
          <path
            class="cls-4"
            d="M396.76,349.66c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72-.09.91-.29,1.22-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-107"
          x1="-3617.1"
          y1="1200.37"
          x2="-3616.69"
          y2="1200.37"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-119">
          <path
            class="cls-4"
            d="M383.83,350.8a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.35,5.35,0,0,0-1.21-.3c-.41-.19-.62-.7-1-.79H385a1.26,1.26,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-108"
          x1="-3653.51"
          y1="1101.12"
          x2="-3653.1"
          y2="1101.12"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-120">
          <path
            class="cls-4"
            d="M410.54,341.73c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.39-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.13,1.13,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-109"
          x1="-3616.54"
          y1="1200.39"
          x2="-3616.13"
          y2="1200.39"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-121">
          <path
            class="cls-4"
            d="M397.61,343a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.3-1a9.74,9.74,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-110"
          x1="-3653.21"
          y1="1100.65"
          x2="-3652.8"
          y2="1100.65"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-122">
          <path
            class="cls-4"
            d="M424.82,333.28c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.21.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.39-.82.7-1.12s.9-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.29-.82.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-111"
          x1="-3615.96"
          y1="1200.4"
          x2="-3615.55"
          y2="1200.4"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-123">
          <path
            class="cls-4"
            d="M411.88,334.33a.35.35,0,0,0-.1.2c-.09.4.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.18,1.18,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-112"
          x1="-3652.91"
          y1="1100.15"
          x2="-3652.5"
          y2="1100.15"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-124">
          <path
            class="cls-4"
            d="M368.24,340c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.2.42-.4.81-.7,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21s1.1-.62,1.4-.73.4-.81.7-1.12.91-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-113"
          x1="-3617.77"
          y1="1199.55"
          x2="-3617.37"
          y2="1199.55"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-125">
          <path
            class="cls-4"
            d="M355.3,341.17a.35.35,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.11.5,1.52.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3c-.71.11-1,.32-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-114"
          x1="-3654.55"
          y1="1101.29"
          x2="-3654.14"
          y2="1101.29"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-126">
          <path
            class="cls-4"
            d="M340,326c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.39-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.91-.11-.91,0-1.22.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7A1.55,1.55,0,0,0,340,326"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-115"
          x1="-3618.36"
          y1="1198.6"
          x2="-3617.95"
          y2="1198.6"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-127">
          <path
            class="cls-4"
            d="M327,327.19a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.22s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.7.71.09,1,.19l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.32,5.32,0,0,0-1.21-.29c-.41-.2-.62-.7-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-116"
          x1="-3655.66"
          y1="1101.32"
          x2="-3655.26"
          y2="1101.32"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-128">
          <path
            class="cls-4"
            d="M353.2,333.1c-.11,0-.1.1-.21.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.21s1.11-.62,1.41-.73.4-.81.7-1.12.91-.31,1-.72c.3-.3.1-.91.4-1.21s.7-.62.9-.92-.11-.91,0-1.22a6.59,6.59,0,0,0,.6-1.22c0-.4-.31-.8-.32-1.21s.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.7,1.93,1.93,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-117"
          x1="-3618.09"
          y1="1199.06"
          x2="-3617.68"
          y2="1199.06"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-129">
          <path
            class="cls-4"
            d="M340.26,334.14a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1,1.12.5,1.53.69.71.1,1,.2l.71.7.31-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.19,1.19,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-118"
          x1="-3655.14"
          y1="1101.33"
          x2="-3654.73"
          y2="1101.33"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-130">
          <path
            class="cls-4"
            d="M382.83,332.29c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21s1.1-.62,1.41-.72.39-.82.69-1.12.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.18,1.18,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-119"
          x1="-3617.2"
          y1="1199.59"
          x2="-3616.79"
          y2="1199.59"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-131">
          <path
            class="cls-4"
            d="M369.89,333.44a.35.35,0,0,0-.1.2c-.09.4.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.91.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.71-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3c-.71,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-120"
          x1="-3654.23"
          y1="1100.81"
          x2="-3653.82"
          y2="1100.81"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-132">
          <path
            class="cls-4"
            d="M396.81,324.26c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.31.3-.1.91-.3,1.21s-.7.62-.9.92.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21a9,9,0,0,1,1.41-.73c.3-.2.39-.81.69-1.12s.91-.31,1-.72.09-.91.39-1.21.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.19,1.19,0,0,0-1-.69,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-121"
          x1="-3616.63"
          y1="1199.61"
          x2="-3616.22"
          y2="1199.61"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-133">
          <path
            class="cls-4"
            d="M383.87,325.4a.35.35,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.11.5,1.52.7.71.09,1,.19l.72.7.3-.21-.31-.9c.1-.41.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.7-.41-.8-.72-1.1a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3c-.61,0-1.11.22-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-122"
          x1="-3653.93"
          y1="1100.33"
          x2="-3653.52"
          y2="1100.33"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-134">
          <path
            class="cls-4"
            d="M410.49,316.33c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.4.19.71-.71c.4-.21.7-.11,1-.21a10,10,0,0,1,1.41-.73c.31-.2.4-.81.7-1.12s.91-.31,1-.71c.31-.31.1-.92.4-1.22s.7-.62.9-.92-.11-.91,0-1.22.49-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.21c0-.11-.11-.1-.11-.21a1.19,1.19,0,0,0-1-.69,1.09,1.09,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-123"
          x1="-3616.07"
          y1="1199.63"
          x2="-3615.66"
          y2="1199.63"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-135">
          <path
            class="cls-4"
            d="M397.65,317.47a.35.35,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.11.5,1.52.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1.09,1.09,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-124"
          x1="-3653.63"
          y1="1099.86"
          x2="-3653.22"
          y2="1099.86"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-136">
          <path
            class="cls-4"
            d="M424.87,307.89c-.1,0-.1.1-.2.1-.41.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.71a4.81,4.81,0,0,1-.29,1.22c-.2.31-.7.62-.9.92s.11.91,0,1.22-.49.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.41.2.7-.71c.4-.21.7-.11,1-.22a10.33,10.33,0,0,1,1.4-.72c.31-.2.4-.81.7-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.91-.11-.91,0-1.22.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3.25,3.25,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-125"
          x1="-3615.49"
          y1="1199.64"
          x2="-3615.08"
          y2="1199.64"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-137">
          <path
            class="cls-4"
            d="M411.83,309a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.22s-.3.81-.29,1.21.51.71.71,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1,1.12.5,1.53.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.92,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1-.92-.19-1.22-.29-.61-.7-1-.8H413a1.15,1.15,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-126"
          x1="-3653.33"
          y1="1099.36"
          x2="-3652.92"
          y2="1099.36"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-138">
          <path
            class="cls-4"
            d="M626.74,373.05c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.21.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21s1.11-.62,1.41-.72.4-.82.7-1.12.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.3-.82.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-127"
          x1="-3610.68"
          y1="1205.35"
          x2="-3610.27"
          y2="1205.35"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-139">
          <path
            class="cls-4"
            d="M613.81,374.2a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.51-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8H615a1.16,1.16,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-128"
          x1="-3645.98"
          y1="1098.04"
          x2="-3645.58"
          y2="1098.04"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-140">
          <path
            class="cls-4"
            d="M598.48,359c-.1,0-.1.1-.2.11-.41.2-.6.71-.91.81s-.91.22-1.21.42-.39.81-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a9,9,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.91-.32,1-.72a2.52,2.52,0,0,1,.4-1.22c.2-.31.7-.61.9-.92s-.11-.91,0-1.21.49-.72.59-1.22-.31-.81-.32-1.22.3-.81.3-1.21c0-.1-.11-.1-.11-.2a1.18,1.18,0,0,0-1-.7,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-129"
          x1="-3611.26"
          y1="1204.4"
          x2="-3610.85"
          y2="1204.4"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-141">
          <path
            class="cls-4"
            d="M585.54,360.22a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.22.71.6.92.9.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11a7.12,7.12,0,0,0,1.53.69c.41.2.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.4.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.81-.72-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-130"
          x1="-3647.1"
          y1="1098.07"
          x2="-3646.69"
          y2="1098.07"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-142">
          <path
            class="cls-4"
            d="M611.7,366.12c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.71-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-131"
          x1="-3611"
          y1="1204.85"
          x2="-3610.59"
          y2="1204.85"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-143">
          <path
            class="cls-4"
            d="M598.76,367.17a.35.35,0,0,0-.1.2c-.09.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.91.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.71-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.91-.11-.91-.41-1.21-.82-.39-1.12-.69-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8H600a1.2,1.2,0,0,0-1.21.73"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-132"
          x1="-3646.57"
          y1="1098.08"
          x2="-3646.16"
          y2="1098.08"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-144">
          <path
            class="cls-4"
            d="M641.23,365.32c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.3-.09.91-.29,1.21s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.61.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.39-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a2.08,2.08,0,0,0-1.53-.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-133"
          x1="-3610.1"
          y1="1205.38"
          x2="-3609.69"
          y2="1205.38"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-145">
          <path
            class="cls-4"
            d="M628.4,366.46a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.29-.62-.71-1-.8h-.31c-.6,0-1.11.21-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-134"
          x1="-3645.66"
          y1="1097.56"
          x2="-3645.25"
          y2="1097.56"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-146">
          <path
            class="cls-4"
            d="M655.21,357.29c-.1,0-.1.1-.2.1-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-135"
          x1="-3609.53"
          y1="1205.4"
          x2="-3609.12"
          y2="1205.4"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-147">
          <path
            class="cls-4"
            d="M642.27,358.33a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.46,1.46,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-136"
          x1="-3645.36"
          y1="1097.08"
          x2="-3644.95"
          y2="1097.08"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-148">
          <path
            class="cls-4"
            d="M669.09,349.35c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.21.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.9-.32,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.3-.82.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-137"
          x1="-3608.97"
          y1="1205.42"
          x2="-3608.56"
          y2="1205.42"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-149">
          <path
            class="cls-4"
            d="M656.05,350.5a.3.3,0,0,0-.09.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-138"
          x1="-3645.06"
          y1="1096.61"
          x2="-3644.66"
          y2="1096.61"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-150">
          <path
            class="cls-4"
            d="M683.27,340.81c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.31-.1.91-.29,1.22s-.71.61-.91.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.71-.11,1-.21s1.1-.62,1.41-.72.39-.82.69-1.12.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21a6.63,6.63,0,0,0,.59-1.22c0-.41-.31-.81-.31-1.22s.29-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-139"
          x1="-3608.39"
          y1="1205.44"
          x2="-3607.98"
          y2="1205.44"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-151">
          <path
            class="cls-4"
            d="M670.33,342.06a.3.3,0,0,0-.09.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-140"
          x1="-3644.76"
          y1="1096.11"
          x2="-3644.35"
          y2="1096.11"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-152">
          <path
            class="cls-4"
            d="M546.58,418.59c-.11,0-.1.1-.21.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71-.09.92-.29,1.22-.7.62-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.12,1.62.3.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22a9.39,9.39,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.91-.31,1-.72c.3-.3.09-.91.4-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,1.93,1.93,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-141"
          x1="-3613.92"
          y1="1205.21"
          x2="-3613.51"
          y2="1205.21"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-153">
          <path
            class="cls-4"
            d="M533.64,419.73a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1,1.12.5,1.53.69.71.1,1,.2l.72.7.3-.21-.32-.91c.1-.4.3-.61.3-1a8.77,8.77,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.19,1.19,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-142"
          x1="-3647.72"
          y1="1100.78"
          x2="-3647.31"
          y2="1100.78"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-154">
          <path
            class="cls-4"
            d="M518.31,404.51c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21s1.1-.62,1.41-.72.39-.81.69-1.12.91-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-143"
          x1="-3614.5"
          y1="1204.26"
          x2="-3614.09"
          y2="1204.26"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-155">
          <path
            class="cls-4"
            d="M505.37,405.65a.35.35,0,0,0-.1.2c-.09.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.1,1,.19l.72.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.41-.8-.72-1.11a6,6,0,0,0-1.22-.29c-.4-.19-.61-.7-1-.8h-.3c-.71,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-144"
          x1="-3648.83"
          y1="1100.81"
          x2="-3648.42"
          y2="1100.81"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-156">
          <path
            class="cls-4"
            d="M531.53,411.56c-.1,0-.1.1-.2.1-.4.2-.6.71-.9.82a5.76,5.76,0,0,0-1.21.41c-.3.21-.4.82-.7,1.12s-.9.42-1,.72-.09.91-.29,1.22-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.39-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-145"
          x1="-3614.23"
          y1="1204.72"
          x2="-3613.83"
          y2="1204.72"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-157">
          <path
            class="cls-4"
            d="M518.59,412.7a.3.3,0,0,0-.09.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.11a5.85,5.85,0,0,0-1.22-.29c-.4-.19-.61-.7-1-.8h-.3a1.18,1.18,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-146"
          x1="-3648.3"
          y1="1100.81"
          x2="-3647.9"
          y2="1100.81"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-158">
          <path
            class="cls-4"
            d="M561.06,410.75c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.11,1.62.31.6.42.9l-.3,1,.41.19.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.71c.3-.31.09-.92.39-1.22s.71-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.31-.8-.32-1.21.3-.81.29-1.21c0-.11-.1-.1-.1-.21a1.2,1.2,0,0,0-1-.69,1.1,1.1,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-147"
          x1="-3613.34"
          y1="1205.25"
          x2="-3612.93"
          y2="1205.25"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-159">
          <path
            class="cls-4"
            d="M548.23,412a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.3,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.32-.91c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.91,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.71-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.62-.7-1-.8h-.3c-.71,0-1.12.22-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-148"
          x1="-3647.4"
          y1="1100.3"
          x2="-3646.99"
          y2="1100.3"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-160">
          <path
            class="cls-4"
            d="M575.15,402.72c-.11,0-.1.1-.21.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.39.82-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.12,1.62.3.6.41.91l-.29,1,.4.2.7-.72c.41-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.91-.31,1-.72c.3-.31.1-.91.4-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7l-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-149"
          x1="-3612.77"
          y1="1205.27"
          x2="-3612.36"
          y2="1205.27"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-161">
          <path
            class="cls-4"
            d="M562.11,403.86a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.91.9.12.91.52,1.21.82.3,1.12.6.41.8.72,1.1,1.12.5,1.53.69.7.1,1,.2l.71.7.31-.21-.32-.91c.1-.4.3-.61.3-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.29,1.29,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-150"
          x1="-3647.1"
          y1="1099.82"
          x2="-3646.69"
          y2="1099.82"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-162">
          <path
            class="cls-4"
            d="M588.93,394.89c-.11,0-.1.1-.21.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71c-.3.31-.09.92-.29,1.22s-.7.62-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22a9.39,9.39,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.91-.31,1-.72.1-.91.4-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,3.09,3.09,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-151"
          x1="-3612.21"
          y1="1205.29"
          x2="-3611.8"
          y2="1205.29"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-163">
          <path
            class="cls-4"
            d="M575.89,396a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.41.8.72,1.1,1.12.5,1.53.7.7.09,1,.19l.71.7.31-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-152"
          x1="-3646.8"
          y1="1099.35"
          x2="-3646.39"
          y2="1099.35"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-164">
          <path
            class="cls-4"
            d="M603.1,386.35c-.1,0-.1.1-.2.1-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.71-.61.9-.92-.11-.91,0-1.21a6.93,6.93,0,0,0,.6-1.22c0-.41-.31-.81-.32-1.21s.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-153"
          x1="-3611.63"
          y1="1205.3"
          x2="-3611.22"
          y2="1205.3"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-165">
          <path
            class="cls-4"
            d="M590.17,387.49a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.3-1a9.73,9.73,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1.26,1.26,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-154"
          x1="-3646.5"
          y1="1098.85"
          x2="-3646.09"
          y2="1098.85"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-166">
          <path
            class="cls-4"
            d="M626.09,348.78c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.39-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.9,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.55,1.55,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-155"
          x1="-3610.24"
          y1="1204.61"
          x2="-3609.84"
          y2="1204.61"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-167">
          <path
            class="cls-4"
            d="M613.26,350a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.91.9.12.91.52,1.21.82.3,1.12.6.41.8.72,1.1a6.67,6.67,0,0,0,1.53.69c.4.2.7.1,1,.2l.71.7.31-.21-.32-.9c.1-.41.3-.62.3-1a8.78,8.78,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.06,1.06,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-156"
          x1="-3646.4"
          y1="1097.3"
          x2="-3646"
          y2="1097.3"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-168">
          <path
            class="cls-4"
            d="M597.93,334.8c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.9.21-1.21.41-.39.82-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21s1.1-.62,1.4-.72.4-.81.7-1.12.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2.07,2.07,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-157"
          x1="-3610.82"
          y1="1203.66"
          x2="-3610.42"
          y2="1203.66"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-169">
          <path
            class="cls-4"
            d="M584.89,335.94a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.82-.29,1.22.51.7.71,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1a6.67,6.67,0,0,0,1.53.69c.4.2.71.1,1,.2l.72.7.3-.21-.31-.91c.09-.4.29-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5,5,0,0,0-1.22-.29c-.41-.2-.61-.71-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-158"
          x1="-3647.52"
          y1="1097.33"
          x2="-3647.11"
          y2="1097.33"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-170">
          <path
            class="cls-4"
            d="M611.05,341.75c-.1,0-.1.1-.2.1-.41.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21a8.94,8.94,0,0,1,1.41-.72c.3-.21.39-.81.69-1.12s.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,1.13,1.13,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-159"
          x1="-3610.56"
          y1="1204.12"
          x2="-3610.15"
          y2="1204.12"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-171">
          <path
            class="cls-4"
            d="M598.21,343a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.59,6.59,0,0,0,1.52.69c.41.2.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.22-.3-.61-.7-1-.79h-.3c-.61,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-160"
          x1="-3646.99"
          y1="1097.34"
          x2="-3646.58"
          y2="1097.34"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-172">
          <path
            class="cls-4"
            d="M640.68,341c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72a5.53,5.53,0,0,1-.29,1.22c-.2.3-.7.61-.9.92s.11.9,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.71c.3-.31.09-.92.39-1.22s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-161"
          x1="-3609.66"
          y1="1204.65"
          x2="-3609.26"
          y2="1204.65"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-173">
          <path
            class="cls-4"
            d="M627.75,342.18a.39.39,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.21.72.6.92.91.11.9.52,1.2.81.3,1.12.6.41.81.72,1.11a7.26,7.26,0,0,0,1.52.69c.41.2.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.11-.41-.51-.71-.62-1.11s.09-.91,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.32,5.32,0,0,0-1.21-.29c-.41-.2-.62-.7-1-.8H629a1.29,1.29,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-162"
          x1="-3646.08"
          y1="1096.82"
          x2="-3645.67"
          y2="1096.82"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-174">
          <path
            class="cls-4"
            d="M654.66,333c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82a5.28,5.28,0,0,0-1.21.42c-.3.2-.4.81-.7,1.12s-.9.41-1,.71a5.28,5.28,0,0,1-.29,1.22c-.2.31-.7.62-.9.92s.11.91,0,1.22-.5.71-.49,1.21.11,1.22.11,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.22s.71-.61.9-.91-.11-.91,0-1.22.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-163"
          x1="-3609.1"
          y1="1204.67"
          x2="-3608.69"
          y2="1204.67"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-175">
          <path
            class="cls-4"
            d="M641.73,334.15a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.28,1.28,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-164"
          x1="-3645.78"
          y1="1096.34"
          x2="-3645.37"
          y2="1096.34"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-176">
          <path
            class="cls-4"
            d="M668.44,325.08c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22s1.11-.61,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.9,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.55,1.55,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-165"
          x1="-3608.54"
          y1="1204.69"
          x2="-3608.13"
          y2="1204.69"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-177">
          <path
            class="cls-4"
            d="M655.51,326.32a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.22s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1a7.29,7.29,0,0,0,1.52.7c.41.19.71.09,1,.19l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.29-.62-.71-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-166"
          x1="-3645.48"
          y1="1095.87"
          x2="-3645.07"
          y2="1095.87"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-178">
          <path
            class="cls-4"
            d="M682.72,316.64c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.9-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-167"
          x1="-3607.96"
          y1="1204.7"
          x2="-3607.55"
          y2="1204.7"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-179">
          <path
            class="cls-4"
            d="M669.78,317.68a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a7,7,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8H671a1.18,1.18,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-168"
          x1="-3645.18"
          y1="1095.37"
          x2="-3644.77"
          y2="1095.37"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-180">
          <path
            class="cls-4"
            d="M546.13,394.21c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71c-.3.31-.09.92-.29,1.22s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22s1.11-.61,1.41-.72.4-.81.7-1.12.91-.31,1-.72c.3-.3.1-.91.4-1.22s.7-.61.9-.92-.11-.9,0-1.21a7.36,7.36,0,0,0,.59-1.22c0-.4-.31-.81-.32-1.21s.3-.81.3-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,1.93,1.93,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-169"
          x1="-3613.48"
          y1="1204.48"
          x2="-3613.07"
          y2="1204.48"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-181">
          <path
            class="cls-4"
            d="M533.19,395.45a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.22s-.3.81-.29,1.21.51.71.71,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1,1.12.5,1.53.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.92,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5,5,0,0,0-1.22-.29c-.41-.2-.61-.71-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-170"
          x1="-3648.14"
          y1="1100.04"
          x2="-3647.73"
          y2="1100.04"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-182">
          <path
            class="cls-4"
            d="M517.86,380.23c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.71c-.3.31-.1.92-.29,1.22s-.71.62-.91.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.61.41.91l-.29,1,.41.2.7-.71c.4-.21.71-.11,1-.22a9.39,9.39,0,0,1,1.41-.72c.3-.2.39-.81.69-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-171"
          x1="-3614.06"
          y1="1203.53"
          x2="-3613.65"
          y2="1203.53"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-183">
          <path
            class="cls-4"
            d="M504.92,381.27a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.1,1,.2l.71.7.3-.21-.41-.8c.1-.41.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.92,4.92,0,0,0-1.22-.29c-.4-.2-.61-.71-1-.8H506a1,1,0,0,0-1.11.62"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-172"
          x1="-3649.25"
          y1="1100.06"
          x2="-3648.84"
          y2="1100.06"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-184">
          <path
            class="cls-4"
            d="M531.08,387.18c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.4-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21a6.93,6.93,0,0,0,.6-1.22c0-.41-.32-.81-.32-1.21s.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-173"
          x1="-3613.79"
          y1="1203.99"
          x2="-3613.39"
          y2="1203.99"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-185">
          <path
            class="cls-4"
            d="M518.15,388.42a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.53.69.7.1,1,.2l.71.7.31-.21-.32-.91c.1-.4.3-.61.3-1a9.73,9.73,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31c-.6,0-1.11.21-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-174"
          x1="-3648.72"
          y1="1100.07"
          x2="-3648.31"
          y2="1100.07"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-186">
          <path
            class="cls-4"
            d="M560.72,386.47c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a10,10,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.91-.31,1-.71c.3-.31.1-.92.4-1.22s.7-.62.9-.92-.11-.91,0-1.22.49-.71.59-1.22-.31-.8-.32-1.21.3-.81.3-1.21c0-.11-.11-.1-.11-.21a1.19,1.19,0,0,0-1-.69,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-175"
          x1="-3612.9"
          y1="1204.51"
          x2="-3612.49"
          y2="1204.51"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-187">
          <path
            class="cls-4"
            d="M547.78,387.61a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.21.71.6.92.91.11.9.52,1.2.81.3,1.11.6.42.8.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21a6.39,6.39,0,0,1-1.12-.69c-.31-.2-.42-.81-.72-1.11s-.92-.19-1.22-.29-.61-.7-1-.8H549a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-176"
          x1="-3647.81"
          y1="1099.55"
          x2="-3647.4"
          y2="1099.55"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-188">
          <path
            class="cls-4"
            d="M574.7,378.44c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71c-.3.31-.09.92-.29,1.22s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.71-.71c.4-.21.7-.11,1-.22a11.06,11.06,0,0,1,1.41-.72c.31-.2.4-.81.7-1.12s.91-.31,1-.72a2.56,2.56,0,0,1,.4-1.22c.2-.3.7-.61.9-.92s-.11-.9,0-1.21.49-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3.09,3.09,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-177"
          x1="-3612.33"
          y1="1204.53"
          x2="-3611.92"
          y2="1204.53"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-189">
          <path
            class="cls-4"
            d="M561.66,379.58a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.22s-.3.81-.3,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1a7.14,7.14,0,0,0,1.53.7c.4.19.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.11-.7-.42-.8-.72-1.1-.92-.2-1.22-.29-.62-.71-1-.8h-.3a1.15,1.15,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-178"
          x1="-3647.51"
          y1="1099.07"
          x2="-3647.1"
          y2="1099.07"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-190">
          <path
            class="cls-4"
            d="M588.48,370.51c-.1,0-.1.1-.2.1-.41.21-.6.71-.91.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.71a5.28,5.28,0,0,1-.29,1.22c-.2.31-.7.62-.9.92s.11.91,0,1.22-.5.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.22a11.06,11.06,0,0,1,1.41-.72c.3-.2.4-.81.7-1.12s.91-.31,1-.72c.3-.3.1-.91.4-1.22s.7-.61.9-.92-.11-.9,0-1.21.49-.71.59-1.22-.31-.81-.32-1.21.3-.81.3-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3.09,3.09,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-179"
          x1="-3611.77"
          y1="1204.56"
          x2="-3611.36"
          y2="1204.56"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-191">
          <path
            class="cls-4"
            d="M575.44,371.65a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.22s-.29.81-.29,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1,1.12.5,1.53.7.71.09,1,.19l.72.7.3-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.29-.62-.71-1-.8h-.31a1.15,1.15,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-180"
          x1="-3647.22"
          y1="1098.6"
          x2="-3646.81"
          y2="1098.6"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-192">
          <path
            class="cls-4"
            d="M602.65,362c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.71-.61.91-.92-.11-.91,0-1.21.5-.71.6-1.22-.31-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7c-.4-.1-.4-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-181"
          x1="-3611.19"
          y1="1204.57"
          x2="-3610.78"
          y2="1204.57"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-193">
          <path
            class="cls-4"
            d="M589.72,363.11a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.81-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.91.9.12.91.52,1.21.82.29,1.12.59.41.81.72,1.11,1.12.49,1.53.69.7.1,1,.19l.71.71.31-.21-.32-.91c.1-.4.3-.61.3-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.21-.3-.62-.7-1-.8h-.31a1.27,1.27,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-182"
          x1="-3646.91"
          y1="1098.1"
          x2="-3646.51"
          y2="1098.1"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-194">
          <path
            class="cls-4"
            d="M626.14,323.38c-.1,0-.1.1-.2.1-.41.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21s1.1-.62,1.4-.73.4-.81.7-1.12.91-.31,1-.71c.3-.31.09-.92.39-1.22s.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.21c0-.11-.1-.1-.11-.21a1.19,1.19,0,0,0-1-.69,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-183"
          x1="-3609.77"
          y1="1203.85"
          x2="-3609.36"
          y2="1203.85"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-195">
          <path
            class="cls-4"
            d="M613.2,324.52a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3c-.71.11-1,.32-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-184"
          x1="-3646.82"
          y1="1096.51"
          x2="-3646.42"
          y2="1096.51"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-196">
          <path
            class="cls-4"
            d="M597.87,309.3c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.3-.09.91-.29,1.21s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.61.31.61.42.91l-.3,1,.41.19.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.69,1.41,1.41,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-185"
          x1="-3610.35"
          y1="1202.91"
          x2="-3609.94"
          y2="1202.91"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-197">
          <path
            class="cls-4"
            d="M584.94,310.54a.39.39,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1a6.81,6.81,0,0,0,1.52.7c.41.2.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.91,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-186"
          x1="-3647.94"
          y1="1096.54"
          x2="-3647.53"
          y2="1096.54"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-198">
          <path
            class="cls-4"
            d="M611.1,316.45c-.1,0-.1.1-.21.1-.4.21-.59.72-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.19.7-.71c.41-.21.71-.11,1-.21s1.11-.62,1.41-.73.4-.81.7-1.12.91-.31,1-.71c.3-.31.1-.92.4-1.22s.7-.62.9-.92-.11-.91,0-1.22a6.59,6.59,0,0,0,.6-1.22c0-.4-.31-.8-.32-1.21s.3-.81.29-1.21c0-.11-.1-.1-.1-.21a1.19,1.19,0,0,0-1-.69,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-187"
          x1="-3610.09"
          y1="1203.36"
          x2="-3609.68"
          y2="1203.36"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-199">
          <path
            class="cls-4"
            d="M598.16,317.49a.35.35,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.21.52.71.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1a7.14,7.14,0,0,0,1.53.7c.4.19.71.09,1,.19l.72.7.3-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1.2,1.2,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-188"
          x1="-3647.41"
          y1="1096.55"
          x2="-3647"
          y2="1096.55"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-200">
          <path
            class="cls-4"
            d="M640.73,315.64c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.21.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.1,1-.21s1.1-.62,1.41-.72.39-.82.69-1.12.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-189"
          x1="-3609.19"
          y1="1203.89"
          x2="-3608.78"
          y2="1203.89"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-201">
          <path
            class="cls-4"
            d="M627.79,316.79a.35.35,0,0,0-.1.2c-.09.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.92.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.1,1,.19l.72.7.3-.2-.31-.91c.09-.4.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8H629c-.71,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-190"
          x1="-3646.5"
          y1="1096.03"
          x2="-3646.09"
          y2="1096.03"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-202">
          <path
            class="cls-4"
            d="M654.71,307.61c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.31.3-.1.91-.3,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.7-.11,1-.21a9,9,0,0,1,1.41-.73c.3-.2.39-.81.69-1.12s.91-.31,1-.71.09-.92.39-1.22.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.21c0-.1-.1-.1-.1-.21a1.22,1.22,0,0,0-1-.69,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-191"
          x1="-3608.63"
          y1="1203.91"
          x2="-3608.22"
          y2="1203.91"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-203">
          <path
            class="cls-4"
            d="M641.77,308.75a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.09.91.11,1.21.71.6.92.91.11.9.52,1.2.81.3,1.12.6.41.8.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.22-.71-.6-.91-.9-.12-.91-.42-1.21-.82-.39-1.12-.69-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8H643c-.61,0-1.11.22-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-192"
          x1="-3646.2"
          y1="1095.55"
          x2="-3645.79"
          y2="1095.55"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-204">
          <path
            class="cls-4"
            d="M668.39,299.68c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.71-.72c.4-.21.7-.11,1-.21a8.46,8.46,0,0,1,1.4-.72c.31-.21.4-.82.7-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.62.9-.92-.11-.91,0-1.21.5-.72.59-1.23-.31-.8-.31-1.21.29-.81.29-1.21c0-.1-.11-.1-.11-.2a1.18,1.18,0,0,0-1-.7,1.09,1.09,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-193"
          x1="-3608.07"
          y1="1203.93"
          x2="-3607.66"
          y2="1203.93"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-205">
          <path
            class="cls-4"
            d="M655.55,300.82a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.09,1.09,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-194"
          x1="-3645.9"
          y1="1095.08"
          x2="-3645.49"
          y2="1095.08"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-206">
          <path
            class="cls-4"
            d="M682.77,291.24c-.1,0-.1.1-.2.1-.41.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72a4.84,4.84,0,0,1-.29,1.21c-.2.31-.7.62-.9.92s.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21a9,9,0,0,1,1.41-.73c.3-.2.39-.81.69-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.19,1.19,0,0,0-1-.69,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-195"
          x1="-3607.48"
          y1="1203.94"
          x2="-3607.08"
          y2="1203.94"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-207">
          <path
            class="cls-4"
            d="M669.73,292.38a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1a6.69,6.69,0,0,0,1.53.7c.41.2.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.92-.19-1.22-.29-.61-.7-1-.8h-.3a1.16,1.16,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-196"
          x1="-3645.6"
          y1="1094.58"
          x2="-3645.19"
          y2="1094.58"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-208">
          <path
            class="cls-4"
            d="M545.87,368.81c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.2,1.2,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-197"
          x1="-3613.01"
          y1="1203.71"
          x2="-3612.6"
          y2="1203.71"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-209">
          <path
            class="cls-4"
            d="M532.93,370.06a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.1,1,.19l.71.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-198"
          x1="-3648.56"
          y1="1099.25"
          x2="-3648.16"
          y2="1099.25"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-210">
          <path
            class="cls-4"
            d="M517.6,354.73c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.11,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-199"
          x1="-3613.59"
          y1="1202.77"
          x2="-3613.18"
          y2="1202.77"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-211">
          <path
            class="cls-4"
            d="M504.67,356a.35.35,0,0,0-.1.2c-.1.4.31.81.31,1.21s-.29.81-.29,1.22.52.7.72,1.1-.09.91.12,1.22.71.6.91.9.12.91.52,1.21.82.29,1.12.59.41.81.72,1.11a7.12,7.12,0,0,0,1.53.69c.4.2.7.09,1,.19l.71.7.31-.2-.32-.91c.1-.4.3-.61.3-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.51-.71-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.21-.29-.62-.7-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-200"
          x1="-3649.68"
          y1="1099.27"
          x2="-3649.27"
          y2="1099.27"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-212">
          <path
            class="cls-4"
            d="M530.83,361.78c-.11,0-.1.1-.21.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.91-.32,1-.72c.3-.31.1-.91.4-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.31-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.18,1.18,0,0,0-1-.7,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-201"
          x1="-3613.33"
          y1="1203.23"
          x2="-3612.92"
          y2="1203.23"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-213">
          <path
            class="cls-4"
            d="M517.89,362.92a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.3,1.22.52.7.72,1.1-.09.91.12,1.21.71.6.92.91.11.91.51,1.21.82.29,1.12.59.42.81.72,1.11a7.12,7.12,0,0,0,1.53.69c.4.2.71.09,1,.19l.72.7.3-.2-.32-.91c.1-.41.3-.61.3-1a8.66,8.66,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.91-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.71-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.62-.7-1-.8h-.3a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-202"
          x1="-3649.15"
          y1="1099.28"
          x2="-3648.74"
          y2="1099.28"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-214">
          <path
            class="cls-4"
            d="M560.46,361c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.22.12,1.62.31.6.41.91l-.29,1,.41.2.7-.71c.4-.21.7-.11,1-.22a8.94,8.94,0,0,1,1.41-.72c.3-.21.39-.81.69-1.12s.91-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-203"
          x1="-3612.43"
          y1="1203.75"
          x2="-3612.02"
          y2="1203.75"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-215">
          <path
            class="cls-4"
            d="M547.52,362.22a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1a6.4,6.4,0,0,0,1.52.69c.41.2.71.1,1,.2l.72.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1-.91-.2-1.22-.29-.61-.71-1-.8h-.3c-.61,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-204"
          x1="-3648.24"
          y1="1098.77"
          x2="-3647.83"
          y2="1098.77"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-216">
          <path
            class="cls-4"
            d="M574.44,352.94c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.91.42-1,.72c-.31.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.22.29-.81.29-1.21c0-.1-.1-.1-.11-.2a1.18,1.18,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-205"
          x1="-3611.87"
          y1="1203.77"
          x2="-3611.46"
          y2="1203.77"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-217">
          <path
            class="cls-4"
            d="M561.4,354.19a.35.35,0,0,0-.1.2c-.09.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.92.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11a6.82,6.82,0,0,0,1.52.69c.41.2.71.1,1,.19l.72.71.3-.21-.31-.91c.1-.4.3-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.41-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-206"
          x1="-3647.94"
          y1="1098.29"
          x2="-3647.53"
          y2="1098.29"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-218">
          <path
            class="cls-4"
            d="M588.22,345.11c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82a5.57,5.57,0,0,0-1.21.41c-.3.21-.4.82-.7,1.12s-.91.42-1,.72c-.31.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a14.6,14.6,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-207"
          x1="-3611.31"
          y1="1203.79"
          x2="-3610.9"
          y2="1203.79"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-219">
          <path
            class="cls-4"
            d="M575.18,346.26a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.92.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.1,1,.19l.72.7.3-.2-.31-.91c.09-.4.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.7-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.81-.72-1.11-.91-.19-1.22-.29-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-208"
          x1="-3647.64"
          y1="1097.82"
          x2="-3647.23"
          y2="1097.82"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-220">
          <path
            class="cls-4"
            d="M602.4,336.67c-.1,0-.1.11-.2.11-.41.2-.6.71-.91.81s-.9.22-1.2.42-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a8.46,8.46,0,0,1,1.4-.72c.31-.21.4-.82.7-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.11-.1-.11-.2a1.2,1.2,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-209"
          x1="-3610.72"
          y1="1203.8"
          x2="-3610.32"
          y2="1203.8"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-221">
          <path
            class="cls-4"
            d="M589.46,337.71a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.21.71.6.92.91.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a7.88,7.88,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.91-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11-.92-.19-1.22-.29-.61-.7-1-.8h-.3a1.31,1.31,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-210"
          x1="-3647.34"
          y1="1097.32"
          x2="-3646.93"
          y2="1097.32"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-222">
          <path
            class="cls-4"
            d="M468.84,464.7c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21s1.11-.62,1.41-.72.4-.82.7-1.12.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-211"
          x1="-3617.09"
          y1="1205.14"
          x2="-3616.69"
          y2="1205.14"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-223">
          <path
            class="cls-4"
            d="M455.9,465.84a.34.34,0,0,0-.09.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.91-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.31a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-212"
          x1="-3649.37"
          y1="1103.5"
          x2="-3648.96"
          y2="1103.5"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-224">
          <path
            class="cls-4"
            d="M440.58,450.62c-.1,0-.1.1-.21.1-.4.21-.59.72-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.4.2.7-.72c.41-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.91-.31,1-.71.1-.92.4-1.22.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.31-.8-.32-1.21.3-.81.29-1.21c0-.11-.1-.1-.1-.21a1.19,1.19,0,0,0-1-.69,1.75,1.75,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-213"
          x1="-3617.67"
          y1="1204.19"
          x2="-3617.27"
          y2="1204.19"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-225">
          <path
            class="cls-4"
            d="M427.64,451.86a.39.39,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.22.51.7.71,1.1-.09.91.12,1.21.71.6.92.91.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11,1.12.49,1.53.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a7.88,7.88,0,0,0,0-1.61c-.1-.41-.51-.71-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.91-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11a5.53,5.53,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-214"
          x1="-3650.48"
          y1="1103.52"
          x2="-3650.07"
          y2="1103.52"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-226">
          <path
            class="cls-4"
            d="M453.8,457.77c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.31-.1.91-.3,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.7-.11,1-.21a8.17,8.17,0,0,1,1.41-.72c.3-.21.39-.82.69-1.12s.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.22.29-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-215"
          x1="-3617.41"
          y1="1204.65"
          x2="-3617"
          y2="1204.65"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-227">
          <path
            class="cls-4"
            d="M440.86,458.81a.39.39,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.69-.42-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1.21,1.21,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-216"
          x1="-3649.95"
          y1="1103.53"
          x2="-3649.54"
          y2="1103.53"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-228">
          <path
            class="cls-4"
            d="M483.33,457c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.39-.81.69-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.92-.11-.9,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a2.08,2.08,0,0,0-1.53-.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-217"
          x1="-3616.51"
          y1="1205.18"
          x2="-3616.11"
          y2="1205.18"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-229">
          <path
            class="cls-4"
            d="M470.5,458.11a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.35,5.35,0,0,0-1.21-.3c-.41-.19-.62-.7-1-.79h-.31c-.6,0-1.11.21-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-218"
          x1="-3649.05"
          y1="1103.02"
          x2="-3648.64"
          y2="1103.02"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-230">
          <path
            class="cls-4"
            d="M497.31,448.93c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21s1.11-.62,1.41-.72.39-.82.7-1.12.9-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.3-.82.29-1.22c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-219"
          x1="-3615.95"
          y1="1205.2"
          x2="-3615.54"
          y2="1205.2"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-231">
          <path
            class="cls-4"
            d="M484.37,450a.35.35,0,0,0-.1.2c-.09.4.32.8.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.91-.11-.9-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.49,1.49,0,0,0-1.21.73"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-220"
          x1="-3648.75"
          y1="1102.54"
          x2="-3648.34"
          y2="1102.54"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-232">
          <path
            class="cls-4"
            d="M511.19,441c-.1,0-.1.1-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.81-.7,1.12-.9.41-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.71-.5,1.22.12,1.21.12,1.62.31.6.42.9l-.3,1,.41.2.7-.72c.4-.21.71-.11,1-.21a8.54,8.54,0,0,1,1.41-.72c.3-.21.4-.82.7-1.12s.9-.32,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.22.3-.81.29-1.21c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-221"
          x1="-3615.39"
          y1="1205.22"
          x2="-3614.98"
          y2="1205.22"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-233">
          <path
            class="cls-4"
            d="M498.15,442.15a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.14,1.14,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-222"
          x1="-3648.45"
          y1="1102.06"
          x2="-3648.04"
          y2="1102.06"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-234">
          <path
            class="cls-4"
            d="M525.37,432.46c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.3.3-.1.91-.3,1.22s-.7.61-.9.91.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.21.71-.11,1-.21s1.1-.62,1.41-.73.39-.81.69-1.12.91-.31,1-.71c.3-.31.09-.92.39-1.22s.7-.62.9-.92-.11-.91,0-1.22a6.05,6.05,0,0,0,.59-1.22c0-.4-.31-.8-.31-1.21s.29-.81.29-1.21c0-.11-.1-.1-.1-.21a1.22,1.22,0,0,0-1-.69,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-223"
          x1="-3614.81"
          y1="1205.23"
          x2="-3614.4"
          y2="1205.23"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-235">
          <path
            class="cls-4"
            d="M512.43,433.7a.39.39,0,0,0-.1.21c-.09.4.32.8.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.21.72.6.92.91.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.41.3-.61.29-1a8.66,8.66,0,0,0,0-1.61c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.91-.11-.91-.42-1.21-.81-.39-1.12-.69-.41-.81-.72-1.11a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.06,1.06,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-224"
          x1="-3648.15"
          y1="1101.57"
          x2="-3647.74"
          y2="1101.57"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-236">
          <path
            class="cls-4"
            d="M468.19,440.43c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.39-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.29-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.13,1.13,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-225"
          x1="-3616.66"
          y1="1204.41"
          x2="-3616.25"
          y2="1204.41"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-237">
          <path
            class="cls-4"
            d="M455.36,441.67a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.53.69.7.1,1,.2l.71.7.31-.21-.32-.91c.1-.4.3-.61.3-1a9.73,9.73,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.35,5.35,0,0,0-1.21-.3c-.41-.19-.62-.7-1-.79h-.31a1.06,1.06,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-226"
          x1="-3649.79"
          y1="1102.76"
          x2="-3649.38"
          y2="1102.76"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-238">
          <path
            class="cls-4"
            d="M440,426.44c-.1,0-.1.11-.2.11-.41.2-.6.71-.91.82s-.9.21-1.21.41-.39.82-.69,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.21.12,1.62.31.6.41.91l-.29,1,.4.2.71-.72c.4-.2.7-.1,1-.21s1.1-.62,1.4-.72.4-.82.7-1.12.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2.81,2.81,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-227"
          x1="-3617.24"
          y1="1203.46"
          x2="-3616.83"
          y2="1203.46"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-239">
          <path
            class="cls-4"
            d="M427,427.59a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.21s-.3.81-.3,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.29,1.11.59.42.81.72,1.11,1.12.49,1.53.69.71.1,1,.19l.72.71.3-.21-.31-.91c.09-.4.29-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.11s.1-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.11a6.16,6.16,0,0,0-1.22-.29c-.41-.19-.61-.7-1-.8h-.3a1,1,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-228"
          x1="-3650.9"
          y1="1102.78"
          x2="-3650.49"
          y2="1102.78"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-240">
          <path
            class="cls-4"
            d="M453.15,433.39c-.1,0-.1.11-.2.11-.41.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.72-.49,1.22.11,1.21.12,1.62.31.6.41.91l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21a9.3,9.3,0,0,1,1.4-.72c.31-.21.4-.82.7-1.12s.91-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,1.41,1.41,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-229"
          x1="-3616.98"
          y1="1203.92"
          x2="-3616.57"
          y2="1203.92"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-241">
          <path
            class="cls-4"
            d="M440.31,434.64a.35.35,0,0,0-.1.2c-.09.41.32.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.09.92.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.1,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3c-.61,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-230"
          x1="-3650.37"
          y1="1102.79"
          x2="-3649.96"
          y2="1102.79"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-242">
          <path
            class="cls-4"
            d="M482.78,432.69c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.72-.09.91-.29,1.21-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.22.12,1.21.12,1.61.31.61.42.91l-.3,1,.41.19.7-.71c.4-.21.71-.11,1-.21a9.47,9.47,0,0,1,1.41-.73c.3-.2.4-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.6-1.22-.32-.8-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.69,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-231"
          x1="-3616.08"
          y1="1204.45"
          x2="-3615.67"
          y2="1204.45"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-243">
          <path
            class="cls-4"
            d="M469.85,433.83a.3.3,0,0,0-.1.21c-.1.4.31.8.31,1.21s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.7.71.09,1,.19l.71.7.3-.21-.31-.9c.1-.41.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.91,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.39-1.12-.7-.41-.8-.72-1.1a5.28,5.28,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.31a1.28,1.28,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-232"
          x1="-3649.47"
          y1="1102.27"
          x2="-3649.06"
          y2="1102.27"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-244">
          <path
            class="cls-4"
            d="M496.76,424.66c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72-.09.91-.29,1.22-.7.61-.9.92.11.91,0,1.21-.5.72-.49,1.22.11,1.22.11,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.4-.81.7-1.12s.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7c-.41-.1-.41-.1-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-233"
          x1="-3615.51"
          y1="1204.46"
          x2="-3615.11"
          y2="1204.46"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-245">
          <path
            class="cls-4"
            d="M483.83,425.8a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.35,5.35,0,0,0-1.21-.3c-.41-.19-.62-.7-1-.79H485a1.26,1.26,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-234"
          x1="-3649.17"
          y1="1101.79"
          x2="-3648.76"
          y2="1101.79"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-246">
          <path
            class="cls-4"
            d="M510.54,416.73c-.1,0-.1.1-.2.1-.4.21-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.22.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.1,1-.21s1.11-.62,1.41-.72.39-.81.7-1.12.9-.31,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.13,1.13,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-235"
          x1="-3614.96"
          y1="1204.49"
          x2="-3614.55"
          y2="1204.49"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-247">
          <path
            class="cls-4"
            d="M497.61,418a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.51.7.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.69.71.1,1,.2l.71.7.3-.21-.31-.91c.1-.4.3-.61.3-1a9.74,9.74,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-236"
          x1="-3648.87"
          y1="1101.32"
          x2="-3648.46"
          y2="1101.32"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-248">
          <path
            class="cls-4"
            d="M524.82,408.28c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.82s-.91.21-1.21.41-.4.82-.7,1.12-.9.42-1,.72c-.3.31-.09.91-.29,1.22s-.71.61-.9.92.11.91,0,1.21-.5.72-.5,1.22.12,1.21.12,1.62.31.6.42.91l-.3,1,.41.2.7-.72c.4-.2.71-.11,1-.21a9.39,9.39,0,0,1,1.41-.72c.3-.21.39-.82.7-1.12s.9-.31,1-.72.09-.91.39-1.22.7-.61.9-.92-.11-.91,0-1.21.5-.72.6-1.22-.32-.81-.32-1.21.29-.82.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7,1.84,1.84,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-237"
          x1="-3614.37"
          y1="1204.5"
          x2="-3613.96"
          y2="1204.5"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-249">
          <path
            class="cls-4"
            d="M511.88,409.33a.35.35,0,0,0-.1.2c-.09.4.32.81.32,1.21s-.29.81-.29,1.22.51.7.72,1.1-.09.91.11,1.22.72.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.12.49,1.52.69.71.09,1,.19l.71.7.3-.2-.31-.91c.1-.4.3-.61.29-1a8.76,8.76,0,0,0,0-1.62c-.11-.41-.52-.71-.62-1.11s.09-.91,0-1.21-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3a1.18,1.18,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-238"
          x1="-3648.57"
          y1="1100.82"
          x2="-3648.16"
          y2="1100.82"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-250">
          <path
            class="cls-4"
            d="M468.24,415c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.2.42-.4.81-.7,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21s1.1-.62,1.4-.73.4-.81.7-1.12.91-.31,1-.72c.3-.3.09-.91.39-1.21s.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.22c0-.1-.11-.1-.11-.2a1.22,1.22,0,0,0-1-.7,2,2,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-239"
          x1="-3616.19"
          y1="1203.65"
          x2="-3615.78"
          y2="1203.65"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-251">
          <path
            class="cls-4"
            d="M455.3,416.17a.35.35,0,0,0-.1.21c-.1.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.11.5,1.52.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3c-.71.11-1,.32-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-240"
          x1="-3650.21"
          y1="1101.97"
          x2="-3649.8"
          y2="1101.97"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-252">
          <path
            class="cls-4"
            d="M440,401c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.9.41-1,.71c-.3.31-.09.92-.29,1.22s-.71.62-.9.92.11.91,0,1.22-.5.71-.5,1.21.12,1.22.12,1.62.31.61.42.91l-.3,1,.41.2.7-.71c.4-.21.71-.11,1-.22a10.43,10.43,0,0,1,1.41-.72c.3-.2.39-.81.7-1.12s.9-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.91-.11-.91,0-1.22.5-.71.6-1.22-.32-.81-.32-1.21.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.25,1.25,0,0,0-1-.7A1.55,1.55,0,0,0,440,401"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-241"
          x1="-3616.77"
          y1="1202.7"
          x2="-3616.36"
          y2="1202.7"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-253">
          <path
            class="cls-4"
            d="M427,402.19a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.22s-.29.81-.29,1.21.51.71.72,1.11-.09.91.11,1.21.72.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.12.5,1.52.7.71.09,1,.19l.71.7.3-.21-.31-.9c.1-.41.3-.61.3-1a9.75,9.75,0,0,0,0-1.62c-.11-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.72-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a5.32,5.32,0,0,0-1.21-.29c-.41-.2-.62-.7-1-.8h-.31a1,1,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-242"
          x1="-3651.32"
          y1="1101.99"
          x2="-3650.91"
          y2="1101.99"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-254">
          <path
            class="cls-4"
            d="M453.2,408.1c-.11,0-.1.1-.21.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.4.2.7-.71c.41-.21.71-.11,1-.21s1.11-.62,1.41-.73.4-.81.7-1.12.91-.31,1-.72c.3-.3.1-.91.4-1.21s.7-.62.9-.92-.11-.91,0-1.22a6.59,6.59,0,0,0,.6-1.22c0-.4-.31-.8-.32-1.21s.3-.81.29-1.22c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.7,1.93,1.93,0,0,0-.5-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-243"
          x1="-3616.51"
          y1="1203.16"
          x2="-3616.1"
          y2="1203.16"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-255">
          <path
            class="cls-4"
            d="M440.26,409.14a.35.35,0,0,0-.1.2c-.1.41.31.81.31,1.21s-.29.82-.29,1.22.52.7.72,1.11-.09.91.12,1.21.71.6.92.9.11.91.51,1.21.82.3,1.12.6.42.8.72,1.1,1.12.5,1.53.69.71.1,1,.2l.71.7.31-.21-.32-.9c.1-.41.3-.61.3-1a8.78,8.78,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.42-1.21-.81-.4-1.12-.7-.41-.8-.72-1.1a4.84,4.84,0,0,0-1.21-.29c-.41-.2-.62-.71-1-.8h-.31a1.19,1.19,0,0,0-1.2.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-244"
          x1="-3650.79"
          y1="1102"
          x2="-3650.38"
          y2="1102"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-256">
          <path
            class="cls-4"
            d="M482.83,407.29c-.1,0-.1.11-.2.11-.4.2-.6.71-.9.81s-.91.22-1.21.42-.4.82-.7,1.12-.91.42-1,.72c-.3.31-.09.91-.29,1.22s-.7.61-.9.92.11.91,0,1.21-.49.71-.49,1.22.11,1.21.12,1.62.31.6.41.9l-.29,1,.41.2.7-.72c.4-.2.7-.11,1-.21s1.1-.62,1.41-.72.39-.82.69-1.12.91-.32,1-.72c.3-.31.09-.91.39-1.22s.7-.61.9-.92-.11-.91,0-1.21.5-.72.59-1.22-.31-.81-.31-1.21.29-.82.29-1.22c0-.1-.1-.1-.11-.2a1.18,1.18,0,0,0-1-.7,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-245"
          x1="-3615.61"
          y1="1203.69"
          x2="-3615.2"
          y2="1203.69"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-257">
          <path
            class="cls-4"
            d="M469.89,408.44a.35.35,0,0,0-.1.2c-.09.4.31.81.32,1.21s-.3.81-.29,1.22.51.7.72,1.1-.1.91.11,1.22.71.6.92.9.11.91.52,1.21.81.29,1.12.59.41.81.72,1.11,1.11.49,1.52.69.71.09,1,.19l.72.7.3-.2-.31-.91c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.41-.51-.71-.61-1.11s.09-.91,0-1.21-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.81-.72-1.11a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3c-.71,0-1.11.21-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-246"
          x1="-3649.89"
          y1="1101.49"
          x2="-3649.48"
          y2="1101.49"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-258">
          <path
            class="cls-4"
            d="M496.81,399.26c-.1,0-.1.1-.2.1-.4.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.72c-.31.3-.1.91-.3,1.21s-.7.62-.9.92.11.91,0,1.22-.49.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.41.19.7-.71c.4-.21.7-.11,1-.21a9,9,0,0,1,1.41-.73c.3-.2.39-.81.69-1.12s.91-.31,1-.72.09-.91.39-1.21.7-.62.9-.92-.11-.91,0-1.22.5-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.19,1.19,0,0,0-1-.69,3,3,0,0,0-.51-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-247"
          x1="-3615.04"
          y1="1203.71"
          x2="-3614.63"
          y2="1203.71"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-259">
          <path
            class="cls-4"
            d="M483.87,400.4a.35.35,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.11.5,1.52.7.71.09,1,.19l.72.7.3-.21-.31-.9c.1-.41.3-.61.29-1a8.77,8.77,0,0,0,0-1.62c-.11-.4-.52-.7-.62-1.1s.09-.91,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.39-1.12-.7-.41-.8-.72-1.1a5.4,5.4,0,0,0-1.22-.29c-.4-.2-.61-.7-1-.8h-.3c-.61,0-1.11.22-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-248"
          x1="-3649.59"
          y1="1101.01"
          x2="-3649.18"
          y2="1101.01"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-260">
          <path
            class="cls-4"
            d="M510.49,391.33c-.1,0-.1.1-.2.1-.41.21-.6.72-.91.82s-.9.21-1.21.42-.39.81-.69,1.12-.91.41-1,.72c-.3.3-.09.91-.29,1.21s-.7.62-.9.92.11.91,0,1.22-.5.71-.49,1.22.11,1.21.12,1.61.31.61.41.91l-.29,1,.4.19.71-.71c.4-.21.7-.11,1-.21a10,10,0,0,1,1.41-.73c.31-.2.4-.81.7-1.12s.91-.31,1-.71c.31-.31.1-.92.4-1.22s.7-.62.9-.92-.11-.91,0-1.22.49-.71.59-1.22-.31-.8-.31-1.21.29-.81.29-1.21c0-.11-.11-.1-.11-.21a1.19,1.19,0,0,0-1-.69,1.09,1.09,0,0,0-.5-.1"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-249"
          x1="-3614.48"
          y1="1203.73"
          x2="-3614.07"
          y2="1203.73"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-261">
          <path
            class="cls-4"
            d="M497.65,392.47a.35.35,0,0,0-.1.21c-.09.4.31.8.32,1.21s-.3.81-.29,1.21.51.71.72,1.11-.1.91.11,1.21.71.6.92.9.11.91.52,1.21.81.3,1.12.6.41.8.72,1.1,1.11.5,1.52.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.61-1.1s.09-.92,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1a5.4,5.4,0,0,0-1.22-.29c-.41-.2-.61-.7-1-.8h-.3a1.09,1.09,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-250"
          x1="-3649.29"
          y1="1100.53"
          x2="-3648.88"
          y2="1100.53"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-262">
          <path
            class="cls-4"
            d="M524.87,382.89c-.1,0-.1.1-.2.1-.41.21-.6.72-.9.82s-.91.21-1.21.42-.4.81-.7,1.12-.91.41-1,.71a4.81,4.81,0,0,1-.29,1.22c-.2.31-.7.62-.9.92s.11.91,0,1.22-.49.71-.49,1.21.11,1.22.12,1.62.31.61.41.91l-.29,1,.41.2.7-.71c.4-.21.7-.11,1-.22a10.33,10.33,0,0,1,1.4-.72c.31-.2.4-.81.7-1.12s.91-.31,1-.72c.3-.3.09-.91.39-1.22s.7-.61.9-.91-.11-.91,0-1.22.5-.71.59-1.22-.31-.81-.31-1.21.29-.81.29-1.22c0-.1-.1-.1-.11-.2a1.22,1.22,0,0,0-1-.7,3.25,3.25,0,0,0-.51-.09"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-251"
          x1="-3613.9"
          y1="1203.74"
          x2="-3613.49"
          y2="1203.74"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-263">
          <path
            class="cls-4"
            d="M511.83,384a.35.35,0,0,0-.1.2c-.1.41.31.81.32,1.22s-.3.81-.29,1.21.51.71.71,1.11-.09.91.12,1.21.71.6.92.9.11.91.52,1.21.81.3,1.11.6.42.8.72,1.1,1.12.5,1.53.7.71.09,1,.19l.72.7.3-.21-.31-.9c.09-.41.29-.61.29-1a8,8,0,0,0,0-1.62c-.1-.4-.51-.7-.62-1.1s.1-.92,0-1.22-.71-.6-.92-.9-.11-.91-.41-1.21-.82-.4-1.12-.7-.42-.8-.72-1.1-.92-.19-1.22-.29-.61-.7-1-.8H513a1.15,1.15,0,0,0-1.21.72"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-252"
          x1="-3648.99"
          y1="1100.03"
          x2="-3648.58"
          y2="1100.03"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-264">
          <path
            class="cls-4"
            d="M288.68,487.92c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09a3.68,3.68,0,0,0-1,.69c-.2.2-.1.9-.3,1.19s-.71.6-.81.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.61-.7c.4-.2.6-.1,1-.2a10.17,10.17,0,0,1,1.41-.69c.3-.2.4-.79.6-1.09s.81-.3,1-.7.1-.89.4-1.19.71-.59.81-.89-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69l-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-253"
          x1="-3622.72"
          y1="1202.47"
          x2="-3622.31"
          y2="1202.47"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-265">
          <path
            class="cls-4"
            d="M275.81,488.91a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.71.6.91.89.1.9.5,1.19.8.3,1.11.6.4.79.7,1.09,1.11.5,1.51.7.6.09,1,.19l.61.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.5-.5-.7-.6-1.09s.1-.89,0-1.19-.61-.6-.81-.9-.1-.89-.4-1.19-.81-.39-1.11-.69-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.31a1.32,1.32,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-254"
          x1="-3654.49"
          y1="1107.03"
          x2="-3654.08"
          y2="1107.03"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-266">
          <path
            class="cls-4"
            d="M303.17,497c-.11,0-.11.1-.21.1-.4.2-.6.7-.9.8s-.81.2-1.21.39-.4.8-.6,1.1a3.41,3.41,0,0,0-1,.69c-.2.2-.1.89-.3,1.19s-.7.6-.8.89.1.9,0,1.19-.51.7-.51,1.19.1,1.19.1,1.69.31.59.41.89l-.31,1,.41.2.6-.69c.4-.2.6-.1,1-.2a8.24,8.24,0,0,1,1.4-.69c.31-.2.41-.8.61-1.1s.8-.29,1-.69.1-.89.41-1.19.7-.6.8-.89-.1-.9,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.2,1.2,0,0,0-1-.7l-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-255"
          x1="-3622.45"
          y1="1203.02"
          x2="-3622.05"
          y2="1203.02"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-267">
          <path
            class="cls-4"
            d="M290.39,498a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.11,1.19.7.59.9.89.1.89.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.61.1,1,.2l.6.69.3-.2-.3-.89c.1-.39.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.49-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.11-.89-.41-1.19-.8-.4-1.1-.69-.41-.8-.71-1.1a5.82,5.82,0,0,0-1.2-.29c-.41-.2-.61-.7-1-.8h-.3a1.24,1.24,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-256"
          x1="-3653.88"
          y1="1107.07"
          x2="-3653.48"
          y2="1107.07"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-268">
          <path
            class="cls-4"
            d="M382.62,536.32c-.1,0-.1.1-.2.1-.4.2-.6.7-.9.8s-.81.19-1.21.39-.4.8-.6,1.09a3.5,3.5,0,0,0-1,.7c-.3.3-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.69c.4-.2.6-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.81-.29,1-.69.1-.89.4-1.19.71-.6.81-.89-.1-.9,0-1.19.5-.7.6-1.2-.3-.79-.3-1.19.3-.79.3-1.19c0-.09-.1-.09-.1-.19a1.21,1.21,0,0,0-1-.7c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-257"
          x1="-3620.78"
          y1="1205.65"
          x2="-3620.38"
          y2="1205.65"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-269">
          <path
            class="cls-4"
            d="M369.75,537.41a.35.35,0,0,0-.1.2c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.09-.1.9.1,1.19.71.6.91.9.1.89.5,1.19.8.3,1.11.59.4.8.7,1.09,1.11.5,1.51.7.6.1,1,.2l.61.69.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.59-.81-.89-.1-.9-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.19-.6-.69-1-.79h-.31a1.34,1.34,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-258"
          x1="-3650.77"
          y1="1106.95"
          x2="-3650.36"
          y2="1106.95"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-270">
          <path
            class="cls-4"
            d="M349.23,521.74c-.1,0-.1.1-.2.1-.4.2-.6.7-.91.8s-.8.19-1.2.39-.41.8-.61,1.09a3.59,3.59,0,0,0-1,.7c-.2.2-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.69c.4-.2.6-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.2.4-.79.6-1.09s.81-.3,1-.69.1-.9.4-1.19.7-.6.81-.9-.11-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.19a1.22,1.22,0,0,0-1-.7c-.3-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-259"
          x1="-3621.51"
          y1="1204.6"
          x2="-3621.11"
          y2="1204.6"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-271">
          <path
            class="cls-4"
            d="M336.46,522.73a.35.35,0,0,0-.1.2c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.09-.1.9.1,1.19.7.6.91.9.1.89.5,1.19.8.3,1.1.59.41.8.71,1.09,1.1.5,1.51.7.6.1,1,.2l.61.69.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.61-1.09s.11-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.19-.6-.69-1-.79h-.3a1.17,1.17,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-260"
          x1="-3652.04"
          y1="1107.05"
          x2="-3651.64"
          y2="1107.05"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-272">
          <path
            class="cls-4"
            d="M365.52,529.68c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09-.81.39-1,.69-.1.9-.3,1.19-.7.6-.81.9.11.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.89l-.3,1,.41.2.6-.7c.4-.2.6-.1,1-.2a9.63,9.63,0,0,1,1.41-.69c.3-.2.4-.8.61-1.09s.8-.3,1-.7.1-.89.4-1.19.71-.59.81-.89-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.19,1.19,0,0,0-1-.69c-.31-.2-.31-.2-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-261"
          x1="-3621.17"
          y1="1205.14"
          x2="-3620.77"
          y2="1205.14"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-273">
          <path
            class="cls-4"
            d="M352.75,530.67a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.71.59.91.89.1.9.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.6.1,1,.2l.6.7.3-.2-.3-.9c.1-.39.3-.59.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.5-.7-.6-1.09s.1-.9,0-1.19-.61-.6-.81-.9-.1-.89-.4-1.19-.8-.39-1.11-.69-.4-.8-.7-1.09a5.23,5.23,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.37,1.37,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-262"
          x1="-3651.41"
          y1="1107.03"
          x2="-3651"
          y2="1107.03"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-274">
          <path
            class="cls-4"
            d="M319.66,504.88c-.1,0-.1.1-.2.1-.4.2-.6.69-.91.79s-.8.2-1.2.4-.41.79-.61,1.09a3.59,3.59,0,0,0-1,.7c-.3.29-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.7a3.53,3.53,0,0,1,1-.19,9.23,9.23,0,0,1,1.41-.7c.3-.2.4-.79.6-1.09s.81-.3,1-.69.1-.9.4-1.19.7-.6.81-.9-.11-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.69c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-263"
          x1="-3622.1"
          y1="1203.56"
          x2="-3621.7"
          y2="1203.56"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-275">
          <path
            class="cls-4"
            d="M306.79,505.87a.35.35,0,0,0-.1.2c-.11.4.3.79.3,1.19s-.3.79-.3,1.19.5.7.6,1.09-.1.9.1,1.19.7.6.9.9.11.89.51,1.19.8.29,1.1.59.41.79.71,1.09,1.1.5,1.51.7a3.53,3.53,0,0,0,1,.19l.61.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.5-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.6-.8-.89-.1-.9-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.91,1.91,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-264"
          x1="-3653.24"
          y1="1107.04"
          x2="-3652.84"
          y2="1107.04"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-276">
          <path
            class="cls-4"
            d="M334.24,513.41c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79a8.48,8.48,0,0,0-1.21.4c-.3.2-.4.79-.6,1.09s-.81.4-1,.7-.1.89-.3,1.19-.7.59-.81.89.11.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.41.2.6-.7a3.53,3.53,0,0,1,1-.19,9.71,9.71,0,0,1,1.41-.7c.3-.2.41-.79.61-1.09s.8-.3,1-.69.1-.9.4-1.19.71-.6.81-.9-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69c-.21-.2-.31-.2-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-265"
          x1="-3621.81"
          y1="1204.08"
          x2="-3621.41"
          y2="1204.08"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-277">
          <path
            class="cls-4"
            d="M321.47,514.5a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.7.6,1.09-.1.89.1,1.19.71.6.91.89.1.9.5,1.2.81.29,1.11.59.4.79.7,1.09,1.11.5,1.51.7.6.09,1,.19l.6.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.5-.7-.6-1.09s.1-.89,0-1.19-.61-.6-.81-.89-.1-.9-.4-1.2-.8-.39-1.1-.69-.41-.79-.71-1.09a5.23,5.23,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.34,1.34,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-266"
          x1="-3652.64"
          y1="1107.06"
          x2="-3652.24"
          y2="1107.06"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-278">
          <path
            class="cls-4"
            d="M400.12,529.68c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09-.81.39-1,.69-.1.9-.3,1.19-.71.6-.81.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.89l-.3,1,.4.2.61-.7c.4-.2.6-.1,1-.2a9.63,9.63,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.81-.3,1-.7.1-.89.4-1.19.71-.59.81-.89-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.19,1.19,0,0,0-1-.69c-.3-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-267"
          x1="-3620.13"
          y1="1205.77"
          x2="-3619.73"
          y2="1205.77"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-279">
          <path
            class="cls-4"
            d="M387.35,530.67a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.71.59.91.89.1.9.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.6.1,1,.2l.6.7.3-.2-.3-.9c.1-.39.3-.59.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.5-.7-.6-1.09s.1-.9,0-1.19-.61-.6-.81-.9-.1-.89-.4-1.19-.8-.39-1.11-.69-.4-.8-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3c-.51.1-1,.29-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-268"
          x1="-3650.34"
          y1="1106.45"
          x2="-3649.94"
          y2="1106.45"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-280">
          <path
            class="cls-4"
            d="M415.91,521.84c-.1,0-.1.1-.2.1-.4.2-.6.7-.9.79a8.48,8.48,0,0,0-1.21.4c-.3.2-.4.79-.6,1.09a3.5,3.5,0,0,0-1,.7c-.3.29-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.7c.4-.19.6-.09,1-.19a9.71,9.71,0,0,1,1.41-.7c.3-.2.4-.79.61-1.09s.8-.3,1-.69.1-.9.4-1.19.71-.6.81-.9-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69,1,1,0,0,0-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-269"
          x1="-3619.52"
          y1="1205.83"
          x2="-3619.12"
          y2="1205.83"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-281">
          <path
            class="cls-4"
            d="M403,522.83a.35.35,0,0,0-.1.2c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.09-.1.9.1,1.19.71.6.91.9.1.89.5,1.19.81.29,1.11.59.4.8.7,1.09,1.11.5,1.51.7.6.1,1,.2l.6.69.3-.2L410,532c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.6-.81-.89-.1-.9-.4-1.19-.8-.4-1.11-.7-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.19-.6-.69-1-.79h-.3a1.34,1.34,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-270"
          x1="-3649.98"
          y1="1105.94"
          x2="-3649.58"
          y2="1105.94"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-282">
          <path
            class="cls-4"
            d="M196.65,436.54c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09a3.5,3.5,0,0,0-1,.7c-.2.19-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.61-.7a3.53,3.53,0,0,1,1-.19,9.71,9.71,0,0,1,1.41-.7c.3-.2.4-.79.61-1.09s.8-.3,1-.69.1-.9.4-1.19.71-.6.81-.9-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69l-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-271"
          x1="-3624.54"
          y1="1199.25"
          x2="-3624.14"
          y2="1199.25"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-283">
          <path
            class="cls-4"
            d="M183.78,437.53a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.7.6,1.09-.1.89.1,1.19.71.6.91.9.1.89.5,1.19.8.29,1.11.59.4.79.7,1.09,1.11.5,1.51.7a3.53,3.53,0,0,0,1,.19l.6.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.6-.81-.89-.1-.9-.4-1.19-.8-.4-1.11-.7-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.34,1.34,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-272"
          x1="-3658.19"
          y1="1107"
          x2="-3657.79"
          y2="1107"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-284">
          <path
            class="cls-4"
            d="M211.14,445.67c-.1,0-.1.09-.21.09-.4.2-.6.7-.9.8s-.81.2-1.21.4-.4.79-.6,1.09a3.41,3.41,0,0,0-1,.69c-.2.2-.1.89-.3,1.19s-.7.6-.8.89.1.9,0,1.19-.51.7-.51,1.19.1,1.19.1,1.69.31.6.41.89l-.3,1,.4.2.6-.69c.4-.2.6-.1,1-.2a9.07,9.07,0,0,1,1.4-.69c.31-.2.41-.8.61-1.09s.8-.3,1-.7.1-.89.41-1.19.7-.59.8-.89-.1-.89,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.2,1.2,0,0,0-1-.7l-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-273"
          x1="-3624.27"
          y1="1199.79"
          x2="-3623.87"
          y2="1199.79"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-285">
          <path
            class="cls-4"
            d="M198.36,446.66a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.61,1.09-.11.89.1,1.19.7.59.9.89.1.89.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.61.1,1,.2l.6.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.41-1.19-.8-.4-1.1-.69-.4-.8-.71-1.09a5.27,5.27,0,0,0-1.2-.3c-.41-.2-.61-.7-1-.8h-.3a1.39,1.39,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-274"
          x1="-3657.59"
          y1="1107.03"
          x2="-3657.19"
          y2="1107.03"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-286">
          <path
            class="cls-4"
            d="M257.2,470.36c-.1,0-.1.1-.2.1-.4.2-.6.7-.91.8s-.8.19-1.2.39-.4.8-.61,1.09a3.59,3.59,0,0,0-1,.7c-.2.2-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.69c.4-.2.6-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.81-.29,1-.69.1-.89.4-1.19.71-.6.81-.89-.1-.9,0-1.19.5-.7.6-1.2-.3-.79-.3-1.19.3-.79.3-1.19c0-.09-.1-.09-.1-.19a1.21,1.21,0,0,0-1-.7c-.3-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-275"
          x1="-3623.34"
          y1="1201.37"
          x2="-3622.93"
          y2="1201.37"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-287">
          <path
            class="cls-4"
            d="M244.43,471.36a.31.31,0,0,0-.1.19c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.1-.1.89.1,1.19.7.59.91.89.1.89.5,1.19.8.3,1.11.59.4.8.7,1.09,1.11.5,1.51.7.6.1,1,.2l.61.69.3-.2-.3-.89c.1-.4.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.59-.81-.89-.1-.89-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a4.84,4.84,0,0,0-1.21-.29c-.4-.2-.6-.7-1-.8h-.31a1.33,1.33,0,0,0-1.1.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-276"
          x1="-3655.75"
          y1="1107.02"
          x2="-3655.35"
          y2="1107.02"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-288">
          <path
            class="cls-4"
            d="M273.49,478.3c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09a3.84,3.84,0,0,0-1,.69c-.3.3-.1.9-.3,1.19s-.7.6-.8.9.1.89,0,1.19-.51.69-.51,1.19.1,1.19.1,1.68.3.6.41.9l-.31,1,.41.2.6-.7c.4-.2.6-.1,1-.2a9.07,9.07,0,0,1,1.4-.69c.31-.2.41-.79.61-1.09s.8-.3,1-.7.1-.89.41-1.19.7-.59.8-.89-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.19,1.19,0,0,0-1-.69c-.3-.2-.3-.2-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-277"
          x1="-3622.99"
          y1="1201.91"
          x2="-3622.59"
          y2="1201.91"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-289">
          <path
            class="cls-4"
            d="M260.72,479.29a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.71.6.91.89.1.9.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.5,1.51.69.61.1,1,.2l.6.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.5-.5-.7-.6-1.09s.1-.9,0-1.19-.6-.6-.81-.9-.1-.89-.4-1.19-.8-.39-1.1-.69-.41-.79-.71-1.09a5.23,5.23,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.37,1.37,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-278"
          x1="-3655.11"
          y1="1107"
          x2="-3654.71"
          y2="1107"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-290">
          <path
            class="cls-4"
            d="M227.63,453.6c-.1,0-.1.1-.2.1-.4.2-.6.69-.91.79s-.8.2-1.2.4-.4.79-.61,1.09a3.59,3.59,0,0,0-1,.7c-.3.29-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.7a3.53,3.53,0,0,1,1-.19,9.23,9.23,0,0,1,1.41-.7c.3-.2.4-.79.6-1.09s.81-.3,1-.69.1-.9.4-1.19.71-.6.81-.9-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-279"
          x1="-3623.92"
          y1="1200.33"
          x2="-3623.52"
          y2="1200.33"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-291">
          <path
            class="cls-4"
            d="M214.76,454.59a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.7.6,1.09-.1.9.1,1.19.7.6.91.9.1.89.5,1.19.8.29,1.1.59.41.79.71,1.09a7,7,0,0,0,1.51.7,3.53,3.53,0,0,0,1,.19l.61.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.5-.69-.61-1.09s.11-.89,0-1.19-.6-.6-.8-.89-.1-.9-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.56,1.56,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-280"
          x1="-3656.95"
          y1="1107.01"
          x2="-3656.54"
          y2="1107.01"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-292">
          <path
            class="cls-4"
            d="M242.32,462.13c-.11,0-.11.1-.21.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09-.81.4-1,.7-.1.89-.3,1.19-.7.59-.8.89.1.89,0,1.19-.51.69-.51,1.19.1,1.19.1,1.69.31.59.41.89l-.31,1,.41.2.6-.7a3.53,3.53,0,0,1,1-.19,9.14,9.14,0,0,1,1.4-.7c.31-.2.41-.79.61-1.09s.8-.3,1-.69.1-.9.41-1.19.7-.6.8-.9-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-281"
          x1="-3623.64"
          y1="1200.85"
          x2="-3623.23"
          y2="1200.85"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-293">
          <path
            class="cls-4"
            d="M229.44,463.12a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.7.6,1.09-.1.9.1,1.19.71.6.91.9.1.89.5,1.19.81.29,1.11.59.4.79.7,1.09,1.11.5,1.51.7a3.6,3.6,0,0,0,1,.19l.6.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.5-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.6-.81-.89-.1-.9-.4-1.19-.8-.4-1.1-.7-.41-.79-.71-1.09a5.27,5.27,0,0,0-1.2-.3c-.41-.2-.61-.69-1-.79h-.3a1.56,1.56,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-282"
          x1="-3656.35"
          y1="1107.02"
          x2="-3655.95"
          y2="1107.02"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-294">
          <path
            class="cls-4"
            d="M289.39,463.12c-.1,0-.1.1-.21.1-.4.2-.6.7-.9.8s-.81.19-1.21.39-.4.8-.6,1.09-.81.4-1,.7-.1.89-.3,1.19-.7.59-.8.89.1.89,0,1.19-.51.7-.51,1.19.1,1.19.1,1.69.31.59.41.89l-.3,1,.4.2.6-.69c.4-.2.6-.1,1-.2a9.14,9.14,0,0,1,1.4-.7c.31-.2.41-.79.61-1.09s.8-.3,1-.69.1-.89.41-1.19.7-.6.8-.9-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.19a1.2,1.2,0,0,0-1-.7c-.3-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-283"
          x1="-3622.24"
          y1="1201.75"
          x2="-3621.84"
          y2="1201.75"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-295">
          <path
            class="cls-4"
            d="M276.61,464.11a.35.35,0,0,0-.1.2c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.61,1.09-.11.9.1,1.19.7.6.9.9.1.89.5,1.19.81.3,1.11.59.4.8.7,1.09,1.11.5,1.51.7.61.1,1,.2l.6.69.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.41-1.19-.8-.4-1.1-.7-.41-.79-.71-1.09a5.27,5.27,0,0,0-1.2-.3c-.41-.19-.61-.69-1-.79h-.3a1.35,1.35,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-284"
          x1="-3654.88"
          y1="1106.25"
          x2="-3654.48"
          y2="1106.25"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-296">
          <path
            class="cls-4"
            d="M304,472.25c-.1,0-.1.1-.2.1-.4.2-.6.69-.91.79s-.8.2-1.2.4-.41.79-.61,1.09a3.78,3.78,0,0,0-1,.69c-.2.2-.1.9-.3,1.19s-.71.6-.81.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.6-.7c.41-.2.61-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.81-.3,1-.7.1-.89.4-1.19.7-.59.8-.89-.1-.89,0-1.19.51-.69.61-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69l-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-285"
          x1="-3621.97"
          y1="1202.29"
          x2="-3621.57"
          y2="1202.29"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-297">
          <path
            class="cls-4"
            d="M291.1,473.24a.35.35,0,0,0-.1.2c-.11.4.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.7.6.9.89.1.9.51,1.19.8.3,1.1.6.41.79.71,1.09,1.1.5,1.51.69.6.1,1,.2l.61.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.51-.7-.61-1.09s.1-.9,0-1.19-.6-.6-.8-.9-.1-.89-.4-1.19-.81-.39-1.11-.69-.4-.79-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.54,1.54,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-286"
          x1="-3654.28"
          y1="1106.29"
          x2="-3653.88"
          y2="1106.29"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-298">
          <path
            class="cls-4"
            d="M383.33,511.63c-.1,0-.1.09-.21.09-.4.2-.6.7-.9.8a9.76,9.76,0,0,0-1.21.39c-.3.2-.4.8-.6,1.1a3.41,3.41,0,0,0-1,.69c-.3.3-.1.89-.3,1.19s-.7.6-.8.89.1.9,0,1.19-.51.7-.51,1.19.1,1.19.1,1.69.31.6.41.89l-.3,1,.4.2.6-.69c.4-.2.6-.1,1-.2a9.07,9.07,0,0,1,1.4-.69c.31-.2.41-.8.61-1.1s.8-.29,1-.69.1-.89.41-1.19.7-.59.8-.89-.1-.9,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.2,1.2,0,0,0-1-.7c-.2-.19-.3-.19-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-287"
          x1="-3620.31"
          y1="1204.92"
          x2="-3619.9"
          y2="1204.92"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-299">
          <path
            class="cls-4"
            d="M370.55,512.62a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.61,1.09-.11.89.1,1.19.7.59.9.89.1.89.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.61.1,1,.2l.6.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.41-1.19-.8-.4-1.1-.69-.4-.8-.71-1.1a5.82,5.82,0,0,0-1.2-.29c-.41-.2-.61-.7-1-.8h-.3c-.5.1-1,.3-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-288"
          x1="-3651.16"
          y1="1106.17"
          x2="-3650.76"
          y2="1106.17"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-300">
          <path
            class="cls-4"
            d="M350,497c-.1,0-.1.09-.2.09-.4.2-.6.7-.9.8s-.81.2-1.21.4-.4.79-.6,1.09a3.41,3.41,0,0,0-1,.69c-.2.2-.1.89-.3,1.19s-.7.6-.8.89.1.9,0,1.19-.51.7-.51,1.19.1,1.19.1,1.69.31.6.41.89l-.31,1,.41.2.6-.69c.4-.2.6-.1,1-.2a9.07,9.07,0,0,1,1.4-.69c.31-.2.41-.8.61-1.09s.8-.3,1-.7.1-.89.41-1.19.7-.59.8-.89-.1-.89,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.2,1.2,0,0,0-1-.7c-.3-.19-.3-.19-.41-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-289"
          x1="-3621.04"
          y1="1203.87"
          x2="-3620.64"
          y2="1203.87"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-301">
          <path
            class="cls-4"
            d="M337.26,497.94a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.71.59.91.89.1.89.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.61.1,1,.2l.6.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.81-.89-.1-.89-.4-1.19-.8-.4-1.1-.69-.41-.8-.71-1.09a5.23,5.23,0,0,0-1.21-.3c-.4-.2-.6-.7-1-.8h-.3a1.21,1.21,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-290"
          x1="-3652.44"
          y1="1106.28"
          x2="-3652.04"
          y2="1106.28"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-302">
          <path
            class="cls-4"
            d="M366.33,504.88c-.1,0-.1.1-.2.1-.41.2-.61.69-.91.79s-.8.2-1.21.4-.4.79-.6,1.09a3.59,3.59,0,0,0-1,.7c-.31.29-.1.89-.31,1.19s-.7.59-.8.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.6-.7a3.67,3.67,0,0,1,1-.19,9.23,9.23,0,0,1,1.41-.7c.3-.2.4-.79.6-1.09s.81-.3,1-.69.1-.9.4-1.19.7-.6.8-.9-.1-.89,0-1.19.51-.69.61-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.69c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-291"
          x1="-3620.7"
          y1="1204.41"
          x2="-3620.29"
          y2="1204.41"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-303">
          <path
            class="cls-4"
            d="M353.55,505.87a.35.35,0,0,0-.1.2c-.1.4.31.79.31,1.19s-.31.79-.31,1.19.51.7.61,1.09-.1.9.1,1.19.7.6.9.9.1.89.51,1.19.8.29,1.1.59.4.79.71,1.09,1.1.5,1.51.7a3.53,3.53,0,0,0,1,.19l.6.7.31-.2-.31-.89c.11-.4.31-.6.31-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.6-.8-.89-.1-.9-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.27,1.27,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-292"
          x1="-3651.8"
          y1="1106.25"
          x2="-3651.4"
          y2="1106.25"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-304">
          <path
            class="cls-4"
            d="M320.36,480.18c-.1,0-.1.1-.2.1-.4.2-.6.7-.9.8s-.81.19-1.21.39-.4.8-.6,1.09-.81.4-1,.7-.1.89-.3,1.19-.7.59-.8.89.1.89,0,1.19-.51.7-.51,1.19.1,1.19.1,1.69.3.59.41.89l-.31,1,.41.2.6-.69c.4-.2.6-.1,1-.2a9.71,9.71,0,0,1,1.41-.7c.3-.19.41-.79.61-1.09s.8-.3,1-.69.1-.89.4-1.19.71-.6.81-.89-.1-.9,0-1.2.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.19a1.2,1.2,0,0,0-1-.7.5.5,0,0,0-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-293"
          x1="-3621.62"
          y1="1202.83"
          x2="-3621.22"
          y2="1202.83"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-305">
          <path
            class="cls-4"
            d="M307.59,481.17a.35.35,0,0,0-.1.2c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.09-.1.9.1,1.2.71.59.91.89.1.89.5,1.19.81.3,1.11.59.4.8.7,1.09,1.11.5,1.51.7.6.1,1,.2l.6.69.3-.2-.3-.89c.1-.4.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.81-.89-.1-.89-.4-1.19-.8-.4-1.1-.7-.41-.79-.71-1.09a5.23,5.23,0,0,0-1.21-.3c-.4-.19-.6-.69-1-.79h-.3c-.51.1-1,.3-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-294"
          x1="-3653.63"
          y1="1106.26"
          x2="-3653.23"
          y2="1106.26"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-306">
          <path
            class="cls-4"
            d="M335.05,488.71c-.1,0-.1.1-.2.1-.41.2-.61.7-.91.8a8.23,8.23,0,0,0-1.2.39c-.31.2-.41.8-.61,1.09a3.59,3.59,0,0,0-1,.7c-.31.3-.1.89-.31,1.19s-.7.59-.8.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.6-.69c.41-.2.61-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.81-.3,1-.69.1-.89.4-1.19.7-.6.8-.89-.1-.9,0-1.2.51-.69.61-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.19a1.22,1.22,0,0,0-1-.7c-.2-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-295"
          x1="-3621.34"
          y1="1203.35"
          x2="-3620.93"
          y2="1203.35"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-307">
          <path
            class="cls-4"
            d="M322.27,489.71a.31.31,0,0,0-.1.19c-.1.4.31.8.31,1.19s-.31.8-.31,1.19.51.7.61,1.1-.1.89.1,1.19.7.59.9.89.1.89.51,1.19.8.3,1.1.59.41.8.71,1.09a6.76,6.76,0,0,0,1.51.7c.4.2.6.1,1,.2l.6.69.31-.2-.31-.89c.11-.4.31-.59.31-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5,5,0,0,0-1.21-.29c-.4-.2-.6-.7-1-.8h-.3c-.5.1-1,.3-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-296"
          x1="-3653.04"
          y1="1106.28"
          x2="-3652.63"
          y2="1106.28"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-308">
          <path
            class="cls-4"
            d="M400.93,504.88c-.1,0-.1.1-.2.1-.41.2-.61.69-.91.79s-.8.2-1.21.4-.4.79-.6,1.09a3.8,3.8,0,0,0-1,.7c-.3.29-.1.89-.3,1.19s-.7.59-.8.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.6-.7a3.6,3.6,0,0,1,1-.19,8.8,8.8,0,0,1,1.41-.7c.3-.2.4-.79.6-1.09s.8-.3,1-.69.1-.9.4-1.19.7-.6.8-.9-.1-.89,0-1.19.51-.69.61-1.19-.31-.79-.31-1.19.31-.79.31-1.19c0-.1-.1-.1-.1-.2a1.24,1.24,0,0,0-1-.69c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-297"
          x1="-3619.66"
          y1="1205.04"
          x2="-3619.25"
          y2="1205.04"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-309">
          <path
            class="cls-4"
            d="M388.15,505.87a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.51.7.61,1.09-.1.9.1,1.19.7.6.9.9.1.89.51,1.19.8.29,1.1.59.4.79.71,1.09,1.1.5,1.5.7a3.67,3.67,0,0,0,1,.19l.6.7.31-.2-.31-.89c.1-.4.31-.6.31-1a9.52,9.52,0,0,0,0-1.69c-.11-.4-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.6-.8-.89-.1-.9-.41-1.19-.8-.4-1.1-.7-.4-.79-.71-1.09a5.27,5.27,0,0,0-1.2-.3c-.4-.2-.61-.69-1-.79h-.3a1.26,1.26,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-298"
          x1="-3650.73"
          y1="1105.67"
          x2="-3650.33"
          y2="1105.67"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-310">
          <path
            class="cls-4"
            d="M416.62,497c-.1,0-.1.1-.2.1-.41.2-.61.7-.91.8a10.32,10.32,0,0,0-1.21.39c-.3.2-.4.8-.6,1.1a3.55,3.55,0,0,0-1,.69c-.3.3-.1.89-.3,1.19s-.7.6-.8.89.1.9,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.6-.69c.4-.2.61-.1,1-.2a8,8,0,0,1,1.41-.69c.3-.2.4-.8.6-1.1s.8-.29,1-.69.1-.89.4-1.19.7-.6.8-.89-.1-.9,0-1.19.51-.7.61-1.19-.31-.8-.31-1.19.31-.8.31-1.19c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7c-.2-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-299"
          x1="-3619.04"
          y1="1205.1"
          x2="-3618.64"
          y2="1205.1"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-311">
          <path
            class="cls-4"
            d="M403.84,498.14a.35.35,0,0,0-.1.19c-.1.4.31.8.31,1.19s-.31.8-.31,1.19.51.7.61,1.1-.1.89.1,1.19.7.59.9.89.1.89.51,1.19.8.3,1.1.59.4.8.71,1.1,1.1.49,1.5.69.61.1,1,.2l.6.69.31-.2-.31-.89c.1-.4.31-.59.31-1a9.52,9.52,0,0,0,0-1.69c-.11-.39-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.7-.4-.79-.71-1.09a5.82,5.82,0,0,0-1.2-.29c-.4-.2-.61-.7-1-.8H405a1.1,1.1,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-300"
          x1="-3650.38"
          y1="1105.17"
          x2="-3649.97"
          y2="1105.17"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-312">
          <path
            class="cls-4"
            d="M197.36,411.74c-.1,0-.1.1-.2.1-.41.2-.61.7-.91.8s-.8.19-1.21.39-.4.8-.6,1.09a3.8,3.8,0,0,0-1,.7c-.2.2-.1.89-.3,1.19s-.7.59-.8.89.1.89,0,1.19-.51.7-.51,1.19.11,1.19.11,1.69.3.59.4.89l-.3,1,.4.2.6-.69c.4-.2.61-.1,1-.2a8.8,8.8,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.8-.29,1-.69.11-.89.41-1.19.7-.6.8-.89-.1-.9,0-1.19.5-.7.61-1.19-.31-.8-.31-1.2.31-.79.31-1.19c0-.09-.11-.09-.11-.19a1.2,1.2,0,0,0-1-.7c-.3-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-301"
          x1="-3624.06"
          y1="1198.52"
          x2="-3623.66"
          y2="1198.52"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-313">
          <path
            class="cls-4"
            d="M184.58,412.74a.31.31,0,0,0-.1.19c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.51.7.61,1.1-.1.89.1,1.19.7.59.9.89.1.89.5,1.19.81.3,1.11.59.4.8.71,1.09,1.1.5,1.5.7.61.1,1,.2l.6.69.3-.2-.3-.89c.1-.4.3-.59.3-1a8.66,8.66,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.41-1.19-.8-.4-1.1-.7-.4-.79-.71-1.09a4.77,4.77,0,0,0-1.2-.29c-.41-.2-.61-.7-1-.8h-.3a1.57,1.57,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-302"
          x1="-3658.58"
          y1="1106.22"
          x2="-3658.18"
          y2="1106.22"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-314">
          <path
            class="cls-4"
            d="M211.94,421c-.1,0-.1.1-.2.1-.4.2-.6.69-.91.79s-.8.2-1.2.4-.41.79-.61,1.09a3.78,3.78,0,0,0-1,.69c-.2.2-.1.9-.3,1.19s-.71.6-.81.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.61-.7c.4-.2.6-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.81-.3,1-.7.1-.89.4-1.19.71-.59.81-.89-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.19,1.19,0,0,0-1-.69l-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-303"
          x1="-3623.79"
          y1="1199.06"
          x2="-3623.39"
          y2="1199.06"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-315">
          <path
            class="cls-4"
            d="M199.07,421.86a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.7.6.91.89.1.9.5,1.19.8.3,1.1.6.41.79.71,1.09,1.1.5,1.51.69.6.1,1,.2l.61.7.3-.2L206,431c.1-.4.3-.6.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.5-.7-.61-1.09s.11-.9,0-1.19-.6-.6-.8-.9-.1-.89-.4-1.19-.81-.39-1.11-.69-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.54,1.54,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-304"
          x1="-3657.98"
          y1="1106.26"
          x2="-3657.58"
          y2="1106.26"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-316">
          <path
            class="cls-4"
            d="M258,445.57c-.11,0-.11.1-.21.1-.4.19-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09-.81.39-1,.69-.1.89-.3,1.19-.7.6-.8.89.1.9,0,1.19-.51.7-.51,1.19.1,1.2.1,1.69.31.6.41.89l-.31,1,.41.19.6-.69c.4-.2.6-.1,1-.2a9.07,9.07,0,0,1,1.4-.69c.31-.2.41-.8.61-1.09s.8-.3,1-.7.1-.89.41-1.19.7-.59.8-.89-.1-.89,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.2,1.2,0,0,0-1-.7c-.3-.19-.3-.19-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-305"
          x1="-3622.86"
          y1="1200.65"
          x2="-3622.46"
          y2="1200.65"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-317">
          <path
            class="cls-4"
            d="M245.23,446.56a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.11,1.19.7.59.9.89.1.89.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.61.1,1,.2l.6.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.5-.7-.6-1.1s.1-.89,0-1.19-.6-.59-.8-.89-.11-.89-.41-1.19-.8-.4-1.1-.69-.41-.8-.71-1.09a5.27,5.27,0,0,0-1.2-.3c-.41-.2-.61-.7-1-.8h-.3a1.22,1.22,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-306"
          x1="-3656.14"
          y1="1106.24"
          x2="-3655.74"
          y2="1106.24"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-318">
          <path
            class="cls-4"
            d="M274.3,453.5c-.1,0-.1.1-.2.1-.4.2-.61.7-.91.79s-.8.2-1.2.4-.41.79-.61,1.09a3.59,3.59,0,0,0-1,.7c-.31.29-.1.89-.31,1.19s-.7.59-.8.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.6-.7c.41-.19.61-.09,1-.19a9.23,9.23,0,0,1,1.41-.7c.3-.2.4-.79.6-1.09s.81-.3,1-.69.1-.9.4-1.19.7-.6.8-.9-.1-.89,0-1.19.51-.69.61-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.69c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-307"
          x1="-3622.52"
          y1="1201.18"
          x2="-3622.12"
          y2="1201.18"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-319">
          <path
            class="cls-4"
            d="M261.53,454.49a.35.35,0,0,0-.1.2c-.11.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.09-.1.9.1,1.19.7.6.9.9.1.89.51,1.19.8.29,1.1.59.41.8.71,1.09,1.1.5,1.51.7.6.1,1,.2l.61.69.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.6-.8-.89-.1-.9-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.19-.6-.69-1-.79h-.3c-.6.2-1,.4-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-308"
          x1="-3655.5"
          y1="1106.22"
          x2="-3655.1"
          y2="1106.22"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-320">
          <path
            class="cls-4"
            d="M228.33,428.8c-.1,0-.1.1-.2.1-.4.2-.6.7-.9.8s-.81.19-1.21.39-.4.8-.6,1.09-.81.4-1,.7-.1.89-.3,1.19-.7.59-.8.89.1.89,0,1.19-.51.7-.51,1.19.1,1.19.1,1.69.31.59.41.89l-.31,1,.41.2.6-.69c.4-.2.6-.1,1-.2a9.14,9.14,0,0,1,1.4-.7c.31-.19.41-.79.61-1.09s.8-.29,1-.69.1-.89.41-1.19.7-.6.8-.89-.1-.9,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.2c0-.09-.1-.09-.1-.19a1.2,1.2,0,0,0-1-.7c-.2-.2-.3-.2-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-309"
          x1="-3623.44"
          y1="1199.6"
          x2="-3623.04"
          y2="1199.6"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-321">
          <path
            class="cls-4"
            d="M215.56,429.8a.31.31,0,0,0-.1.19c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.1-.1.89.1,1.19.71.59.91.89.1.89.5,1.19.81.3,1.11.59.4.8.7,1.1,1.11.49,1.51.69.61.1,1,.2l.6.69.3-.2-.3-.89c.1-.4.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.6-.59-.81-.89-.1-.89-.4-1.19-.8-.4-1.1-.7-.41-.79-.71-1.09a4.77,4.77,0,0,0-1.2-.29c-.41-.2-.61-.7-1-.8h-.3a1.55,1.55,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-310"
          x1="-3657.34"
          y1="1106.23"
          x2="-3656.94"
          y2="1106.23"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-322">
          <path
            class="cls-4"
            d="M243,437.33c-.1,0-.1.1-.2.1-.4.2-.61.7-.91.8s-.8.2-1.2.39-.41.8-.61,1.09a3.59,3.59,0,0,0-1,.7c-.31.3-.1.89-.31,1.19s-.7.59-.8.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.6-.69c.41-.2.61-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.81-.29,1-.69.1-.89.4-1.19.7-.6.8-.89-.1-.9,0-1.19.51-.7.61-1.19-.3-.8-.3-1.19.3-.8.3-1.2c0-.09-.1-.09-.1-.19a1.22,1.22,0,0,0-1-.7c-.2-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-311"
          x1="-3623.16"
          y1="1200.12"
          x2="-3622.76"
          y2="1200.12"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-323">
          <path
            class="cls-4"
            d="M230.25,438.43a.31.31,0,0,0-.1.19c-.11.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.1-.1.89.1,1.19.7.59.9.89.11.89.51,1.19.8.3,1.1.59.41.8.71,1.09,1.1.5,1.51.7.6.1,1,.2l.61.69.3-.2-.3-.89c.1-.4.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5,5,0,0,0-1.21-.29c-.4-.2-.6-.7-1-.8h-.3a1.08,1.08,0,0,0-1.1.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-312"
          x1="-3656.74"
          y1="1106.25"
          x2="-3656.34"
          y2="1106.25"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-324">
          <path
            class="cls-4"
            d="M288.18,437.14c-.1,0-.1.09-.2.09-.4.2-.61.7-.91.8s-.8.2-1.2.4-.41.79-.61,1.09a3.37,3.37,0,0,0-1,.69c-.2.2-.1.89-.31,1.19s-.7.6-.8.89.1.9,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.6.4.89l-.3,1,.4.2.6-.69c.41-.2.61-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.1s.81-.29,1-.69.1-.89.4-1.19.7-.59.8-.89-.1-.9,0-1.19.51-.7.61-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.7c-.3-.19-.3-.19-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-313"
          x1="-3621.8"
          y1="1200.95"
          x2="-3621.4"
          y2="1200.95"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-325">
          <path
            class="cls-4"
            d="M275.41,438.13a.34.34,0,0,0-.11.2c-.1.39.31.79.31,1.19s-.31.79-.31,1.19.51.69.61,1.09-.1.89.1,1.19.7.59.9.89.1.89.51,1.19.8.3,1.1.6.41.79.71,1.09,1.1.49,1.51.69.6.1,1,.2l.61.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.51-.69-.61-1.09s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.69-.4-.8-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.2-.6-.7-1-.8h-.3a1.55,1.55,0,0,0-1.1.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-314"
          x1="-3655.35"
          y1="1105.47"
          x2="-3654.95"
          y2="1105.47"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-326">
          <path
            class="cls-4"
            d="M302.76,446.36c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09a3.68,3.68,0,0,0-1,.69c-.2.2-.1.9-.3,1.2s-.71.59-.81.89.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.61-.7c.4-.2.6-.1,1-.2a10.75,10.75,0,0,1,1.41-.69c.3-.2.4-.79.61-1.09s.8-.3,1-.69.1-.9.4-1.2.71-.59.81-.89-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69l-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-315"
          x1="-3621.53"
          y1="1201.49"
          x2="-3621.13"
          y2="1201.49"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-327">
          <path
            class="cls-4"
            d="M289.89,447.25a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.7.6,1.09-.1.9.1,1.19.71.6.91.9.1.89.5,1.19.8.29,1.11.59.4.79.7,1.09,1.11.5,1.51.7a3.53,3.53,0,0,0,1,.19l.6.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.4-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.6-.81-.89-.1-.9-.4-1.19-.8-.4-1.11-.7-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79H291a1.56,1.56,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-316"
          x1="-3654.75"
          y1="1105.51"
          x2="-3654.35"
          y2="1105.51"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-328">
          <path
            class="cls-4"
            d="M382.12,485.64c-.1,0-.1.1-.2.1-.4.2-.61.69-.91.79a8.4,8.4,0,0,0-1.2.4c-.31.2-.41.79-.61,1.09a3.78,3.78,0,0,0-1,.69c-.31.3-.1.9-.31,1.19s-.7.6-.8.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.6-.7c.41-.2.61-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.79.6-1.09s.81-.3,1-.7.1-.89.4-1.19.7-.59.8-.89-.1-.89,0-1.19.51-.69.61-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69c-.2-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-317"
          x1="-3619.87"
          y1="1204.12"
          x2="-3619.47"
          y2="1204.12"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-329">
          <path
            class="cls-4"
            d="M369.35,486.73a.34.34,0,0,0-.11.2c-.1.39.31.79.31,1.19s-.31.79-.31,1.19.51.69.61,1.09-.1.89.1,1.19.7.59.9.89.1.9.51,1.19.8.3,1.1.6.41.79.71,1.09,1.1.49,1.51.69.6.1,1,.2l.61.7.3-.2-.3-.9c.1-.39.3-.59.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.51-.7-.61-1.09s.1-.9,0-1.19-.6-.6-.8-.9-.1-.89-.4-1.19-.81-.39-1.11-.69-.4-.8-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.16,1.16,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-318"
          x1="-3651.63"
          y1="1105.39"
          x2="-3651.23"
          y2="1105.39"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-330">
          <path
            class="cls-4"
            d="M348.83,471c-.1,0-.1.1-.2.1-.41.2-.61.69-.91.79s-.8.2-1.21.4-.4.79-.6,1.09a3.78,3.78,0,0,0-1,.69c-.21.2-.11.9-.31,1.19s-.7.6-.8.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.6-.7c.41-.2.61-.1,1-.2a8.73,8.73,0,0,1,1.41-.69c.3-.2.4-.79.6-1.09s.8-.3,1-.7.1-.89.4-1.19.7-.59.8-.89-.1-.89,0-1.19.51-.69.61-1.19-.31-.79-.31-1.19.31-.79.31-1.19c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.69c-.3-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-319"
          x1="-3620.6"
          y1="1203.07"
          x2="-3620.2"
          y2="1203.07"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-331">
          <path
            class="cls-4"
            d="M336.05,472a.35.35,0,0,0-.1.2c-.1.4.31.79.31,1.19s-.31.79-.31,1.19.51.69.61,1.09-.1.89.1,1.19.7.6.9.89.1.9.51,1.19.8.3,1.1.6.4.79.71,1.09,1.1.5,1.5.69.61.1,1,.2l.6.7.31-.2-.31-.89c.1-.4.31-.6.31-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.51-.7-.61-1.09s.1-.9,0-1.19-.6-.6-.8-.9-.1-.89-.4-1.19-.81-.39-1.11-.69-.4-.79-.71-1.09a5.27,5.27,0,0,0-1.2-.3c-.4-.2-.61-.69-1-.79h-.3a1.21,1.21,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-320"
          x1="-3652.91"
          y1="1105.49"
          x2="-3652.51"
          y2="1105.49"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-332">
          <path
            class="cls-4"
            d="M365.12,478.89c-.1,0-.1.1-.2.1-.4.2-.6.7-.91.8s-.8.19-1.2.39-.4.8-.61,1.09a3.59,3.59,0,0,0-1,.7c-.3.3-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.69c.4-.2.6-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.81-.29,1-.69.1-.89.4-1.19.71-.6.81-.89-.1-.9,0-1.19.5-.7.6-1.19-.3-.8-.3-1.2.3-.79.3-1.19c0-.09-.1-.09-.1-.19a1.21,1.21,0,0,0-1-.7c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-321"
          x1="-3620.26"
          y1="1203.61"
          x2="-3619.85"
          y2="1203.61"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-333">
          <path
            class="cls-4"
            d="M352.35,479.89a.31.31,0,0,0-.1.19c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.1-.1.89.1,1.19.71.59.91.89.1.89.5,1.19.8.3,1.11.59.4.8.7,1.09,1.11.5,1.51.7.6.1,1,.2l.61.69.3-.2-.3-.89c.1-.4.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.59-.81-.89-.1-.89-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a4.84,4.84,0,0,0-1.21-.29c-.4-.2-.6-.7-1-.8h-.31c-.6.2-1,.4-1.1.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-322"
          x1="-3652.27"
          y1="1105.47"
          x2="-3651.87"
          y2="1105.47"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-334">
          <path
            class="cls-4"
            d="M319.16,454.2c-.1,0-.1.1-.2.1-.41.19-.61.69-.91.79s-.8.2-1.21.4-.4.79-.6,1.09a3.55,3.55,0,0,0-1,.69c-.3.3-.1.89-.3,1.19s-.7.6-.8.89.1.9,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.6.4.89l-.3,1,.4.2.6-.69c.4-.2.61-.1,1-.2a8.73,8.73,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.8-.3,1-.7.1-.89.4-1.19.7-.59.8-.89-.1-.89,0-1.19.51-.7.61-1.19-.31-.8-.31-1.19.31-.8.31-1.19c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7c-.2-.19-.3-.19-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-323"
          x1="-3621.18"
          y1="1202.02"
          x2="-3620.78"
          y2="1202.02"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-335">
          <path
            class="cls-4"
            d="M306.38,455.19a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.51.69.61,1.09-.1.89.1,1.19.7.59.9.89.1.89.51,1.19.8.3,1.1.6.4.79.71,1.09,1.1.49,1.5.69.61.1,1,.2l.6.69.31-.19-.31-.9c.1-.39.31-.59.31-1a9.41,9.41,0,0,0,0-1.68c-.11-.5-.51-.7-.61-1.1s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.41-1.19-.8-.4-1.1-.69-.4-.8-.71-1.09a5.27,5.27,0,0,0-1.2-.3c-.4-.2-.61-.7-1-.8h-.3a1.57,1.57,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-324"
          x1="-3654.11"
          y1="1105.48"
          x2="-3653.7"
          y2="1105.48"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-336">
          <path
            class="cls-4"
            d="M333.84,462.73c-.1,0-.1.1-.2.1-.4.19-.6.69-.9.79s-.81.2-1.21.4-.4.79-.61,1.09a3.37,3.37,0,0,0-1,.69c-.3.3-.1.89-.3,1.19s-.71.6-.81.89.1.9,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.6.4.89l-.3,1,.4.19.61-.69c.4-.2.6-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.81-.3,1-.7.1-.89.4-1.19.71-.59.81-.89-.1-.89,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7c-.2-.19-.3-.19-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-325"
          x1="-3620.9"
          y1="1202.55"
          x2="-3620.5"
          y2="1202.55"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-337">
          <path
            class="cls-4"
            d="M321.07,463.82a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.71.59.91.89.1.89.5,1.19.8.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.6.1,1,.2l.61.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.59-.81-.89-.1-.89-.4-1.19-.81-.4-1.11-.69-.4-.8-.7-1.1a5.91,5.91,0,0,0-1.21-.29c-.4-.2-.6-.7-1-.8h-.31a1.17,1.17,0,0,0-1.1.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-326"
          x1="-3653.51"
          y1="1105.5"
          x2="-3653.11"
          y2="1105.5"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-338">
          <path
            class="cls-4"
            d="M399.72,478.89c-.1,0-.1.1-.2.1-.4.2-.6.7-.91.8a8.23,8.23,0,0,0-1.2.39c-.3.2-.41.8-.61,1.09a3.59,3.59,0,0,0-1,.7c-.3.3-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.69c.4-.2.6-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.81-.29,1-.69.1-.89.4-1.19.7-.6.81-.89-.11-.9,0-1.19.5-.7.6-1.19-.3-.8-.3-1.2.3-.79.3-1.19c0-.09-.1-.09-.1-.19a1.22,1.22,0,0,0-1-.7c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-327"
          x1="-3619.22"
          y1="1204.24"
          x2="-3618.82"
          y2="1204.24"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-339">
          <path
            class="cls-4"
            d="M387,480a.35.35,0,0,0-.1.2c-.1.4.3.8.3,1.19s-.3.8-.3,1.19.5.7.6,1.09-.1.9.1,1.19.7.6.91.9.1.89.5,1.19.8.3,1.1.59.41.8.71,1.09,1.11.5,1.51.7.6.1,1,.2l.61.69.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.61-1.09s.11-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.7-.4-.79-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.19-.6-.69-1-.79h-.3a1.09,1.09,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-328"
          x1="-3651.21"
          y1="1104.89"
          x2="-3650.8"
          y2="1104.89"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-340">
          <path
            class="cls-4"
            d="M415.41,471.06c-.1,0-.1.1-.2.1-.4.2-.6.69-.91.79s-.8.2-1.2.4-.41.79-.61,1.09a3.78,3.78,0,0,0-1,.69c-.3.3-.1.9-.3,1.19s-.71.6-.81.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.89l-.3,1,.4.2.61-.7c.4-.2.6-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.81-.3,1-.7.1-.89.4-1.19.71-.59.81-.89-.11-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69c-.2-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-329"
          x1="-3618.6"
          y1="1204.29"
          x2="-3618.2"
          y2="1204.29"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-341">
          <path
            class="cls-4"
            d="M402.64,472.15a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.7.59.91.89.1.89.5,1.19.8.3,1.1.6.41.79.71,1.09,1.11.49,1.51.69.6.1,1,.2l.61.7.3-.2-.3-.9c.1-.39.3-.59.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.5-.7-.6-1.09s.1-.9,0-1.2-.61-.59-.81-.89-.1-.89-.4-1.19-.81-.39-1.11-.69-.4-.8-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.7-1-.79h-.31a1.16,1.16,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-330"
          x1="-3650.85"
          y1="1104.38"
          x2="-3650.45"
          y2="1104.38"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-342">
          <path
            class="cls-4"
            d="M196.25,385.76c-.1,0-.1.1-.2.1-.4.19-.6.69-.91.79s-.8.2-1.2.4-.41.79-.61,1.09-.8.39-1,.69-.1.89-.3,1.19-.71.6-.81.89.1.9,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.6.4.89l-.3,1,.4.19.61-.69c.4-.2.6-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.81-.3,1-.7.1-.89.4-1.19.7-.59.81-.89-.11-.89,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.22,1.22,0,0,0-1-.7l-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-331"
          x1="-3623.62"
          y1="1197.72"
          x2="-3623.22"
          y2="1197.72"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-343">
          <path
            class="cls-4"
            d="M183.38,386.75a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.7.59.91.89.1.89.5,1.19.8.3,1.1.6.41.79.71,1.09,1.1.49,1.51.69.6.1,1,.2l.61.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.5-.5-.7-.61-1.1s.11-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.69-.4-.8-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.7-1-.8h-.3a1.55,1.55,0,0,0-1.1.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-332"
          x1="-3659.06"
          y1="1105.44"
          x2="-3658.66"
          y2="1105.44"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-344">
          <path
            class="cls-4"
            d="M210.73,395c-.1,0-.1.1-.2.1-.4.2-.6.69-.9.79s-.81.2-1.21.4-.4.79-.6,1.09-.81.4-1,.7-.1.89-.3,1.19-.7.59-.81.89.11.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.41.2.6-.7a3.53,3.53,0,0,1,1-.19,9.71,9.71,0,0,1,1.41-.7c.3-.2.4-.79.61-1.09s.8-.3,1-.69.1-.9.4-1.19.71-.6.81-.9-.1-.89,0-1.19.5-.69.6-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.69l-.41-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-333"
          x1="-3623.35"
          y1="1198.26"
          x2="-3622.95"
          y2="1198.26"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-345">
          <path
            class="cls-4"
            d="M198,396a.35.35,0,0,0-.1.2c-.1.4.3.79.3,1.19s-.3.79-.3,1.19.5.7.6,1.09-.1.9.1,1.19.71.6.91.9.1.89.5,1.19.81.29,1.11.59.4.79.7,1.09,1.11.5,1.51.7a3.53,3.53,0,0,0,1,.19l.6.7.3-.2-.3-.89c.1-.4.3-.6.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.5-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.6-.81-.89-.1-.9-.4-1.19-.8-.4-1.1-.7-.41-.79-.71-1.09a5.23,5.23,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3A1.11,1.11,0,0,0,198,396"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-334"
          x1="-3658.46"
          y1="1105.48"
          x2="-3658.06"
          y2="1105.48"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-346">
          <path
            class="cls-4"
            d="M256.8,419.58c-.1,0-.1.1-.2.1-.4.2-.61.69-.91.79s-.8.2-1.2.4-.41.79-.61,1.09a3.78,3.78,0,0,0-1,.69c-.21.2-.1.9-.31,1.19s-.7.6-.8.9.1.89,0,1.19-.5.69-.5,1.19.1,1.19.1,1.68.3.6.4.9l-.3,1,.4.2.6-.7c.41-.2.61-.1,1-.2a10.17,10.17,0,0,1,1.41-.69c.3-.2.4-.79.6-1.09s.81-.3,1-.7.1-.89.4-1.19.7-.59.8-.89-.1-.89,0-1.19.51-.69.61-1.19-.3-.79-.3-1.19.3-.79.3-1.19c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.69c-.3-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-335"
          x1="-3622.42"
          y1="1199.84"
          x2="-3622.02"
          y2="1199.84"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-347">
          <path
            class="cls-4"
            d="M244,420.57a.34.34,0,0,0-.11.2c-.1.4.31.79.31,1.19s-.31.79-.31,1.19.51.69.61,1.09-.1.89.1,1.19.7.6.9.89.1.9.51,1.19.8.3,1.1.6.41.79.71,1.09,1.1.5,1.51.69.6.1,1,.2l.6.7.31-.2-.31-.89c.11-.4.31-.6.31-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.51-.7-.61-1.09s.1-.9,0-1.19-.6-.6-.8-.9-.1-.89-.4-1.19-.81-.39-1.11-.69-.4-.79-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.2-.6-.69-1-.79h-.3a1.36,1.36,0,0,0-1.1.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-336"
          x1="-3656.62"
          y1="1105.46"
          x2="-3656.22"
          y2="1105.46"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-348">
          <path
            class="cls-4"
            d="M273.09,427.51c-.1,0-.1.1-.2.1-.4.2-.6.7-.9.8s-.81.2-1.21.39-.4.8-.6,1.09a3.5,3.5,0,0,0-1,.7c-.3.3-.1.89-.3,1.19s-.71.59-.81.89.1.89,0,1.19-.5.7-.5,1.19.1,1.19.1,1.69.3.59.4.89l-.3,1,.4.2.61-.69c.4-.2.6-.1,1-.2a9.23,9.23,0,0,1,1.41-.7c.3-.19.4-.79.6-1.09s.81-.29,1-.69.1-.89.4-1.19.71-.6.81-.89-.1-.9,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.21,1.21,0,0,0-1-.7c-.3-.2-.4-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-337"
          x1="-3622.08"
          y1="1200.38"
          x2="-3621.68"
          y2="1200.38"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-349">
          <path
            class="cls-4"
            d="M260.32,428.51a.35.35,0,0,0-.1.19c-.1.4.3.8.3,1.19s-.3.8-.3,1.2.5.69.6,1.09-.1.89.1,1.19.71.59.91.89.1.89.5,1.19.8.3,1.11.59.4.8.7,1.1,1.11.49,1.51.69.6.1,1,.2l.6.69.3-.2-.3-.89c.1-.4.3-.59.3-1a9.52,9.52,0,0,0,0-1.69c-.1-.39-.5-.69-.6-1.09s.1-.89,0-1.19-.61-.59-.81-.89-.1-.89-.4-1.19-.8-.4-1.11-.7-.4-.79-.7-1.09a5.91,5.91,0,0,0-1.21-.29c-.4-.2-.6-.7-1-.8h-.3c-.51.2-1,.4-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-338"
          x1="-3655.98"
          y1="1105.44"
          x2="-3655.58"
          y2="1105.44"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-350">
          <path
            class="cls-4"
            d="M227.13,402.82c-.1,0-.1.1-.2.1-.41.19-.61.69-.91.79s-.8.2-1.21.4-.4.79-.6,1.09-.8.39-1,.69-.11.89-.31,1.19-.7.6-.8.89.1.9,0,1.19-.5.7-.5,1.19.1,1.2.1,1.69.3.6.4.89l-.3,1,.4.19.6-.69c.41-.2.61-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.8-.3,1-.7.1-.89.4-1.19.7-.59.8-.89-.1-.89,0-1.19.51-.7.61-1.19-.31-.8-.31-1.19.31-.8.31-1.19c0-.1-.1-.1-.1-.2a1.23,1.23,0,0,0-1-.7c-.2-.19-.3-.19-.4-.19"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-339"
          x1="-3623"
          y1="1198.8"
          x2="-3622.6"
          y2="1198.8"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-351">
          <path
            class="cls-4"
            d="M214.35,403.81a.35.35,0,0,0-.1.2c-.1.39.31.79.31,1.19s-.31.79-.31,1.19.51.69.61,1.09-.1.89.1,1.19.7.59.9.89.1.89.51,1.19.8.3,1.1.6.4.79.71,1.09,1.1.49,1.51.69.6.1,1,.2l.6.69.31-.19-.31-.9c.1-.39.31-.59.31-1a9.41,9.41,0,0,0,0-1.68c-.1-.5-.51-.7-.61-1.1s.1-.89,0-1.19-.6-.59-.8-.89-.1-.89-.4-1.19-.81-.4-1.11-.69-.4-.8-.7-1.09a5.49,5.49,0,0,0-1.21-.3c-.4-.2-.61-.7-1-.79h-.3a1.55,1.55,0,0,0-1.11.79"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-340"
          x1="-3657.81"
          y1="1105.45"
          x2="-3657.41"
          y2="1105.45"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <clipPath id="clip-path-352">
          <path
            class="cls-4"
            d="M241.81,411.35c-.1,0-.1.1-.2.1-.4.19-.6.69-.9.79a8.09,8.09,0,0,0-1.21.4c-.3.19-.4.79-.6,1.09s-.81.39-1,.69-.1.89-.3,1.19-.71.6-.81.89.1.9,0,1.19-.5.7-.5,1.2.1,1.19.1,1.68.3.6.4.89l-.3,1,.4.19.61-.69c.4-.2.6-.1,1-.2a9.16,9.16,0,0,1,1.41-.69c.3-.2.4-.8.6-1.09s.81-.3,1-.7.1-.89.4-1.19.71-.59.81-.89-.1-.89,0-1.19.5-.7.6-1.19-.3-.8-.3-1.19.3-.8.3-1.19c0-.1-.1-.1-.1-.2a1.19,1.19,0,0,0-1-.69c-.2-.2-.3-.2-.4-.2"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-341"
          x1="-3622.72"
          y1="1199.33"
          x2="-3622.32"
          y2="1199.33"
          gradientTransform="translate(70435.33 -82347.73) rotate(-31.38) scale(28.44)"
          xlink:href="#linear-gradient"
        />
        <clipPath id="clip-path-353">
          <path
            class="cls-4"
            d="M229,412.44a.35.35,0,0,0-.1.2c-.1.39.3.79.3,1.19s-.3.79-.3,1.19.5.69.6,1.09-.1.89.1,1.19.71.59.91.89.1.89.5,1.19.81.3,1.11.6.4.79.7,1.09,1.11.49,1.51.69.6.1,1,.2l.6.69.3-.19-.3-.9c.1-.39.3-.59.3-1a9.41,9.41,0,0,0,0-1.68c-.1-.4-.5-.7-.6-1.1s.1-.89,0-1.19-.61-.59-.81-.89-.1-.89-.4-1.19-.8-.4-1.11-.69-.4-.8-.7-1.09a5.35,5.35,0,0,0-1.21-.3c-.4-.2-.6-.7-1-.8h-.3a1.17,1.17,0,0,0-1.11.8"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-342"
          x1="-3657.21"
          y1="1105.46"
          x2="-3656.81"
          y2="1105.46"
          gradientTransform="translate(106589.68 22639.32) rotate(28.62) scale(28.44)"
          xlink:href="#linear-gradient-2"
        />
        <mask
          id="mask-7"
          x="775.55"
          y="189.01"
          width="91.63"
          height="226.75"
          maskUnits="userSpaceOnUse"
        >
          <polygon
            class="cls-1"
            points="867.17 362.86 775.55 415.76 775.55 241.91 867.17 189.01 867.17 362.86"
          />
        </mask>
        <clipPath id="clip-path-354">
          <path
            class="cls-6"
            d="M735.2,120.45l-68.08-39.6a14.61,14.61,0,0,0-6.61,11.46l68.07,39.59A14.56,14.56,0,0,1,735.2,120.45Z"
          />
        </clipPath>
        <clipPath id="clip-path-355">
          <path
            class="cls-6"
            d="M835.2,178.45l-68.08-39.6a14.61,14.61,0,0,0-6.61,11.46l68.07,39.59A14.56,14.56,0,0,1,835.2,178.45Z"
          />
        </clipPath>
        <clipPath id="clip-path-356">
          <path
            class="cls-6"
            d="M640.2,65.45l-68.08-39.6a14.61,14.61,0,0,0-6.61,11.46L633.58,76.9A14.56,14.56,0,0,1,640.2,65.45Z"
          />
        </clipPath>
        <linearGradient
          id="SVGID_19"
          x1="-1549.28"
          y1="229.03"
          x2="-1548.33"
          y2="231.2"
          gradientTransform="matrix(-1, 0, 0, 1, -705.08, 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#bfc4d1" />
          <stop offset="0.55" stop-color="#9ca0b1" />
          <stop offset="1" stop-color="#7c8094" />
        </linearGradient>
        <linearGradient
          id="SVGID_19-2"
          x1="-1517.01"
          y1="247.66"
          x2="-1516.06"
          y2="249.83"
          gradientTransform="matrix(-0.6, -0.8, -0.8, 0.6, 98.65, -1112.81)"
          xlink:href="#SVGID_19"
        />
        <linearGradient
          id="SVGID_19-3"
          x1="-1549.28"
          y1="260.99"
          x2="-1548.33"
          y2="263.16"
          xlink:href="#SVGID_19"
        />
        <linearGradient
          id="SVGID_19-4"
          x1="-1517.01"
          y1="279.62"
          x2="-1516.06"
          y2="281.79"
          xlink:href="#SVGID_19"
        />
        <linearGradient
          id="SVGID_8"
          x1="-1545.16"
          y1="249.54"
          x2="-1534.31"
          y2="249.54"
          gradientTransform="matrix(-1, 0, 0, 1, -705.08, 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#e3e9f8" />
          <stop offset="1" stop-color="#7c8094" />
        </linearGradient>
        <linearGradient
          id="SVGID_8-2"
          x1="-1535.9"
          y1="253.18"
          x2="-1517.94"
          y2="253.18"
          xlink:href="#SVGID_8"
        />
        <linearGradient
          id="SVGID_8-3"
          x1="-1530.62"
          y1="264.84"
          x2="-1527.2"
          y2="264.84"
          xlink:href="#SVGID_8"
        />
        <linearGradient
          id="SVGID_9"
          x1="-1534.36"
          y1="256.11"
          x2="-1530.81"
          y2="256.11"
          gradientTransform="matrix(-1, 0, 0, 1, -705.08, 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#7c8094" />
          <stop offset="1" stop-color="#e3e9f8" />
        </linearGradient>
        <linearGradient
          id="SVGID_9-2"
          x1="-1549.57"
          y1="256.49"
          x2="-1520.26"
          y2="256.49"
          xlink:href="#SVGID_9"
        />
        <linearGradient
          id="SVGID_8-4"
          x1="-1540.59"
          y1="238.6"
          x2="-1517.07"
          y2="265.64"
          xlink:href="#SVGID_8"
        />
        <mask
          id="mask-8"
          x="618.66"
          y="103.19"
          width="116.41"
          height="61.81"
          maskUnits="userSpaceOnUse"
        >
          <use transform="translate(618 103)" xlink:href="#image" />
        </mask>
        <image
          id="image"
          width="118"
          height="59"
          xlink:href="data:image/png;base64,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"
        />
        <mask
          id="mask-9"
          x="523.66"
          y="49.19"
          width="116.41"
          height="61.81"
          maskUnits="userSpaceOnUse"
        >
          <use transform="translate(523 49)" xlink:href="#image" />
        </mask>
        <mask
          id="mask-10"
          x="718.66"
          y="162.19"
          width="116.41"
          height="61.81"
          maskUnits="userSpaceOnUse"
        >
          <use transform="translate(718 162)" xlink:href="#image" />
        </mask>
      </defs>
      <g class="cls-7">
        <g id="Layer_1" data-name="Layer 1">
          <polygon
            class="cls-8"
            points="5.21 487.72 5.21 451.46 404.69 682.11 404.69 718.37 5.21 487.72"
          />
          <polygon
            class="cls-9"
            points="5.21 451.46 558.51 131.38 958 362.03 404.69 682.11 5.21 451.46"
          />
          <polygon
            class="cls-10"
            points="958 362.03 958 398.29 404.69 718.37 404.69 682.11 958 362.03"
          />
          <polygon
            class="cls-11"
            points="103 449 560 184 861 360 406 624 103 449"
          />
          <g class="cls-12">
            <polygon
              class="cls-13"
              points="561.7 173.16 470.07 226.06 470.07 52.21 561.7 -0.69 561.7 173.16"
            />
          </g>
          <path
            class="cls-14"
            d="M462.79,233.19a1.23,1.23,0,0,1-1.25-1.25V59.68a1.24,1.24,0,0,1,.62-1.08L553.79,5.7a1.25,1.25,0,0,1,1.87,1.08V179a1.25,1.25,0,0,1-.62,1.08L463.41,233A1.25,1.25,0,0,1,462.79,233.19ZM464,60.4V229.78l89.13-51.46V9ZM554.41,179h0Z"
          />
          <path
            class="cls-15"
            d="M466.81,237.75a3.09,3.09,0,0,1-1.56-.41,3.14,3.14,0,0,1-1.56-2.71V62.37a3.14,3.14,0,0,1,1.56-2.71l91.63-52.9a3.12,3.12,0,0,1,4.68,2.71V181.73a3.1,3.1,0,0,1-1.56,2.7l-91.62,52.91A3.15,3.15,0,0,1,466.81,237.75Zm3.13-173.58V229.22l85.38-49.29v-165Zm88.5,117.56h0Z"
          />
          <g class="cls-16">
            <polygon
              class="cls-13"
              points="466.15 235.1 374.52 288 374.52 114.15 466.15 61.25 466.15 235.1"
            />
          </g>
          <path
            class="cls-14"
            d="M371.23,286.14a1.26,1.26,0,0,1-1.25-1.25V112.63a1.26,1.26,0,0,1,.63-1.09l91.63-52.9a1.25,1.25,0,0,1,1.24,0,1.26,1.26,0,0,1,.63,1.08V232a1.25,1.25,0,0,1-.63,1.08L371.86,286A1.27,1.27,0,0,1,371.23,286.14Zm1.25-172.79V282.72l89.13-51.45V61.89ZM462.86,232h0Z"
          />
          <path
            class="cls-15"
            d="M375.26,290.7a3.12,3.12,0,0,1-3.12-3.13V115.31a3.1,3.1,0,0,1,1.56-2.7l91.63-52.9a3.12,3.12,0,0,1,4.68,2.7V234.67a3.12,3.12,0,0,1-1.56,2.71l-91.63,52.9A3.1,3.1,0,0,1,375.26,290.7Zm3.13-173.59V282.16l85.38-49.29v-165Zm88.5,117.56h0Z"
          />
          <g class="cls-17">
            <polygon
              class="cls-13"
              points="374.12 288.33 282.5 341.23 282.5 167.38 374.12 114.48 374.12 288.33"
            />
          </g>
          <path
            class="cls-14"
            d="M279.21,339.37a1.26,1.26,0,0,1-1.25-1.25V165.85a1.26,1.26,0,0,1,.63-1.08l91.62-52.9a1.26,1.26,0,0,1,1.88,1.08V285.22a1.26,1.26,0,0,1-.63,1.08l-91.62,52.9A1.29,1.29,0,0,1,279.21,339.37Zm1.25-172.79V336l89.13-51.46V115.12Zm90.38,118.64h0Z"
          />
          <path
            class="cls-15"
            d="M283.24,343.93a3.12,3.12,0,0,1-3.12-3.13V168.54a3.09,3.09,0,0,1,1.56-2.7l91.62-52.91a3.18,3.18,0,0,1,3.13,0,3.12,3.12,0,0,1,1.56,2.71V287.9a3.12,3.12,0,0,1-1.56,2.71l-91.63,52.9A3.1,3.1,0,0,1,283.24,343.93Zm3.12-173.59v165l85.38-49.29v-165ZM374.87,287.9h0Z"
          />
          <g class="cls-18">
            <polygon
              class="cls-13"
              points="281.74 342.25 190.11 395.15 190.11 221.3 281.74 168.4 281.74 342.25"
            />
          </g>
          <path
            class="cls-14"
            d="M186.82,393.28a1.25,1.25,0,0,1-.62-.16,1.26,1.26,0,0,1-.63-1.08V219.77a1.25,1.25,0,0,1,.63-1.08l91.63-52.9a1.25,1.25,0,0,1,1.87,1.08V339.13a1.26,1.26,0,0,1-.63,1.09l-91.62,52.9A1.26,1.26,0,0,1,186.82,393.28Zm1.25-172.79V389.87l89.13-51.46V169Zm90.38,118.64h0Z"
          />
          <path
            class="cls-15"
            d="M190.85,397.84a3.09,3.09,0,0,1-1.56-.41,3.12,3.12,0,0,1-1.56-2.71V222.46a3.12,3.12,0,0,1,1.56-2.71l91.63-52.9a3.12,3.12,0,0,1,4.68,2.71V341.82a3.09,3.09,0,0,1-1.56,2.7l-91.62,52.91A3.15,3.15,0,0,1,190.85,397.84ZM194,224.26V389.31L279.36,340V175Zm88.5,117.56h0Z"
          />
          <g class="cls-19">
            <polygon
              class="cls-13"
              points="190.13 395.47 98.5 448.37 98.5 274.52 190.13 221.62 190.13 395.47"
            />
          </g>
          <path
            class="cls-14"
            d="M95.22,446.51a1.23,1.23,0,0,1-.62-.17,1.25,1.25,0,0,1-.63-1.08V273a1.26,1.26,0,0,1,.63-1.09L186.22,219a1.27,1.27,0,0,1,1.25,0,1.25,1.25,0,0,1,.63,1.08V392.36a1.26,1.26,0,0,1-.63,1.08l-91.63,52.9A1.23,1.23,0,0,1,95.22,446.51Zm1.25-172.79V443.09l89.13-51.46V222.26Zm90.38,118.64h0Z"
          />
          <path
            class="cls-15"
            d="M99.25,451.07a3.1,3.1,0,0,1-1.56-.42,3.13,3.13,0,0,1-1.57-2.71V275.68a3.1,3.1,0,0,1,1.57-2.7l91.62-52.91a3.18,3.18,0,0,1,3.13,0,3.14,3.14,0,0,1,1.56,2.71V395a3.14,3.14,0,0,1-1.56,2.71l-91.63,52.9A3.1,3.1,0,0,1,99.25,451.07Zm3.12-173.59v165l85.38-49.29v-165ZM190.88,395h0Z"
          />
          <path
            class="cls-20"
            d="M282.18,345a.77.77,0,0,1-.77-.77V168.56a.77.77,0,0,1,1.54,0V344.27A.77.77,0,0,1,282.18,345Z"
          />
          <path
            class="cls-20"
            d="M374.46,290.36a.76.76,0,0,1-.77-.77V112.9a.77.77,0,1,1,1.54,0V289.59A.76.76,0,0,1,374.46,290.36Z"
          />
          <path
            class="cls-20"
            d="M466.16,238.58a.76.76,0,0,1-.77-.77V62.1a.77.77,0,1,1,1.54,0V237.81A.76.76,0,0,1,466.16,238.58Z"
          />
          <path
            class="cls-20"
            d="M190.19,399.42a.76.76,0,0,1-.77-.77V219.86a.77.77,0,1,1,1.54,0V398.65A.77.77,0,0,1,190.19,399.42Z"
          />
          <g id="FFU">
            <path
              class="cls-21"
              d="M794.23,236.51l17.84,10.26a4.6,4.6,0,0,0-2.22,3.49L792,240A4.62,4.62,0,0,1,794.23,236.51Z"
            />
            <path
              class="cls-22"
              d="M809.85,250.26v31.49a1.2,1.2,0,0,0,.55,1.12h0l-17.83-10.25h0a1.21,1.21,0,0,1-.54-1.12V240Z"
            />
            <path
              class="cls-23"
              d="M825.72,218.33a1.68,1.68,0,0,1,1.67-.18h0l17.84,10.25h0a1.64,1.64,0,0,0-1.66.19l-31.49,18.18-17.84-10.26Z"
            />
          </g>
          <g class="cls-24">
            <polygon
              class="cls-13"
              points="866 358.83 559.1 180.64 559.1 6.79 866 184.98 866 358.83"
            />
          </g>
          <path
            class="cls-15"
            d="M870,361.52l-306.9-178.2a2.58,2.58,0,0,1-1.17-2V9.05c0-.75.53-1.05,1.17-.68L870,186.57a2.57,2.57,0,0,1,1.16,2V360.85C871.19,361.59,870.67,361.89,870,361.52ZM564.29,181.31,868.86,358.16V188.58L564.29,11.73Z"
          />
          <path
            class="cls-25"
            d="M562,179,863.09,353.8V188.25L562,13.41ZM866,362.19,559.1,184a6.4,6.4,0,0,1-2.91-5V6.7c0-1.86,1.3-2.61,2.91-1.68L866,183.21a6.45,6.45,0,0,1,2.91,5V360.51C868.91,362.37,867.6,363.12,866,362.19Z"
          />
          <polygon
            class="cls-26"
            points="716.53 275.53 713.82 276.62 708.45 273.68 708.45 97.8 716.53 102.78 716.53 275.53"
          />
          <polygon
            class="cls-15"
            points="716.55 275.61 714.23 276.59 714.23 101.86 716.55 103.2 716.55 275.61"
          />
          <g id="hum">
            <path
              class="cls-27"
              d="M530.37,194.74l2.77-1.37a1.76,1.76,0,0,1,1.64.24,4.22,4.22,0,0,1,1.91,3.6,1.37,1.37,0,0,1-.81,1.24h0L533,199.87l-.09-.84h0a4.2,4.2,0,0,1-1.91-3.6,1.91,1.91,0,0,1,.11-.51Z"
            />
            <path
              class="cls-28"
              d="M529.52,196a4.2,4.2,0,0,0,1.91,3.6c1.18.73,2.23.3,2.36-1a4.22,4.22,0,0,0-1.91-3.6C530.7,194.3,529.64,194.73,529.52,196Z"
            />
            <path
              class="cls-29"
              d="M530.37,196.52a2.52,2.52,0,0,0,1.15,2.16c.71.44,1.34.18,1.42-.58a2.55,2.55,0,0,0-1.15-2.16C531.08,195.5,530.44,195.76,530.37,196.52Z"
            />
            <path
              class="cls-1"
              d="M531.14,195.72a1,1,0,0,0-.25.59,2.55,2.55,0,0,0,1.15,2.17,1.27,1.27,0,0,0,.65.21.91.91,0,0,1-1.17,0,2.52,2.52,0,0,1-1.15-2.16A.78.78,0,0,1,531.14,195.72Z"
            />
            <path
              class="cls-27"
              d="M554.67,182.39l2.77-1.37a1.71,1.71,0,0,1,1.63.24,4.23,4.23,0,0,1,1.92,3.6,1.39,1.39,0,0,1-.81,1.24h0l-2.93,1.42-.09-.84h0a4.22,4.22,0,0,1-1.91-3.6,1.91,1.91,0,0,1,.12-.51Z"
            />
            <path
              class="cls-28"
              d="M553.81,183.64a4.23,4.23,0,0,0,1.92,3.6c1.17.73,2.23.3,2.35-1a4.2,4.2,0,0,0-1.91-3.6C555,182,553.94,182.38,553.81,183.64Z"
            />
            <path
              class="cls-29"
              d="M554.66,184.16a2.55,2.55,0,0,0,1.15,2.17c.71.44,1.35.18,1.43-.58a2.56,2.56,0,0,0-1.16-2.16C555.37,183.15,554.74,183.41,554.66,184.16Z"
            />
            <path
              class="cls-1"
              d="M555.44,183.37a.92.92,0,0,0-.25.59,2.53,2.53,0,0,0,1.15,2.17,1.27,1.27,0,0,0,.65.21.92.92,0,0,1-1.18,0,2.55,2.55,0,0,1-1.15-2.17A.78.78,0,0,1,555.44,183.37Z"
            />
            <path
              class="cls-27"
              d="M547.38,203.47l2.76-1.36a1.72,1.72,0,0,1,1.64.23,4.2,4.2,0,0,1,1.91,3.6,1.37,1.37,0,0,1-.81,1.24h0L550,208.61l-.09-.85h0a4.22,4.22,0,0,1-1.91-3.6,2.4,2.4,0,0,1,.11-.51Z"
            />
            <path
              class="cls-28"
              d="M546.52,204.72a4.22,4.22,0,0,0,1.91,3.6c1.18.73,2.24.3,2.36-1a4.2,4.2,0,0,0-1.91-3.6C547.7,203,546.64,203.46,546.52,204.72Z"
            />
            <path
              class="cls-29"
              d="M547.37,205.25a2.54,2.54,0,0,0,1.15,2.16c.71.44,1.35.18,1.42-.57a2.53,2.53,0,0,0-1.15-2.17C548.08,204.23,547.44,204.49,547.37,205.25Z"
            />
            <path
              class="cls-1"
              d="M548.14,204.46a1,1,0,0,0-.25.58,2.55,2.55,0,0,0,1.15,2.17,1.3,1.3,0,0,0,.65.21.9.9,0,0,1-1.17,0,2.54,2.54,0,0,1-1.15-2.16C547.42,204.73,547.73,204.45,548.14,204.46Z"
            />
            <path
              class="cls-27"
              d="M571.67,191.12l2.77-1.37a1.76,1.76,0,0,1,1.64.24,4.22,4.22,0,0,1,1.91,3.6,1.37,1.37,0,0,1-.81,1.24h0l-2.93,1.43-.09-.85h0a4.2,4.2,0,0,1-1.91-3.6,1.59,1.59,0,0,1,.11-.51Z"
            />
            <path
              class="cls-28"
              d="M570.82,192.37a4.2,4.2,0,0,0,1.91,3.6c1.18.73,2.23.3,2.36-1a4.22,4.22,0,0,0-1.91-3.6C572,190.68,570.94,191.11,570.82,192.37Z"
            />
            <path
              class="cls-29"
              d="M571.67,192.9a2.52,2.52,0,0,0,1.15,2.16c.71.44,1.34.18,1.42-.57a2.55,2.55,0,0,0-1.15-2.17C572.38,191.88,571.74,192.14,571.67,192.9Z"
            />
            <path
              class="cls-1"
              d="M572.44,192.1a.92.92,0,0,0-.25.59,2.55,2.55,0,0,0,1.15,2.17,1.27,1.27,0,0,0,.65.21.9.9,0,0,1-1.17,0,2.52,2.52,0,0,1-1.15-2.16A.77.77,0,0,1,572.44,192.1Z"
            />
            <g class="cls-7">
              <path
                class="cls-2"
                d="M577.73,191.32v-3c0,.77-.57,1.55-1.72,2.13v3C577.16,192.87,577.73,192.09,577.73,191.32Z"
              />
              <g class="cls-30">
                <g class="cls-7">
                  <path
                    class="cls-2"
                    d="M576,190.41v3c1.15-.58,1.72-1.36,1.72-2.13v-3c0,.77-.57,1.55-1.72,2.13Z"
                  />
                </g>
              </g>
              <path
                class="cls-3"
                d="M530,191.93v3c0,.77.56,1.53,1.69,2.1v-3C530.56,193.45,530,192.69,530,191.93Z"
              />
              <g class="cls-31">
                <g class="cls-7">
                  <path
                    class="cls-3"
                    d="M530,191.93v3c0,.77.56,1.53,1.69,2.1v-3c-1.12-.58-1.69-1.34-1.69-2.1Z"
                  />
                </g>
              </g>
              <polygon
                class="cls-3"
                points="531.68 194.03 531.69 197.06 546.13 204.48 546.12 201.45 531.68 194.03"
              />
              <polygon
                class="cls-2"
                points="554.38 201.45 554.39 204.48 576.01 193.45 576 190.41 554.38 201.45"
              />
              <g class="cls-7">
                <path
                  class="cls-5"
                  d="M546.12,201.45v3a10.16,10.16,0,0,0,8.26,0v-3A10.24,10.24,0,0,1,546.12,201.45Z"
                />
                <g class="cls-32">
                  <g class="cls-7">
                    <path
                      class="cls-33"
                      d="M546.12,201.45v3a6.46,6.46,0,0,0,1.14.46v-3a6.55,6.55,0,0,1-1.15-.45Z"
                    />
                    <path
                      class="cls-5"
                      d="M547.27,201.9v3a10.37,10.37,0,0,0,7.12-.46v-3a10.4,10.4,0,0,1-7.11.45Z"
                    />
                  </g>
                </g>
              </g>
              <path
                class="cls-34"
                d="M531.71,189.8c-2.28,1.16-2.29,3.06,0,4.23l14.44,7.42a10.24,10.24,0,0,0,8.26,0l21.62-11c2.28-1.16,2.29-3.06,0-4.23l-14.44-7.42a10.26,10.26,0,0,0-8.27,0Z"
              />
            </g>
            <g class="cls-7">
              <path
                class="cls-2"
                d="M577.73,187.86l-.11-41.72c0,.77-.57,1.54-1.72,2.13L576,190C577.16,189.41,577.73,188.63,577.73,187.86Z"
              />
              <g class="cls-35">
                <g class="cls-7">
                  <path
                    class="cls-2"
                    d="M575.9,148.27,576,190c1.15-.58,1.72-1.36,1.72-2.13l-.11-41.72c0,.77-.57,1.54-1.72,2.13Z"
                  />
                </g>
              </g>
              <path
                class="cls-3"
                d="M529.89,149.78l.11,41.73c0,.76.56,1.52,1.69,2.1l-.11-41.73C530.45,151.31,529.89,150.54,529.89,149.78Z"
              />
              <g class="cls-36">
                <g class="cls-7">
                  <path
                    class="cls-3"
                    d="M529.89,149.78l.11,41.73c0,.76.56,1.52,1.69,2.1l-.11-41.73c-1.13-.57-1.69-1.34-1.69-2.1Z"
                  />
                </g>
              </g>
              <polygon
                class="cls-3"
                points="531.58 151.88 531.69 193.61 546.13 201.03 546.02 159.3 531.58 151.88"
              />
              <polygon
                class="cls-2"
                points="554.28 159.3 554.39 201.03 576.01 189.99 575.9 148.27 554.28 159.3"
              />
              <g class="cls-7">
                <path
                  class="cls-5"
                  d="M546,159.3l.11,41.72a10.16,10.16,0,0,0,8.26,0l-.11-41.72A10.16,10.16,0,0,1,546,159.3Z"
                />
                <g class="cls-37">
                  <g class="cls-7">
                    <path
                      class="cls-33"
                      d="M546,159.3l.11,41.72a6.46,6.46,0,0,0,1.14.46l-.11-41.72a7.75,7.75,0,0,1-1.14-.46Z"
                    />
                    <path
                      class="cls-5"
                      d="M547.16,159.76l.11,41.72a10.37,10.37,0,0,0,7.12-.46l-.11-41.72a10.37,10.37,0,0,1-7.12.46Z"
                    />
                  </g>
                </g>
              </g>
              <path
                class="cls-34"
                d="M531.61,147.65c-2.28,1.17-2.3,3.07,0,4.23L546,159.3a10.16,10.16,0,0,0,8.26,0l21.62-11c2.28-1.16,2.29-3.07,0-4.23l-14.45-7.42a10.24,10.24,0,0,0-8.26,0Z"
              />
            </g>
            <g class="cls-7">
              <g class="cls-7">
                <g class="cls-38">
                  <g class="cls-7">
                    <path
                      class="cls-33"
                      d="M529.78,142l.11,7.2c0,.76.56,1.52,1.69,2.1l-.11-7.2c-1.13-.58-1.69-1.34-1.69-2.1Z"
                    />
                  </g>
                </g>
              </g>
              <polygon
                class="cls-39"
                points="531.47 144.14 531.58 151.34 541.48 156.43 541.48 149.28 531.47 144.14"
              />
              <path
                class="cls-40"
                d="M561.38,128.87a10.26,10.26,0,0,0-8.27,0l-21.61,11c-2.28,1.16-2.29,3.06,0,4.23l10,5.14L571.39,134Z"
              />
              <g class="cls-7">
                <g class="cls-41">
                  <path
                    class="cls-5"
                    d="M575.79,144.17l.11,3.56c1.15-.59,1.72-1.36,1.72-2.13l-.11-3.57c0,.78-.57,1.55-1.72,2.14Z"
                  />
                </g>
              </g>
              <polygon
                class="cls-5"
                points="554.17 155.2 554.28 158.76 575.9 147.73 575.79 144.16 554.17 155.2"
              />
              <g class="cls-7">
                <g class="cls-42">
                  <g class="cls-7">
                    <path
                      class="cls-3"
                      d="M545.91,155.2l.11,3.56a7.75,7.75,0,0,0,1.14.46l-.1-3.57a6.55,6.55,0,0,1-1.15-.45Z"
                    />
                    <path
                      class="cls-3"
                      d="M547.06,155.65l.1,3.57a10.43,10.43,0,0,0,7.12-.46l-.11-3.56a10.4,10.4,0,0,1-7.11.45Z"
                    />
                  </g>
                </g>
              </g>
              <path
                class="cls-40"
                d="M575.82,139.93l-4.43-2.27-29.91,15.26,4.43,2.28a10.24,10.24,0,0,0,8.26,0l21.62-11C578.07,143,578.08,141.1,575.82,139.93Z"
              />
            </g>
            <polygon
              class="cls-5"
              points="571.39 134.02 541.48 149.28 541.48 149.28 545.91 155.21 575.82 139.95 571.39 134.02 571.39 134.02"
            />
            <polygon
              class="cls-39"
              points="545.91 155.2 541.48 149.28 541.48 156.43 546.02 158.76 545.91 155.2"
            />
            <polygon
              class="cls-43"
              points="572.47 165.73 572.47 167.59 558.17 174.96 558.17 173.1 571.83 166.06 572.15 165.9 572.15 165.89 572.47 165.73"
            />
            <polygon
              class="cls-1"
              points="572.15 165.89 572.15 167.29 558.17 174.5 558.17 173.1 571.83 166.06 572.15 165.9 572.15 165.89"
            />
            <polygon
              class="cls-3"
              points="558.17 173.31 558.17 173.68 559.58 175.08 559.58 174.71 558.17 173.31"
            />
            <path
              class="cls-44"
              d="M573.23,167.77l-13.65,6.94-1.41-1.4,13.66-6.94Z"
            />
            <polygon
              class="cls-45"
              points="559.58 174.71 559.58 175.08 573.23 168.14 573.23 167.77 559.58 174.71"
            />
            <polygon
              class="cls-43"
              points="572.47 163.4 572.47 165.26 558.17 172.63 558.17 170.77 571.83 163.73 572.15 163.57 572.15 163.56 572.47 163.4"
            />
            <polygon
              class="cls-1"
              points="572.15 163.56 572.15 164.96 558.17 172.17 558.17 170.77 571.83 163.73 572.15 163.57 572.15 163.56"
            />
            <polygon
              class="cls-3"
              points="558.17 170.98 558.17 171.35 559.58 172.75 559.58 172.38 558.17 170.98"
            />
            <path
              class="cls-44"
              d="M573.23,165.44l-13.65,6.94-1.41-1.4L571.83,164Z"
            />
            <polygon
              class="cls-45"
              points="559.58 172.38 559.58 172.75 573.23 165.81 573.23 165.44 559.58 172.38"
            />
            <polygon
              class="cls-43"
              points="572.47 161.22 572.47 163.08 558.17 170.45 558.17 168.59 571.83 161.55 572.15 161.38 572.15 161.38 572.47 161.22"
            />
            <polygon
              class="cls-1"
              points="572.15 161.38 572.15 162.78 558.17 169.99 558.17 168.59 571.83 161.55 572.15 161.38 572.15 161.38"
            />
            <polygon
              class="cls-3"
              points="558.17 168.8 558.17 169.17 559.58 170.56 559.58 170.19 558.17 168.8"
            />
            <path
              class="cls-44"
              d="M573.23,163.26l-13.65,6.94-1.41-1.4,13.66-6.94Z"
            />
            <polygon
              class="cls-45"
              points="559.58 170.19 559.58 170.56 573.23 163.63 573.23 163.26 559.58 170.19"
            />
            <polygon
              class="cls-43"
              points="572.47 159.12 572.47 160.97 558.17 168.35 558.17 166.49 571.83 159.45 572.15 159.28 572.15 159.28 572.47 159.12"
            />
            <polygon
              class="cls-1"
              points="572.15 159.28 572.15 160.68 558.17 167.89 558.17 166.49 571.83 159.45 572.15 159.28 572.15 159.28"
            />
            <polygon
              class="cls-3"
              points="558.17 166.7 558.17 167.07 559.58 168.46 559.58 168.09 558.17 166.7"
            />
            <path
              class="cls-44"
              d="M573.23,161.16l-13.65,6.93-1.41-1.39,13.66-6.94Z"
            />
            <polygon
              class="cls-45"
              points="559.58 168.09 559.58 168.46 573.23 161.53 573.23 161.16 559.58 168.09"
            />
            <polygon
              class="cls-43"
              points="572.47 156.79 572.47 158.65 558.17 166.02 558.17 164.16 571.83 157.12 572.15 156.95 572.15 156.95 572.47 156.79"
            />
            <polygon
              class="cls-1"
              points="572.15 156.95 572.15 158.35 558.17 165.56 558.17 164.16 571.83 157.12 572.15 156.95 572.15 156.95"
            />
            <polygon
              class="cls-3"
              points="558.17 164.37 558.17 164.74 559.58 166.13 559.58 165.76 558.17 164.37"
            />
            <path
              class="cls-44"
              d="M573.23,158.83l-13.65,6.94-1.41-1.4,13.66-6.94Z"
            />
            <polygon
              class="cls-45"
              points="559.58 165.76 559.58 166.13 573.23 159.2 573.23 158.83 559.58 165.76"
            />
            <polygon
              class="cls-43"
              points="572.47 154.6 572.47 156.46 558.17 163.84 558.17 161.98 571.83 154.94 572.15 154.77 572.15 154.77 572.47 154.6"
            />
            <polygon
              class="cls-1"
              points="572.15 154.77 572.15 156.16 558.17 163.38 558.17 161.98 571.83 154.94 572.15 154.77 572.15 154.77"
            />
            <polygon
              class="cls-3"
              points="558.17 162.19 558.17 162.56 559.58 163.95 559.58 163.58 558.17 162.19"
            />
            <path
              class="cls-44"
              d="M573.23,156.64l-13.65,6.94-1.41-1.39,13.66-6.94Z"
            />
            <polygon
              class="cls-45"
              points="559.58 163.58 559.58 163.95 573.23 157.01 573.23 156.64 559.58 163.58"
            />
            <polygon
              class="cls-46"
              points="539.49 158.42 532.06 154.63 531.69 154.44 531.69 155.81 539.49 159.79 539.49 158.42"
            />
            <polygon
              class="cls-1"
              points="539.49 158.42 532.06 154.63 532.06 155.66 539.49 159.45 539.49 158.42"
            />
            <polygon
              class="cls-46"
              points="539.49 160.33 532.06 156.55 531.69 156.35 531.69 157.72 539.49 161.7 539.49 160.33"
            />
            <polygon
              class="cls-1"
              points="539.49 160.33 532.06 156.55 532.06 157.57 539.49 161.36 539.49 160.33"
            />
            <polygon
              class="cls-46"
              points="539.49 162.23 532.06 158.44 531.69 158.25 531.69 159.62 539.49 163.6 539.49 162.23"
            />
            <polygon
              class="cls-1"
              points="539.49 162.23 532.06 158.44 532.06 159.47 539.49 163.26 539.49 162.23"
            />
            <polygon
              class="cls-46"
              points="539.49 164.25 532.06 160.46 531.69 160.27 531.69 161.64 539.49 165.62 539.49 164.25"
            />
            <polygon
              class="cls-1"
              points="539.49 164.25 532.06 160.46 532.06 161.49 539.49 165.28 539.49 164.25"
            />
            <polygon
              class="cls-46"
              points="539.49 166.35 532.06 162.56 531.69 162.37 531.69 163.74 539.49 167.72 539.49 166.35"
            />
            <polygon
              class="cls-1"
              points="539.49 166.35 532.06 162.56 532.06 163.59 539.49 167.38 539.49 166.35"
            />
            <polygon
              class="cls-46"
              points="539.49 168.26 532.06 164.48 531.69 164.28 531.69 165.65 539.49 169.63 539.49 168.26"
            />
            <polygon
              class="cls-1"
              points="539.49 168.26 532.06 164.48 532.06 165.5 539.49 169.29 539.49 168.26"
            />
            <polygon
              class="cls-46"
              points="539.49 170.16 532.06 166.37 531.69 166.18 531.69 167.55 539.49 171.53 539.49 170.16"
            />
            <polygon
              class="cls-1"
              points="539.49 170.16 532.06 166.37 532.06 167.4 539.49 171.19 539.49 170.16"
            />
            <polygon
              class="cls-46"
              points="539.49 172.18 532.06 168.4 531.69 168.2 531.69 169.57 539.49 173.55 539.49 172.18"
            />
            <polygon
              class="cls-1"
              points="539.49 172.18 532.06 168.4 532.06 169.42 539.49 173.21 539.49 172.18"
            />
            <polygon
              class="cls-46"
              points="539.49 174.32 532.06 170.53 531.69 170.34 531.69 171.71 539.49 175.69 539.49 174.32"
            />
            <polygon
              class="cls-1"
              points="539.49 174.32 532.06 170.53 532.06 171.56 539.49 175.35 539.49 174.32"
            />
            <polygon
              class="cls-46"
              points="539.49 176.22 532.06 172.43 531.69 172.24 531.69 173.6 539.49 177.58 539.49 176.22"
            />
            <polygon
              class="cls-1"
              points="539.49 176.22 532.06 172.43 532.06 173.45 539.49 177.24 539.49 176.22"
            />
            <polygon
              class="cls-46"
              points="539.49 178.24 532.06 174.45 531.69 174.26 531.69 175.63 539.49 179.6 539.49 178.24"
            />
            <polygon
              class="cls-1"
              points="539.49 178.24 532.06 174.45 532.06 175.48 539.49 179.26 539.49 178.24"
            />
            <polygon
              class="cls-47"
              points="566.76 148.14 561.72 150.71 558.88 149.26 563.92 146.69 566.76 148.14"
            />
            <polygon
              class="cls-48"
              points="560.23 148.57 560.23 149.96 560.87 150.28 560.87 148.25 560.23 148.57"
            />
            <polygon
              class="cls-48"
              points="562.5 147.42 562.5 150.32 563.92 149.59 563.92 146.69 562.5 147.42"
            />
            <path
              class="cls-49"
              d="M552.77,153.64c-.29-.15-.45-.34-.45-.55s.16-.41.45-.56a2.63,2.63,0,0,1,2.13,0c.29.15.45.34.45.56s-.16.4-.45.55a2.58,2.58,0,0,1-2.13,0Zm0-1.08h0c-.28.14-.43.33-.43.53s.15.38.43.52a2.62,2.62,0,0,0,2.09,0c.28-.14.43-.33.43-.52s-.15-.39-.43-.53a2.31,2.31,0,0,0-1-.22A2.35,2.35,0,0,0,552.79,152.56Z"
            />
            <g class="cls-7">
              <g class="cls-7">
                <g class="cls-50">
                  <g class="cls-7">
                    <path
                      class="cls-51"
                      d="M552.78,152.32v.73a.38.38,0,0,0,.11.25v-.73a.34.34,0,0,1-.11-.25Z"
                    />
                    <path
                      class="cls-52"
                      d="M552.89,152.57v.73a.77.77,0,0,0,.2.13,1.43,1.43,0,0,0,.52.15v-.73a1.72,1.72,0,0,1-.53-.14,1,1,0,0,1-.19-.14Z"
                    />
                    <path
                      class="cls-51"
                      d="M553.61,152.85v.73a1.72,1.72,0,0,0,1-.15c.21-.1.32-.24.32-.38v-.73c0,.14-.1.28-.31.39a1.83,1.83,0,0,1-1,.14Z"
                    />
                  </g>
                </g>
              </g>
              <path
                class="cls-52"
                d="M553.09,151.94c-.42.21-.42.55,0,.77a1.86,1.86,0,0,0,1.5,0c.41-.22.41-.56,0-.77A1.84,1.84,0,0,0,553.09,151.94Z"
              />
            </g>
            <path
              class="cls-49"
              d="M549.46,155.38c-.29-.14-.45-.34-.45-.55s.16-.41.45-.56a2.63,2.63,0,0,1,2.13,0c.29.15.45.35.45.56s-.16.41-.45.55a2.58,2.58,0,0,1-2.13,0Zm0-1.08h0c-.28.14-.43.33-.43.53s.15.38.43.52a2.54,2.54,0,0,0,2.09,0c.28-.14.43-.33.43-.52s-.15-.39-.43-.53a2.49,2.49,0,0,0-1.05-.22A2.45,2.45,0,0,0,549.48,154.3Z"
            />
            <g class="cls-7">
              <g class="cls-7">
                <g class="cls-53">
                  <g class="cls-7">
                    <path
                      class="cls-51"
                      d="M549.46,154.07v.72a.38.38,0,0,0,.11.25v-.73a.35.35,0,0,1-.12-.24Z"
                    />
                    <path
                      class="cls-52"
                      d="M549.58,154.31V155a1.15,1.15,0,0,0,.2.14,1.66,1.66,0,0,0,.52.14v-.73a1.65,1.65,0,0,1-.53-.14.72.72,0,0,1-.19-.14Z"
                    />
                    <path
                      class="cls-51"
                      d="M550.3,154.59v.73a1.81,1.81,0,0,0,1-.14c.21-.11.31-.25.31-.39v-.73c0,.14-.11.28-.31.39a1.84,1.84,0,0,1-1,.14Z"
                    />
                  </g>
                </g>
              </g>
              <path
                class="cls-52"
                d="M549.78,153.68c-.42.21-.42.56,0,.77a1.86,1.86,0,0,0,1.5,0c.41-.21.41-.56,0-.77A1.84,1.84,0,0,0,549.78,153.68Z"
              />
            </g>
          </g>
          <g id="plant2">
            <polygon
              class="cls-54"
              points="518.47 320.6 595.51 275.7 553.9 252.25 476.26 297.55 518.47 320.6"
            />
            <ellipse
              class="cls-55"
              cx="521.42"
              cy="311.67"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.13 5.29) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="493.15"
              cy="297.58"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.99 5.01) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="506.37"
              cy="304.63"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.06 5.14) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="535.8"
              cy="302.92"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.04 5.44) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="549.68"
              cy="295.29"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.96 5.58) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="563.76"
              cy="287.36"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -2.88, 5.72)"
            />
            <ellipse
              class="cls-55"
              cx="577.64"
              cy="279.23"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.8 5.86) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="476.56 297.25 514.92 319.12 516.12 318.3 477.36 296.43 476.56 297.25"
            />
            <polygon
              class="cls-54"
              points="519.96 317.65 519.98 319.07 594.7 275.71 593.48 275.02 519.96 317.65"
            />
            <polygon
              class="cls-56"
              points="514.31 318.72 514.37 325.4 477.54 304.62 477.37 297.64 514.31 318.72"
            />
            <polygon
              class="cls-56"
              points="519.97 318.86 520.05 326.25 594.67 282.49 594.6 275.61 519.97 318.86"
            />
            <path
              class="cls-57"
              d="M522.48,296.68a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.92,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.57,1.57,0,0,0-.3.72c-.1.2.21.5.21.7s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.31,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.11.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="520.99 309.65 521.5 309.64 521.48 307.92 520.87 307.93 520.99 309.65"
            />
            <path
              class="cls-58"
              d="M521,300c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.31-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.23,3.23,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M520.69,299.53c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.3.1.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.19.5.19.81.39l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.2-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-60">
              <polygon
                class="cls-61"
                points="515.75 301.3 526.1 294.92 533.5 306.38 523.05 312.76 515.75 301.3"
              />
            </g>
            <g class="cls-62">
              <polygon
                class="cls-63"
                points="515.38 295.34 526.16 300.89 519.71 312.9 508.93 307.14 515.38 295.34"
              />
            </g>
            <polygon
              class="cls-58"
              points="520.28 308.84 520.69 309.65 521.11 311.67 521.62 311.66 521.9 309.64 522.2 308.82 520.28 308.84"
            />
            <path
              class="cls-57"
              d="M494.21,282.7a5.2,5.2,0,0,1-.41-.7c-.1-.21.1-.51-.11-.71s-.4-.3-.51-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.62.11.5,0,.7a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.2.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.21.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="492.73 295.56 493.33 295.56 493.31 293.74 492.61 293.75 492.73 295.56"
            />
            <path
              class="cls-58"
              d="M492.63,286.06c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.72.59-1a.09.09,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.22c0,.3.31.71.32,1.11s-.5.71-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.61.2-.91.51l-.39.81-.41-.09.09-.91c-.2-.31-.51-.4-.51-.71a8,8,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.49-.71.49-1c.2-.41,0-.91,0-1.11"
            />
            <path
              class="cls-59"
              d="M492.42,285.45c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.5.92.31.7.32,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.39.72.7.11.7.31,1a6.39,6.39,0,0,0,1,.79c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.52-.91.1-.81-.11-1"
            />
            <g class="cls-64">
              <polygon
                class="cls-65"
                points="487.48 287.22 497.94 280.84 505.14 292.3 494.78 298.68 487.48 287.22"
              />
            </g>
            <g class="cls-66">
              <polygon
                class="cls-67"
                points="487.22 281.05 498 286.61 491.44 298.61 480.66 292.85 487.22 281.05"
              />
            </g>
            <polygon
              class="cls-58"
              points="492.01 294.86 492.42 295.57 492.85 297.59 493.35 297.48 493.64 295.56 493.93 294.74 492.01 294.86"
            />
            <path
              class="cls-57"
              d="M507.44,289.75a3.7,3.7,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.32-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.69,1.69,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.21,0,.51.1.71a4.24,4.24,0,0,0,.52.7c.1.21.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.1-.5,0-.7a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="505.95 302.62 506.45 302.61 506.44 300.89 505.83 300.9 505.95 302.62"
            />
            <path
              class="cls-58"
              d="M506,293c.1-.3.6-.51.7-.81s.1-.81.29-1.12a4.74,4.74,0,0,0,1-.62c.3-.2.3-.71.6-1a.11.11,0,0,0,.1-.11,1,1,0,0,1,1.21.19c.1,0,.11.1.11.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1,.1.81,0,1.12-.61.51-.8.81-.1.82-.3,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M505.64,292.5c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.62.39.72.7.11.7.31,1a6.87,6.87,0,0,0,1,.79c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-68">
              <polygon
                class="cls-69"
                points="500.7 294.27 511.06 287.79 518.36 299.35 508 305.63 500.7 294.27"
              />
            </g>
            <g class="cls-70">
              <polygon
                class="cls-71"
                points="500.34 288.2 511.12 293.96 504.67 305.76 493.89 300.21 500.34 288.2"
              />
            </g>
            <polygon
              class="cls-58"
              points="505.23 301.91 505.64 302.62 506.07 304.64 506.58 304.63 506.86 302.61 507.15 301.79 505.23 301.91"
            />
            <path
              class="cls-57"
              d="M537,289a5,5,0,0,1-.41-.71c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.11-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.2.51-.41s.49-.71.49-.81-.1-.5,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.3-.4.2-.6"
            />
            <polygon
              class="cls-58"
              points="535.58 301.81 536.19 301.8 536.07 300.08 535.36 300.09 535.58 301.81"
            />
            <path
              class="cls-58"
              d="M535.49,292.3c.09-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.3.2-.6.21-.9.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M535.28,291.8c-.11-.31-.61-.5-.72-.71s-.11-.7-.31-1-.71-.3-.92-.5-.31-.71-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.1-.81c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.72.19-1-.41-.6-.51-.9.09-.81-.11-1"
            />
            <g class="cls-72">
              <polygon
                class="cls-73"
                points="530.34 293.46 540.79 287.08 547.99 298.65 537.64 304.93 530.34 293.46"
              />
            </g>
            <g class="cls-74">
              <polygon
                class="cls-75"
                points="529.97 287.5 540.75 293.16 534.3 305.06 523.52 299.4 529.97 287.5"
              />
            </g>
            <polygon
              class="cls-58"
              points="534.87 301.21 535.18 301.91 535.6 303.93 536.21 303.83 536.49 301.8 536.69 301.09 534.87 301.21"
            />
            <path
              class="cls-57"
              d="M551,280.91a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="549.56 293.78 550.07 293.77 550.05 292.05 549.34 292.06 549.56 293.78"
            />
            <path
              class="cls-58"
              d="M549.47,284.16c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1a4.12,4.12,0,0,1,0,1.11c-.1.3-.6.51-.8.82s-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M549.26,283.66c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.3.1.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.7.11,1,.61.39.71.7.11.7.32,1a6,6,0,0,0,1,.79c.3.2.5.2.81.4l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.2-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-76">
              <polygon
                class="cls-77"
                points="544.32 285.43 554.77 279.05 561.97 290.62 551.62 296.89 544.32 285.43"
              />
            </g>
            <g class="cls-78">
              <polygon
                class="cls-79"
                points="543.96 279.46 554.73 285.02 548.18 297.03 537.4 291.37 543.96 279.46"
              />
            </g>
            <polygon
              class="cls-58"
              points="548.85 293.07 549.16 293.78 549.58 295.8 550.09 295.79 550.47 293.77 550.67 293.06 548.85 293.07"
            />
            <path
              class="cls-57"
              d="M564.73,273a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.57,1.57,0,0,0-.3.72c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.21.51-.41s.49-.71.49-.81-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.21-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="563.34 285.95 563.85 285.94 563.83 284.12 563.12 284.13 563.34 285.95"
            />
            <path
              class="cls-58"
              d="M563.25,276.34c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22c0,.3.31.71.31,1.11s-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.29,1.11-.91.72-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22,0-.3-.31-.7-.32-1.1s.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M563,275.73c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.7.11,1,.61.39.71.7.11.7.32,1a6,6,0,0,0,1,.79c.3.2.5.2.81.4l.41.71.3-.11-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91,0-.71-.11-1"
            />
            <g class="cls-80">
              <polygon
                class="cls-81"
                points="558.1 277.5 568.45 271.12 575.75 282.58 565.4 288.96 558.1 277.5"
              />
            </g>
            <g class="cls-82">
              <polygon
                class="cls-83"
                points="557.73 271.43 568.51 277.19 562.06 289.1 551.28 283.44 557.73 271.43"
              />
            </g>
            <polygon
              class="cls-58"
              points="562.63 285.14 562.94 285.95 563.46 287.87 563.97 287.86 564.25 285.94 564.45 285.02 562.63 285.14"
            />
            <path
              class="cls-57"
              d="M579,264.54a4.32,4.32,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.1.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41s.49-.71.49-.82-.1-.5,0-.7.3-.41.29-.71-.21-.51-.21-.71a1.11,1.11,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="577.62 277.4 578.13 277.4 578.11 275.58 577.4 275.69 577.62 277.4"
            />
            <path
              class="cls-58"
              d="M577.53,267.89c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.49,1,.11.8,0,1.11-.6.51-.8.82-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M577.32,267.29c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.7,0,1.11s-.5.61-.5.92.31.7.31,1-.29.72-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.71.11.7.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.81-.11-1"
            />
            <g class="cls-84">
              <polygon
                class="cls-85"
                points="572.28 269.06 582.73 262.68 590.03 274.14 579.58 280.52 572.28 269.06"
              />
            </g>
            <g class="cls-86">
              <polygon
                class="cls-87"
                points="572.01 262.99 582.69 268.75 576.24 280.66 565.46 275 572.01 262.99"
              />
            </g>
            <polygon
              class="cls-58"
              points="576.91 276.7 577.22 277.41 577.64 279.43 578.15 279.42 578.53 277.29 578.73 276.58 576.91 276.7"
            />
          </g>
          <g id="plant2-2" data-name="plant2">
            <polygon
              class="cls-54"
              points="438.31 366.03 515.34 321.14 473.73 297.68 396.09 342.99 438.31 366.03"
            />
            <ellipse
              class="cls-55"
              cx="441.25"
              cy="357.1"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -3.59, 4.48)"
            />
            <ellipse
              class="cls-55"
              cx="412.98"
              cy="343.12"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.45 4.2) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="426.21"
              cy="350.07"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.52 4.33) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="455.63"
              cy="348.45"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.5 4.63) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="469.51"
              cy="340.72"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.42 4.77) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="483.59"
              cy="332.89"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.34 4.91) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="497.47"
              cy="324.76"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.26 5.05) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="396.39 342.78 434.75 364.55 435.95 363.73 397.19 341.96 396.39 342.78"
            />
            <polygon
              class="cls-54"
              points="439.79 363.08 439.81 364.5 514.43 321.15 513.31 320.55 439.79 363.08"
            />
            <polygon
              class="cls-56"
              points="434.14 364.15 434.21 371.03 397.37 350.05 397.2 343.18 434.14 364.15"
            />
            <polygon
              class="cls-56"
              points="439.81 364.5 439.88 371.88 514.5 328.03 514.43 321.05 439.81 364.5"
            />
            <path
              class="cls-57"
              d="M442.31,342.21a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.11a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.19.51-.09.71a4.46,4.46,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.51-.21-.71s.19-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="440.82 355.08 441.33 355.07 441.31 353.35 440.71 353.36 440.82 355.08"
            />
            <path
              class="cls-58"
              d="M440.83,345.57c.1-.31.6-.51.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.76,7.76,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.31-1.11.49-.72.49-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M440.52,345.06c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.8c-.1,0-.1,0-.1-.11a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.42.61.52.91-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.9.1-.82-.11-1"
            />
            <g class="cls-88">
              <polygon
                class="cls-89"
                points="435.58 346.73 445.94 340.46 453.34 351.92 442.88 358.3 435.58 346.73"
              />
            </g>
            <g class="cls-90">
              <polygon
                class="cls-91"
                points="435.22 340.77 446 346.43 439.54 358.43 428.76 352.77 435.22 340.77"
              />
            </g>
            <polygon
              class="cls-58"
              points="440.11 354.38 440.52 355.08 440.95 357.1 441.45 357.1 441.74 355.07 442.03 354.36 440.11 354.38"
            />
            <path
              class="cls-57"
              d="M414.05,328.23a3.7,3.7,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.32-.71c-.1,0-.1,0-.1-.1a.78.78,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.51.3-.5.61.1.5,0,.71a1.59,1.59,0,0,0-.29.71c-.1.2.21.5.21.7s-.2.51-.1.71a4,4,0,0,1,.42.71c.1.2,0,.5.1.7a4,4,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.1-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.51-.21-.71s.2-.4.2-.61"
            />
            <polygon
              class="cls-58"
              points="412.56 341.1 413.06 341.09 413.05 339.27 412.44 339.38 412.56 341.1"
            />
            <path
              class="cls-58"
              d="M412.46,331.49c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.61,1-.19.71-.19,1.21c0,.31.32.71.32,1.11s-.5.72-.5,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.61.51-.81.82s-.09.81-.29,1.12-.9.71-1,1c-.3.2-.6.21-.9.51l-.4.82L413,339l.1-.91c-.21-.3-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.5-.72.49-1c.2-.31,0-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M412.25,331c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.71.31,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11L412,337c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.51-.91.09-.81-.12-1"
            />
            <g class="cls-92">
              <polygon
                class="cls-93"
                points="407.31 332.75 417.77 326.27 424.97 337.84 414.61 344.11 407.31 332.75"
              />
            </g>
            <g class="cls-94">
              <polygon
                class="cls-95"
                points="407.05 326.48 417.83 332.14 411.27 344.15 400.49 338.49 407.05 326.48"
              />
            </g>
            <polygon
              class="cls-58"
              points="411.84 340.4 412.26 341.1 412.68 343.12 413.19 343.12 413.47 340.99 413.76 340.28 411.84 340.4"
            />
            <path
              class="cls-57"
              d="M427.27,335.18a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.72-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.1.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.3.2-.61"
            />
            <polygon
              class="cls-58"
              points="425.78 348.15 426.29 348.14 426.27 346.32 425.66 346.33 425.78 348.15"
            />
            <path
              class="cls-58"
              d="M425.79,338.54c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.72-.19,1.22.31.71.31,1.11-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.19,3.19,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M425.48,337.93c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.49.62-.49.92.31.7.31,1-.29.71-.19,1,.41.6.51.91-.09.71.12,1,.61.4.71.7.11.71.32,1a7.06,7.06,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.61-.11-1"
            />
            <g class="cls-96">
              <polygon
                class="cls-97"
                points="420.54 339.8 430.89 333.32 438.29 344.78 427.84 351.16 420.54 339.8"
              />
            </g>
            <g class="cls-98">
              <polygon
                class="cls-99"
                points="420.17 333.74 430.95 339.39 424.5 351.3 413.72 345.64 420.17 333.74"
              />
            </g>
            <polygon
              class="cls-58"
              points="425.07 347.35 425.48 348.15 425.9 350.07 426.41 350.06 426.69 348.14 426.99 347.33 425.07 347.35"
            />
            <path
              class="cls-57"
              d="M456.8,334.48a4.05,4.05,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.09-.2-.21-.5-.21-.7a.56.56,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="455.42 347.44 456.02 347.34 455.9 345.62 455.19 345.62 455.42 347.44"
            />
            <path
              class="cls-58"
              d="M455.32,337.83c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.31,0,.81.11,1.12s.52.7.62,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M455.11,337.23c-.1-.31-.61-.5-.72-.7s-.1-.71-.31-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.41.6.52.9-.1.71.11,1,.61.4.72.7.1.71.31,1a3.57,3.57,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.22-1,.3-.71.2-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-100">
              <polygon
                class="cls-101"
                points="450.17 339.1 460.63 332.62 467.82 344.08 457.47 350.46 450.17 339.1"
              />
            </g>
            <g class="cls-102">
              <polygon
                class="cls-103"
                points="449.81 332.93 460.59 338.69 454.13 350.59 443.25 344.94 449.81 332.93"
              />
            </g>
            <polygon
              class="cls-58"
              points="454.7 346.64 455.01 347.45 455.44 349.37 456.04 349.36 456.32 347.33 456.52 346.52 454.7 346.64"
            />
            <path
              class="cls-57"
              d="M470.78,326.44a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.19.5-.09.7a5,5,0,0,1,.41.71c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.3-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="469.39 339.31 469.9 339.3 469.88 337.48 469.18 337.49 469.39 339.31"
            />
            <path
              class="cls-58"
              d="M469.3,329.7c.1-.31.6-.51.7-.82s.09-.81.29-1.11a6.11,6.11,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.6.51-.8.82s-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M469.09,329.19c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.71.32,1-.3.71-.2,1,.42.61.52.91-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.19.81.39l.41.71L469,336l-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91.1-.7-.11-1"
            />
            <g class="cls-104">
              <polygon
                class="cls-105"
                points="464.15 330.96 474.61 324.58 481.81 336.05 471.45 342.42 464.15 330.96"
              />
            </g>
            <g class="cls-106">
              <polygon
                class="cls-107"
                points="463.79 324.9 474.57 330.56 468.01 342.56 457.23 336.9 463.79 324.9"
              />
            </g>
            <polygon
              class="cls-58"
              points="468.68 338.61 468.99 339.31 469.42 341.23 469.92 341.23 470.31 339.3 470.5 338.49 468.68 338.61"
            />
            <path
              class="cls-57"
              d="M484.56,318.51a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.7a5,5,0,0,1,.41.71c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.09-.2-.21-.5-.21-.71s.3-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="483.18 331.38 483.68 331.37 483.66 329.65 482.95 329.66 483.18 331.38"
            />
            <path
              class="cls-58"
              d="M483.08,321.87c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M482.87,321.26c-.1-.3-.61-.5-.72-.7s-.1-.7-.31-1-.71-.29-.91-.49-.32-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.71.32,1-.3.71-.2,1,.41.61.52.91-.1.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.31-.11-.11-.8c.09-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91,0-.7-.11-1"
            />
            <g class="cls-108">
              <polygon
                class="cls-109"
                points="477.93 323.03 488.29 316.65 495.58 328.12 485.23 334.49 477.93 323.03"
              />
            </g>
            <g class="cls-110">
              <polygon
                class="cls-111"
                points="477.57 317.07 488.35 322.73 481.89 334.63 471.11 328.97 477.57 317.07"
              />
            </g>
            <polygon
              class="cls-58"
              points="482.46 330.68 482.77 331.38 483.3 333.4 483.8 333.4 484.08 331.37 484.28 330.66 482.46 330.68"
            />
            <path
              class="cls-57"
              d="M498.84,310a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.51-.2.72-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71a.86.86,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="497.45 322.94 497.96 322.93 497.94 321.21 497.24 321.22 497.45 322.94"
            />
            <path
              class="cls-58"
              d="M497.36,313.33c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.72-.19,1.22c0,.3.31.71.31,1.11s-.49.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11-.91.72-1,1c-.31.2-.61.2-.91.51l-.4.81-.4-.09.09-.91c-.2-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21,0-.31-.31-.71-.32-1.11s.5-.72.5-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M497.15,312.82c-.1-.3-.61-.5-.72-.7s-.1-.71-.31-1-.71-.29-.91-.49-.32-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.62-.5.92.31.7.32,1-.3.71-.2,1,.41.6.52.91-.1.71.11,1,.61.4.72.7.1.71.31,1a3.57,3.57,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.31-.11-.11-.81c.09-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91.09-.81-.11-1"
            />
            <g class="cls-112">
              <polygon
                class="cls-113"
                points="492.11 314.59 502.56 308.11 509.87 319.68 499.41 325.95 492.11 314.59"
              />
            </g>
            <g class="cls-114">
              <polygon
                class="cls-115"
                points="491.85 308.52 502.52 314.18 496.07 326.09 485.29 320.43 491.85 308.52"
              />
            </g>
            <polygon
              class="cls-58"
              points="496.74 322.24 497.05 322.94 497.48 324.96 497.98 324.95 498.37 322.93 498.56 322.12 496.74 322.24"
            />
          </g>
          <g id="plant2-3" data-name="plant2">
            <polygon
              class="cls-54"
              points="517.92 296.22 594.96 251.43 553.25 227.97 475.61 273.28 517.92 296.22"
            />
            <ellipse
              class="cls-55"
              cx="520.87"
              cy="287.39"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.88 5.29) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="492.6"
              cy="273.31"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.74 5) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="505.82"
              cy="280.36"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.81 5.13) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="535.15"
              cy="278.64"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -2.79, 5.43)"
            />
            <ellipse
              class="cls-55"
              cx="549.13"
              cy="271.01"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.72 5.57) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="563.21"
              cy="263.18"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.64 5.71) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="577.09"
              cy="254.95"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.55 5.85) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="476.01 272.97 514.37 294.84 515.57 293.92 476.71 272.15 476.01 272.97"
            />
            <polygon
              class="cls-54"
              points="519.41 293.37 519.43 294.79 594.05 251.34 592.83 250.84 519.41 293.37"
            />
            <polygon
              class="cls-56"
              points="513.76 294.44 513.83 301.22 476.99 280.24 476.82 273.47 513.76 294.44"
            />
            <polygon
              class="cls-56"
              points="519.42 294.69 519.5 302.07 594.12 258.32 594.05 251.34 519.42 294.69"
            />
            <path
              class="cls-57"
              d="M521.83,272.5a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.2-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.3-.4.2-.61"
            />
            <polygon
              class="cls-58"
              points="520.44 285.37 520.95 285.36 520.93 283.54 520.22 283.65 520.44 285.37"
            />
            <path
              class="cls-58"
              d="M520.35,275.86c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3,3,0,0,0-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M520.14,275.25c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.51.2.81.39l.41.71.3-.11-.1-.8c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.91.09-.7-.11-1"
            />
            <g class="cls-116">
              <polygon
                class="cls-117"
                points="515.2 277.02 525.55 270.65 532.85 282.11 522.4 288.49 515.2 277.02"
              />
            </g>
            <g class="cls-118">
              <polygon
                class="cls-119"
                points="514.83 270.96 525.51 276.72 519.16 288.62 508.28 282.96 514.83 270.96"
              />
            </g>
            <polygon
              class="cls-58"
              points="519.73 284.67 520.04 285.37 520.46 287.39 521.07 287.39 521.35 285.36 521.55 284.55 519.73 284.67"
            />
            <path
              class="cls-57"
              d="M493.67,258.42a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.1.5-.2.71-.5.3-.49.61.1.5,0,.71a1.39,1.39,0,0,0-.29.71c-.1.2.2.5.21.7s-.2.51-.1.71a4.05,4.05,0,0,1,.41.71c.11.3,0,.5.11.7a4,4,0,0,0,.51.71,5.91,5.91,0,0,1,.51.4l.11.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="492.18 271.29 492.68 271.28 492.67 269.56 492.06 269.57 492.18 271.29"
            />
            <path
              class="cls-58"
              d="M492.08,261.78c.1-.31.6-.51.7-.82s.09-.81.29-1.11a6.11,6.11,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.11-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.76,7.76,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.5-.72.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M491.87,261.17c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.7.32,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.81.39l.42.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.91.1-.71-.11-1"
            />
            <g class="cls-120">
              <polygon
                class="cls-121"
                points="486.93 262.94 497.29 256.56 504.59 268.02 494.23 274.4 486.93 262.94"
              />
            </g>
            <g class="cls-122">
              <polygon
                class="cls-123"
                points="486.57 256.67 497.35 262.43 490.89 274.34 480.11 268.68 486.57 256.67"
              />
            </g>
            <polygon
              class="cls-58"
              points="491.46 270.59 491.87 271.29 492.3 273.31 492.8 273.31 493.09 271.28 493.38 270.57 491.46 270.59"
            />
            <path
              class="cls-57"
              d="M506.79,265.47a3.7,3.7,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.52-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.51.31-.5.61.1.5,0,.71a1.39,1.39,0,0,0-.29.71c-.1.2.21.5.21.7s-.2.51-.1.71a4.44,4.44,0,0,1,.42.71c.1.2,0,.5.1.7a4,4,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="505.4 278.34 505.9 278.33 505.89 276.61 505.18 276.62 505.4 278.34"
            />
            <path
              class="cls-58"
              d="M505.3,268.73c.1-.31.6-.52.7-.82s.1-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.71-.5,1,.11.81,0,1.11-.61.51-.81.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.41-.09.1-.91c-.21-.31-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41,12.06,12.06,0,0,0,.19-1.21c0-.41-.31-.71-.31-1.11s.5-.72.49-1-.1-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M505.1,268.22c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.72-.29-.92-.49-.31-.71-.61-.81c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.12,1,.61.4.71.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-124">
              <polygon
                class="cls-125"
                points="500.16 269.99 510.51 263.62 517.81 275.07 507.35 281.45 500.16 269.99"
              />
            </g>
            <g class="cls-126">
              <polygon
                class="cls-127"
                points="499.79 264.03 510.47 269.69 504.12 281.59 493.24 275.93 499.79 264.03"
              />
            </g>
            <polygon
              class="cls-58"
              points="504.68 277.64 505 278.44 505.42 280.36 506.03 280.36 506.31 278.33 506.5 277.62 504.68 277.64"
            />
            <path
              class="cls-57"
              d="M536.42,264.67A4.05,4.05,0,0,1,536,264c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.61-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.92,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.6c.1-.21.31-.21.51-.41a7.9,7.9,0,0,0,.49-.82c.1-.2-.1-.5,0-.71a1.39,1.39,0,0,0,.29-.71c.1-.2-.2-.5-.21-.7a.59.59,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="534.93 277.63 535.54 277.63 535.52 275.91 534.81 275.92 534.93 277.63"
            />
            <path
              class="cls-58"
              d="M534.94,268c.09-.3.6-.51.7-.81s.09-.82.29-1.12a5.44,5.44,0,0,0,1-.62c.31-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.12s.52.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12a3.23,3.23,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M534.63,267.42c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.31c-.1,0-.1.11-.1.11-.09.3.11.7,0,1.11s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.6-.51-.9.09-.61-.11-1"
            />
            <g class="cls-128">
              <polygon
                class="cls-129"
                points="529.69 269.29 540.14 262.81 547.44 274.37 537.09 280.75 529.69 269.29"
              />
            </g>
            <g class="cls-130">
              <polygon
                class="cls-131"
                points="529.43 263.32 540.21 268.88 533.65 280.78 522.87 275.13 529.43 263.32"
              />
            </g>
            <polygon
              class="cls-58"
              points="534.32 276.83 534.63 277.64 535.05 279.66 535.56 279.65 535.94 277.62 536.14 276.81 534.32 276.83"
            />
            <path
              class="cls-57"
              d="M550.4,256.63a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.11,0-.11,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.7a6.14,6.14,0,0,1,.41.71c.1.3,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.1.1.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a2.31,2.31,0,0,0,.49-.81c.1-.2-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71a.57.57,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="549.01 269.6 549.52 269.59 549.5 267.77 548.79 267.78 549.01 269.6"
            />
            <path
              class="cls-58"
              d="M548.92,260c.1-.31.6-.51.7-.82s.09-.81.29-1.11a6,6,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12a3,3,0,0,0-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M548.61,259.38c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.6-.11-1"
            />
            <g class="cls-132">
              <polygon
                class="cls-133"
                points="543.67 261.25 554.13 254.78 561.42 266.24 551.07 272.61 543.67 261.25"
              />
            </g>
            <g class="cls-134">
              <polygon
                class="cls-135"
                points="543.41 255.19 554.19 260.85 547.63 272.75 536.85 267.09 543.41 255.19"
              />
            </g>
            <polygon
              class="cls-58"
              points="548.3 268.8 548.61 269.6 549.03 271.52 549.54 271.52 549.82 269.59 550.12 268.68 548.3 268.8"
            />
            <path
              class="cls-57"
              d="M564.18,248.8a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.2-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.3-.4.2-.61"
            />
            <polygon
              class="cls-58"
              points="562.79 261.67 563.3 261.56 563.18 259.84 562.57 259.85 562.79 261.67"
            />
            <path
              class="cls-58"
              d="M562.7,252.16c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.21c0,.31.31.71.31,1.11s-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1a3.75,3.75,0,0,1,0-1.11"
            />
            <path
              class="cls-59"
              d="M562.49,251.55c-.11-.3-.61-.5-.72-.7s-.1-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.51.2.81.39l.41.71.31-.11-.11-.8c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.2-1-.42-.6-.52-.91,0-.8-.11-1"
            />
            <g class="cls-136">
              <polygon
                class="cls-137"
                points="557.55 253.32 567.9 246.95 575.2 258.41 564.75 264.79 557.55 253.32"
              />
            </g>
            <g class="cls-138">
              <polygon
                class="cls-139"
                points="557.08 247.26 567.97 253.02 561.41 264.82 550.73 259.26 557.08 247.26"
              />
            </g>
            <polygon
              class="cls-58"
              points="562.08 260.97 562.39 261.67 562.81 263.69 563.32 263.59 563.6 261.56 563.9 260.85 562.08 260.97"
            />
            <path
              class="cls-57"
              d="M578.46,240.26a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="576.97 253.13 577.58 253.12 577.56 251.4 576.85 251.41 576.97 253.13"
            />
            <path
              class="cls-58"
              d="M576.87,243.62c.1-.31.61-.51.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21c0,.31.31.71.31,1.11s-.5.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.29,1.12a3.07,3.07,0,0,0-1,1c-.3.2-.6.21-.9.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.32-.71-.32-1.11.5-.72.5-1c.19-.41,0-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M576.67,243.11c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.11s-.5.62-.5.92.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.81-.11-1"
            />
            <g class="cls-140">
              <polygon
                class="cls-141"
                points="571.73 244.78 582.18 238.4 589.38 249.97 579.03 256.24 571.73 244.78"
              />
            </g>
            <g class="cls-142">
              <polygon
                class="cls-143"
                points="571.36 238.82 582.14 244.47 575.69 256.38 564.91 250.72 571.36 238.82"
              />
            </g>
            <polygon
              class="cls-58"
              points="576.26 252.43 576.67 253.13 577.09 255.15 577.6 255.15 577.88 253.12 578.18 252.41 576.26 252.43"
            />
          </g>
          <g id="plant2-4" data-name="plant2">
            <polygon
              class="cls-54"
              points="437.86 341.65 514.89 296.86 473.28 273.4 395.64 318.61 437.86 341.65"
            />
            <ellipse
              class="cls-55"
              cx="440.9"
              cy="332.82"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.35 4.48) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="412.54"
              cy="318.74"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.21 4.19) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="425.86"
              cy="325.79"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.28 4.33) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="455.18"
              cy="324.07"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.26 4.62) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="469.06"
              cy="316.45"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.18 4.76) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="483.25"
              cy="308.61"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.1 4.91) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="497.02"
              cy="300.38"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.01 5.05) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="395.94 318.4 434.3 340.17 435.51 339.35 396.74 317.58 395.94 318.4"
            />
            <polygon
              class="cls-54"
              points="439.34 338.7 439.36 340.12 514.08 296.76 512.87 296.27 439.34 338.7"
            />
            <polygon
              class="cls-56"
              points="433.69 339.87 433.76 346.65 397.03 325.67 396.75 318.8 433.69 339.87"
            />
            <polygon
              class="cls-56"
              points="439.36 340.12 439.43 347.5 514.05 303.75 513.98 296.77 439.36 340.12"
            />
            <path
              class="cls-57"
              d="M441.86,317.93a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.2.71s-.19.5-.09.7a5,5,0,0,1,.41.71c.11.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a2.53,2.53,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.2-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="440.48 330.8 440.98 330.79 440.86 328.97 440.26 329.08 440.48 330.8"
            />
            <path
              class="cls-58"
              d="M440.38,321.29c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.6.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.5-.71.49-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M440.07,320.68c-.1-.3-.61-.49-.71-.7s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a3.71,3.71,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.81-.11-1"
            />
            <g class="cls-144">
              <polygon
                class="cls-145"
                points="435.23 322.45 445.59 316.08 452.89 327.54 442.43 333.92 435.23 322.45"
              />
            </g>
            <g class="cls-146">
              <polygon
                class="cls-147"
                points="434.77 316.39 445.55 322.15 439.09 334.05 428.31 328.39 434.77 316.39"
              />
            </g>
            <polygon
              class="cls-58"
              points="439.66 330.1 440.07 330.8 440.5 332.82 441 332.82 441.29 330.79 441.58 329.98 439.66 330.1"
            />
            <path
              class="cls-57"
              d="M413.6,303.85a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.11,0-.11,0-.11-.11a.78.78,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.5.31-.5.61.1.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.1.71a4.44,4.44,0,0,1,.42.71c.1.2,0,.5.1.7a4.52,4.52,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.51-.41s.49-.71.49-.81-.1-.51,0-.71a1.64,1.64,0,0,0,.29-.71c.1-.2-.21-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="412.11 316.72 412.72 316.71 412.7 314.99 411.99 315 412.11 316.72"
            />
            <path
              class="cls-58"
              d="M412.11,307.11c.1-.31.61-.52.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.11,0,.11.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.3,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41,12.06,12.06,0,0,0,.19-1.21c0-.41-.31-.71-.31-1.11s.5-.72.5-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M411.81,306.6c-.11-.3-.62-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.71.31,1-.3.71-.19,1,.41.61.51.91-.09.71.12,1,.61.4.71.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-148">
              <polygon
                class="cls-149"
                points="406.87 308.37 417.32 301.89 424.52 313.46 414.17 319.83 406.87 308.37"
              />
            </g>
            <g class="cls-150">
              <polygon
                class="cls-151"
                points="406.6 302.1 417.38 307.86 410.83 319.77 400.05 314.11 406.6 302.1"
              />
            </g>
            <polygon
              class="cls-58"
              points="411.5 316.02 411.81 316.72 412.23 318.74 412.74 318.74 413.02 316.71 413.32 316 411.5 316.02"
            />
            <path
              class="cls-57"
              d="M426.82,310.9a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.71c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.11,0-.11,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.46,4.46,0,0,1,.41.71c.1.3,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.09-.21-.11-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.51-.2-.71s.19-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="425.43 323.77 425.94 323.76 425.82 321.94 425.21 321.95 425.43 323.77"
            />
            <path
              class="cls-58"
              d="M425.34,314.16c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21c0,.3.31.71.31,1.11s-.49.71-.49,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.6.51-.8.82s-.09.81-.29,1.11-.91.72-1,1c-.31.2-.61.2-.91.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M425,313.65c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.11s-.5.62-.5.92.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.2-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-152">
              <polygon
                class="cls-153"
                points="420.19 315.42 430.55 309.04 437.84 320.5 427.39 326.88 420.19 315.42"
              />
            </g>
            <g class="cls-154">
              <polygon
                class="cls-155"
                points="419.72 309.36 430.5 315.01 424.05 327.02 413.27 321.36 419.72 309.36"
              />
            </g>
            <polygon
              class="cls-58"
              points="424.62 323.07 425.03 323.87 425.45 325.79 425.96 325.68 426.24 323.76 426.54 322.95 424.62 323.07"
            />
            <path
              class="cls-57"
              d="M456.35,310.1a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7a.56.56,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="454.97 323.06 455.57 323.06 455.45 321.24 454.75 321.24 454.97 323.06"
            />
            <path
              class="cls-58"
              d="M454.87,313.45c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22s-.31-.7-.31-1.11.49-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M454.66,312.85c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.42.6.52.9-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.61-.11-1"
            />
            <g class="cls-156">
              <polygon
                class="cls-157"
                points="449.72 314.72 460.18 308.24 467.38 319.7 457.02 326.18 449.72 314.72"
              />
            </g>
            <g class="cls-158">
              <polygon
                class="cls-159"
                points="449.36 308.65 460.14 314.31 453.68 326.21 442.9 320.56 449.36 308.65"
              />
            </g>
            <polygon
              class="cls-58"
              points="454.25 322.26 454.56 323.07 455.09 324.99 455.59 324.98 455.88 323.05 456.07 322.24 454.25 322.26"
            />
            <path
              class="cls-57"
              d="M470.33,302.06a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.09.2.21.5.21.71s-.19.5-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7,5.91,5.91,0,0,1,.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.3-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="468.95 314.93 469.45 314.92 469.44 313.2 468.73 313.21 468.95 314.93"
            />
            <path
              class="cls-58"
              d="M468.85,305.42c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.59-1a.09.09,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42c-.1-.3.2-.71.19-1.21,0-.31-.31-.71-.31-1.11s.49-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M468.64,304.81c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.39l.42.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.91.1-.7-.11-1"
            />
            <g class="cls-160">
              <polygon
                class="cls-161"
                points="463.7 306.58 474.16 300.2 481.36 311.67 471 318.05 463.7 306.58"
              />
            </g>
            <g class="cls-162">
              <polygon
                class="cls-163"
                points="463.34 300.52 474.12 306.28 467.56 318.18 456.88 312.52 463.34 300.52"
              />
            </g>
            <polygon
              class="cls-58"
              points="468.23 314.23 468.54 314.93 469.07 316.95 469.57 316.95 469.86 314.92 470.05 314.11 468.23 314.23"
            />
            <path
              class="cls-57"
              d="M484.21,294.23a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.21.71s-.2.5-.1.7a5,5,0,0,1,.41.71c.11.3,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.2-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="482.73 307.1 483.23 306.99 483.21 305.27 482.61 305.28 482.73 307.1"
            />
            <path
              class="cls-58"
              d="M482.63,297.49c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42c-.1-.3.19-.71.19-1.21s-.31-.71-.31-1.11.49-.72.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M482.42,297c-.1-.3-.61-.49-.71-.7s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.9,0-.81-.11-1"
            />
            <g class="cls-164">
              <polygon
                class="cls-165"
                points="477.48 298.75 487.84 292.28 495.14 303.84 484.78 310.11 477.48 298.75"
              />
            </g>
            <g class="cls-166">
              <polygon
                class="cls-167"
                points="477.12 292.69 487.9 298.35 481.44 310.25 470.66 304.69 477.12 292.69"
              />
            </g>
            <polygon
              class="cls-58"
              points="482.01 306.4 482.42 307.1 482.85 309.12 483.35 309.02 483.64 306.99 483.93 306.28 482.01 306.4"
            />
            <path
              class="cls-57"
              d="M498.39,285.59a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.1.5-.2.71-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.05,4.05,0,0,1,.41.71c.1.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.09-.21-.11-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.2-.71a.56.56,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="497 298.56 497.51 298.55 497.49 296.83 496.79 296.84 497 298.56"
            />
            <path
              class="cls-58"
              d="M496.91,289c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.71-.19,1.21.31.71.32,1.11-.5.71-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.61.2-.91.51l-.39.81-.41-.09.09-.91c-.2-.31-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M496.7,288.44c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.7.32,1-.3.71-.2,1,.42.6.52.91-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.31-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91.1-.71-.11-1"
            />
            <g class="cls-168">
              <polygon
                class="cls-169"
                points="491.66 290.21 502.12 283.83 509.42 295.4 499.06 301.67 491.66 290.21"
              />
            </g>
            <g class="cls-170">
              <polygon
                class="cls-171"
                points="491.4 284.25 502.18 289.8 495.62 301.81 484.84 296.15 491.4 284.25"
              />
            </g>
            <polygon
              class="cls-58"
              points="496.29 297.86 496.6 298.56 497.03 300.58 497.53 300.57 497.92 298.55 498.11 297.84 496.29 297.86"
            />
          </g>
          <g id="plant2-5" data-name="plant2">
            <polygon
              class="cls-54"
              points="517.87 270.93 594.91 226.03 553.19 202.58 475.65 247.88 517.87 270.93"
            />
            <ellipse
              class="cls-55"
              cx="520.81"
              cy="261.99"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.63 5.29) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="492.65"
              cy="247.91"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.48 5) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="505.77"
              cy="254.96"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.55 5.13) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="535.19"
              cy="253.35"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -2.54, 5.43)"
            />
            <ellipse
              class="cls-55"
              cx="549.07"
              cy="245.62"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -2.46, 5.57)"
            />
            <ellipse
              class="cls-55"
              cx="563.16"
              cy="237.69"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.38 5.71) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="577.04"
              cy="229.55"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.29 5.85) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="476.05 247.57 514.31 269.44 515.52 268.62 476.75 246.76 476.05 247.57"
            />
            <polygon
              class="cls-54"
              points="519.46 267.98 519.47 269.39 594.1 226.04 592.88 225.44 519.46 267.98"
            />
            <polygon
              class="cls-56"
              points="513.8 269.05 513.87 275.82 476.94 254.95 476.87 247.97 513.8 269.05"
            />
            <polygon
              class="cls-56"
              points="519.47 269.29 519.55 276.68 594.07 232.82 594 226.04 519.47 269.29"
            />
            <path
              class="cls-57"
              d="M521.88,247.11a3.51,3.51,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.47,1.47,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.31,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.1.3.2.51.4l.1.61h.31l.09-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="520.39 259.97 521 259.97 520.88 258.25 520.27 258.25 520.39 259.97"
            />
            <path
              class="cls-58"
              d="M520.29,250.36c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.6.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.5-.71.49-1c.2-.31,0-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M520.08,249.86c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.71-.12-1"
            />
            <g class="cls-172">
              <polygon
                class="cls-173"
                points="515.14 251.63 525.6 245.25 532.8 256.71 522.44 263.09 515.14 251.63"
              />
            </g>
            <g class="cls-174">
              <polygon
                class="cls-175"
                points="514.78 245.66 525.56 251.22 519.11 263.22 508.33 257.57 514.78 245.66"
              />
            </g>
            <polygon
              class="cls-58"
              points="519.67 259.17 520.09 260.08 520.51 262 521.02 261.99 521.3 259.96 521.59 259.15 519.67 259.17"
            />
            <path
              class="cls-57"
              d="M493.61,233a4.05,4.05,0,0,1-.41-.71c-.1-.2.09-.5-.11-.7s-.41-.3-.51-.61-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.6c.09-.21.3-.21.5-.41a7.9,7.9,0,0,0,.49-.82c.1-.2-.1-.5,0-.71a1.39,1.39,0,0,0,.29-.71c.1-.2-.2-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="492.22 245.89 492.73 245.89 492.61 244.07 492 244.17 492.22 245.89"
            />
            <path
              class="cls-58"
              d="M492.13,236.38c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.91.72-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.21-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M491.92,235.78c-.11-.31-.61-.5-.72-.71s-.1-.7-.31-1-.71-.3-.92-.5-.31-.71-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.3-.1-.1-.81c.09-.31.4-.31.49-.72s.3-1,.4-1.31-.21-.71-.22-1,.3-.72.19-1-.41-.6-.51-.9,0-.81-.11-1"
            />
            <g class="cls-176">
              <polygon
                class="cls-177"
                points="486.98 237.55 497.33 231.17 504.63 242.63 494.18 249.01 486.98 237.55"
              />
            </g>
            <g class="cls-178">
              <polygon
                class="cls-179"
                points="486.51 231.38 497.29 236.94 490.94 248.94 480.06 243.28 486.51 231.38"
              />
            </g>
            <polygon
              class="cls-58"
              points="491.41 245.19 491.82 245.9 492.24 247.91 492.85 247.91 493.03 245.88 493.33 245.07 491.41 245.19"
            />
            <path
              class="cls-57"
              d="M506.83,240.08a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.09.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="505.35 252.94 505.95 252.94 505.83 251.22 505.23 251.22 505.35 252.94"
            />
            <path
              class="cls-58"
              d="M505.25,243.33c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.86,5.86,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.91.72-1,1c-.3.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1c.2-.3,0-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M505,242.83c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.41.6.52.9-.1.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.22-1,.3-.71.2-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-180">
              <polygon
                class="cls-181"
                points="500.1 244.6 510.56 238.22 517.75 249.68 507.4 256.06 500.1 244.6"
              />
            </g>
            <g class="cls-182">
              <polygon
                class="cls-183"
                points="499.74 238.63 510.52 244.29 504.06 256.19 493.28 250.53 499.74 238.63"
              />
            </g>
            <polygon
              class="cls-58"
              points="504.63 252.24 505.04 252.94 505.47 254.96 505.97 254.96 506.25 252.93 506.55 252.22 504.63 252.24"
            />
            <path
              class="cls-57"
              d="M536.47,239.27a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.62.1.5,0,.7a1.46,1.46,0,0,0-.29.72c-.1.2.2.5.21.7s-.2.51-.1.71a3.51,3.51,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.52.71c.1.1.3.19.51.4l.1.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="534.98 252.24 535.49 252.23 535.47 250.41 534.86 250.52 534.98 252.24"
            />
            <path
              class="cls-58"
              d="M534.88,242.63c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.61,1-.19.71-.19,1.21c0,.3.32.71.32,1.11s-.5.71-.5,1,.11.81,0,1.11-.61.51-.81.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.41-.09.1-.91c-.21-.31-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21,0-.31-.31-.71-.31-1.11s.5-.72.49-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M534.67,242.12c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.51-.91.09-.81-.12-1"
            />
            <g class="cls-184">
              <polygon
                class="cls-185"
                points="529.74 243.89 540.09 237.41 547.39 248.97 537.03 255.25 529.74 243.89"
              />
            </g>
            <g class="cls-186">
              <polygon
                class="cls-187"
                points="529.37 237.82 540.15 243.48 533.7 255.39 522.91 249.73 529.37 237.82"
              />
            </g>
            <polygon
              class="cls-58"
              points="534.37 251.53 534.68 252.24 535.1 254.26 535.61 254.25 535.89 252.13 536.18 251.41 534.37 251.53"
            />
            <path
              class="cls-57"
              d="M550.45,231.24a3.51,3.51,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.52-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="548.96 244.2 549.46 244.1 549.45 242.38 548.84 242.38 548.96 244.2"
            />
            <path
              class="cls-58"
              d="M548.86,234.59c.1-.3.6-.51.7-.81s.1-.81.29-1.12a5.19,5.19,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.5,1,.11.81,0,1.12-.61.51-.81.81-.09.81-.29,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M548.65,234c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.71-.12-1"
            />
            <g class="cls-188">
              <polygon
                class="cls-189"
                points="543.72 235.86 554.07 229.38 561.37 240.94 551.01 247.22 543.72 235.86"
              />
            </g>
            <g class="cls-190">
              <polygon
                class="cls-191"
                points="543.35 229.79 554.13 235.45 547.68 247.35 536.9 241.69 543.35 229.79"
              />
            </g>
            <polygon
              class="cls-58"
              points="548.24 243.4 548.66 244.21 549.08 246.23 549.59 246.12 549.87 244.09 550.16 243.38 548.24 243.4"
            />
            <path
              class="cls-57"
              d="M564.23,223.31a4,4,0,0,1-.42-.71c-.1-.2.1-.5-.1-.7s-.41-.3-.52-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="562.74 236.27 563.35 236.27 563.23 234.45 562.52 234.45 562.74 236.27"
            />
            <path
              class="cls-58"
              d="M562.64,226.66c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22.32.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.5-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M562.43,226.16c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.81-.12-1"
            />
            <g class="cls-192">
              <polygon
                class="cls-193"
                points="557.49 227.83 567.95 221.55 575.25 232.91 564.79 239.39 557.49 227.83"
              />
            </g>
            <g class="cls-194">
              <polygon
                class="cls-195"
                points="557.13 221.86 567.91 227.52 561.46 239.52 550.67 233.76 557.13 221.86"
              />
            </g>
            <polygon
              class="cls-58"
              points="562.02 235.47 562.43 236.28 562.76 238.19 563.37 238.19 563.65 236.26 563.94 235.45 562.02 235.47"
            />
            <path
              class="cls-57"
              d="M578.4,214.87a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a4.32,4.32,0,0,1,.41.7c.11.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.3-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="577.02 227.73 577.52 227.73 577.4 226.01 576.8 226.01 577.02 227.73"
            />
            <path
              class="cls-58"
              d="M576.92,218.22c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12a3.23,3.23,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.09-.91c-.2-.3-.5-.4-.51-.7a8,8,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.11-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M576.71,217.62c-.1-.31-.61-.5-.71-.71s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.32.71.32,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.31-.21-.71-.21-1,.29-.72.19-1-.41-.6-.52-.9,0-.71-.11-1"
            />
            <g class="cls-196">
              <polygon
                class="cls-197"
                points="571.77 219.39 582.13 213.01 589.43 224.47 579.07 230.85 571.77 219.39"
              />
            </g>
            <g class="cls-198">
              <polygon
                class="cls-199"
                points="571.41 213.32 582.19 219.08 575.74 230.98 564.96 225.32 571.41 213.32"
              />
            </g>
            <polygon
              class="cls-58"
              points="576.3 227.03 576.61 227.74 577.14 229.75 577.64 229.75 577.83 227.72 578.22 226.91 576.3 227.03"
            />
          </g>
          <g id="plant2-6" data-name="plant2">
            <polygon
              class="cls-54"
              points="437.6 316.26 514.64 271.36 473.02 247.91 395.38 293.21 437.6 316.26"
            />
            <ellipse
              class="cls-55"
              cx="440.65"
              cy="307.42"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.09 4.48) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="412.28"
              cy="293.34"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.95 4.19) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="425.6"
              cy="300.39"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.02 4.32) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="454.92"
              cy="298.68"
              rx="3.84"
              ry="1.72"
              transform="translate(-3 4.62) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="468.81"
              cy="291.05"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.92 4.76) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="482.99"
              cy="283.12"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.84 4.9) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="496.77"
              cy="274.98"
              rx="3.84"
              ry="1.72"
              transform="translate(-2.76 5.04) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="395.68 293.01 434.04 314.88 435.25 313.95 396.49 292.19 395.68 293.01"
            />
            <polygon
              class="cls-54"
              points="439.11 315.23 439.12 316.65 513.85 273.39 512.53 272.8 439.11 315.23"
            />
            <polygon
              class="cls-56"
              points="433.43 314.38 433.5 321.26 396.77 300.28 396.5 293.4 433.43 314.38"
            />
            <polygon
              class="cls-56"
              points="439.22 316.44 439.29 323.83 513.91 280.07 513.85 273.19 439.22 316.44"
            />
            <path
              class="cls-57"
              d="M441.61,292.54a3.7,3.7,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.11,0-.11,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.68,1.68,0,0,0-.29.72c-.1.2.21.5.21.7s-.2.51-.1.71a4,4,0,0,1,.42.71c.1.2,0,.5.1.7a4.36,4.36,0,0,0,.52.71c.1.2.3.19.51.4l.1.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.1-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="440.22 305.4 440.73 305.4 440.61 303.58 440 303.59 440.22 305.4"
            />
            <path
              class="cls-58"
              d="M440.12,295.79c.1-.3.6-.51.7-.81s.1-.81.3-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.19c.1,0,.11.1.11.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1,.1.8,0,1.11-.61.51-.8.82-.1.81-.3,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41A11.86,11.86,0,0,0,440,299c0-.3-.31-.7-.31-1.11s.5-.71.49-1-.21-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M439.81,295.29c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.62.4.72.7.11.7.31,1a7.73,7.73,0,0,0,1,.8c.31.19.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-200">
              <polygon
                class="cls-201"
                points="434.98 297.06 445.33 290.68 452.63 302.14 442.17 308.52 434.98 297.06"
              />
            </g>
            <g class="cls-202">
              <polygon
                class="cls-203"
                points="434.51 290.99 445.29 296.75 438.84 308.66 428.06 303 434.51 290.99"
              />
            </g>
            <polygon
              class="cls-58"
              points="439.4 304.7 439.82 305.41 440.24 307.43 440.75 307.32 441.03 305.4 441.32 304.58 439.4 304.7"
            />
            <path
              class="cls-57"
              d="M413.34,278.46a4.32,4.32,0,0,1-.41-.7c-.1-.21.1-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.62.11.5,0,.7a1.58,1.58,0,0,0-.3.71c0,.31.21.51.21.71s-.2.51-.09.71a4.32,4.32,0,0,1,.41.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.21.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.09-.2-.11-.5,0-.7a1.46,1.46,0,0,0,.29-.72c.1-.2-.2-.5-.2-.7s.29-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="411.85 291.32 412.46 291.32 412.44 289.5 411.73 289.61 411.85 291.32"
            />
            <path
              class="cls-58"
              d="M411.86,281.81c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.29-.71.59-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.21.3,0,.8.11,1.11s.52.7.62,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.23,3.23,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.09.09-.92c-.2-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M411.55,281.21c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.3.1.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.39.71.7.11.7.32,1a6.05,6.05,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.1-.81c.09-.3.4-.31.49-.71s.3-1,.4-1.32-.21-.71-.22-1,.3-.71.19-1-.41-.61-.51-.91.09-.81-.11-1"
            />
            <g class="cls-204">
              <polygon
                class="cls-205"
                points="406.61 282.98 417.07 276.6 424.26 288.06 413.91 294.44 406.61 282.98"
              />
            </g>
            <g class="cls-206">
              <polygon
                class="cls-207"
                points="406.34 276.71 417.12 282.37 410.57 294.37 399.79 288.71 406.34 276.71"
              />
            </g>
            <polygon
              class="cls-58"
              points="411.24 290.62 411.55 291.33 411.98 293.35 412.48 293.34 412.76 291.31 413.06 290.5 411.24 290.62"
            />
            <path
              class="cls-57"
              d="M426.56,285.41a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.31,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.31.19-.61"
            />
            <polygon
              class="cls-58"
              points="425.18 298.37 425.68 298.37 425.56 296.65 424.96 296.66 425.18 298.37"
            />
            <path
              class="cls-58"
              d="M425.08,288.76c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1a4.2,4.2,0,0,1,0,1.12c-.1.3-.6.51-.8.81s-.09.82-.29,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22,0-.3-.31-.7-.31-1.11s.49-.71.49-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M424.77,288.26c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.5.92.31.7.32,1-.3.71-.2,1,.42.6.52.9-.09.71.11,1,.61.39.72.7.1.7.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.52-.91.1-.71-.11-1"
            />
            <g class="cls-208">
              <polygon
                class="cls-209"
                points="419.93 290.03 430.29 283.65 437.59 295.11 427.13 301.49 419.93 290.03"
              />
            </g>
            <g class="cls-210">
              <polygon
                class="cls-211"
                points="419.47 284.06 430.25 289.62 423.79 301.63 413.01 295.87 419.47 284.06"
              />
            </g>
            <polygon
              class="cls-58"
              points="424.36 297.57 424.77 298.38 425.2 300.4 425.7 300.39 425.99 298.37 426.28 297.55 424.36 297.57"
            />
            <path
              class="cls-57"
              d="M456.1,284.7a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.21.71s-.2.5-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.5.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71a.57.57,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="454.71 297.67 455.32 297.66 455.2 295.84 454.49 295.95 454.71 297.67"
            />
            <path
              class="cls-58"
              d="M454.61,288.06c.1-.31.6-.51.7-.82s.1-.81.29-1.11a5.19,5.19,0,0,0,1-.62c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.21c0,.31.31.71.31,1.11s-.5.72-.5,1,.11.81,0,1.11-.61.52-.81.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.6.21-.9.51l-.4.82-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a9,9,0,0,1-.52-1.42,12.06,12.06,0,0,0,.19-1.21c0-.31-.31-.71-.31-1.11s.5-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M454.4,287.45c-.1-.3-.61-.5-.71-.7s-.11-.7-.31-1-.72-.29-.92-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.39l.41.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.51-.91.09-.7-.12-1"
            />
            <g class="cls-212">
              <polygon
                class="cls-213"
                points="449.47 289.32 459.92 282.85 467.12 294.41 456.76 300.69 449.47 289.32"
              />
            </g>
            <g class="cls-214">
              <polygon
                class="cls-215"
                points="449.1 283.26 459.88 288.92 453.43 300.82 442.65 295.16 449.1 283.26"
              />
            </g>
            <polygon
              class="cls-58"
              points="453.99 296.87 454.31 297.67 454.83 299.69 455.34 299.69 455.62 297.66 455.81 296.85 453.99 296.87"
            />
            <path
              class="cls-57"
              d="M470.08,276.67a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.46,1.46,0,0,0-.29.72c-.1.2.2.5.21.7s-.2.51-.1.71a3.51,3.51,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.52.71c.1.1.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="468.69 289.64 469.19 289.53 469.18 287.81 468.47 287.82 468.69 289.64"
            />
            <path
              class="cls-58"
              d="M468.59,280c.1-.31.6-.52.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.11.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.71.31,1.11-.5.71-.49,1,.1.81,0,1.11-.61.51-.8.82-.1.81-.3,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.41-.09.1-.91c-.21-.31-.51-.4-.52-.71a8.93,8.93,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M468.38,279.42c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.62.39.72.7.11.7.31,1a6.87,6.87,0,0,0,1,.79c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-216">
              <polygon
                class="cls-217"
                points="463.45 281.29 473.9 274.81 481.1 286.27 470.74 292.65 463.45 281.29"
              />
            </g>
            <g class="cls-218">
              <polygon
                class="cls-219"
                points="463.08 275.22 473.86 280.88 467.31 292.79 456.63 287.13 463.08 275.22"
              />
            </g>
            <polygon
              class="cls-58"
              points="467.97 288.83 468.29 289.64 468.81 291.56 469.32 291.55 469.6 289.53 469.79 288.71 467.97 288.83"
            />
            <path
              class="cls-57"
              d="M484,268.74a3.7,3.7,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.47,1.47,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.31,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.1.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="482.47 281.61 482.97 281.6 482.96 279.88 482.35 279.89 482.47 281.61"
            />
            <path
              class="cls-58"
              d="M482.37,272.09c.1-.3.6-.51.7-.81s.1-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.71.31,1.11-.5.71-.5,1,.11.81,0,1.11-.61.51-.81.82-.09.81-.29,1.11-.9.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.39-.52-.7a8.93,8.93,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22s-.31-.7-.31-1.11.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M482.16,271.59c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.5-.31-.7-.61-.8c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.62.4.72.7.11.7.31,1a7.73,7.73,0,0,0,1,.8c.31.19.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91,0-.81-.12-1"
            />
            <g class="cls-220">
              <polygon
                class="cls-221"
                points="477.23 273.26 487.58 266.98 494.88 278.44 484.52 284.82 477.23 273.26"
              />
            </g>
            <g class="cls-222">
              <polygon
                class="cls-223"
                points="476.86 267.29 487.64 272.95 481.19 284.86 470.41 279.3 476.86 267.29"
              />
            </g>
            <polygon
              class="cls-58"
              points="481.75 280.9 482.17 281.61 482.59 283.63 483.1 283.62 483.38 281.6 483.68 280.88 481.75 280.9"
            />
            <path
              class="cls-57"
              d="M498.14,260.3a4.3,4.3,0,0,1-.42-.7c-.1-.21.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.62.1.5,0,.7a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.21,0,.51.11.71a4.9,4.9,0,0,0,.51.7c.11.21.31.2.51.4l.11.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="496.75 273.16 497.25 273.16 497.24 271.44 496.53 271.45 496.75 273.16"
            />
            <path
              class="cls-58"
              d="M496.65,263.65c.1-.3.6-.51.7-.81s.09-.81.29-1.12a4.74,4.74,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.19c.1,0,.1.1.11.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.5,1,.11.8,0,1.11-.61.51-.81.82-.09.81-.29,1.11-.9.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M496.44,263.05c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.71.11.7.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-224">
              <polygon
                class="cls-225"
                points="491.4 264.82 501.86 258.44 509.16 269.9 498.8 276.28 491.4 264.82"
              />
            </g>
            <g class="cls-226">
              <polygon
                class="cls-227"
                points="491.14 258.75 501.92 264.51 495.36 276.31 484.58 270.76 491.14 258.75"
              />
            </g>
            <polygon
              class="cls-58"
              points="496.03 272.46 496.34 273.17 496.77 275.19 497.27 275.18 497.66 273.15 497.85 272.34 496.03 272.46"
            />
          </g>
          <polygon
            class="cls-228"
            points="393.49 276.54 390.54 274.95 391.57 375.91 394.52 378.11 393.49 276.54"
          />
          <polygon
            class="cls-229"
            points="437.15 401.96 439.96 400.01 438.9 294.9 436.08 296.54 437.15 401.96"
          />
          <polygon
            class="cls-54"
            points="435.98 296.54 438.8 295 393.23 270.26 390.51 271.91 435.98 296.54"
          />
          <polygon
            class="cls-229"
            points="474.12 226.34 474.14 228.67 514.13 250.93 514.1 248.5 474.12 226.34"
          />
          <polygon
            class="cls-54"
            points="551.23 178.51 553.67 179.81 393.26 273.3 390.51 271.81 551.23 178.51"
          />
          <polygon
            class="cls-54"
            points="591.34 203.61 594.26 201.86 551.63 178.21 548.71 179.96 591.34 203.61"
          />
          <polygon
            class="cls-229"
            points="595.05 310.11 597.86 308.36 596.8 203.35 593.99 205 595.05 310.11"
          />
          <polygon
            class="cls-229"
            points="517.3 354.3 520.21 352.45 519.18 250.58 516.26 252.12 517.3 354.3"
          />
          <polygon
            class="cls-228"
            points="516.27 252.63 513.42 251.04 514.44 352.01 517.3 354.3 516.27 252.63"
          />
          <polygon
            class="cls-230"
            points="551.26 181.35 551.28 183.78 591.37 206.03 591.34 203.61 551.26 181.35"
          />
          <polygon
            class="cls-54"
            points="594.26 201.86 596.8 203.35 435.98 296.54 433.34 295.15 594.26 201.86"
          />
          <polygon
            class="cls-229"
            points="436.12 300.29 596.83 206.38 596.8 203.35 436.08 296.54 436.12 300.29"
          />
          <polygon
            class="cls-54"
            points="514.4 248.5 516.92 247.06 476.43 224.8 474.12 226.14 514.4 248.5"
          />
          <polygon
            class="cls-228"
            points="436.12 299.68 433.27 298.09 434.29 399.26 437.15 401.56 436.12 299.68"
          />
          <polygon
            class="cls-229"
            points="394.53 379.02 397.34 377.07 396.34 278.23 393.49 276.54 394.53 379.02"
          />
          <polygon
            class="cls-228"
            points="390.51 271.81 435.98 296.54 436.02 300.29 390.54 274.95 390.51 271.81"
          />
          <g id="plant2-7" data-name="plant2">
            <polygon
              class="cls-54"
              points="360.57 412.25 437.61 367.35 396 343.9 318.36 389.2 360.57 412.25"
            />
            <ellipse
              class="cls-55"
              cx="363.52"
              cy="403.31"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.06 3.7) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="335.25"
              cy="389.23"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.92 3.41) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="348.47"
              cy="396.28"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.99 3.55) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="377.9"
              cy="394.57"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.97 3.85) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="391.78"
              cy="386.94"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.9 3.99) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="405.86"
              cy="379.01"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -3.82, 4.13)"
            />
            <ellipse
              class="cls-55"
              cx="419.74"
              cy="370.87"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.73 4.27) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="318.66 388.89 357.02 410.77 358.22 409.94 319.46 388.08 318.66 388.89"
            />
            <polygon
              class="cls-54"
              points="362.06 409.3 362.07 410.71 436.8 367.36 435.58 366.67 362.06 409.3"
            />
            <polygon
              class="cls-56"
              points="356.41 410.37 356.47 417.05 319.64 396.27 319.47 389.29 356.41 410.37"
            />
            <polygon
              class="cls-56"
              points="362.07 410.51 362.15 417.9 436.77 374.14 436.7 367.26 362.07 410.51"
            />
            <path
              class="cls-57"
              d="M364.58,388.33a4.05,4.05,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.61c.1-.21.31-.21.51-.41a2.6,2.6,0,0,0,.49-.82c.1-.2-.1-.5,0-.7a1.46,1.46,0,0,0,.29-.72c.1-.2-.2-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="363.09 401.3 363.6 401.29 363.58 399.57 362.97 399.58 363.09 401.3"
            />
            <path
              class="cls-58"
              d="M363.1,391.68c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5.44,5.44,0,0,0,1-.62c.3-.2.3-.71.6-1a.11.11,0,0,0,.1-.11,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.09.82-.29,1.12a3.12,3.12,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M362.79,391.18c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.39.71.7.11.7.32,1a3.28,3.28,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-231">
              <polygon
                class="cls-232"
                points="357.85 392.95 368.2 386.57 375.6 398.03 365.15 404.41 357.85 392.95"
              />
            </g>
            <g class="cls-233">
              <polygon
                class="cls-234"
                points="357.48 386.98 368.26 392.54 361.81 404.55 351.03 398.79 357.48 386.98"
              />
            </g>
            <polygon
              class="cls-58"
              points="362.38 400.49 362.79 401.3 363.21 403.32 363.72 403.31 364 401.29 364.3 400.47 362.38 400.49"
            />
            <path
              class="cls-57"
              d="M336.31,374.35a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.2.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="334.83 387.21 335.43 387.21 335.42 385.39 334.71 385.39 334.83 387.21"
            />
            <path
              class="cls-58"
              d="M334.73,377.7c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.11,1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.21.3,0,.8.12,1.11s.51.7.61,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.09.09-.92c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.49-.71.49-1c.2-.41,0-.91,0-1.12"
            />
            <path
              class="cls-59"
              d="M334.52,377.1c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.5.92.31.7.32,1-.3.72-.2,1,.42.6.52.9-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.81-.11-1"
            />
            <g class="cls-235">
              <polygon
                class="cls-236"
                points="329.58 378.87 340.04 372.49 347.24 383.95 336.88 390.33 329.58 378.87"
              />
            </g>
            <g class="cls-237">
              <polygon
                class="cls-238"
                points="329.32 372.7 340.1 378.26 333.54 390.26 322.76 384.5 329.32 372.7"
              />
            </g>
            <polygon
              class="cls-58"
              points="334.11 386.51 334.52 387.22 334.95 389.24 335.45 389.13 335.74 387.2 336.03 386.39 334.11 386.51"
            />
            <path
              class="cls-57"
              d="M349.54,381.4a3.51,3.51,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.32-.71c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71-.3.41-.29.71.21.51.21.71-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.2,0,.51.1.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.1-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="348.05 394.26 348.56 394.26 348.54 392.54 347.93 392.55 348.05 394.26"
            />
            <path
              class="cls-58"
              d="M348.05,384.65c.1-.3.6-.51.7-.82s.1-.81.29-1.11a5.19,5.19,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.5,1,.11.81,0,1.12-.61.51-.8.81-.1.81-.3,1.12a3.23,3.23,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.51-.31-.7-.31-1.11s.5-.71.49-1-.21-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M347.74,384.15c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.71-.12-1"
            />
            <g class="cls-239">
              <polygon
                class="cls-240"
                points="342.81 385.92 353.16 379.44 360.46 391 350.1 397.28 342.81 385.92"
              />
            </g>
            <g class="cls-241">
              <polygon
                class="cls-242"
                points="342.44 379.85 353.22 385.61 346.76 397.41 335.99 391.86 342.44 379.85"
              />
            </g>
            <polygon
              class="cls-58"
              points="347.33 393.56 347.75 394.27 348.17 396.29 348.68 396.28 348.96 394.25 349.25 393.44 347.33 393.56"
            />
            <path
              class="cls-57"
              d="M379.07,380.59a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a6.14,6.14,0,0,1,.41.71c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41s.49-.71.49-.81-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.21-.5-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="377.68 393.46 378.29 393.45 378.17 391.73 377.46 391.74 377.68 393.46"
            />
            <path
              class="cls-58"
              d="M377.59,384c.09-.31.6-.51.7-.82s.09-.81.29-1.11a6,6,0,0,0,1-.62c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.29,1.12-.91.71-1,1c-.3.2-.6.21-.9.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M377.38,383.44c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.2-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.81-.11-1"
            />
            <g class="cls-243">
              <polygon
                class="cls-244"
                points="372.44 385.11 382.89 378.73 390.09 390.3 379.74 396.57 372.44 385.11"
              />
            </g>
            <g class="cls-245">
              <polygon
                class="cls-246"
                points="372.07 379.15 382.86 384.81 376.4 396.71 365.62 391.05 372.07 379.15"
              />
            </g>
            <polygon
              class="cls-58"
              points="376.97 392.86 377.28 393.56 377.7 395.58 378.31 395.48 378.59 393.45 378.89 392.74 376.97 392.86"
            />
            <path
              class="cls-57"
              d="M393.05,372.56a4.32,4.32,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.21.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41a7.6,7.6,0,0,0,.49-.82c.1-.2-.1-.5,0-.7a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="391.66 385.42 392.17 385.42 392.15 383.7 391.44 383.71 391.66 385.42"
            />
            <path
              class="cls-58"
              d="M391.56,375.81c.1-.3.61-.51.7-.81s.1-.81.3-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1a.11.11,0,0,0,.1-.11,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1,.11.81,0,1.12-.6.51-.8.82-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.32-.7-.32-1.11.5-.71.5-1-.11-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M391.36,375.31c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.7,0,1.11s-.5.61-.5.92.31.7.31,1-.29.72-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.71.11.7.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-247">
              <polygon
                class="cls-248"
                points="386.42 377.08 396.88 370.7 404.07 382.26 393.72 388.54 386.42 377.08"
              />
            </g>
            <g class="cls-249">
              <polygon
                class="cls-250"
                points="386.05 371.11 396.83 376.67 390.28 388.68 379.5 383.02 386.05 371.11"
              />
            </g>
            <polygon
              class="cls-58"
              points="390.95 384.72 391.26 385.43 391.68 387.45 392.19 387.44 392.57 385.42 392.77 384.7 390.95 384.72"
            />
            <path
              class="cls-57"
              d="M406.83,364.63a4.32,4.32,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.11,0-.11,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.1.5,0,.7a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.21.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41s.49-.71.49-.82-.1-.5,0-.7.3-.41.29-.71-.21-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="405.44 377.6 405.95 377.59 405.93 375.77 405.22 375.78 405.44 377.6"
            />
            <path
              class="cls-58"
              d="M405.35,368c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.49,1a4.12,4.12,0,0,1,0,1.11c-.1.3-.6.51-.8.82s-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M405.14,367.38c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.09.3.11.7,0,1.11s-.5.61-.5.92.31.7.31,1-.29.72-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.71.11.7.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.6-.51-.9,0-.71-.11-1"
            />
            <g class="cls-251">
              <polygon
                class="cls-252"
                points="400.2 369.15 410.55 362.77 417.85 374.23 407.5 380.61 400.2 369.15"
              />
            </g>
            <g class="cls-253">
              <polygon
                class="cls-254"
                points="399.83 363.08 410.61 368.84 404.16 380.74 393.38 375.09 399.83 363.08"
              />
            </g>
            <polygon
              class="cls-58"
              points="404.73 376.79 405.04 377.6 405.56 379.52 406.07 379.51 406.35 377.59 406.55 376.67 404.73 376.79"
            />
            <path
              class="cls-57"
              d="M421.11,356.19a4.05,4.05,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.31-.71c-.11,0-.11,0-.11-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.1.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.2,0,.51.1.71a4.89,4.89,0,0,0,.52.7c.1.2.3.2.51.4l.11.61h.3l.09-.61c.1-.21.3-.21.51-.41s.49-.72.49-.82-.1-.5,0-.7a1.68,1.68,0,0,0,.29-.72c.1-.2-.21-.5-.21-.7a1.11,1.11,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="419.72 369.05 420.23 369.05 420.21 367.23 419.5 367.33 419.72 369.05"
            />
            <path
              class="cls-58"
              d="M419.63,359.54c.09-.3.6-.51.69-.81s.1-.81.3-1.12a5.44,5.44,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.1.81-.29,1.12-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M419.42,358.94c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.09.3.11.7,0,1.11s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.6-.51-.9.09-.81-.11-1"
            />
            <g class="cls-255">
              <polygon
                class="cls-256"
                points="414.38 360.71 424.83 354.33 432.13 365.79 421.68 372.17 414.38 360.71"
              />
            </g>
            <g class="cls-257">
              <polygon
                class="cls-258"
                points="414.11 354.64 424.79 360.4 418.34 372.3 407.56 366.65 414.11 354.64"
              />
            </g>
            <polygon
              class="cls-58"
              points="419.01 368.35 419.32 369.06 419.74 371.08 420.25 371.07 420.63 368.94 420.83 368.23 419.01 368.35"
            />
          </g>
          <g id="plant2-8" data-name="plant2">
            <polygon
              class="cls-54"
              points="359.92 387.87 437.06 343.08 395.35 319.62 317.71 364.93 359.92 387.87"
            />
            <ellipse
              class="cls-55"
              cx="362.97"
              cy="379.04"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.82 3.69) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="334.7"
              cy="364.96"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.68 3.41) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="347.92"
              cy="372.01"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.75 3.54) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="377.24"
              cy="370.29"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.73 3.84) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="391.23"
              cy="362.66"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.65 3.98) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="405.31"
              cy="354.83"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.57 4.12) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="419.19"
              cy="346.6"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.49 4.26) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="318.11 364.62 356.47 386.49 357.67 385.57 318.81 363.8 318.11 364.62"
            />
            <polygon
              class="cls-54"
              points="361.51 385.02 361.53 386.44 436.15 342.98 434.93 342.49 361.51 385.02"
            />
            <polygon
              class="cls-56"
              points="355.86 386.09 355.93 392.87 319.09 371.89 318.92 365.12 355.86 386.09"
            />
            <polygon
              class="cls-56"
              points="361.52 386.34 361.6 393.72 436.22 349.96 436.15 342.98 361.52 386.34"
            />
            <path
              class="cls-57"
              d="M363.93,364.15a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.11a.77.77,0,0,0-.91,0c-.11,0-.11,0-.11.11s-.09.5-.19.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a5.39,5.39,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.1.1.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="362.54 377.02 363.05 377.01 363.03 375.19 362.32 375.3 362.54 377.02"
            />
            <path
              class="cls-58"
              d="M362.45,367.51c.09-.31.6-.51.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12a3,3,0,0,0-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M362.24,366.9c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.1-.81c.09-.3.4-.3.49-.71s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-259">
              <polygon
                class="cls-260"
                points="357.3 368.67 367.65 362.29 374.95 373.75 364.5 380.13 357.3 368.67"
              />
            </g>
            <g class="cls-261">
              <polygon
                class="cls-262"
                points="356.93 362.61 367.62 368.37 361.26 380.27 350.38 374.61 356.93 362.61"
              />
            </g>
            <polygon
              class="cls-58"
              points="361.83 376.32 362.14 377.02 362.56 379.04 363.17 379.04 363.45 377.01 363.65 376.2 361.83 376.32"
            />
            <path
              class="cls-57"
              d="M335.77,350.07a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.49.62.1.5,0,.7a1.46,1.46,0,0,0-.29.72c-.1.2.2.5.21.7s-.2.51-.1.71a4.05,4.05,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.11.2.31.19.51.4l.11.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="334.28 362.94 334.78 362.93 334.76 361.21 334.16 361.22 334.28 362.94"
            />
            <path
              class="cls-58"
              d="M334.18,353.43c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.72.59-1a.09.09,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.72-.19,1.22c0,.3.31.71.32,1.11s-.5.71-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11-.9.72-1,1c-.3.2-.61.2-.91.51l-.39.81-.41-.09.09-.91c-.2-.31-.51-.4-.51-.71a7.76,7.76,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.49-.72.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M334,352.82c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.5.92.31.7.32,1-.3.71-.19,1,.41.6.51.91-.09.7.11,1,.61.39.72.7.11.7.31,1a3.71,3.71,0,0,0,1,.8c.31.19.51.19.81.39l.42.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.52-.91.1-.71-.11-1"
            />
            <g class="cls-263">
              <polygon
                class="cls-264"
                points="329.03 354.59 339.39 348.21 346.69 359.67 336.33 366.05 329.03 354.59"
              />
            </g>
            <g class="cls-265">
              <polygon
                class="cls-266"
                points="328.67 348.32 339.45 354.08 332.99 365.98 322.21 360.33 328.67 348.32"
              />
            </g>
            <polygon
              class="cls-58"
              points="333.56 362.24 333.97 362.94 334.4 364.96 334.9 364.95 335.19 362.93 335.48 362.21 333.56 362.24"
            />
            <path
              class="cls-57"
              d="M348.89,357.12a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.72-.51.3-.5.61.1.5,0,.71a1.39,1.39,0,0,0-.29.71c-.1.2.2.5.21.7s-.2.51-.1.71a3.51,3.51,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="347.5 369.99 348 369.98 347.99 368.26 347.28 368.27 347.5 369.99"
            />
            <path
              class="cls-58"
              d="M347.4,360.37c.1-.3.6-.51.7-.81s.1-.81.29-1.12a4.74,4.74,0,0,0,1-.62c.3-.3.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.2c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.5,1,.11.8,0,1.11-.61.51-.81.82-.09.81-.29,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.39-.52-.7a8.93,8.93,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.1-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M347.19,359.87c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.61-.8c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.7.11,1,.62.39.72.7.11.7.31,1a3.48,3.48,0,0,0,1,.79c.31.2.51.2.82.4l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-267">
              <polygon
                class="cls-268"
                points="342.26 361.64 352.61 355.26 359.91 366.72 349.45 373.1 342.26 361.64"
              />
            </g>
            <g class="cls-269">
              <polygon
                class="cls-270"
                points="341.89 355.68 352.57 361.33 346.22 373.24 335.33 367.58 341.89 355.68"
              />
            </g>
            <polygon
              class="cls-58"
              points="346.78 369.29 347.1 370.09 347.52 372.01 348.13 372 348.41 369.98 348.61 369.27 346.78 369.29"
            />
            <path
              class="cls-57"
              d="M378.52,356.32a5,5,0,0,1-.41-.71c-.11-.2.09-.5-.11-.71s-.41-.29-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.11-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.6c.1-.21.31-.21.51-.41s.49-.72.49-.82-.1-.5,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.7a.59.59,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="377.03 369.28 377.64 369.28 377.62 367.56 376.91 367.56 377.03 369.28"
            />
            <path
              class="cls-58"
              d="M377,359.67c.09-.3.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.22.31.7.31,1.1-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.56,7.56,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.71-.32-1.11.5-.71.5-1-.11-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M376.73,359.07c-.11-.31-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.71-.61-.8c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.31.41-.31.5-.72s.3-1,.39-1.31-.21-.71-.21-1,.3-.72.19-1-.41-.6-.51-.9.09-.61-.11-1"
            />
            <g class="cls-271">
              <polygon
                class="cls-272"
                points="371.79 360.94 382.24 354.46 389.54 366.02 379.19 372.4 371.79 360.94"
              />
            </g>
            <g class="cls-273">
              <polygon
                class="cls-274"
                points="371.53 354.97 382.31 360.53 375.75 372.43 364.97 366.77 371.53 354.97"
              />
            </g>
            <polygon
              class="cls-58"
              points="376.42 368.48 376.73 369.29 377.15 371.31 377.66 371.3 378.04 369.27 378.24 368.46 376.42 368.48"
            />
            <path
              class="cls-57"
              d="M392.5,348.28a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.11,0-.11,0-.11.11s-.09.5-.19.71-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="391.11 361.25 391.62 361.24 391.6 359.42 390.89 359.43 391.11 361.25"
            />
            <path
              class="cls-58"
              d="M391,351.64c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.15,3.15,0,0,0-1,1c-.31.2-.61.2-.91.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M390.71,351c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.6-.11-1"
            />
            <g class="cls-275">
              <polygon
                class="cls-276"
                points="385.77 352.9 396.23 346.42 403.52 357.88 393.17 364.26 385.77 352.9"
              />
            </g>
            <g class="cls-277">
              <polygon
                class="cls-278"
                points="385.5 346.84 396.29 352.49 389.73 364.4 378.95 358.74 385.5 346.84"
              />
            </g>
            <polygon
              class="cls-58"
              points="390.4 360.44 390.71 361.25 391.13 363.17 391.64 363.17 391.92 361.24 392.22 360.33 390.4 360.44"
            />
            <path
              class="cls-57"
              d="M406.28,340.45a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.11a.77.77,0,0,0-.91,0c-.11,0-.11,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a5.39,5.39,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a2.31,2.31,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="404.89 353.32 405.4 353.21 405.28 351.49 404.67 351.5 404.89 353.32"
            />
            <path
              class="cls-58"
              d="M404.8,343.81c.1-.31.6-.51.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21c0,.31.31.71.31,1.11s-.49.72-.49,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.6.51-.8.82s-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1a3.75,3.75,0,0,1,0-1.11"
            />
            <path
              class="cls-59"
              d="M404.59,343.2c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.3-.11-.1-.81c.09-.3.4-.3.49-.71s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.91,0-.81-.11-1"
            />
            <g class="cls-279">
              <polygon
                class="cls-280"
                points="399.65 344.97 410 338.59 417.3 350.06 406.85 356.43 399.65 344.97"
              />
            </g>
            <g class="cls-281">
              <polygon
                class="cls-282"
                points="399.18 338.91 410.07 344.67 403.51 356.47 392.83 350.91 399.18 338.91"
              />
            </g>
            <polygon
              class="cls-58"
              points="404.18 352.62 404.49 353.32 404.91 355.34 405.42 355.23 405.7 353.21 406 352.5 404.18 352.62"
            />
            <path
              class="cls-57"
              d="M420.56,331.91a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.57,1.57,0,0,0-.3.72c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.3.19.51.4l.11.6h.3l.09-.61c.1-.2.31-.21.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="419.07 344.78 419.68 344.77 419.66 343.05 418.95 343.06 419.07 344.78"
            />
            <path
              class="cls-58"
              d="M419,335.27c.1-.31.61-.52.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.11,0,.11.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.72-.19,1.22c0,.3.31.71.31,1.11s-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.3,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.32-.71-.32-1.11.5-.72.5-1c.19-.41,0-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M418.77,334.76c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.81-.11-1"
            />
            <g class="cls-283">
              <polygon
                class="cls-284"
                points="413.83 336.43 424.28 330.05 431.48 341.62 421.13 347.89 413.83 336.43"
              />
            </g>
            <g class="cls-285">
              <polygon
                class="cls-286"
                points="413.46 330.46 424.24 336.12 417.79 348.03 407.01 342.37 413.46 330.46"
              />
            </g>
            <polygon
              class="cls-58"
              points="418.36 344.07 418.77 344.78 419.19 346.8 419.7 346.79 419.98 344.77 420.28 344.06 418.36 344.07"
            />
          </g>
          <g id="plant2-9" data-name="plant2">
            <polygon
              class="cls-54"
              points="359.97 362.57 437.01 317.68 395.29 294.22 317.75 339.53 359.97 362.57"
            />
            <ellipse
              class="cls-55"
              cx="362.91"
              cy="353.64"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.56 3.69) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="334.75"
              cy="339.56"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.42 3.41) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="347.87"
              cy="346.61"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.49 3.54) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="377.29"
              cy="345"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.47 3.84) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="391.17"
              cy="337.27"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.39 3.98) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="405.26"
              cy="329.33"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.31 4.12) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="419.14"
              cy="321.2"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.23 4.26) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="318.15 339.22 356.41 361.09 357.62 360.27 318.85 338.4 318.15 339.22"
            />
            <polygon
              class="cls-54"
              points="361.56 359.62 361.57 361.04 436.2 317.69 434.98 317.09 361.56 359.62"
            />
            <polygon
              class="cls-56"
              points="355.9 360.69 355.97 367.47 319.04 346.6 318.97 339.62 355.9 360.69"
            />
            <polygon
              class="cls-56"
              points="361.57 360.94 361.65 368.32 436.16 324.47 436.1 317.69 361.57 360.94"
            />
            <path
              class="cls-57"
              d="M364,338.76a4,4,0,0,1-.42-.71c-.1-.2.1-.5-.1-.7s-.41-.3-.52-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="362.49 351.62 363.1 351.62 362.98 349.9 362.37 349.9 362.49 351.62"
            />
            <path
              class="cls-58"
              d="M362.39,342c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.31.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1a3.82,3.82,0,0,1,0,1.12c-.09.3-.6.51-.8.81s-.09.81-.29,1.12-.9.72-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.34,8.34,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.71-.31-1.11s.5-.71.49-1c.2-.3,0-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M362.18,341.51c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-287">
              <polygon
                class="cls-288"
                points="357.24 343.28 367.7 336.9 374.9 348.36 364.54 354.74 357.24 343.28"
              />
            </g>
            <g class="cls-289">
              <polygon
                class="cls-290"
                points="356.88 337.31 367.66 342.87 361.21 354.87 350.43 349.21 356.88 337.31"
              />
            </g>
            <polygon
              class="cls-58"
              points="361.77 350.82 362.19 351.73 362.61 353.64 363.12 353.64 363.4 351.61 363.69 350.8 361.77 350.82"
            />
            <path
              class="cls-57"
              d="M335.71,324.68a5,5,0,0,1-.41-.71c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.2-.1-.5,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.2-.4.2-.6"
            />
            <polygon
              class="cls-58"
              points="334.32 337.54 334.83 337.53 334.71 335.71 334.1 335.82 334.32 337.54"
            />
            <path
              class="cls-58"
              d="M334.23,328c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M334,327.42c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.39l.41.71.3-.11-.1-.8c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.9,0-.81-.11-1"
            />
            <g class="cls-291">
              <polygon
                class="cls-292"
                points="329.08 329.19 339.44 322.82 346.73 334.28 336.28 340.66 329.08 329.19"
              />
            </g>
            <g class="cls-293">
              <polygon
                class="cls-294"
                points="328.61 323.03 339.39 328.58 333.04 340.59 322.16 334.93 328.61 323.03"
              />
            </g>
            <polygon
              class="cls-58"
              points="333.51 336.84 333.92 337.54 334.34 339.56 334.95 339.56 335.13 337.53 335.43 336.72 333.51 336.84"
            />
            <path
              class="cls-57"
              d="M348.93,331.73a6.14,6.14,0,0,1-.41-.71c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.19.5-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.5,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.2-.4.19-.6"
            />
            <polygon
              class="cls-58"
              points="347.44 344.59 348.05 344.58 347.93 342.87 347.33 342.87 347.44 344.59"
            />
            <path
              class="cls-58"
              d="M347.35,335c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21,0-.3-.31-.71-.32-1.11s.5-.71.5-1c.2-.3,0-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M347.14,334.48c-.1-.31-.61-.5-.72-.71s-.1-.7-.31-1-.71-.3-.91-.5-.32-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.41.61.52.91-.1.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.1-.11-.81c.09-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.72.2-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-295">
              <polygon
                class="cls-296"
                points="342.2 336.25 352.66 329.87 359.86 341.33 349.5 347.71 342.2 336.25"
              />
            </g>
            <g class="cls-297">
              <polygon
                class="cls-298"
                points="341.84 330.28 352.62 335.94 346.16 347.84 335.38 342.18 341.84 330.28"
              />
            </g>
            <polygon
              class="cls-58"
              points="346.73 343.89 347.14 344.59 347.57 346.61 348.07 346.61 348.36 344.58 348.65 343.87 346.73 343.89"
            />
            <path
              class="cls-57"
              d="M378.57,330.92a4.3,4.3,0,0,1-.42-.7c-.1-.21.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.61.1.51,0,.71a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.21,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.21.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="377.08 343.89 377.58 343.88 377.57 342.06 376.96 342.17 377.08 343.89"
            />
            <path
              class="cls-58"
              d="M377,334.27c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.19c.1,0,.1.1.1.21.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.22c0,.3.32.7.32,1.11s-.5.71-.5,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22,0-.3-.31-.7-.31-1.11s.5-.71.49-1-.11-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M376.77,333.77c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.7.11,1,.62.39.72.7.11.7.31,1a3.48,3.48,0,0,0,1,.79c.31.2.51.2.82.4l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.51-.91.09-.81-.12-1"
            />
            <g class="cls-299">
              <polygon
                class="cls-300"
                points="371.83 335.54 382.19 329.06 389.49 340.62 379.13 346.9 371.83 335.54"
              />
            </g>
            <g class="cls-301">
              <polygon
                class="cls-302"
                points="371.47 329.47 382.25 335.13 375.8 347.04 365.01 341.38 371.47 329.47"
              />
            </g>
            <polygon
              class="cls-58"
              points="376.46 343.18 376.77 343.89 377.2 345.91 377.71 345.9 377.99 343.77 378.28 343.06 376.46 343.18"
            />
            <path
              class="cls-57"
              d="M392.55,322.89a4.93,4.93,0,0,1-.42-.71c-.1-.2.1-.51-.1-.71s-.41-.29-.52-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.21.71s-.2.5-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.2.5-.4a2.67,2.67,0,0,0,.5-.82c.1-.2-.11-.5,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="391.06 335.85 391.56 335.75 391.55 334.03 390.94 334.03 391.06 335.85"
            />
            <path
              class="cls-58"
              d="M391,326.24c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.19,5.19,0,0,0,1-.62c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.2,1.22c0,.3.32.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.61.51-.81.81-.09.81-.29,1.12a3.23,3.23,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.5-.71.49-1-.11-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M390.75,325.64c-.1-.31-.61-.5-.71-.71s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.31-.21-.71-.21-1,.29-.72.19-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-303">
              <polygon
                class="cls-304"
                points="385.81 327.51 396.17 321.03 403.47 332.59 393.11 338.87 385.81 327.51"
              />
            </g>
            <g class="cls-305">
              <polygon
                class="cls-306"
                points="385.45 321.44 396.23 327.1 389.78 339 379 333.34 385.45 321.44"
              />
            </g>
            <polygon
              class="cls-58"
              points="390.34 335.05 390.76 335.86 391.18 337.87 391.69 337.77 391.97 335.74 392.26 335.03 390.34 335.05"
            />
            <path
              class="cls-57"
              d="M406.22,315a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.51.2.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7a.57.57,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="404.84 327.92 405.44 327.92 405.33 326.1 404.62 326.1 404.84 327.92"
            />
            <path
              class="cls-58"
              d="M404.74,318.31c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.6.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.34,8.34,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.4-.31-.71-.31-1.11s.5-.71.49-1-.11-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M404.53,317.81c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a3.71,3.71,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.81-.12-1"
            />
            <g class="cls-307">
              <polygon
                class="cls-308"
                points="399.59 319.48 410.05 313.2 417.35 324.56 406.89 331.04 399.59 319.48"
              />
            </g>
            <g class="cls-309">
              <polygon
                class="cls-310"
                points="399.23 313.51 410.01 319.17 403.56 331.17 392.77 325.41 399.23 313.51"
              />
            </g>
            <polygon
              class="cls-58"
              points="404.12 327.12 404.54 327.93 404.86 329.84 405.46 329.84 405.75 327.91 406.04 327.1 404.12 327.12"
            />
            <path
              class="cls-57"
              d="M420.5,306.52a6.14,6.14,0,0,1-.41-.71c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.2.71s-.19.5-.09.71a4.32,4.32,0,0,1,.41.7c.11.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.5,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.3-.4.19-.6"
            />
            <polygon
              class="cls-58"
              points="419.12 319.38 419.62 319.37 419.5 317.65 418.9 317.66 419.12 319.38"
            />
            <path
              class="cls-58"
              d="M419,309.87c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.3.2-.6.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42,12.06,12.06,0,0,0,.19-1.21c0-.41-.31-.71-.31-1.11s.5-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M418.81,309.26c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.32.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.81.39l.42.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.91,0-.7-.11-1"
            />
            <g class="cls-311">
              <polygon
                class="cls-312"
                points="413.87 311.03 424.23 304.66 431.53 316.12 421.17 322.5 413.87 311.03"
              />
            </g>
            <g class="cls-313">
              <polygon
                class="cls-314"
                points="413.51 304.97 424.29 310.73 417.83 322.63 407.05 316.97 413.51 304.97"
              />
            </g>
            <polygon
              class="cls-58"
              points="418.4 318.68 418.71 319.38 419.24 321.4 419.75 321.4 419.93 319.37 420.32 318.56 418.4 318.68"
            />
          </g>
          <polygon
            class="cls-228"
            points="313.03 322.88 310.08 321.29 311.1 422.26 314.06 424.46 313.03 322.88"
          />
          <polygon
            class="cls-54"
            points="355.52 342.89 358.34 341.34 312.77 316.61 310.05 318.26 355.52 342.89"
          />
          <polygon
            class="cls-229"
            points="316.22 317.99 316.24 320.32 356.23 342.58 356.2 340.15 316.22 317.99"
          />
          <polygon
            class="cls-54"
            points="393.33 270.16 395.77 271.45 313.81 320.04 310.66 318.25 393.33 270.16"
          />
          <polygon
            class="cls-54"
            points="433.44 295.25 436.36 293.5 393.73 269.86 390.81 271.61 433.44 295.25"
          />
          <polygon
            class="cls-229"
            points="437.15 401.76 439.96 400.01 438.9 295 436.08 296.64 437.15 401.76"
          />
          <polygon
            class="cls-229"
            points="356.57 446.99 359.39 445.14 358.36 343.27 355.54 344.81 356.57 446.99"
          />
          <polygon
            class="cls-228"
            points="355.55 345.32 352.7 343.73 353.72 444.69 356.57 446.99 355.55 345.32"
          />
          <polygon
            class="cls-230"
            points="393.36 273 393.38 275.42 433.46 297.68 433.44 295.25 393.36 273"
          />
          <polygon
            class="cls-229"
            points="355.56 346.94 438.93 298.03 438.9 295 355.52 342.89 355.56 346.94"
          />
          <polygon
            class="cls-54"
            points="356.5 340.15 359.02 338.71 318.53 316.45 316.22 317.79 356.5 340.15"
          />
          <polygon
            class="cls-229"
            points="314.16 424.66 317.08 422.7 316.08 323.86 313.13 322.27 314.16 424.66"
          />
          <polygon
            class="cls-228"
            points="310.05 318.16 355.52 342.89 355.56 346.63 310.08 321.29 310.05 318.16"
          />
          <polygon
            class="cls-40"
            points="356 343 596.9 203.15 552.13 178 310 318 356 343"
          />
          <g id="plant2-10" data-name="plant2">
            <polygon
              class="cls-54"
              points="618.47 395.6 695.51 350.7 653.9 327.25 576.26 372.55 618.47 395.6"
            />
            <ellipse
              class="cls-55"
              cx="621.42"
              cy="386.67"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.88 6.31) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="593.15"
              cy="372.58"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.74 6.02) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="606.37"
              cy="379.63"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.81 6.16) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="635.8"
              cy="377.92"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.79 6.45) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="649.68"
              cy="370.29"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.71 6.59) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="663.76"
              cy="362.36"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -3.63, 6.74)"
            />
            <ellipse
              class="cls-55"
              cx="677.64"
              cy="354.23"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.55 6.88) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="576.56 372.25 614.92 394.12 616.12 393.3 577.36 371.43 576.56 372.25"
            />
            <polygon
              class="cls-54"
              points="619.96 392.65 619.98 394.07 694.7 350.71 693.48 350.02 619.96 392.65"
            />
            <polygon
              class="cls-56"
              points="614.31 393.72 614.37 400.4 577.54 379.62 577.37 372.64 614.31 393.72"
            />
            <polygon
              class="cls-56"
              points="619.97 393.86 620.05 401.25 694.67 357.49 694.6 350.61 619.97 393.86"
            />
            <path
              class="cls-57"
              d="M622.48,371.68a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.92,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.57,1.57,0,0,0-.3.72c-.1.2.21.5.21.7s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.31,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.11.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="620.99 384.65 621.5 384.64 621.48 382.92 620.87 382.93 620.99 384.65"
            />
            <path
              class="cls-58"
              d="M621,375c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.31-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.23,3.23,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M620.69,374.53c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.3.1.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.19.5.19.81.39l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.2-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-315">
              <polygon
                class="cls-316"
                points="615.75 376.3 626.1 369.92 633.5 381.38 623.05 387.76 615.75 376.3"
              />
            </g>
            <g class="cls-317">
              <polygon
                class="cls-318"
                points="615.38 370.34 626.16 375.89 619.71 387.9 608.93 382.14 615.38 370.34"
              />
            </g>
            <polygon
              class="cls-58"
              points="620.28 383.84 620.69 384.65 621.11 386.67 621.62 386.66 621.9 384.64 622.2 383.82 620.28 383.84"
            />
            <path
              class="cls-57"
              d="M594.21,357.7a5.2,5.2,0,0,1-.41-.7c-.1-.21.1-.51-.11-.71s-.4-.3-.51-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.62.11.5,0,.7a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.2.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.21.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="592.73 370.56 593.33 370.56 593.32 368.74 592.61 368.75 592.73 370.56"
            />
            <path
              class="cls-58"
              d="M592.63,361.06c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.72.59-1a.09.09,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.22c0,.3.31.71.32,1.11s-.5.71-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.61.2-.91.51l-.39.81-.41-.09.09-.91c-.2-.31-.51-.4-.51-.71a8,8,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.49-.71.49-1c.2-.41,0-.91,0-1.11"
            />
            <path
              class="cls-59"
              d="M592.42,360.45c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.5.92.31.7.32,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.39.72.7.11.7.31,1a6.39,6.39,0,0,0,1,.79c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.52-.91.1-.81-.11-1"
            />
            <g class="cls-319">
              <polygon
                class="cls-320"
                points="587.48 362.22 597.94 355.84 605.14 367.3 594.78 373.68 587.48 362.22"
              />
            </g>
            <g class="cls-321">
              <polygon
                class="cls-322"
                points="587.22 356.05 598 361.61 591.44 373.61 580.66 367.85 587.22 356.05"
              />
            </g>
            <polygon
              class="cls-58"
              points="592.01 369.86 592.42 370.57 592.85 372.59 593.35 372.48 593.64 370.56 593.93 369.74 592.01 369.86"
            />
            <path
              class="cls-57"
              d="M607.44,364.75a3.7,3.7,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.32-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.69,1.69,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.21,0,.51.1.71a4.24,4.24,0,0,0,.52.7c.1.21.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.1-.5,0-.7a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="605.95 377.62 606.46 377.61 606.44 375.89 605.83 375.9 605.95 377.62"
            />
            <path
              class="cls-58"
              d="M606,368c.1-.3.6-.51.7-.81s.1-.81.29-1.12a4.74,4.74,0,0,0,1-.62c.3-.2.3-.71.6-1a.11.11,0,0,0,.1-.11,1,1,0,0,1,1.21.19c.1,0,.11.1.11.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1,.1.81,0,1.12-.61.51-.8.81-.1.82-.3,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M605.64,367.5c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.62.39.72.7.11.7.31,1a6.87,6.87,0,0,0,1,.79c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-323">
              <polygon
                class="cls-324"
                points="600.71 369.27 611.06 362.79 618.36 374.35 608 380.63 600.71 369.27"
              />
            </g>
            <g class="cls-325">
              <polygon
                class="cls-326"
                points="600.34 363.2 611.12 368.96 604.67 380.76 593.89 375.21 600.34 363.2"
              />
            </g>
            <polygon
              class="cls-58"
              points="605.23 376.91 605.64 377.62 606.07 379.64 606.58 379.63 606.86 377.61 607.15 376.79 605.23 376.91"
            />
            <path
              class="cls-57"
              d="M637,364a5,5,0,0,1-.41-.71c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.11-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.2.51-.41s.49-.71.49-.81-.1-.5,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.3-.4.2-.6"
            />
            <polygon
              class="cls-58"
              points="635.58 376.81 636.19 376.8 636.07 375.08 635.36 375.09 635.58 376.81"
            />
            <path
              class="cls-58"
              d="M635.49,367.3c.09-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.3.2-.6.21-.9.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M635.28,366.8c-.11-.31-.61-.5-.72-.71s-.11-.7-.31-1-.71-.3-.92-.5-.31-.71-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.1-.81c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.72.19-1-.41-.6-.51-.9.09-.81-.11-1"
            />
            <g class="cls-327">
              <polygon
                class="cls-328"
                points="630.34 368.46 640.79 362.08 647.99 373.65 637.64 379.93 630.34 368.46"
              />
            </g>
            <g class="cls-329">
              <polygon
                class="cls-330"
                points="629.97 362.5 640.75 368.16 634.3 380.06 623.52 374.4 629.97 362.5"
              />
            </g>
            <polygon
              class="cls-58"
              points="634.87 376.21 635.18 376.91 635.6 378.93 636.21 378.83 636.49 376.8 636.69 376.09 634.87 376.21"
            />
            <path
              class="cls-57"
              d="M651,355.91a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="649.56 368.78 650.07 368.77 650.05 367.05 649.34 367.06 649.56 368.78"
            />
            <path
              class="cls-58"
              d="M649.47,359.16c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1a4.12,4.12,0,0,1,0,1.11c-.1.3-.6.51-.8.82s-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M649.26,358.66c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.3.1.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.7.11,1,.61.39.71.7.11.7.32,1a6,6,0,0,0,1,.79c.3.2.5.2.81.4l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.2-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-331">
              <polygon
                class="cls-332"
                points="644.32 360.43 654.77 354.05 661.97 365.62 651.62 371.89 644.32 360.43"
              />
            </g>
            <g class="cls-333">
              <polygon
                class="cls-334"
                points="643.96 354.46 654.73 360.02 648.18 372.03 637.4 366.37 643.96 354.46"
              />
            </g>
            <polygon
              class="cls-58"
              points="648.85 368.07 649.16 368.78 649.58 370.8 650.09 370.79 650.47 368.77 650.67 368.06 648.85 368.07"
            />
            <path
              class="cls-57"
              d="M664.73,348a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.57,1.57,0,0,0-.3.72c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.21.51-.41s.49-.71.49-.81-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.21-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="663.34 360.95 663.85 360.94 663.83 359.12 663.12 359.13 663.34 360.95"
            />
            <path
              class="cls-58"
              d="M663.25,351.34c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22c0,.3.31.71.31,1.11s-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.29,1.11-.91.72-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22,0-.3-.31-.7-.32-1.1s.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M663,350.73c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.7.11,1,.61.39.71.7.11.7.32,1a6,6,0,0,0,1,.79c.3.2.5.2.81.4l.41.71.3-.11-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91,0-.71-.11-1"
            />
            <g class="cls-335">
              <polygon
                class="cls-336"
                points="658.1 352.5 668.45 346.12 675.75 357.58 665.4 363.96 658.1 352.5"
              />
            </g>
            <g class="cls-337">
              <polygon
                class="cls-338"
                points="657.73 346.43 668.51 352.19 662.06 364.1 651.28 358.44 657.73 346.43"
              />
            </g>
            <polygon
              class="cls-58"
              points="662.63 360.14 662.94 360.95 663.46 362.87 663.97 362.86 664.25 360.94 664.45 360.02 662.63 360.14"
            />
            <path
              class="cls-57"
              d="M679,339.54a4.32,4.32,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.1.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41s.49-.71.49-.82-.1-.5,0-.7.3-.41.29-.71-.21-.51-.21-.71a1.11,1.11,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="677.62 352.4 678.13 352.4 678.11 350.58 677.4 350.69 677.62 352.4"
            />
            <path
              class="cls-58"
              d="M677.53,342.89c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.49,1,.11.8,0,1.11-.6.51-.8.82-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M677.32,342.29c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.7,0,1.11s-.5.61-.5.92.31.7.31,1-.29.72-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.71.11.7.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.81-.11-1"
            />
            <g class="cls-339">
              <polygon
                class="cls-340"
                points="672.28 344.06 682.73 337.68 690.03 349.14 679.58 355.52 672.28 344.06"
              />
            </g>
            <g class="cls-341">
              <polygon
                class="cls-342"
                points="672.01 337.99 682.69 343.75 676.24 355.66 665.46 350 672.01 337.99"
              />
            </g>
            <polygon
              class="cls-58"
              points="676.91 351.7 677.22 352.41 677.64 354.43 678.15 354.42 678.53 352.29 678.73 351.58 676.91 351.7"
            />
          </g>
          <g id="plant2-11" data-name="plant2">
            <polygon
              class="cls-54"
              points="538.3 441.03 615.34 396.14 573.73 372.68 496.09 417.99 538.3 441.03"
            />
            <ellipse
              class="cls-55"
              cx="541.25"
              cy="432.1"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -4.35, 5.5)"
            />
            <ellipse
              class="cls-55"
              cx="512.98"
              cy="418.12"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.21 5.21) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="526.21"
              cy="425.07"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.28 5.35) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="555.63"
              cy="423.45"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.26 5.65) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="569.51"
              cy="415.72"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.18 5.79) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="583.59"
              cy="407.89"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.1 5.93) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="597.47"
              cy="399.76"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.02 6.07) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="496.39 417.78 534.75 439.55 535.96 438.73 497.19 416.96 496.39 417.78"
            />
            <polygon
              class="cls-54"
              points="539.79 438.08 539.81 439.5 614.43 396.15 613.31 395.55 539.79 438.08"
            />
            <polygon
              class="cls-56"
              points="534.14 439.15 534.21 446.03 497.37 425.05 497.2 418.18 534.14 439.15"
            />
            <polygon
              class="cls-56"
              points="539.81 439.5 539.88 446.88 614.5 403.03 614.43 396.05 539.81 439.5"
            />
            <path
              class="cls-57"
              d="M542.31,417.21a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.11a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.19.51-.09.71a4.46,4.46,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.51-.21-.71s.19-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="540.82 430.08 541.33 430.07 541.31 428.35 540.71 428.36 540.82 430.08"
            />
            <path
              class="cls-58"
              d="M540.83,420.57c.1-.31.6-.51.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.76,7.76,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.31-1.11.49-.72.49-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M540.52,420.06c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.8c-.1,0-.1,0-.1-.11a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.42.61.52.91-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.9.1-.82-.11-1"
            />
            <g class="cls-343">
              <polygon
                class="cls-344"
                points="535.58 421.73 545.94 415.46 553.34 426.92 542.88 433.3 535.58 421.73"
              />
            </g>
            <g class="cls-345">
              <polygon
                class="cls-346"
                points="535.22 415.77 546 421.43 539.54 433.43 528.76 427.77 535.22 415.77"
              />
            </g>
            <polygon
              class="cls-58"
              points="540.11 429.38 540.52 430.08 540.95 432.1 541.45 432.1 541.74 430.07 542.03 429.36 540.11 429.38"
            />
            <path
              class="cls-57"
              d="M514.05,403.23a3.7,3.7,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.32-.71c-.1,0-.1,0-.1-.1a.78.78,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.51.3-.5.61.1.5,0,.71a1.59,1.59,0,0,0-.29.71c-.1.2.21.5.21.7s-.2.51-.1.71a4,4,0,0,1,.42.71c.1.2,0,.5.1.7a4,4,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.1-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.51-.21-.71s.2-.4.2-.61"
            />
            <polygon
              class="cls-58"
              points="512.56 416.1 513.07 416.09 513.05 414.27 512.44 414.38 512.56 416.1"
            />
            <path
              class="cls-58"
              d="M512.46,406.49c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.61,1-.19.71-.19,1.21c0,.31.32.71.32,1.11s-.5.72-.5,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.61.51-.81.82s-.09.81-.29,1.12-.9.71-1,1c-.3.2-.6.21-.9.51l-.4.82L513,414l.1-.91c-.21-.3-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.5-.72.49-1c.2-.31,0-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M512.25,406c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.71.31,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11L512,412c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.51-.91.09-.81-.12-1"
            />
            <g class="cls-347">
              <polygon
                class="cls-348"
                points="507.31 407.75 517.77 401.27 524.97 412.84 514.61 419.11 507.31 407.75"
              />
            </g>
            <g class="cls-349">
              <polygon
                class="cls-350"
                points="507.05 401.48 517.83 407.14 511.27 419.15 500.49 413.49 507.05 401.48"
              />
            </g>
            <polygon
              class="cls-58"
              points="511.84 415.4 512.26 416.1 512.68 418.12 513.19 418.12 513.47 415.99 513.76 415.28 511.84 415.4"
            />
            <path
              class="cls-57"
              d="M527.27,410.18a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.72-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.1.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.3.2-.61"
            />
            <polygon
              class="cls-58"
              points="525.78 423.15 526.29 423.14 526.27 421.32 525.66 421.33 525.78 423.15"
            />
            <path
              class="cls-58"
              d="M525.79,413.54c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.72-.19,1.22.31.71.31,1.11-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.19,3.19,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M525.48,412.93c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.49.62-.49.92.31.7.31,1-.29.71-.19,1,.41.6.51.91-.09.71.12,1,.61.4.71.7.11.71.32,1a7.06,7.06,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.61-.11-1"
            />
            <g class="cls-351">
              <polygon
                class="cls-352"
                points="520.54 414.8 530.89 408.32 538.29 419.78 527.84 426.16 520.54 414.8"
              />
            </g>
            <g class="cls-353">
              <polygon
                class="cls-354"
                points="520.17 408.74 530.95 414.39 524.5 426.3 513.72 420.64 520.17 408.74"
              />
            </g>
            <polygon
              class="cls-58"
              points="525.07 422.35 525.48 423.15 525.9 425.07 526.41 425.06 526.69 423.14 526.99 422.33 525.07 422.35"
            />
            <path
              class="cls-57"
              d="M556.8,409.48a4.05,4.05,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.09-.2-.21-.5-.21-.7a.56.56,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="555.42 422.44 556.02 422.34 555.9 420.62 555.2 420.62 555.42 422.44"
            />
            <path
              class="cls-58"
              d="M555.32,412.83c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.31,0,.81.11,1.12s.52.7.62,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M555.11,412.23c-.1-.31-.61-.5-.72-.7s-.1-.71-.31-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.41.6.52.9-.1.71.11,1,.61.4.72.7.1.71.31,1a3.57,3.57,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.22-1,.3-.71.2-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-355">
              <polygon
                class="cls-356"
                points="550.17 414.1 560.63 407.62 567.83 419.08 557.47 425.46 550.17 414.1"
              />
            </g>
            <g class="cls-357">
              <polygon
                class="cls-358"
                points="549.81 407.93 560.59 413.69 554.13 425.59 543.25 419.94 549.81 407.93"
              />
            </g>
            <polygon
              class="cls-58"
              points="554.7 421.64 555.01 422.45 555.43 424.37 556.04 424.36 556.33 422.33 556.52 421.52 554.7 421.64"
            />
            <path
              class="cls-57"
              d="M570.78,401.44a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.19.5-.09.7a5,5,0,0,1,.41.71c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.3-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="569.39 414.31 569.9 414.3 569.88 412.48 569.17 412.49 569.39 414.31"
            />
            <path
              class="cls-58"
              d="M569.3,404.7c.1-.31.6-.51.7-.82s.09-.81.29-1.11a6.11,6.11,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.6.51-.8.82s-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M569.09,404.19c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.71.32,1-.3.71-.2,1,.42.61.52.91-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.19.81.39l.41.71L569,411l-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91.1-.7-.11-1"
            />
            <g class="cls-359">
              <polygon
                class="cls-360"
                points="564.15 405.96 574.61 399.58 581.81 411.05 571.45 417.42 564.15 405.96"
              />
            </g>
            <g class="cls-361">
              <polygon
                class="cls-362"
                points="563.79 399.9 574.57 405.56 568.01 417.56 557.23 411.9 563.79 399.9"
              />
            </g>
            <polygon
              class="cls-58"
              points="568.68 413.61 568.99 414.31 569.41 416.23 569.92 416.23 570.31 414.3 570.5 413.49 568.68 413.61"
            />
            <path
              class="cls-57"
              d="M584.56,393.51a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.7a5,5,0,0,1,.41.71c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.09-.2-.21-.5-.21-.71s.3-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="583.17 406.38 583.68 406.37 583.66 404.65 582.96 404.66 583.17 406.38"
            />
            <path
              class="cls-58"
              d="M583.08,396.87c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M582.87,396.26c-.1-.3-.61-.5-.72-.7s-.1-.7-.31-1-.71-.29-.91-.49-.32-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.71.32,1-.3.71-.2,1,.41.61.52.91-.1.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.31-.11-.11-.8c.09-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91,0-.7-.11-1"
            />
            <g class="cls-363">
              <polygon
                class="cls-364"
                points="577.93 398.03 588.29 391.65 595.59 403.12 585.23 409.49 577.93 398.03"
              />
            </g>
            <g class="cls-365">
              <polygon
                class="cls-366"
                points="577.57 392.07 588.35 397.73 581.89 409.63 571.11 403.97 577.57 392.07"
              />
            </g>
            <polygon
              class="cls-58"
              points="582.46 405.68 582.77 406.38 583.3 408.4 583.8 408.4 584.09 406.37 584.28 405.66 582.46 405.68"
            />
            <path
              class="cls-57"
              d="M598.84,385a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.51-.2.72-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71a.86.86,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="597.46 397.94 597.96 397.93 597.94 396.21 597.24 396.22 597.46 397.94"
            />
            <path
              class="cls-58"
              d="M597.36,388.33c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.72-.19,1.22c0,.3.31.71.31,1.11s-.49.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11-.91.72-1,1c-.31.2-.61.2-.91.51l-.4.81-.4-.09.09-.91c-.2-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21,0-.31-.31-.71-.32-1.11s.5-.72.5-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M597.15,387.82c-.1-.3-.61-.5-.72-.7s-.1-.71-.31-1-.71-.29-.91-.49-.32-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.62-.5.92.31.7.32,1-.3.71-.2,1,.41.6.52.91-.1.71.11,1,.61.4.72.7.1.71.31,1a3.57,3.57,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.31-.11-.11-.81c.09-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91.09-.81-.11-1"
            />
            <g class="cls-367">
              <polygon
                class="cls-368"
                points="592.11 389.59 602.57 383.11 609.87 394.68 599.41 400.95 592.11 389.59"
              />
            </g>
            <g class="cls-369">
              <polygon
                class="cls-370"
                points="591.85 383.52 602.52 389.18 596.07 401.09 585.29 395.43 591.85 383.52"
              />
            </g>
            <polygon
              class="cls-58"
              points="596.74 397.24 597.05 397.94 597.48 399.96 597.98 399.95 598.37 397.93 598.56 397.12 596.74 397.24"
            />
          </g>
          <g id="plant2-12" data-name="plant2">
            <polygon
              class="cls-54"
              points="617.92 371.22 694.96 326.43 653.25 302.97 575.61 348.28 617.92 371.22"
            />
            <ellipse
              class="cls-55"
              cx="620.87"
              cy="362.39"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.64 6.3) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="592.6"
              cy="348.31"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.5 6.02) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="605.82"
              cy="355.36"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.57 6.15) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="635.15"
              cy="353.64"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -3.55, 6.45)"
            />
            <ellipse
              class="cls-55"
              cx="649.13"
              cy="346.01"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.47 6.59) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="663.21"
              cy="338.18"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.39 6.73) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="677.09"
              cy="329.95"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.31 6.87) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="576.01 347.97 614.37 369.84 615.57 368.92 576.71 347.15 576.01 347.97"
            />
            <polygon
              class="cls-54"
              points="619.41 368.37 619.43 369.79 694.05 326.34 692.83 325.84 619.41 368.37"
            />
            <polygon
              class="cls-56"
              points="613.76 369.44 613.83 376.22 576.99 355.24 576.82 348.47 613.76 369.44"
            />
            <polygon
              class="cls-56"
              points="619.42 369.69 619.5 377.07 694.12 333.32 694.05 326.34 619.42 369.69"
            />
            <path
              class="cls-57"
              d="M621.83,347.5a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.2-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.3-.4.2-.61"
            />
            <polygon
              class="cls-58"
              points="620.44 360.37 620.95 360.36 620.93 358.54 620.22 358.65 620.44 360.37"
            />
            <path
              class="cls-58"
              d="M620.35,350.86c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3,3,0,0,0-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M620.14,350.25c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.51.2.81.39l.41.71.3-.11-.1-.8c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.91.09-.7-.11-1"
            />
            <g class="cls-371">
              <polygon
                class="cls-372"
                points="615.2 352.02 625.55 345.65 632.85 357.11 622.4 363.49 615.2 352.02"
              />
            </g>
            <g class="cls-373">
              <polygon
                class="cls-374"
                points="614.83 345.96 625.51 351.72 619.16 363.62 608.28 357.96 614.83 345.96"
              />
            </g>
            <polygon
              class="cls-58"
              points="619.73 359.67 620.04 360.37 620.46 362.39 621.07 362.39 621.35 360.36 621.55 359.55 619.73 359.67"
            />
            <path
              class="cls-57"
              d="M593.67,333.42a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.1.5-.2.71-.5.3-.49.61.1.5,0,.71a1.39,1.39,0,0,0-.29.71c-.1.2.2.5.21.7s-.2.51-.1.71a4.05,4.05,0,0,1,.41.71c.11.3,0,.5.11.7a4,4,0,0,0,.51.71,5.91,5.91,0,0,1,.51.4l.11.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="592.18 346.29 592.68 346.28 592.66 344.56 592.06 344.57 592.18 346.29"
            />
            <path
              class="cls-58"
              d="M592.08,336.78c.1-.31.6-.51.7-.82s.09-.81.29-1.11a6.11,6.11,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.11-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.76,7.76,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.5-.72.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M591.87,336.17c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.7.32,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.81.39l.42.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.91.1-.71-.11-1"
            />
            <g class="cls-375">
              <polygon
                class="cls-376"
                points="586.93 337.94 597.29 331.56 604.59 343.02 594.23 349.4 586.93 337.94"
              />
            </g>
            <g class="cls-377">
              <polygon
                class="cls-378"
                points="586.57 331.67 597.35 337.43 590.89 349.34 580.11 343.68 586.57 331.67"
              />
            </g>
            <polygon
              class="cls-58"
              points="591.46 345.59 591.87 346.29 592.3 348.31 592.8 348.31 593.09 346.28 593.38 345.57 591.46 345.59"
            />
            <path
              class="cls-57"
              d="M606.79,340.47a3.7,3.7,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.52-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.51.31-.5.61.1.5,0,.71a1.39,1.39,0,0,0-.29.71c-.1.2.21.5.21.7s-.2.51-.1.71a4.44,4.44,0,0,1,.42.71c.1.2,0,.5.1.7a4,4,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="605.4 353.34 605.9 353.33 605.89 351.61 605.18 351.62 605.4 353.34"
            />
            <path
              class="cls-58"
              d="M605.3,343.73c.1-.31.6-.52.7-.82s.1-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.71-.5,1,.11.81,0,1.11-.61.51-.81.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.41-.09.1-.91c-.21-.31-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41,12.06,12.06,0,0,0,.19-1.21c0-.41-.31-.71-.31-1.11s.5-.72.49-1-.1-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M605.1,343.22c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.72-.29-.92-.49-.31-.71-.61-.81c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.12,1,.61.4.71.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-379">
              <polygon
                class="cls-380"
                points="600.16 344.99 610.51 338.62 617.81 350.07 607.35 356.45 600.16 344.99"
              />
            </g>
            <g class="cls-381">
              <polygon
                class="cls-382"
                points="599.79 339.03 610.47 344.69 604.12 356.59 593.24 350.93 599.79 339.03"
              />
            </g>
            <polygon
              class="cls-58"
              points="604.68 352.64 605 353.44 605.42 355.36 606.03 355.36 606.31 353.33 606.5 352.62 604.68 352.64"
            />
            <path
              class="cls-57"
              d="M636.42,339.67A4.05,4.05,0,0,1,636,339c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.61-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.92,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.6c.1-.21.31-.21.51-.41a7.9,7.9,0,0,0,.49-.82c.1-.2-.1-.5,0-.71a1.39,1.39,0,0,0,.29-.71c.1-.2-.2-.5-.21-.7a.59.59,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="634.93 352.63 635.54 352.63 635.52 350.91 634.81 350.92 634.93 352.63"
            />
            <path
              class="cls-58"
              d="M634.94,343c.09-.3.6-.51.7-.81s.09-.82.29-1.12a5.44,5.44,0,0,0,1-.62c.31-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.12s.52.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12a3.23,3.23,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M634.63,342.42c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.31c-.1,0-.1.11-.1.11-.09.3.11.7,0,1.11s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.6-.51-.9.09-.61-.11-1"
            />
            <g class="cls-383">
              <polygon
                class="cls-384"
                points="629.69 344.29 640.14 337.81 647.44 349.37 637.09 355.75 629.69 344.29"
              />
            </g>
            <g class="cls-385">
              <polygon
                class="cls-386"
                points="629.43 338.32 640.21 343.88 633.65 355.78 622.87 350.13 629.43 338.32"
              />
            </g>
            <polygon
              class="cls-58"
              points="634.32 351.83 634.63 352.64 635.05 354.66 635.56 354.65 635.94 352.62 636.14 351.81 634.32 351.83"
            />
            <path
              class="cls-57"
              d="M650.4,331.63a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.11,0-.11,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.7a6.14,6.14,0,0,1,.41.71c.1.3,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.1.1.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a2.31,2.31,0,0,0,.49-.81c.1-.2-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71a.57.57,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="649.01 344.6 649.52 344.59 649.5 342.77 648.79 342.78 649.01 344.6"
            />
            <path
              class="cls-58"
              d="M648.92,335c.1-.31.6-.51.7-.82s.09-.81.29-1.11a6,6,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12a3,3,0,0,0-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M648.61,334.38c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.6-.11-1"
            />
            <g class="cls-387">
              <polygon
                class="cls-388"
                points="643.67 336.25 654.13 329.77 661.42 341.24 651.07 347.61 643.67 336.25"
              />
            </g>
            <g class="cls-389">
              <polygon
                class="cls-390"
                points="643.41 330.19 654.19 335.85 647.63 347.75 636.85 342.09 643.41 330.19"
              />
            </g>
            <polygon
              class="cls-58"
              points="648.3 343.8 648.61 344.6 649.03 346.52 649.54 346.52 649.82 344.59 650.12 343.68 648.3 343.8"
            />
            <path
              class="cls-57"
              d="M664.18,323.8a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.2-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.3-.4.2-.61"
            />
            <polygon
              class="cls-58"
              points="662.79 336.67 663.3 336.56 663.18 334.84 662.57 334.85 662.79 336.67"
            />
            <path
              class="cls-58"
              d="M662.7,327.16c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.21c0,.31.31.71.31,1.11s-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1a3.75,3.75,0,0,1,0-1.11"
            />
            <path
              class="cls-59"
              d="M662.49,326.55c-.11-.3-.61-.5-.72-.7s-.1-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.51.2.81.39l.41.71.31-.11-.11-.8c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.2-1-.42-.6-.52-.91,0-.8-.11-1"
            />
            <g class="cls-391">
              <polygon
                class="cls-392"
                points="657.55 328.32 667.9 321.95 675.2 333.41 664.75 339.79 657.55 328.32"
              />
            </g>
            <g class="cls-393">
              <polygon
                class="cls-394"
                points="657.08 322.26 667.97 328.02 661.41 339.82 650.73 334.26 657.08 322.26"
              />
            </g>
            <polygon
              class="cls-58"
              points="662.08 335.97 662.39 336.67 662.81 338.69 663.32 338.59 663.6 336.56 663.9 335.85 662.08 335.97"
            />
            <path
              class="cls-57"
              d="M678.46,315.26a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.3,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="676.97 328.13 677.58 328.12 677.56 326.4 676.85 326.41 676.97 328.13"
            />
            <path
              class="cls-58"
              d="M676.87,318.62c.1-.31.61-.51.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21c0,.31.31.71.31,1.11s-.5.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.29,1.12a3.07,3.07,0,0,0-1,1c-.3.2-.6.21-.9.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.32-.71-.32-1.11.5-.72.5-1c.19-.41,0-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M676.67,318.11c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.11s-.5.62-.5.92.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.81-.11-1"
            />
            <g class="cls-395">
              <polygon
                class="cls-396"
                points="671.73 319.78 682.18 313.4 689.38 324.97 679.03 331.24 671.73 319.78"
              />
            </g>
            <g class="cls-397">
              <polygon
                class="cls-398"
                points="671.36 313.82 682.14 319.48 675.69 331.38 664.91 325.72 671.36 313.82"
              />
            </g>
            <polygon
              class="cls-58"
              points="676.26 327.43 676.67 328.13 677.09 330.15 677.6 330.14 677.88 328.12 678.18 327.41 676.26 327.43"
            />
          </g>
          <g id="plant2-13" data-name="plant2">
            <polygon
              class="cls-54"
              points="537.86 416.65 614.89 371.86 573.28 348.4 495.64 393.61 537.86 416.65"
            />
            <ellipse
              class="cls-55"
              cx="540.9"
              cy="407.82"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.1 5.5) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="512.54"
              cy="393.74"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.96 5.21) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="525.86"
              cy="400.79"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.03 5.34) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="555.18"
              cy="399.07"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.01 5.64) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="569.06"
              cy="391.45"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.93 5.78) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="583.25"
              cy="383.61"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.85 5.92) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="597.02"
              cy="375.38"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.77 6.06) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="495.94 393.4 534.3 415.17 535.51 414.35 496.74 392.58 495.94 393.4"
            />
            <polygon
              class="cls-54"
              points="539.34 413.7 539.36 415.12 614.08 371.76 612.87 371.27 539.34 413.7"
            />
            <polygon
              class="cls-56"
              points="533.69 414.87 533.76 421.65 497.03 400.67 496.75 393.8 533.69 414.87"
            />
            <polygon
              class="cls-56"
              points="539.36 415.12 539.43 422.5 614.05 378.75 613.98 371.77 539.36 415.12"
            />
            <path
              class="cls-57"
              d="M541.86,392.93a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.2.71s-.19.5-.09.7a5,5,0,0,1,.41.71c.11.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a2.53,2.53,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.2-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="540.48 405.8 540.98 405.79 540.86 403.97 540.26 404.08 540.48 405.8"
            />
            <path
              class="cls-58"
              d="M540.38,396.29c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.6.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.5-.71.49-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M540.07,395.68c-.1-.3-.61-.49-.71-.7s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a3.71,3.71,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.81-.11-1"
            />
            <g class="cls-399">
              <polygon
                class="cls-400"
                points="535.23 397.45 545.59 391.08 552.89 402.54 542.43 408.92 535.23 397.45"
              />
            </g>
            <g class="cls-401">
              <polygon
                class="cls-402"
                points="534.77 391.39 545.55 397.15 539.09 409.05 528.31 403.39 534.77 391.39"
              />
            </g>
            <polygon
              class="cls-58"
              points="539.66 405.1 540.07 405.8 540.5 407.82 541 407.82 541.29 405.79 541.58 404.98 539.66 405.1"
            />
            <path
              class="cls-57"
              d="M513.6,378.85a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.11,0-.11,0-.11-.11a.78.78,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.5.31-.5.61.1.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.1.71a4.44,4.44,0,0,1,.42.71c.1.2,0,.5.1.7a4.52,4.52,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.51-.41s.49-.71.49-.81-.1-.51,0-.71a1.64,1.64,0,0,0,.29-.71c.1-.2-.21-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="512.11 391.72 512.72 391.71 512.7 389.99 511.99 390 512.11 391.72"
            />
            <path
              class="cls-58"
              d="M512.11,382.11c.1-.31.61-.52.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.11,0,.11.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.3,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41,12.06,12.06,0,0,0,.19-1.21c0-.41-.31-.71-.31-1.11s.5-.72.5-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M511.81,381.6c-.11-.3-.62-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.71.31,1-.3.71-.19,1,.41.61.51.91-.09.71.12,1,.61.4.71.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-403">
              <polygon
                class="cls-404"
                points="506.87 383.37 517.32 376.89 524.52 388.46 514.16 394.83 506.87 383.37"
              />
            </g>
            <g class="cls-405">
              <polygon
                class="cls-406"
                points="506.6 377.1 517.38 382.86 510.83 394.77 500.05 389.11 506.6 377.1"
              />
            </g>
            <polygon
              class="cls-58"
              points="511.5 391.02 511.81 391.72 512.23 393.74 512.74 393.74 513.02 391.71 513.32 391 511.5 391.02"
            />
            <path
              class="cls-57"
              d="M526.82,385.9a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.71c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.11,0-.11,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.46,4.46,0,0,1,.41.71c.1.3,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.09-.21-.11-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.51-.2-.71s.19-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="525.43 398.77 525.94 398.76 525.82 396.94 525.21 396.95 525.43 398.77"
            />
            <path
              class="cls-58"
              d="M525.34,389.16c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21c0,.3.31.71.31,1.11s-.49.71-.49,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.6.51-.8.82s-.09.81-.29,1.11-.91.72-1,1c-.31.2-.61.2-.91.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M525,388.65c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.11s-.5.62-.5.92.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.2-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-407">
              <polygon
                class="cls-408"
                points="520.19 390.42 530.54 384.04 537.84 395.5 527.39 401.88 520.19 390.42"
              />
            </g>
            <g class="cls-409">
              <polygon
                class="cls-410"
                points="519.72 384.36 530.5 390.01 524.05 402.02 513.27 396.36 519.72 384.36"
              />
            </g>
            <polygon
              class="cls-58"
              points="524.62 398.07 525.03 398.87 525.45 400.79 525.96 400.68 526.24 398.76 526.54 397.95 524.62 398.07"
            />
            <path
              class="cls-57"
              d="M556.35,385.1a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7a.56.56,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="554.97 398.06 555.57 398.06 555.45 396.24 554.75 396.24 554.97 398.06"
            />
            <path
              class="cls-58"
              d="M554.87,388.45c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22s-.31-.7-.31-1.11.49-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M554.66,387.85c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.42.6.52.9-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.61-.11-1"
            />
            <g class="cls-411">
              <polygon
                class="cls-412"
                points="549.72 389.72 560.18 383.24 567.38 394.7 557.02 401.18 549.72 389.72"
              />
            </g>
            <g class="cls-413">
              <polygon
                class="cls-414"
                points="549.36 383.65 560.14 389.31 553.68 401.21 542.9 395.56 549.36 383.65"
              />
            </g>
            <polygon
              class="cls-58"
              points="554.25 397.26 554.56 398.07 555.09 399.99 555.59 399.98 555.88 398.05 556.07 397.24 554.25 397.26"
            />
            <path
              class="cls-57"
              d="M570.33,377.06a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.09.2.21.5.21.71s-.19.5-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7,5.91,5.91,0,0,1,.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.3-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="568.95 389.93 569.45 389.92 569.43 388.2 568.73 388.21 568.95 389.93"
            />
            <path
              class="cls-58"
              d="M568.85,380.42c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.59-1a.09.09,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42c-.1-.3.2-.71.19-1.21,0-.31-.31-.71-.31-1.11s.49-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M568.64,379.81c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.39l.42.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.91.1-.7-.11-1"
            />
            <g class="cls-415">
              <polygon
                class="cls-416"
                points="563.7 381.58 574.16 375.2 581.36 386.67 571 393.05 563.7 381.58"
              />
            </g>
            <g class="cls-417">
              <polygon
                class="cls-418"
                points="563.34 375.52 574.12 381.28 567.56 393.18 556.88 387.52 563.34 375.52"
              />
            </g>
            <polygon
              class="cls-58"
              points="568.23 389.23 568.54 389.93 569.07 391.95 569.57 391.95 569.86 389.92 570.05 389.11 568.23 389.23"
            />
            <path
              class="cls-57"
              d="M584.21,369.23a5.2,5.2,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.21.71s-.2.5-.1.7a5,5,0,0,1,.41.71c.11.3,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.2-.4.19-.61"
            />
            <polygon
              class="cls-58"
              points="582.73 382.1 583.23 381.99 583.21 380.27 582.61 380.28 582.73 382.1"
            />
            <path
              class="cls-58"
              d="M582.63,372.49c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.3.2-.61.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42c-.1-.3.19-.71.19-1.21s-.31-.71-.31-1.11.49-.72.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M582.42,372c-.1-.3-.61-.49-.71-.7s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.9,0-.81-.11-1"
            />
            <g class="cls-419">
              <polygon
                class="cls-420"
                points="577.48 373.75 587.84 367.28 595.14 378.84 584.78 385.11 577.48 373.75"
              />
            </g>
            <g class="cls-421">
              <polygon
                class="cls-422"
                points="577.12 367.69 587.9 373.35 581.44 385.25 570.66 379.69 577.12 367.69"
              />
            </g>
            <polygon
              class="cls-58"
              points="582.01 381.4 582.42 382.1 582.85 384.12 583.35 384.02 583.64 381.99 583.93 381.28 582.01 381.4"
            />
            <path
              class="cls-57"
              d="M598.39,360.59a4.32,4.32,0,0,1-.41-.7c-.1-.2.1-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.1.5-.2.71-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.05,4.05,0,0,1,.41.71c.1.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.09-.21-.11-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.2-.71a.56.56,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="597 373.56 597.51 373.55 597.49 371.83 596.79 371.84 597 373.56"
            />
            <path
              class="cls-58"
              d="M596.91,364c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.19.71-.19,1.21.31.71.32,1.11-.5.71-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.61.2-.91.51l-.39.81-.41-.09.09-.91c-.2-.31-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M596.7,363.44c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.5.92.31.7.32,1-.3.71-.2,1,.42.6.52.91-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.31-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.22-1,.3-.71.2-1-.41-.6-.52-.91.1-.71-.11-1"
            />
            <g class="cls-423">
              <polygon
                class="cls-424"
                points="591.66 365.21 602.12 358.83 609.42 370.4 599.06 376.67 591.66 365.21"
              />
            </g>
            <g class="cls-425">
              <polygon
                class="cls-426"
                points="591.4 359.25 602.18 364.8 595.62 376.81 584.84 371.15 591.4 359.25"
              />
            </g>
            <polygon
              class="cls-58"
              points="596.29 372.86 596.6 373.56 597.03 375.58 597.53 375.57 597.92 373.55 598.11 372.84 596.29 372.86"
            />
          </g>
          <g id="plant2-14" data-name="plant2">
            <polygon
              class="cls-54"
              points="617.87 345.93 694.91 301.03 653.19 277.58 575.65 322.88 617.87 345.93"
            />
            <ellipse
              class="cls-55"
              cx="620.81"
              cy="336.99"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.38 6.3) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="592.65"
              cy="322.91"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.24 6.02) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="605.77"
              cy="329.96"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.31 6.15) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="635.19"
              cy="328.35"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -3.29, 6.45)"
            />
            <ellipse
              class="cls-55"
              cx="649.07"
              cy="320.62"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -3.21, 6.59)"
            />
            <ellipse
              class="cls-55"
              cx="663.16"
              cy="312.69"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.13 6.73) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="677.04"
              cy="304.55"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.05 6.87) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="576.05 322.57 614.31 344.44 615.52 343.62 576.75 321.76 576.05 322.57"
            />
            <polygon
              class="cls-54"
              points="619.46 342.98 619.47 344.39 694.1 301.04 692.88 300.44 619.46 342.98"
            />
            <polygon
              class="cls-56"
              points="613.8 344.05 613.87 350.82 576.94 329.95 576.87 322.97 613.8 344.05"
            />
            <polygon
              class="cls-56"
              points="619.47 344.29 619.55 351.68 694.07 307.82 694 301.04 619.47 344.29"
            />
            <path
              class="cls-57"
              d="M621.88,322.11a3.51,3.51,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.47,1.47,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.31,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.1.3.2.51.4l.1.61h.31l.09-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="620.39 334.97 621 334.97 620.88 333.25 620.27 333.25 620.39 334.97"
            />
            <path
              class="cls-58"
              d="M620.29,325.36c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.6.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.5-.71.49-1c.2-.31,0-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M620.08,324.86c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.71-.12-1"
            />
            <g class="cls-427">
              <polygon
                class="cls-428"
                points="615.14 326.63 625.6 320.25 632.8 331.71 622.44 338.09 615.14 326.63"
              />
            </g>
            <g class="cls-429">
              <polygon
                class="cls-430"
                points="614.78 320.66 625.56 326.22 619.11 338.22 608.33 332.57 614.78 320.66"
              />
            </g>
            <polygon
              class="cls-58"
              points="619.67 334.17 620.09 335.08 620.51 337 621.02 336.99 621.3 334.96 621.59 334.15 619.67 334.17"
            />
            <path
              class="cls-57"
              d="M593.61,308a4.05,4.05,0,0,1-.41-.71c-.1-.2.09-.5-.11-.7s-.41-.3-.51-.61-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.6c.09-.21.3-.21.5-.41a7.9,7.9,0,0,0,.49-.82c.1-.2-.1-.5,0-.71a1.39,1.39,0,0,0,.29-.71c.1-.2-.2-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="592.22 320.89 592.73 320.89 592.61 319.07 592 319.17 592.22 320.89"
            />
            <path
              class="cls-58"
              d="M592.13,311.38c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.91.72-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.21-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M591.92,310.78c-.11-.31-.61-.5-.72-.71s-.1-.7-.31-1-.71-.3-.92-.5-.31-.71-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.3-.1-.1-.81c.09-.31.4-.31.49-.72s.3-1,.4-1.31-.21-.71-.22-1,.3-.72.19-1-.41-.6-.51-.9,0-.81-.11-1"
            />
            <g class="cls-431">
              <polygon
                class="cls-432"
                points="586.98 312.55 597.34 306.17 604.63 317.63 594.18 324.01 586.98 312.55"
              />
            </g>
            <g class="cls-433">
              <polygon
                class="cls-434"
                points="586.51 306.38 597.29 311.94 590.94 323.94 580.06 318.28 586.51 306.38"
              />
            </g>
            <polygon
              class="cls-58"
              points="591.41 320.19 591.82 320.89 592.24 322.91 592.85 322.91 593.03 320.88 593.33 320.07 591.41 320.19"
            />
            <path
              class="cls-57"
              d="M606.83,315.08a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.09.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="605.35 327.94 605.95 327.94 605.83 326.22 605.23 326.22 605.35 327.94"
            />
            <path
              class="cls-58"
              d="M605.25,318.33c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.86,5.86,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.91.72-1,1c-.3.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1c.2-.3,0-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M605,317.83c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.41.6.52.9-.1.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.22-1,.3-.71.2-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-435">
              <polygon
                class="cls-436"
                points="600.1 319.6 610.56 313.22 617.75 324.68 607.4 331.06 600.1 319.6"
              />
            </g>
            <g class="cls-437">
              <polygon
                class="cls-438"
                points="599.74 313.63 610.52 319.29 604.06 331.19 593.28 325.53 599.74 313.63"
              />
            </g>
            <polygon
              class="cls-58"
              points="604.63 327.24 605.04 327.94 605.47 329.96 605.97 329.96 606.25 327.93 606.55 327.22 604.63 327.24"
            />
            <path
              class="cls-57"
              d="M636.47,314.27a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.62.1.5,0,.7a1.46,1.46,0,0,0-.29.72c-.1.2.2.5.21.7s-.2.51-.1.71a3.51,3.51,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.52.71c.1.1.3.19.51.4l.1.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="634.98 327.24 635.49 327.23 635.47 325.41 634.86 325.52 634.98 327.24"
            />
            <path
              class="cls-58"
              d="M634.88,317.63c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.61,1-.19.71-.19,1.21c0,.3.32.71.32,1.11s-.5.71-.5,1,.11.81,0,1.11-.61.51-.81.82-.09.81-.29,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.41-.09.1-.91c-.21-.31-.51-.4-.52-.71a8.58,8.58,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21,0-.31-.31-.71-.31-1.11s.5-.72.49-1-.11-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M634.67,317.12c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.11s-.5.62-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.51-.91.09-.81-.12-1"
            />
            <g class="cls-439">
              <polygon
                class="cls-440"
                points="629.74 318.89 640.09 312.41 647.39 323.98 637.03 330.25 629.74 318.89"
              />
            </g>
            <g class="cls-441">
              <polygon
                class="cls-442"
                points="629.37 312.82 640.15 318.48 633.7 330.39 622.91 324.73 629.37 312.82"
              />
            </g>
            <polygon
              class="cls-58"
              points="634.37 326.54 634.68 327.24 635.1 329.26 635.61 329.25 635.89 327.13 636.18 326.42 634.37 326.54"
            />
            <path
              class="cls-57"
              d="M650.45,306.24a3.51,3.51,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.52-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="648.96 319.2 649.46 319.1 649.45 317.38 648.84 317.38 648.96 319.2"
            />
            <path
              class="cls-58"
              d="M648.86,309.59c.1-.3.6-.51.7-.81s.1-.81.29-1.12a5.19,5.19,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.5,1,.11.81,0,1.12-.61.51-.81.81-.09.81-.29,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M648.65,309c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.71-.12-1"
            />
            <g class="cls-443">
              <polygon
                class="cls-444"
                points="643.72 310.86 654.07 304.38 661.37 315.94 651.01 322.22 643.72 310.86"
              />
            </g>
            <g class="cls-445">
              <polygon
                class="cls-446"
                points="643.35 304.79 654.13 310.45 647.68 322.35 636.9 316.69 643.35 304.79"
              />
            </g>
            <polygon
              class="cls-58"
              points="648.24 318.4 648.66 319.21 649.08 321.23 649.59 321.12 649.87 319.09 650.16 318.38 648.24 318.4"
            />
            <path
              class="cls-57"
              d="M664.23,298.31a4,4,0,0,1-.42-.71c-.1-.2.1-.5-.1-.7s-.41-.3-.52-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="662.74 311.27 663.35 311.27 663.23 309.45 662.52 309.45 662.74 311.27"
            />
            <path
              class="cls-58"
              d="M662.64,301.66c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22.32.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.5-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M662.43,301.16c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.81-.12-1"
            />
            <g class="cls-447">
              <polygon
                class="cls-448"
                points="657.49 302.83 667.95 296.55 675.25 307.91 664.79 314.39 657.49 302.83"
              />
            </g>
            <g class="cls-449">
              <polygon
                class="cls-450"
                points="657.13 296.86 667.91 302.52 661.46 314.52 650.67 308.76 657.13 296.86"
              />
            </g>
            <polygon
              class="cls-58"
              points="662.02 310.47 662.43 311.28 662.76 313.19 663.37 313.19 663.65 311.26 663.94 310.45 662.02 310.47"
            />
            <path
              class="cls-57"
              d="M678.4,289.87a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a4.32,4.32,0,0,1,.41.7c.11.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.3-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="677.02 302.73 677.52 302.73 677.4 301.01 676.8 301.01 677.02 302.73"
            />
            <path
              class="cls-58"
              d="M676.92,293.22c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12a3.23,3.23,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.09-.91c-.2-.3-.5-.4-.51-.7a8,8,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.11-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M676.71,292.62c-.1-.31-.61-.5-.71-.71s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.32.71.32,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.31-.21-.71-.21-1,.29-.72.19-1-.41-.6-.52-.9,0-.71-.11-1"
            />
            <g class="cls-451">
              <polygon
                class="cls-452"
                points="671.77 294.39 682.13 288.01 689.43 299.47 679.07 305.85 671.77 294.39"
              />
            </g>
            <g class="cls-453">
              <polygon
                class="cls-454"
                points="671.41 288.32 682.19 294.08 675.74 305.98 664.96 300.32 671.41 288.32"
              />
            </g>
            <polygon
              class="cls-58"
              points="676.3 302.03 676.61 302.74 677.14 304.75 677.64 304.75 677.83 302.72 678.22 301.91 676.3 302.03"
            />
          </g>
          <g id="plant2-15" data-name="plant2">
            <polygon
              class="cls-54"
              points="537.6 391.26 614.64 346.36 573.02 322.91 495.38 368.21 537.6 391.26"
            />
            <ellipse
              class="cls-55"
              cx="540.65"
              cy="382.42"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.84 5.49) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="512.28"
              cy="368.34"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.7 5.2) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="525.6"
              cy="375.39"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.77 5.34) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="554.92"
              cy="373.68"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.75 5.64) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="568.81"
              cy="366.05"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.68 5.78) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="582.99"
              cy="358.12"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.59 5.92) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="596.77"
              cy="349.98"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.51 6.06) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="495.68 368.01 534.04 389.88 535.25 388.95 496.49 367.19 495.68 368.01"
            />
            <polygon
              class="cls-54"
              points="539.11 390.23 539.12 391.65 613.85 348.39 612.53 347.8 539.11 390.23"
            />
            <polygon
              class="cls-56"
              points="533.43 389.38 533.5 396.26 496.77 375.28 496.5 368.4 533.43 389.38"
            />
            <polygon
              class="cls-56"
              points="539.22 391.44 539.29 398.83 613.91 355.07 613.85 348.19 539.22 391.44"
            />
            <path
              class="cls-57"
              d="M541.61,367.54a3.7,3.7,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.11,0-.11,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.68,1.68,0,0,0-.29.72c-.1.2.21.5.21.7s-.2.51-.1.71a4,4,0,0,1,.42.71c.1.2,0,.5.1.7a4.36,4.36,0,0,0,.52.71c.1.2.3.19.51.4l.1.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.1-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="540.22 380.4 540.73 380.4 540.61 378.58 540 378.59 540.22 380.4"
            />
            <path
              class="cls-58"
              d="M540.12,370.79c.1-.3.6-.51.7-.81s.1-.81.3-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.19c.1,0,.11.1.11.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1,.1.8,0,1.11-.61.51-.8.82-.1.81-.3,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41A11.86,11.86,0,0,0,540,374c0-.3-.31-.7-.31-1.11s.5-.71.49-1-.21-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M539.81,370.29c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.62.4.72.7.11.7.31,1a7.73,7.73,0,0,0,1,.8c.31.19.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-455">
              <polygon
                class="cls-456"
                points="534.98 372.06 545.33 365.68 552.63 377.14 542.17 383.52 534.98 372.06"
              />
            </g>
            <g class="cls-457">
              <polygon
                class="cls-458"
                points="534.51 365.99 545.29 371.75 538.84 383.66 528.06 378 534.51 365.99"
              />
            </g>
            <polygon
              class="cls-58"
              points="539.4 379.7 539.82 380.41 540.24 382.43 540.75 382.32 541.03 380.4 541.33 379.58 539.4 379.7"
            />
            <path
              class="cls-57"
              d="M513.34,353.46a4.32,4.32,0,0,1-.41-.7c-.1-.21.1-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.62.11.5,0,.7a1.58,1.58,0,0,0-.3.71c0,.31.21.51.21.71s-.2.51-.09.71a4.32,4.32,0,0,1,.41.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.21.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.09-.2-.11-.5,0-.7a1.46,1.46,0,0,0,.29-.72c.1-.2-.2-.5-.2-.7s.29-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="511.85 366.32 512.46 366.32 512.44 364.5 511.73 364.61 511.85 366.32"
            />
            <path
              class="cls-58"
              d="M511.86,356.81c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.29-.71.59-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.21.3,0,.8.11,1.11s.52.7.62,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.23,3.23,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.09.09-.92c-.2-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M511.55,356.21c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.3.1.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.39.71.7.11.7.32,1a6.05,6.05,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.1-.81c.09-.3.4-.31.49-.71s.3-1,.4-1.32-.21-.71-.22-1,.3-.71.19-1-.41-.61-.51-.91.09-.81-.11-1"
            />
            <g class="cls-459">
              <polygon
                class="cls-460"
                points="506.61 357.98 517.07 351.6 524.26 363.06 513.91 369.44 506.61 357.98"
              />
            </g>
            <g class="cls-461">
              <polygon
                class="cls-462"
                points="506.34 351.71 517.12 357.37 510.57 369.37 499.79 363.71 506.34 351.71"
              />
            </g>
            <polygon
              class="cls-58"
              points="511.24 365.62 511.55 366.33 511.98 368.35 512.48 368.34 512.76 366.31 513.06 365.5 511.24 365.62"
            />
            <path
              class="cls-57"
              d="M526.56,360.41a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.31,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.31.19-.61"
            />
            <polygon
              class="cls-58"
              points="525.18 373.37 525.68 373.37 525.56 371.65 524.96 371.66 525.18 373.37"
            />
            <path
              class="cls-58"
              d="M525.08,363.76c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.31,0,.81.12,1.12s.51.7.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1a4.2,4.2,0,0,1,0,1.12c-.1.3-.6.51-.8.81s-.09.82-.29,1.12a3.34,3.34,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22,0-.3-.31-.7-.31-1.11s.49-.71.49-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M524.77,363.26c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.5.92.31.7.32,1-.3.71-.2,1,.42.6.52.9-.09.71.11,1,.61.39.72.7.1.7.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.4l.41.7.31-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.52-.91.1-.71-.11-1"
            />
            <g class="cls-463">
              <polygon
                class="cls-464"
                points="519.93 365.03 530.29 358.65 537.59 370.11 527.13 376.49 519.93 365.03"
              />
            </g>
            <g class="cls-465">
              <polygon
                class="cls-466"
                points="519.47 359.06 530.25 364.62 523.79 376.63 513.01 370.87 519.47 359.06"
              />
            </g>
            <polygon
              class="cls-58"
              points="524.36 372.57 524.77 373.38 525.2 375.4 525.7 375.39 525.99 373.37 526.28 372.55 524.36 372.57"
            />
            <path
              class="cls-57"
              d="M556.1,359.7a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.21.71s-.2.5-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.5.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71a.57.57,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="554.71 372.67 555.32 372.66 555.2 370.84 554.49 370.95 554.71 372.67"
            />
            <path
              class="cls-58"
              d="M554.61,363.06c.1-.31.6-.51.7-.82s.1-.81.29-1.11a5.19,5.19,0,0,0,1-.62c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.21c0,.31.31.71.31,1.11s-.5.72-.5,1,.11.81,0,1.11-.61.52-.81.82-.09.81-.29,1.12-.9.71-1,1c-.3.2-.6.21-.9.51l-.4.82-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a9,9,0,0,1-.52-1.42,12.06,12.06,0,0,0,.19-1.21c0-.31-.31-.71-.31-1.11s.5-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M554.4,362.45c-.1-.3-.61-.5-.71-.7s-.11-.7-.31-1-.72-.29-.92-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.39l.41.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.51-.91.09-.7-.12-1"
            />
            <g class="cls-467">
              <polygon
                class="cls-468"
                points="549.47 364.32 559.92 357.85 567.12 369.41 556.76 375.69 549.47 364.32"
              />
            </g>
            <g class="cls-469">
              <polygon
                class="cls-470"
                points="549.1 358.26 559.88 363.92 553.43 375.82 542.65 370.16 549.1 358.26"
              />
            </g>
            <polygon
              class="cls-58"
              points="553.99 371.87 554.3 372.67 554.83 374.69 555.34 374.69 555.62 372.66 555.81 371.85 553.99 371.87"
            />
            <path
              class="cls-57"
              d="M570.08,351.67a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.46,1.46,0,0,0-.29.72c-.1.2.2.5.21.7s-.2.51-.1.71a3.51,3.51,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.52.71c.1.1.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="568.69 364.64 569.2 364.53 569.18 362.81 568.47 362.82 568.69 364.64"
            />
            <path
              class="cls-58"
              d="M568.59,355c.1-.31.6-.52.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.11.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.71.31,1.11-.5.71-.49,1,.1.81,0,1.11-.61.51-.8.82-.1.81-.3,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.41-.09.1-.91c-.21-.31-.51-.4-.52-.71a8.93,8.93,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M568.38,354.42c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.62.39.72.7.11.7.31,1a6.87,6.87,0,0,0,1,.79c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-471">
              <polygon
                class="cls-472"
                points="563.45 356.29 573.9 349.81 581.1 361.27 570.74 367.65 563.45 356.29"
              />
            </g>
            <g class="cls-473">
              <polygon
                class="cls-474"
                points="563.08 350.22 573.86 355.88 567.31 367.79 556.63 362.13 563.08 350.22"
              />
            </g>
            <polygon
              class="cls-58"
              points="567.97 363.83 568.29 364.64 568.81 366.56 569.32 366.55 569.6 364.53 569.79 363.71 567.97 363.83"
            />
            <path
              class="cls-57"
              d="M584,343.74a3.7,3.7,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.62.1.5,0,.7a1.47,1.47,0,0,0-.29.71c-.1.21.21.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.31,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.1.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="582.47 356.61 582.97 356.6 582.96 354.88 582.35 354.89 582.47 356.61"
            />
            <path
              class="cls-58"
              d="M582.37,347.09c.1-.3.6-.51.7-.81s.1-.81.29-1.12a5.13,5.13,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.71.31,1.11-.5.71-.5,1,.11.81,0,1.11-.61.51-.81.82-.09.81-.29,1.11-.9.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.39-.52-.7a8.93,8.93,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22s-.31-.7-.31-1.11.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M582.16,346.59c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.29-.92-.5-.31-.7-.61-.8c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.71.11,1,.62.4.72.7.11.7.31,1a7.73,7.73,0,0,0,1,.8c.31.19.51.19.82.39l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91,0-.81-.12-1"
            />
            <g class="cls-475">
              <polygon
                class="cls-476"
                points="577.23 348.26 587.58 341.98 594.88 353.44 584.52 359.82 577.23 348.26"
              />
            </g>
            <g class="cls-477">
              <polygon
                class="cls-478"
                points="576.86 342.29 587.64 347.95 581.19 359.86 570.41 354.3 576.86 342.29"
              />
            </g>
            <polygon
              class="cls-58"
              points="581.75 355.9 582.16 356.61 582.59 358.63 583.1 358.62 583.38 356.6 583.67 355.88 581.75 355.9"
            />
            <path
              class="cls-57"
              d="M598.14,335.3a4.3,4.3,0,0,1-.42-.7c-.1-.21.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.62.1.5,0,.7a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.21,0,.51.11.71a4.9,4.9,0,0,0,.51.7c.11.21.31.2.51.4l.11.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="596.75 348.16 597.25 348.16 597.24 346.44 596.53 346.45 596.75 348.16"
            />
            <path
              class="cls-58"
              d="M596.65,338.65c.1-.3.6-.51.7-.81s.09-.81.29-1.12a4.74,4.74,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.19c.1,0,.1.1.11.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.5,1,.11.8,0,1.11-.61.51-.81.82-.09.81-.29,1.11-.9.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M596.44,338.05c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.71.11.7.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-479">
              <polygon
                class="cls-480"
                points="591.4 339.82 601.86 333.44 609.16 344.9 598.8 351.28 591.4 339.82"
              />
            </g>
            <g class="cls-481">
              <polygon
                class="cls-482"
                points="591.14 333.75 601.92 339.51 595.36 351.31 584.58 345.76 591.14 333.75"
              />
            </g>
            <polygon
              class="cls-58"
              points="596.03 347.46 596.34 348.17 596.77 350.19 597.27 350.18 597.66 348.15 597.85 347.34 596.03 347.46"
            />
          </g>
          <polygon
            class="cls-228"
            points="493.49 351.54 490.54 349.95 491.57 450.91 494.52 453.11 493.49 351.54"
          />
          <polygon
            class="cls-229"
            points="537.15 476.96 539.96 475.01 538.9 369.9 536.08 371.54 537.15 476.96"
          />
          <polygon
            class="cls-54"
            points="535.98 371.54 538.8 370 493.23 345.26 490.51 346.91 535.98 371.54"
          />
          <polygon
            class="cls-229"
            points="574.12 301.34 574.14 303.67 614.13 325.93 614.1 323.5 574.12 301.34"
          />
          <polygon
            class="cls-54"
            points="651.23 253.51 653.67 254.81 493.26 348.3 490.51 346.81 651.23 253.51"
          />
          <polygon
            class="cls-54"
            points="691.34 278.61 694.26 276.86 651.63 253.21 648.71 254.96 691.34 278.61"
          />
          <polygon
            class="cls-229"
            points="695.05 385.11 697.86 383.36 696.8 278.35 693.99 280 695.05 385.11"
          />
          <polygon
            class="cls-229"
            points="617.3 429.3 620.21 427.45 619.18 325.58 616.26 327.12 617.3 429.3"
          />
          <polygon
            class="cls-228"
            points="616.27 327.63 613.42 326.04 614.44 427.01 617.3 429.3 616.27 327.63"
          />
          <polygon
            class="cls-230"
            points="651.26 256.35 651.28 258.78 691.37 281.03 691.34 278.61 651.26 256.35"
          />
          <polygon
            class="cls-54"
            points="694.26 276.86 696.8 278.35 535.98 371.54 533.34 370.15 694.26 276.86"
          />
          <polygon
            class="cls-229"
            points="536.12 375.29 696.83 281.38 696.8 278.35 536.08 371.54 536.12 375.29"
          />
          <polygon
            class="cls-54"
            points="614.4 323.5 616.92 322.06 576.43 299.8 574.12 301.14 614.4 323.5"
          />
          <polygon
            class="cls-228"
            points="536.12 374.68 533.27 373.09 534.29 474.26 537.15 476.56 536.12 374.68"
          />
          <polygon
            class="cls-229"
            points="494.53 454.02 497.34 452.07 496.34 353.23 493.49 351.54 494.53 454.02"
          />
          <polygon
            class="cls-228"
            points="490.51 346.81 535.98 371.54 536.02 375.29 490.54 349.95 490.51 346.81"
          />
          <polygon
            class="cls-40"
            points="536.39 371.34 619.16 323.25 574.39 298.1 490.92 346.7 536.39 371.34"
          />
          <polygon
            class="cls-40"
            points="614.03 326.24 696.9 278.14 652.13 253 568.56 301.6 614.03 326.24"
          />
          <g id="plant2-16" data-name="plant2">
            <polygon
              class="cls-54"
              points="460.57 487.25 537.61 442.35 496 418.9 418.36 464.2 460.57 487.25"
            />
            <ellipse
              class="cls-55"
              cx="463.52"
              cy="478.31"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -4.82, 4.72)"
            />
            <ellipse
              class="cls-55"
              cx="435.25"
              cy="464.23"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.68 4.43) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="448.47"
              cy="471.28"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.75 4.56) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="477.9"
              cy="469.57"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.73 4.86) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="491.78"
              cy="461.94"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.65 5) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="505.86"
              cy="454.01"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.57 5.14) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="519.74"
              cy="445.87"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.49 5.28) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="418.66 463.89 457.02 485.77 458.22 484.94 419.46 463.08 418.66 463.89"
            />
            <polygon
              class="cls-54"
              points="462.06 484.3 462.07 485.71 536.8 442.36 535.58 441.67 462.06 484.3"
            />
            <polygon
              class="cls-56"
              points="456.41 485.37 456.47 492.05 419.64 471.27 419.47 464.29 456.41 485.37"
            />
            <polygon
              class="cls-56"
              points="462.07 485.51 462.15 492.9 536.77 449.14 536.7 442.26 462.07 485.51"
            />
            <path
              class="cls-57"
              d="M464.58,463.33a4.05,4.05,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.61c.1-.21.31-.21.51-.41a2.6,2.6,0,0,0,.49-.82c.1-.2-.1-.5,0-.7a1.46,1.46,0,0,0,.29-.72c.1-.2-.2-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="463.09 476.3 463.6 476.29 463.58 474.57 462.97 474.58 463.09 476.3"
            />
            <path
              class="cls-58"
              d="M463.1,466.68c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5.44,5.44,0,0,0,1-.62c.3-.2.3-.71.6-1a.11.11,0,0,0,.1-.11,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.49.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.09.82-.29,1.12a3.12,3.12,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.7-.32-1.11.5-.71.5-1-.21-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M462.79,466.18c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.5.61-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.39.71.7.11.7.32,1a3.28,3.28,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-483">
              <polygon
                class="cls-484"
                points="457.85 467.95 468.2 461.57 475.6 473.03 465.15 479.41 457.85 467.95"
              />
            </g>
            <g class="cls-485">
              <polygon
                class="cls-486"
                points="457.48 461.98 468.26 467.54 461.81 479.55 451.03 473.79 457.48 461.98"
              />
            </g>
            <polygon
              class="cls-58"
              points="462.38 475.49 462.79 476.3 463.21 478.32 463.72 478.31 464 476.29 464.3 475.47 462.38 475.49"
            />
            <path
              class="cls-57"
              d="M436.31,449.35a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.2.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.41.19-.61"
            />
            <polygon
              class="cls-58"
              points="434.83 462.21 435.43 462.21 435.42 460.39 434.71 460.39 434.83 462.21"
            />
            <path
              class="cls-58"
              d="M434.73,452.7c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.29-.71.59-1a.1.1,0,0,0,.1-.11,1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.21.3,0,.8.12,1.11s.51.7.61,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.09.09-.92c-.2-.3-.51-.4-.51-.7a8,8,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.49-.71.49-1c.2-.41,0-.91,0-1.12"
            />
            <path
              class="cls-59"
              d="M434.52,452.1c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.5.92.31.7.32,1-.3.72-.2,1,.42.6.52.9-.09.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.31.2.51.2.81.4l.42.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.81-.11-1"
            />
            <g class="cls-487">
              <polygon
                class="cls-488"
                points="429.58 453.87 440.04 447.49 447.24 458.95 436.88 465.33 429.58 453.87"
              />
            </g>
            <g class="cls-489">
              <polygon
                class="cls-490"
                points="429.32 447.7 440.1 453.26 433.54 465.26 422.76 459.5 429.32 447.7"
              />
            </g>
            <polygon
              class="cls-58"
              points="434.11 461.51 434.52 462.22 434.95 464.24 435.45 464.13 435.74 462.2 436.03 461.39 434.11 461.51"
            />
            <path
              class="cls-57"
              d="M449.54,456.4a3.51,3.51,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.32-.71c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71-.3.41-.29.71.21.51.21.71-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.2,0,.51.1.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.61c.1-.21.3-.21.5-.41s.5-.72.5-.82-.1-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="448.05 469.26 448.56 469.26 448.54 467.54 447.93 467.55 448.05 469.26"
            />
            <path
              class="cls-58"
              d="M448.05,459.65c.1-.3.6-.51.7-.82s.1-.81.29-1.11a5.19,5.19,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.5,1,.11.81,0,1.12-.61.51-.8.81-.1.81-.3,1.12a3.23,3.23,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.51-.31-.7-.31-1.11s.5-.71.49-1-.21-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M447.74,459.15c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.1.3.11.7,0,1.11s-.5.61-.49.92.31.7.31,1-.3.72-.19,1,.41.6.51.9-.09.71.11,1,.62.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.3.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.71-.12-1"
            />
            <g class="cls-491">
              <polygon
                class="cls-492"
                points="442.81 460.92 453.16 454.44 460.46 466 450.1 472.28 442.81 460.92"
              />
            </g>
            <g class="cls-493">
              <polygon
                class="cls-494"
                points="442.44 454.85 453.22 460.61 446.76 472.41 435.99 466.86 442.44 454.85"
              />
            </g>
            <polygon
              class="cls-58"
              points="447.33 468.56 447.75 469.27 448.17 471.29 448.68 471.28 448.96 469.25 449.25 468.44 447.33 468.56"
            />
            <path
              class="cls-57"
              d="M479.07,455.59a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.11s-.09.5-.19.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a6.14,6.14,0,0,1,.41.71c.1.2,0,.5.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.6h.3l.09-.61c.1-.2.31-.2.51-.41s.49-.71.49-.81-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.21-.5-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="477.68 468.46 478.29 468.45 478.17 466.73 477.46 466.74 477.68 468.46"
            />
            <path
              class="cls-58"
              d="M477.59,459c.09-.31.6-.51.7-.82s.09-.81.29-1.11a6,6,0,0,0,1-.62c.3-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.5.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.29,1.12-.91.71-1,1c-.3.2-.6.21-.9.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M477.38,458.44c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.39l.41.71.3-.11-.11-.8c.1-.31.41-.31.5-.72s.3-1,.39-1.32-.2-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.81-.11-1"
            />
            <g class="cls-495">
              <polygon
                class="cls-496"
                points="472.44 460.11 482.89 453.73 490.09 465.3 479.74 471.57 472.44 460.11"
              />
            </g>
            <g class="cls-497">
              <polygon
                class="cls-498"
                points="472.07 454.15 482.86 459.81 476.4 471.71 465.62 466.05 472.07 454.15"
              />
            </g>
            <polygon
              class="cls-58"
              points="476.97 467.86 477.28 468.56 477.7 470.58 478.31 470.48 478.59 468.45 478.89 467.74 476.97 467.86"
            />
            <path
              class="cls-57"
              d="M493.05,447.56a4.32,4.32,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.09.71a5.2,5.2,0,0,1,.41.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.21.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41a7.6,7.6,0,0,0,.49-.82c.1-.2-.1-.5,0-.7a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="491.66 460.42 492.17 460.42 492.15 458.7 491.44 458.71 491.66 460.42"
            />
            <path
              class="cls-58"
              d="M491.56,450.81c.1-.3.61-.51.7-.81s.1-.81.3-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1a.11.11,0,0,0,.1-.11,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.49,1,.11.81,0,1.12-.6.51-.8.82-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22s-.32-.7-.32-1.11.5-.71.5-1-.11-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M491.36,450.31c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.7,0,1.11s-.5.61-.5.92.31.7.31,1-.29.72-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.71.11.7.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.11-1"
            />
            <g class="cls-499">
              <polygon
                class="cls-500"
                points="486.42 452.08 496.88 445.7 504.07 457.26 493.72 463.54 486.42 452.08"
              />
            </g>
            <g class="cls-501">
              <polygon
                class="cls-502"
                points="486.05 446.11 496.83 451.67 490.28 463.68 479.5 458.02 486.05 446.11"
              />
            </g>
            <polygon
              class="cls-58"
              points="490.95 459.72 491.26 460.43 491.68 462.45 492.19 462.44 492.57 460.42 492.77 459.7 490.95 459.72"
            />
            <path
              class="cls-57"
              d="M506.83,439.63a4.32,4.32,0,0,1-.41-.7c-.11-.21.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.11,0-.11,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.1.5,0,.7a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.21,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.21.3.2.51.4l.11.61h.3l.09-.61c.1-.2.31-.21.51-.41s.49-.71.49-.82-.1-.5,0-.7.3-.41.29-.71-.21-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="505.44 452.6 505.95 452.59 505.93 450.77 505.22 450.78 505.44 452.6"
            />
            <path
              class="cls-58"
              d="M505.35,443c.09-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.22.19c.1,0,.1.1.1.21.2.3,0,.8.11,1.11s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.49,1a4.12,4.12,0,0,1,0,1.11c-.1.3-.6.51-.8.82s-.1.81-.29,1.11-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.09.09-.92c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.3.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M505.14,442.38c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.31.11.11,0,0,0-.1.11c-.09.3.11.7,0,1.11s-.5.61-.5.92.31.7.31,1-.29.72-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.71.11.7.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.6-.51-.9,0-.71-.11-1"
            />
            <g class="cls-503">
              <polygon
                class="cls-504"
                points="500.2 444.15 510.55 437.77 517.85 449.23 507.5 455.61 500.2 444.15"
              />
            </g>
            <g class="cls-505">
              <polygon
                class="cls-506"
                points="499.83 438.08 510.61 443.84 504.16 455.74 493.38 450.09 499.83 438.08"
              />
            </g>
            <polygon
              class="cls-58"
              points="504.73 451.79 505.04 452.6 505.56 454.52 506.07 454.51 506.35 452.59 506.55 451.67 504.73 451.79"
            />
            <path
              class="cls-57"
              d="M521.11,431.19a4.05,4.05,0,0,1-.41-.71c-.11-.2.09-.5-.11-.7s-.41-.3-.51-.6-.11-.51-.31-.71c-.11,0-.11,0-.11-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.1.51,0,.71a1.58,1.58,0,0,0-.3.71c-.1.21.21.51.21.71s-.2.51-.1.71a4.3,4.3,0,0,1,.42.7c.1.2,0,.51.1.71a4.89,4.89,0,0,0,.52.7c.1.2.3.2.51.4l.11.61h.3l.09-.61c.1-.21.3-.21.51-.41s.49-.72.49-.82-.1-.5,0-.7a1.68,1.68,0,0,0,.29-.72c.1-.2-.21-.5-.21-.7a1.11,1.11,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="519.72 444.05 520.23 444.05 520.21 442.23 519.5 442.33 519.72 444.05"
            />
            <path
              class="cls-58"
              d="M519.63,434.54c.09-.3.6-.51.69-.81s.1-.81.3-1.12a5.44,5.44,0,0,0,1-.62c.3-.2.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.2.31,0,.81.11,1.12s.51.7.62,1-.2.71-.19,1.22c0,.3.31.7.31,1.11s-.5.71-.49,1,.11.81,0,1.12-.6.51-.8.81-.1.81-.29,1.12-.91.72-1,1c-.3.21-.6.21-.9.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.31,7.31,0,0,1-.52-1.41c0-.31.19-.71.19-1.22,0-.3-.31-.7-.32-1.11s.5-.71.5-1-.11-.81,0-1.12"
            />
            <path
              class="cls-59"
              d="M519.42,433.94c-.11-.3-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.7-.61-.8c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.09.3.11.7,0,1.11s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.3.41-.31.5-.71s.3-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.6-.51-.9.09-.81-.11-1"
            />
            <g class="cls-507">
              <polygon
                class="cls-508"
                points="514.38 435.71 524.83 429.33 532.13 440.79 521.67 447.17 514.38 435.71"
              />
            </g>
            <g class="cls-509">
              <polygon
                class="cls-510"
                points="514.11 429.64 524.79 435.4 518.34 447.3 507.56 441.65 514.11 429.64"
              />
            </g>
            <polygon
              class="cls-58"
              points="519.01 443.35 519.32 444.06 519.74 446.08 520.25 446.07 520.63 443.94 520.83 443.23 519.01 443.35"
            />
          </g>
          <g id="plant2-17" data-name="plant2">
            <polygon
              class="cls-54"
              points="459.92 462.87 537.06 418.08 495.35 394.62 417.71 439.93 459.92 462.87"
            />
            <ellipse
              class="cls-55"
              cx="462.97"
              cy="454.04"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.57 4.71) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="434.7"
              cy="439.96"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.43 4.42) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="447.92"
              cy="447.01"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.5 4.56) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="477.24"
              cy="445.29"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.48 4.85) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="491.23"
              cy="437.66"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.4 4.99) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="505.31"
              cy="429.83"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.32 5.14) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="519.19"
              cy="421.6"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.24 5.28) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="418.11 439.62 456.47 461.49 457.67 460.57 418.81 438.8 418.11 439.62"
            />
            <polygon
              class="cls-54"
              points="461.51 460.02 461.53 461.44 536.15 417.98 534.93 417.49 461.51 460.02"
            />
            <polygon
              class="cls-56"
              points="455.86 461.09 455.93 467.87 419.09 446.89 418.92 440.12 455.86 461.09"
            />
            <polygon
              class="cls-56"
              points="461.52 461.34 461.6 468.72 536.22 424.96 536.15 417.98 461.52 461.34"
            />
            <path
              class="cls-57"
              d="M463.93,439.15a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.11a.77.77,0,0,0-.91,0c-.11,0-.11,0-.11.11s-.09.5-.19.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a5.39,5.39,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.1.1.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="462.54 452.02 463.05 452.01 463.03 450.19 462.32 450.3 462.54 452.02"
            />
            <path
              class="cls-58"
              d="M462.45,442.51c.09-.31.6-.51.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.12a3,3,0,0,0-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.21-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M462.24,441.9c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.1-.81c.09-.3.4-.3.49-.71s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.91.09-.71-.11-1"
            />
            <g class="cls-511">
              <polygon
                class="cls-512"
                points="457.3 443.67 467.65 437.29 474.95 448.75 464.5 455.13 457.3 443.67"
              />
            </g>
            <g class="cls-513">
              <polygon
                class="cls-514"
                points="456.93 437.61 467.62 443.37 461.26 455.27 450.38 449.61 456.93 437.61"
              />
            </g>
            <polygon
              class="cls-58"
              points="461.83 451.32 462.14 452.02 462.56 454.04 463.17 454.04 463.45 452.01 463.65 451.2 461.83 451.32"
            />
            <path
              class="cls-57"
              d="M435.77,425.07a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.49.62.1.5,0,.7a1.46,1.46,0,0,0-.29.72c-.1.2.2.5.21.7s-.2.51-.1.71a4.05,4.05,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.11.2.31.19.51.4l.11.6h.31l.09-.61c.1-.2.3-.21.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.58,1.58,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="434.28 437.94 434.78 437.93 434.76 436.21 434.16 436.22 434.28 437.94"
            />
            <path
              class="cls-58"
              d="M434.18,428.43c.1-.31.6-.52.7-.82s.09-.81.29-1.12a5.43,5.43,0,0,0,1-.61c.3-.21.29-.72.59-1a.09.09,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.7.61,1-.19.72-.19,1.22c0,.3.31.71.32,1.11s-.5.71-.5,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11-.9.72-1,1c-.3.2-.61.2-.91.51l-.39.81-.41-.09.09-.91c-.2-.31-.51-.4-.51-.71a7.76,7.76,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.21s-.31-.71-.31-1.11.49-.72.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M434,427.82c-.1-.3-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.5.92.31.7.32,1-.3.71-.19,1,.41.6.51.91-.09.7.11,1,.61.39.72.7.11.7.31,1a3.71,3.71,0,0,0,1,.8c.31.19.51.19.81.39l.42.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.52-.91.1-.71-.11-1"
            />
            <g class="cls-515">
              <polygon
                class="cls-516"
                points="429.03 429.59 439.39 423.21 446.69 434.67 436.33 441.05 429.03 429.59"
              />
            </g>
            <g class="cls-517">
              <polygon
                class="cls-518"
                points="428.67 423.32 439.45 429.08 432.99 440.98 422.21 435.33 428.67 423.32"
              />
            </g>
            <polygon
              class="cls-58"
              points="433.56 437.24 433.97 437.94 434.4 439.96 434.9 439.95 435.19 437.93 435.48 437.21 433.56 437.24"
            />
            <path
              class="cls-57"
              d="M448.89,432.12a4.3,4.3,0,0,1-.42-.7c-.1-.2.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.72-.51.3-.5.61.1.5,0,.71a1.39,1.39,0,0,0-.29.71c-.1.2.2.5.21.7s-.2.51-.1.71a3.51,3.51,0,0,1,.41.71c.11.2,0,.5.11.7a4.36,4.36,0,0,0,.52.71c.1.2.3.2.51.4l.1.6h.31l.09-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.21-.11-.51,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.21-.21-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="447.5 444.99 448 444.98 447.99 443.26 447.28 443.27 447.5 444.99"
            />
            <path
              class="cls-58"
              d="M447.4,435.37c.1-.3.6-.51.7-.81s.1-.81.29-1.12a4.74,4.74,0,0,0,1-.62c.3-.3.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.2c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.71-.19,1.22.31.7.31,1.11-.5.71-.5,1,.11.8,0,1.11-.61.51-.81.82-.09.81-.29,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.39-.52-.7a8.93,8.93,0,0,1-.52-1.41,11.86,11.86,0,0,0,.19-1.22c0-.4-.31-.7-.31-1.11s.5-.71.49-1-.1-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M447.19,434.87c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.61-.8c-.11,0-.11,0-.11-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.7.11,1,.62.39.72.7.11.7.31,1a3.48,3.48,0,0,0,1,.79c.31.2.51.2.82.4l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.3-.71.19-1-.41-.61-.51-.91.09-.71-.12-1"
            />
            <g class="cls-519">
              <polygon
                class="cls-520"
                points="442.26 436.64 452.61 430.26 459.91 441.72 449.45 448.1 442.26 436.64"
              />
            </g>
            <g class="cls-521">
              <polygon
                class="cls-522"
                points="441.89 430.68 452.57 436.33 446.22 448.24 435.33 442.58 441.89 430.68"
              />
            </g>
            <polygon
              class="cls-58"
              points="446.78 444.29 447.1 445.09 447.52 447.01 448.13 447 448.41 444.98 448.61 444.27 446.78 444.29"
            />
            <path
              class="cls-57"
              d="M478.52,431.32a5,5,0,0,1-.41-.71c-.11-.2.09-.5-.11-.71s-.41-.29-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.11-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.3.2.51.4l.11.61h.3l.09-.6c.1-.21.31-.21.51-.41s.49-.72.49-.82-.1-.5,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.7a.59.59,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="477.03 444.28 477.64 444.28 477.62 442.56 476.91 442.56 477.03 444.28"
            />
            <path
              class="cls-58"
              d="M477,434.67c.09-.3.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.51.71.62,1-.2.71-.19,1.22.31.7.31,1.1-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.31.21-.61.21-.91.52l-.4.81-.4-.1.09-.91c-.21-.3-.51-.4-.51-.7a7.56,7.56,0,0,1-.52-1.41c0-.31.19-.71.19-1.22s-.31-.71-.32-1.11.5-.71.5-1-.11-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M476.73,434.07c-.11-.31-.62-.5-.72-.7s-.11-.71-.31-1-.71-.3-.92-.5-.31-.71-.61-.8c-.1,0-.1,0-.11-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.6.52.9-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.2.81.4l.41.7.3-.1-.11-.81c.1-.31.41-.31.5-.72s.3-1,.39-1.31-.21-.71-.21-1,.3-.72.19-1-.41-.6-.51-.9.09-.61-.11-1"
            />
            <g class="cls-523">
              <polygon
                class="cls-524"
                points="471.79 435.94 482.24 429.46 489.54 441.02 479.19 447.4 471.79 435.94"
              />
            </g>
            <g class="cls-525">
              <polygon
                class="cls-526"
                points="471.53 429.97 482.31 435.53 475.75 447.43 464.97 441.77 471.53 429.97"
              />
            </g>
            <polygon
              class="cls-58"
              points="476.42 443.48 476.73 444.29 477.15 446.31 477.66 446.3 478.04 444.27 478.24 443.46 476.42 443.48"
            />
            <path
              class="cls-57"
              d="M492.5,423.28a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.11,0-.11,0-.11.11s-.09.5-.19.71-.5.3-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71a.58.58,0,0,0,.2-.61"
            />
            <polygon
              class="cls-58"
              points="491.11 436.25 491.62 436.24 491.6 434.42 490.89 434.43 491.11 436.25"
            />
            <path
              class="cls-58"
              d="M491,426.64c.09-.31.6-.52.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.15,3.15,0,0,0-1,1c-.31.2-.61.2-.91.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M490.71,426c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.31.11.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.6-.11-1"
            />
            <g class="cls-527">
              <polygon
                class="cls-528"
                points="485.77 427.9 496.23 421.42 503.52 432.88 493.17 439.26 485.77 427.9"
              />
            </g>
            <g class="cls-529">
              <polygon
                class="cls-530"
                points="485.5 421.84 496.29 427.49 489.73 439.4 478.95 433.74 485.5 421.84"
              />
            </g>
            <polygon
              class="cls-58"
              points="490.4 435.44 490.71 436.25 491.13 438.17 491.64 438.17 491.92 436.24 492.22 435.33 490.4 435.44"
            />
            <path
              class="cls-57"
              d="M506.28,415.45a4.32,4.32,0,0,1-.41-.7c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.11a.77.77,0,0,0-.91,0c-.11,0-.11,0-.1.11s-.1.5-.2.71-.5.31-.5.61.11.5,0,.71a1.49,1.49,0,0,0-.3.71c-.1.2.21.5.21.7s-.2.51-.09.71a5.39,5.39,0,0,1,.41.71c.1.2,0,.5.11.7a4,4,0,0,0,.51.71c.1.2.31.2.51.4l.11.6h.3l.1-.61c.09-.2.3-.2.5-.41a2.31,2.31,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.51-.21-.71s.3-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="504.89 428.32 505.4 428.21 505.28 426.49 504.67 426.5 504.89 428.32"
            />
            <path
              class="cls-58"
              d="M504.8,418.81c.1-.31.6-.51.7-.82s.09-.81.29-1.12a5.37,5.37,0,0,0,1-.61c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.7.62,1-.2.71-.19,1.21c0,.31.31.71.31,1.11s-.49.72-.49,1a4.13,4.13,0,0,1,0,1.11c-.1.31-.6.51-.8.82s-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.71a7.08,7.08,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.72.5-1a3.75,3.75,0,0,1,0-1.11"
            />
            <path
              class="cls-59"
              d="M504.59,418.2c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a3.44,3.44,0,0,0,1,.8c.3.2.51.19.81.39l.41.71.3-.11-.1-.81c.09-.3.4-.3.49-.71s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.91,0-.81-.11-1"
            />
            <g class="cls-531">
              <polygon
                class="cls-532"
                points="499.65 419.97 510 413.59 517.3 425.06 506.85 431.43 499.65 419.97"
              />
            </g>
            <g class="cls-533">
              <polygon
                class="cls-534"
                points="499.18 413.91 510.07 419.67 503.51 431.47 492.83 425.91 499.18 413.91"
              />
            </g>
            <polygon
              class="cls-58"
              points="504.18 427.62 504.49 428.32 504.91 430.34 505.42 430.23 505.7 428.21 506 427.5 504.18 427.62"
            />
            <path
              class="cls-57"
              d="M520.56,406.91a4.32,4.32,0,0,1-.41-.7c-.11-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.51-.31-.71c-.1,0-.1,0-.11-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.5.31-.5.62.11.5,0,.7a1.57,1.57,0,0,0-.3.72c-.1.2.21.5.21.7s-.2.51-.09.71a4.8,4.8,0,0,1,.41.71c.1.2,0,.5.11.7a4.36,4.36,0,0,0,.51.71c.1.2.3.19.51.4l.11.6h.3l.09-.61c.1-.2.31-.21.51-.41a8.74,8.74,0,0,0,.49-.81c.1-.21-.1-.51,0-.71a1.47,1.47,0,0,0,.29-.71c.1-.21-.2-.51-.21-.71s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="519.07 419.78 519.68 419.77 519.66 418.05 518.95 418.06 519.07 419.78"
            />
            <path
              class="cls-58"
              d="M519,410.27c.1-.31.61-.52.7-.82s.1-.81.3-1.12a5.37,5.37,0,0,0,1-.61c.3-.21.3-.72.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.11,0,.11.1.11.2.2.3,0,.81.11,1.11s.51.7.62,1-.2.72-.19,1.22c0,.3.31.71.31,1.11s-.5.71-.49,1,.11.81,0,1.11-.6.51-.8.82-.1.81-.3,1.11a3.26,3.26,0,0,0-1,1c-.3.2-.6.2-.9.51l-.4.81-.4-.09.09-.91c-.21-.31-.51-.4-.51-.71a7.31,7.31,0,0,1-.52-1.41c-.11-.3.19-.71.19-1.21s-.32-.71-.32-1.11.5-.72.5-1c.19-.41,0-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M518.77,409.76c-.11-.3-.61-.5-.72-.7s-.11-.71-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.22.32.1.1,0,0,0-.1.1c-.09.3.11.71,0,1.11s-.5.62-.5.92.31.7.31,1-.29.71-.19,1,.41.6.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.19.81.39l.41.71.3-.11-.11-.81c.1-.3.41-.3.5-.71s.3-1,.39-1.32-.21-.7-.21-1,.3-.71.19-1-.41-.6-.51-.91.09-.81-.11-1"
            />
            <g class="cls-535">
              <polygon
                class="cls-536"
                points="513.83 411.43 524.28 405.05 531.48 416.62 521.13 422.89 513.83 411.43"
              />
            </g>
            <g class="cls-537">
              <polygon
                class="cls-538"
                points="513.46 405.46 524.24 411.12 517.79 423.03 507.01 417.37 513.46 405.46"
              />
            </g>
            <polygon
              class="cls-58"
              points="518.36 419.07 518.77 419.78 519.19 421.8 519.7 421.79 519.98 419.77 520.28 419.06 518.36 419.07"
            />
          </g>
          <g id="plant2-18" data-name="plant2">
            <polygon
              class="cls-54"
              points="459.97 437.57 537.01 392.68 495.29 369.22 417.75 414.53 459.97 437.57"
            />
            <ellipse
              class="cls-55"
              cx="462.91"
              cy="428.64"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.31 4.71) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="434.75"
              cy="414.56"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.17 4.42) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="447.87"
              cy="421.61"
              rx="3.84"
              ry="1.72"
              transform="matrix(1, -0.01, 0.01, 1, -4.24, 4.55)"
            />
            <ellipse
              class="cls-55"
              cx="477.29"
              cy="420"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.23 4.85) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="491.17"
              cy="412.27"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.15 4.99) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="505.26"
              cy="404.33"
              rx="3.84"
              ry="1.72"
              transform="translate(-4.07 5.13) rotate(-0.58)"
            />
            <ellipse
              class="cls-55"
              cx="519.14"
              cy="396.2"
              rx="3.84"
              ry="1.72"
              transform="translate(-3.98 5.27) rotate(-0.58)"
            />
            <polygon
              class="cls-54"
              points="418.15 414.22 456.41 436.09 457.62 435.27 418.85 413.4 418.15 414.22"
            />
            <polygon
              class="cls-54"
              points="461.56 434.62 461.57 436.04 536.2 392.69 534.98 392.09 461.56 434.62"
            />
            <polygon
              class="cls-56"
              points="455.9 435.69 455.97 442.47 419.04 421.6 418.97 414.62 455.9 435.69"
            />
            <polygon
              class="cls-56"
              points="461.57 435.94 461.65 443.32 536.16 399.47 536.1 392.69 461.57 435.94"
            />
            <path
              class="cls-57"
              d="M464,413.76a4,4,0,0,1-.42-.71c-.1-.2.1-.5-.1-.7s-.41-.3-.52-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.41.2-.61"
            />
            <polygon
              class="cls-58"
              points="462.49 426.62 463.1 426.62 462.98 424.9 462.37 424.9 462.49 426.62"
            />
            <path
              class="cls-58"
              d="M462.39,417c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.31.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.22c0,.3.31.7.32,1.11s-.5.71-.5,1a3.82,3.82,0,0,1,0,1.12c-.09.3-.6.51-.8.81s-.09.81-.29,1.12-.9.72-1,1c-.3.21-.61.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.34,8.34,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.71-.31-1.11s.5-.71.49-1c.2-.3,0-.7,0-1.11"
            />
            <path
              class="cls-59"
              d="M462.18,416.51c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-539">
              <polygon
                class="cls-540"
                points="457.24 418.28 467.7 411.9 474.9 423.36 464.54 429.74 457.24 418.28"
              />
            </g>
            <g class="cls-541">
              <polygon
                class="cls-542"
                points="456.88 412.31 467.66 417.87 461.21 429.87 450.43 424.21 456.88 412.31"
              />
            </g>
            <polygon
              class="cls-58"
              points="461.77 425.82 462.19 426.73 462.61 428.64 463.12 428.64 463.4 426.61 463.69 425.8 461.77 425.82"
            />
            <path
              class="cls-57"
              d="M435.71,399.68a5,5,0,0,1-.41-.71c-.1-.2.09-.51-.11-.71s-.41-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.11,0-.11,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.2.5-.09.71a5.2,5.2,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.1.2.31.2.51.4l.11.61h.3l.1-.61c.09-.2.3-.2.5-.41a7,7,0,0,0,.49-.81c.1-.2-.1-.5,0-.71a1.43,1.43,0,0,0,.29-.71c.1-.2-.2-.5-.21-.71s.2-.4.2-.6"
            />
            <polygon
              class="cls-58"
              points="434.32 412.54 434.83 412.53 434.71 410.71 434.1 410.82 434.32 412.54"
            />
            <path
              class="cls-58"
              d="M434.23,403c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.2.71-.19,1.21.31.71.31,1.11-.49.72-.49,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21s-.31-.71-.32-1.11.5-.71.5-1-.21-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M434,402.42c-.11-.3-.61-.5-.72-.7s-.11-.7-.31-1-.71-.29-.92-.49-.31-.71-.61-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.09.09,0,0,0-.1.1c-.1.31.1.71,0,1.12s-.5.61-.5.91.31.71.31,1-.29.71-.19,1,.41.61.52.91-.1.71.11,1,.61.4.71.7.11.71.32,1a6.61,6.61,0,0,0,1,.8c.3.2.5.2.81.39l.41.71.3-.11-.1-.8c.09-.31.4-.31.49-.72s.3-1,.4-1.32-.21-.7-.22-1,.3-.71.19-1-.41-.6-.51-.9,0-.81-.11-1"
            />
            <g class="cls-543">
              <polygon
                class="cls-544"
                points="429.08 404.19 439.44 397.82 446.73 409.28 436.28 415.66 429.08 404.19"
              />
            </g>
            <g class="cls-545">
              <polygon
                class="cls-546"
                points="428.61 398.03 439.39 403.58 433.04 415.59 422.16 409.93 428.61 398.03"
              />
            </g>
            <polygon
              class="cls-58"
              points="433.51 411.84 433.92 412.54 434.34 414.56 434.95 414.56 435.13 412.53 435.43 411.72 433.51 411.84"
            />
            <path
              class="cls-57"
              d="M448.93,406.73a6.14,6.14,0,0,1-.41-.71c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.11-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.53,1.53,0,0,0-.3.71c-.1.2.21.5.21.71s-.19.5-.09.71a4.32,4.32,0,0,1,.41.7c.1.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.5,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.2-.4.19-.6"
            />
            <polygon
              class="cls-58"
              points="447.44 419.59 448.05 419.58 447.93 417.87 447.33 417.87 447.44 419.59"
            />
            <path
              class="cls-58"
              d="M447.35,410c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.44,5.44,0,0,0,1-.62c.31-.21.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.22.19c.1,0,.1.1.1.2.21.3,0,.81.11,1.11s.52.71.62,1-.19.71-.19,1.21c0,.31.31.71.32,1.11s-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12-.91.71-1,1c-.31.2-.61.21-.91.51l-.4.82-.4-.1.09-.91c-.2-.3-.51-.4-.51-.7a7.4,7.4,0,0,1-.52-1.42c0-.3.19-.71.19-1.21,0-.3-.31-.71-.32-1.11s.5-.71.5-1c.2-.3,0-.71,0-1.11"
            />
            <path
              class="cls-59"
              d="M447.14,409.48c-.1-.31-.61-.5-.72-.71s-.1-.7-.31-1-.71-.3-.91-.5-.32-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.31.71.32,1-.3.71-.2,1,.41.61.52.91-.1.71.11,1,.61.4.72.7.1.71.31,1a7.12,7.12,0,0,0,1,.8c.3.2.51.2.81.4l.41.7.31-.1-.11-.81c.09-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.22-1,.3-.72.2-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-547">
              <polygon
                class="cls-548"
                points="442.2 411.25 452.66 404.87 459.86 416.33 449.5 422.71 442.2 411.25"
              />
            </g>
            <g class="cls-549">
              <polygon
                class="cls-550"
                points="441.84 405.28 452.62 410.94 446.16 422.84 435.38 417.18 441.84 405.28"
              />
            </g>
            <polygon
              class="cls-58"
              points="446.73 418.89 447.14 419.59 447.57 421.61 448.07 421.61 448.36 419.58 448.65 418.87 446.73 418.89"
            />
            <path
              class="cls-57"
              d="M478.57,405.92a4.3,4.3,0,0,1-.42-.7c-.1-.21.1-.51-.1-.71s-.41-.3-.52-.6-.1-.51-.31-.71c-.1,0-.1,0-.1-.1a.76.76,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.19.71-.51.31-.5.61.1.51,0,.71a1.47,1.47,0,0,0-.29.71c-.1.21.2.51.21.71s-.2.51-.1.71a3.7,3.7,0,0,1,.41.7c.11.21,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.21.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.21.5-.41a7.91,7.91,0,0,0,.5-.82c.1-.2-.11-.5,0-.7a1.57,1.57,0,0,0,.3-.72c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="477.08 418.89 477.58 418.88 477.57 417.06 476.96 417.17 477.08 418.89"
            />
            <path
              class="cls-58"
              d="M477,409.27c.1-.3.6-.51.7-.81s.09-.81.29-1.12a5,5,0,0,0,1-.62c.3-.2.3-.71.6-1,.1,0,.1-.11.1-.11a1,1,0,0,1,1.21.19c.1,0,.1.1.1.21.21.3,0,.81.12,1.11s.51.7.61,1-.19.71-.19,1.22c0,.3.32.7.32,1.11s-.5.71-.5,1,.11.8,0,1.11-.6.51-.8.82-.09.81-.29,1.11a3.34,3.34,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.09.1-.92c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41c-.1-.3.2-.71.19-1.22,0-.3-.31-.7-.31-1.11s.5-.71.49-1-.11-.71,0-1.12"
            />
            <path
              class="cls-59"
              d="M476.77,408.77c-.1-.3-.61-.5-.71-.7s-.11-.71-.31-1-.72-.3-.92-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.3.11.71,0,1.11s-.5.61-.49.92.31.7.31,1-.3.71-.19,1,.41.6.51.91-.09.7.11,1,.62.39.72.7.11.7.31,1a3.48,3.48,0,0,0,1,.79c.31.2.51.2.82.4l.41.71.3-.11-.11-.81c.1-.3.4-.3.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.61-.51-.91.09-.81-.12-1"
            />
            <g class="cls-551">
              <polygon
                class="cls-552"
                points="471.83 410.54 482.19 404.06 489.49 415.62 479.13 421.9 471.83 410.54"
              />
            </g>
            <g class="cls-553">
              <polygon
                class="cls-554"
                points="471.47 404.47 482.25 410.13 475.8 422.04 465.01 416.38 471.47 404.47"
              />
            </g>
            <polygon
              class="cls-58"
              points="476.46 418.18 476.77 418.89 477.2 420.91 477.71 420.9 477.99 418.77 478.28 418.06 476.46 418.18"
            />
            <path
              class="cls-57"
              d="M492.55,397.89a4.93,4.93,0,0,1-.42-.71c-.1-.2.1-.51-.1-.71s-.41-.29-.52-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.09.51-.19.71-.51.31-.5.61.1.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.21.71s-.2.5-.1.71a3.7,3.7,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.52.7c.1.2.3.2.51.4l.1.61h.31l.09-.61c.1-.2.3-.2.5-.4a2.67,2.67,0,0,0,.5-.82c.1-.2-.11-.5,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7s.2-.31.2-.61"
            />
            <polygon
              class="cls-58"
              points="491.06 410.85 491.56 410.75 491.55 409.03 490.94 409.03 491.06 410.85"
            />
            <path
              class="cls-58"
              d="M491,401.24c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.19,5.19,0,0,0,1-.62c.3-.31.3-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.11.2.2.3,0,.81.11,1.11s.51.71.62,1-.2.71-.2,1.22c0,.3.32.7.32,1.11s-.5.71-.5,1,.11.81,0,1.12-.61.51-.81.81-.09.81-.29,1.12a3.23,3.23,0,0,0-1,1c-.3.21-.6.21-.9.52l-.4.81-.41-.1.1-.91c-.21-.3-.51-.4-.52-.7a8.93,8.93,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.3-.31-.7-.31-1.11s.5-.71.49-1-.11-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M490.75,400.64c-.1-.31-.61-.5-.71-.71s-.11-.7-.32-1-.71-.3-.91-.5-.31-.71-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.31.4-.31.5-.72s.29-1,.39-1.31-.21-.71-.21-1,.29-.72.19-1-.41-.6-.52-.9.1-.71-.11-1"
            />
            <g class="cls-555">
              <polygon
                class="cls-556"
                points="485.81 402.51 496.17 396.03 503.47 407.59 493.11 413.87 485.81 402.51"
              />
            </g>
            <g class="cls-557">
              <polygon
                class="cls-558"
                points="485.45 396.44 496.23 402.1 489.78 414 479 408.34 485.45 396.44"
              />
            </g>
            <polygon
              class="cls-58"
              points="490.34 410.05 490.76 410.86 491.18 412.87 491.69 412.77 491.97 410.74 492.26 410.03 490.34 410.05"
            />
            <path
              class="cls-57"
              d="M506.22,390a4.8,4.8,0,0,1-.41-.71c-.1-.2.1-.5-.11-.7s-.4-.3-.51-.61-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.51.2.71s-.19.51-.09.71a4.32,4.32,0,0,1,.41.7c.11.2,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.6c.1-.21.3-.21.5-.41s.5-.72.5-.82-.11-.5,0-.71a1.49,1.49,0,0,0,.3-.71c.1-.2-.21-.5-.21-.7a.57.57,0,0,0,.19-.61"
            />
            <polygon
              class="cls-58"
              points="504.84 402.92 505.44 402.92 505.33 401.1 504.62 401.1 504.84 402.92"
            />
            <path
              class="cls-58"
              d="M504.74,393.31c.1-.3.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.2.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.22.31.7.32,1.11-.5.71-.5,1,.11.81,0,1.12-.6.51-.8.81-.09.81-.29,1.12-.9.72-1,1c-.3.21-.6.21-.91.52l-.39.81-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.34,8.34,0,0,1-.52-1.41,12.33,12.33,0,0,0,.19-1.22c0-.4-.31-.71-.31-1.11s.5-.71.49-1-.11-.8,0-1.11"
            />
            <path
              class="cls-59"
              d="M504.53,392.81c-.1-.31-.61-.5-.71-.7s-.11-.71-.32-1-.71-.3-.91-.5-.31-.7-.62-.8c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.31c-.1,0-.1.11-.1.11-.1.3.11.7,0,1.11s-.5.61-.49.91.31.71.31,1-.3.71-.19,1,.41.6.51.9-.09.71.11,1,.61.4.72.7.11.71.31,1a3.71,3.71,0,0,0,1,.8c.31.2.51.2.82.4l.41.7.3-.1-.11-.81c.1-.31.4-.31.5-.71s.29-1,.39-1.32-.21-.71-.21-1,.29-.71.19-1-.41-.6-.51-.9.09-.81-.12-1"
            />
            <g class="cls-559">
              <polygon
                class="cls-560"
                points="499.59 394.48 510.05 388.2 517.35 399.56 506.89 406.04 499.59 394.48"
              />
            </g>
            <g class="cls-561">
              <polygon
                class="cls-562"
                points="499.23 388.51 510.01 394.17 503.56 406.17 492.77 400.41 499.23 388.51"
              />
            </g>
            <polygon
              class="cls-58"
              points="504.12 402.12 504.54 402.93 504.86 404.84 505.46 404.84 505.75 402.91 506.04 402.1 504.12 402.12"
            />
            <path
              class="cls-57"
              d="M520.5,381.52a6.14,6.14,0,0,1-.41-.71c-.1-.2.1-.51-.11-.71s-.4-.3-.51-.6-.1-.5-.31-.7c-.1,0-.1,0-.1-.1a.74.74,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.51-.2.71-.5.31-.5.61.11.51,0,.71a1.43,1.43,0,0,0-.29.71c-.1.2.2.5.2.71s-.19.5-.09.71a4.32,4.32,0,0,1,.41.7c.11.3,0,.51.11.71a4.24,4.24,0,0,0,.51.7c.11.2.31.2.51.4l.11.61h.3l.1-.61c.1-.2.3-.2.5-.41a9.17,9.17,0,0,0,.5-.81c.1-.2-.11-.5,0-.71a1.53,1.53,0,0,0,.3-.71c.1-.2-.21-.5-.21-.71s.3-.4.19-.6"
            />
            <polygon
              class="cls-58"
              points="519.12 394.38 519.62 394.37 519.5 392.65 518.9 392.66 519.12 394.38"
            />
            <path
              class="cls-58"
              d="M519,384.87c.1-.31.6-.51.7-.82s.09-.81.29-1.11a5.5,5.5,0,0,0,1-.62c.3-.21.29-.71.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.21.3,0,.81.12,1.11s.51.71.61,1-.19.71-.19,1.21.31.71.32,1.11-.5.72-.5,1,.11.81,0,1.11-.6.52-.8.82-.09.81-.29,1.12a3.13,3.13,0,0,0-1,1c-.3.2-.6.21-.91.51l-.39.82-.41-.1.09-.91c-.2-.3-.51-.4-.51-.7a8.13,8.13,0,0,1-.52-1.42,12.06,12.06,0,0,0,.19-1.21c0-.41-.31-.71-.31-1.11s.5-.71.49-1-.11-.81,0-1.11"
            />
            <path
              class="cls-59"
              d="M518.81,384.26c-.1-.3-.61-.5-.71-.7s-.11-.7-.32-1-.71-.29-.91-.49-.31-.71-.62-.81c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.32.1.1,0,0,0-.1.1c-.1.31.11.71,0,1.12s-.5.61-.5.91.32.71.32,1-.3.71-.19,1,.41.61.51.91-.09.71.11,1,.61.4.72.7.11.71.31,1a7.73,7.73,0,0,0,1,.8c.31.2.51.2.81.39l.42.71.3-.11-.11-.8c.1-.31.4-.31.5-.72s.29-1,.39-1.32-.21-.7-.21-1,.29-.71.19-1-.41-.6-.52-.91,0-.7-.11-1"
            />
            <g class="cls-563">
              <polygon
                class="cls-564"
                points="513.87 386.03 524.23 379.66 531.53 391.12 521.17 397.5 513.87 386.03"
              />
            </g>
            <g class="cls-565">
              <polygon
                class="cls-566"
                points="513.51 379.97 524.29 385.73 517.84 397.63 507.05 391.97 513.51 379.97"
              />
            </g>
            <polygon
              class="cls-58"
              points="518.4 393.68 518.71 394.38 519.24 396.4 519.75 396.4 519.93 394.37 520.32 393.56 518.4 393.68"
            />
          </g>
          <polygon
            class="cls-228"
            points="413.03 397.88 410.08 396.29 411.1 497.26 414.06 499.46 413.03 397.88"
          />
          <polygon
            class="cls-54"
            points="455.52 417.89 458.34 416.34 412.77 391.61 410.05 393.26 455.52 417.89"
          />
          <polygon
            class="cls-229"
            points="416.22 392.99 416.24 395.32 456.23 417.58 456.2 415.15 416.22 392.99"
          />
          <polygon
            class="cls-54"
            points="493.33 345.16 495.77 346.45 413.81 395.04 410.66 393.25 493.33 345.16"
          />
          <polygon
            class="cls-54"
            points="533.44 370.25 536.36 368.5 493.73 344.86 490.81 346.61 533.44 370.25"
          />
          <polygon
            class="cls-229"
            points="537.15 476.76 539.96 475.01 538.9 370 536.09 371.64 537.15 476.76"
          />
          <polygon
            class="cls-229"
            points="456.57 521.99 459.39 520.14 458.36 418.27 455.54 419.81 456.57 521.99"
          />
          <polygon
            class="cls-228"
            points="455.55 420.32 452.7 418.73 453.72 519.7 456.57 521.99 455.55 420.32"
          />
          <polygon
            class="cls-230"
            points="493.36 348 493.38 350.42 533.47 372.68 533.44 370.25 493.36 348"
          />
          <polygon
            class="cls-229"
            points="455.56 421.94 538.93 373.03 538.9 370 455.52 417.89 455.56 421.94"
          />
          <polygon
            class="cls-54"
            points="456.5 415.15 459.02 413.71 418.53 391.45 416.22 392.79 456.5 415.15"
          />
          <polygon
            class="cls-229"
            points="414.16 499.66 417.08 497.7 416.08 398.86 413.13 397.27 414.16 499.66"
          />
          <polygon
            class="cls-228"
            points="410.05 393.16 455.52 417.89 455.56 421.63 410.08 396.29 410.05 393.16"
          />
          <polygon
            class="cls-40"
            points="456.13 417.88 539 369.79 494.23 344.65 410.66 393.25 456.13 417.88"
          />
          <polygon
            class="cls-40"
            points="170.7 446.06 378.5 563.2 430.19 536.52 222.1 419.08 170.7 446.06"
          />
          <polygon
            class="cls-54"
            points="380.01 562.31 380.01 569.25 427.48 543.76 427.48 537.81 380.01 562.31"
          />
          <path
            class="cls-57"
            d="M284.36,486.53a5.72,5.72,0,0,1-.41-.69c-.1-.2.11-.5-.1-.7s-.4-.3-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.8.8,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.29-.5.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c0,.2.2.5.2.7s-.2.49-.1.69a4.68,4.68,0,0,1,.4.69c.1.2,0,.5.1.7a4.11,4.11,0,0,0,.5.69c.1.1.31.2.51.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4s.51-.69.51-.79-.11-.5,0-.7a1.41,1.41,0,0,0,.3-.69c.1-.2-.2-.5-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="282.85 499.23 283.45 499.23 283.35 497.44 282.75 497.44 282.85 499.23"
          />
          <path
            class="cls-58"
            d="M282.85,489.8c.1-.29.6-.49.7-.79s.1-.79.3-1.09a5.06,5.06,0,0,0,1-.6c.3-.19.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.7.61,1-.21.7-.21,1.19.31.7.31,1.09-.51.7-.51,1,.1.79,0,1.09-.6.49-.8.79-.1.79-.3,1.09a10.37,10.37,0,0,0-1,1c-.3.2-.6.2-.8.5l-.41.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.69a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.7.2-1.19s-.3-.7-.3-1.09.5-.7.5-1-.2-.8-.1-1.1"
          />
          <path
            class="cls-59"
            d="M282.75,489.21c-.1-.3-.61-.5-.71-.7s-.1-.69-.3-1a7.3,7.3,0,0,0-.9-.49c-.31-.2-.31-.7-.61-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.3.1.1,0,0,0-.1.1c-.11.3.1.7,0,1.09s-.51.6-.51.89.3.7.3,1-.3.69-.2,1,.41.59.51.89-.1.7.1,1,.6.4.7.7.1.69.3,1a7,7,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.31-.1-.1-.79c.1-.3.4-.3.5-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89,0-.69-.1-1"
          />
          <g class="cls-567">
            <polygon
              class="cls-568"
              points="277.82 490.89 288.08 484.65 295.12 496.05 284.86 502.2 277.82 490.89"
            />
          </g>
          <g class="cls-569">
            <polygon
              class="cls-570"
              points="277.52 484.75 288.08 490.5 281.64 502.2 270.98 496.55 277.52 484.75"
            />
          </g>
          <polygon
            class="cls-58"
            points="282.14 498.43 282.55 499.23 282.85 501.21 283.45 501.21 283.75 499.23 284.06 498.43 282.14 498.43"
          />
          <ellipse class="cls-55" cx="283.25" cy="501.21" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M298.94,495.66a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.4-.3-.51-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.51.3-.51.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c0,.19.2.49.2.69s-.2.5-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.5.1.69a4.9,4.9,0,0,0,.51.7c.1.2.3.2.5.39l.1.6h.3l.1-.6c.1-.19.3-.19.51-.39a9.22,9.22,0,0,0,.5-.8c.1-.19-.1-.49,0-.69a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.2-.3.2-.59"
          />
          <polygon
            class="cls-58"
            points="297.43 508.35 297.94 508.35 297.83 506.67 297.23 506.67 297.43 508.35"
          />
          <path
            class="cls-58"
            d="M297.43,498.93c.1-.3.61-.5.71-.79s.1-.8.3-1.1a4.75,4.75,0,0,0,1-.59c.31-.2.31-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.11,0,.11.1.11.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.69-.5,1,.1.8,0,1.09-.61.5-.81.8-.1.79-.3,1.09a10.35,10.35,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.4-.1.1-.89c-.2-.3-.51-.4-.51-.7a7.75,7.75,0,0,1-.5-1.39c-.1-.29.2-.69.2-1.19s-.3-.69-.3-1.09.5-.69.5-1-.3-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M297.23,498.33c-.1-.29-.6-.49-.7-.69s-.1-.69-.3-1a8.27,8.27,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.69.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.6.4.7.69.1.7.31,1a7,7,0,0,0,1,.8c.3.2.5.2.81.39l.4.7.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.6-.5-.89,0-.6-.1-1"
          />
          <g class="cls-571">
            <polygon
              class="cls-572"
              points="292.3 500.12 302.66 493.87 309.7 505.28 299.34 511.43 292.3 500.12"
            />
          </g>
          <g class="cls-573">
            <polygon
              class="cls-574"
              points="292 493.97 302.56 499.72 296.13 511.33 285.56 505.67 292 493.97"
            />
          </g>
          <polygon
            class="cls-58"
            points="296.73 507.66 297.03 508.35 297.43 510.34 297.94 510.34 298.24 508.35 298.54 507.66 296.73 507.66"
          />
          <ellipse class="cls-55" cx="297.83" cy="510.34" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M378.3,535a4.48,4.48,0,0,1-.41-.69c-.1-.2.11-.5-.1-.69s-.4-.3-.5-.6-.1-.5-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7,5,5,0,0,1,.51.39l.1.6h.3l.1-.6c.1-.2.3-.2.5-.39s.51-.7.51-.8-.11-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.49-.2-.69a.56.56,0,0,0,.2-.6"
          />
          <polygon
            class="cls-58"
            points="376.79 547.73 377.39 547.73 377.29 545.94 376.59 546.04 376.79 547.73"
          />
          <path
            class="cls-58"
            d="M376.79,538.31c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.52,5.52,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.2.3,0,.8.1,1.09s.5.7.61,1-.21.69-.21,1.19c0,.29.31.69.31,1.09s-.51.69-.51,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.3,1.09a9.48,9.48,0,0,0-1,1c-.3.2-.6.2-.8.49l-.41.8-.4-.1.1-.9c-.2-.29-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c0-.3.2-.69.2-1.19,0-.3-.3-.69-.3-1.09s.5-.69.5-1-.2-.7-.1-1.09"
          />
          <path
            class="cls-59"
            d="M376.59,537.71c-.1-.3-.61-.49-.71-.69s-.1-.7-.3-1a7.26,7.26,0,0,0-.9-.5c-.31-.2-.31-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.29.1.1,0,0,0-.11.1c-.1.3.11.7,0,1.09s-.5.6-.5.9.3.69.3,1-.3.69-.2,1,.4.6.51.89-.11.7.1,1,.6.39.7.69.1.69.3,1a7.06,7.06,0,0,0,1,.8c.3.19.5.19.8.39l.4.7.31-.1-.1-.8c.1-.29.4-.29.5-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9.1-.69-.1-1"
          />
          <g class="cls-575">
            <polygon
              class="cls-576"
              points="371.76 539.5 382.02 533.25 389.06 544.65 378.8 550.8 371.76 539.5"
            />
          </g>
          <g class="cls-577">
            <polygon
              class="cls-578"
              points="371.46 533.45 382.02 539.2 375.48 550.9 364.92 545.25 371.46 533.45"
            />
          </g>
          <polygon
            class="cls-58"
            points="376.08 547.04 376.49 547.73 376.89 549.71 377.39 549.71 377.69 547.73 377.89 546.94 376.08 547.04"
          />
          <ellipse class="cls-55" cx="377.19" cy="549.71" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M345,520.35a3.8,3.8,0,0,1-.41-.69c-.1-.2.1-.5-.1-.69s-.4-.3-.5-.6-.1-.5-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c0,.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.09.3.19.51.39l.1.6h.3l.1-.6c.1-.2.3-.2.5-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.5,1.5,0,0,0,.31-.7c.1-.19-.21-.49-.21-.69s.31-.4.21-.6"
          />
          <polygon
            class="cls-58"
            points="343.5 533.05 344 533.05 344 531.26 343.3 531.26 343.5 533.05"
          />
          <path
            class="cls-58"
            d="M343.5,523.63c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.29,5.29,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.2.3,0,.8.1,1.09s.5.7.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.69-.5,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.3,1.1a7.8,7.8,0,0,0-1,1c-.3.2-.6.2-.8.49l-.41.8-.4-.1.1-.9c-.2-.29-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c-.11-.3.2-.69.2-1.19s-.31-.69-.31-1.09.51-.69.51-1-.2-.8-.1-1.09"
          />
          <path
            class="cls-59"
            d="M343.3,523c-.1-.3-.61-.49-.71-.69s-.1-.7-.3-1a6.76,6.76,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.5.89-.1.7.1,1,.61.39.71.69.1.69.3,1a6.55,6.55,0,0,0,1,.8c.3.19.5.19.8.39l.4.7.3-.1-.1-.8c.1-.29.41-.29.51-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9.1-.69-.1-1"
          />
          <g class="cls-579">
            <polygon
              class="cls-580"
              points="338.47 524.72 348.73 518.47 355.77 529.88 345.51 536.03 338.47 524.72"
            />
          </g>
          <g class="cls-581">
            <polygon
              class="cls-582"
              points="338.07 518.57 348.73 524.32 342.19 535.93 331.63 530.27 338.07 518.57"
            />
          </g>
          <polygon
            class="cls-58"
            points="342.79 532.26 343.1 533.05 343.5 535.03 344 535.03 344.4 533.05 344.6 532.26 342.79 532.26"
          />
          <ellipse class="cls-55" cx="343.9" cy="535.03" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M361.3,528.29a4.35,4.35,0,0,1-.4-.7c-.1-.19.1-.49-.1-.69s-.41-.3-.51-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.11.5-.21.7-.5.29-.5.59.1.5,0,.69a1.49,1.49,0,0,0-.3.7c-.1.2.2.49.2.69s-.2.5-.1.7a4.21,4.21,0,0,1,.4.69c.1.2,0,.5.1.7a4.58,4.58,0,0,0,.51.69c.1.2.3.2.5.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4A7.63,7.63,0,0,0,361,531c.1-.2-.1-.5,0-.7a1.46,1.46,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.2-.39.2-.59"
          />
          <polygon
            class="cls-58"
            points="359.79 540.99 360.29 540.99 360.19 539.3 359.59 539.3 359.79 540.99"
          />
          <path
            class="cls-58"
            d="M359.79,531.56c.1-.3.6-.49.7-.79s.11-.79.31-1.09a5.3,5.3,0,0,0,1-.6c.3-.2.3-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.51.69.61,1-.2.7-.2,1.19c0,.3.3.7.3,1.09s-.5.7-.5,1,.1.8,0,1.1-.61.49-.81.79-.1.79-.3,1.09a9.34,9.34,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.41-.1.1-.89c-.2-.3-.5-.4-.5-.69a8,8,0,0,1-.5-1.39c-.1-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.09s.5-.7.5-1-.3-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M359.59,531.07c-.1-.3-.6-.5-.7-.7s-.11-.69-.31-1a7.26,7.26,0,0,0-.9-.5c-.3-.19-.3-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.51.59-.51.89.31.7.31,1-.31.7-.21,1,.41.59.51.89-.1.69.1,1,.6.4.7.69.1.7.3,1a7.74,7.74,0,0,0,1,.79c.3.2.5.2.8.4l.41.69.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.59-.5-.89,0-.8-.1-1"
          />
          <g class="cls-583">
            <polygon
              class="cls-584"
              points="354.66 532.65 365.02 526.5 372.06 537.91 361.7 544.06 354.66 532.65"
            />
          </g>
          <g class="cls-585">
            <polygon
              class="cls-586"
              points="354.36 526.8 364.92 532.46 358.48 544.16 347.92 538.5 354.36 526.8"
            />
          </g>
          <polygon
            class="cls-58"
            points="359.09 540.19 359.39 540.99 359.79 542.97 360.39 542.97 360.6 540.99 360.9 540.19 359.09 540.19"
          />
          <ellipse class="cls-55" cx="360.19" cy="542.97" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M315.34,503.49a3.59,3.59,0,0,1-.41-.69c-.1-.2.1-.5-.1-.7s-.4-.29-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.8.8,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.3-.5.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c-.11.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.19,0,.49.1.69a4.11,4.11,0,0,0,.5.69c.1.1.3.2.5.4l.11.6h.3l.1-.6c.1-.2.3-.2.5-.4a2.38,2.38,0,0,0,.5-.79c.1-.2-.1-.5,0-.69a1.5,1.5,0,0,0,.31-.7c.1-.2-.21-.49-.21-.69a.57.57,0,0,0,.21-.6"
          />
          <polygon
            class="cls-58"
            points="313.83 516.29 314.43 516.29 314.33 514.5 313.63 514.5 313.83 516.29"
          />
          <path
            class="cls-58"
            d="M313.83,506.77c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.88,5.88,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.7.6,1-.2.7-.2,1.19c0,.3.3.7.3,1.1s-.5.69-.5,1,.1.79,0,1.09-.6.49-.8.79-.1.8-.31,1.09a10.32,10.32,0,0,0-1,1c-.3.2-.6.2-.81.5l-.4.79-.4-.09.1-.9c-.2-.3-.5-.39-.5-.69a7.8,7.8,0,0,1-.51-1.39c-.1-.3.21-.69.21-1.19,0-.3-.31-.69-.31-1.09s.51-.7.51-1-.2-.7-.1-1.09"
          />
          <path
            class="cls-59"
            d="M313.63,506.37c-.11-.3-.61-.5-.71-.7s-.1-.69-.3-1a5.83,5.83,0,0,0-.91-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.6-.5.89.3.7.3,1-.3.69-.2,1,.4.59.5.89-.1.7.1,1,.61.4.71.7.1.69.3,1a3.36,3.36,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.3-.1-.1-.79c.1-.3.41-.3.51-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89.1-.79-.1-1"
          />
          <g class="cls-587">
            <polygon
              class="cls-588"
              points="308.8 507.96 319.06 501.81 326.1 513.21 315.84 519.36 308.8 507.96"
            />
          </g>
          <g class="cls-589">
            <polygon
              class="cls-590"
              points="308.5 502.1 319.06 507.76 312.52 519.46 301.96 513.81 308.5 502.1"
            />
          </g>
          <polygon
            class="cls-58"
            points="313.12 515.49 313.52 516.29 313.93 518.17 314.43 518.17 314.73 516.29 314.93 515.49 313.12 515.49"
          />
          <ellipse class="cls-55" cx="314.23" cy="518.17" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M330,512.12a4.68,4.68,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.41-.29-.51-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.78.78,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.11.5-.21.7-.5.3-.5.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.68,4.68,0,0,1,.4.69c.1.2,0,.5.1.7a4.12,4.12,0,0,0,.51.69c.1.2.3.2.5.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4a7.63,7.63,0,0,0,.51-.79c.1-.2-.1-.5,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.5-.2-.69a.56.56,0,0,0,.2-.6"
          />
          <polygon
            class="cls-58"
            points="328.51 524.82 329.11 524.82 329.01 523.03 328.31 523.13 328.51 524.82"
          />
          <path
            class="cls-58"
            d="M328.51,515.39c.1-.29.6-.49.7-.79s.11-.79.31-1.09a5.3,5.3,0,0,0,1-.6c.3-.19.3-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.21.3,0,.79.1,1.09s.51.7.61,1-.2.7-.2,1.19c0,.3.3.7.3,1.09s-.5.7-.5,1,.1.79,0,1.09-.61.49-.81.79-.1.79-.3,1.09a10.37,10.37,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.41-.1.1-.89c-.2-.3-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c0-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.09s.5-.7.5-1-.2-.7-.1-1.1"
          />
          <path
            class="cls-59"
            d="M328.31,514.9c-.1-.3-.6-.5-.7-.7s-.11-.69-.31-1a6.17,6.17,0,0,0-.9-.49c-.3-.2-.3-.7-.6-.8-.11,0-.11,0-.11-.1a1,1,0,0,0-1.2.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.51.6-.51.89.31.7.31,1-.31.69-.21,1,.41.59.51.89-.1.7.1,1,.6.4.7.7.1.69.3,1a7.55,7.55,0,0,0,1,.79c.3.2.5.2.8.4l.41.69.3-.1-.1-.79c.1-.3.4-.3.5-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89.1-.79-.1-1"
          />
          <g class="cls-591">
            <polygon
              class="cls-592"
              points="323.48 516.59 333.74 510.34 340.78 521.74 330.52 527.89 323.48 516.59"
            />
          </g>
          <g class="cls-593">
            <polygon
              class="cls-594"
              points="323.18 510.63 333.74 516.29 327.2 527.99 316.64 522.34 323.18 510.63"
            />
          </g>
          <polygon
            class="cls-58"
            points="327.81 524.12 328.11 524.82 328.61 526.8 329.11 526.8 329.42 524.82 329.62 524.02 327.81 524.12"
          />
          <ellipse class="cls-55" cx="328.91" cy="526.8" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M395.9,528.29a4.35,4.35,0,0,1-.4-.7c-.1-.19.1-.49-.1-.69s-.41-.3-.51-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.29-.5.59.1.5,0,.69a1.49,1.49,0,0,0-.3.7c-.1.2.2.49.2.69s-.2.5-.1.7a4.21,4.21,0,0,1,.4.69c.1.2,0,.5.1.7a4.57,4.57,0,0,0,.5.69c.11.2.31.2.51.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4s.51-.69.51-.79-.1-.5,0-.7a1.46,1.46,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.2-.29.2-.59"
          />
          <polygon
            class="cls-58"
            points="394.39 541.08 394.89 541.08 394.79 539.2 394.19 539.3 394.39 541.08"
          />
          <path
            class="cls-58"
            d="M394.39,531.56c.1-.3.6-.49.7-.79s.1-.79.31-1.09a5.3,5.3,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.11-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.51.69.61,1-.2.7-.2,1.19c0,.3.3.7.3,1.09s-.51.7-.51,1,.1.8,0,1.1-.6.49-.8.79-.1.79-.3,1.09a9.34,9.34,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.41-.1.1-.89c-.2-.3-.5-.4-.5-.69a8,8,0,0,1-.5-1.39c0-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.09s.5-.7.5-1a3.65,3.65,0,0,1-.1-1.09"
          />
          <path
            class="cls-59"
            d="M394.19,531.07c-.1-.3-.61-.5-.71-.7s-.1-.69-.3-1a7.26,7.26,0,0,0-.9-.5c-.3-.19-.3-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.51.59-.51.89.3.7.3,1-.3.7-.2,1,.41.59.51.89-.1.69.1,1,.6.4.7.69.1.7.3,1a7.74,7.74,0,0,0,1,.79c.3.2.5.2.8.4l.41.69.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.59-.5-.89,0-.8-.1-1"
          />
          <g class="cls-595">
            <polygon
              class="cls-596"
              points="389.26 532.75 399.62 526.5 406.66 537.91 396.3 544.06 389.26 532.75"
            />
          </g>
          <g class="cls-597">
            <polygon
              class="cls-598"
              points="388.96 526.8 399.52 532.55 393.08 544.16 382.52 538.5 388.96 526.8"
            />
          </g>
          <polygon
            class="cls-58"
            points="393.69 540.29 393.99 541.08 394.39 542.97 394.99 542.97 395.19 540.99 395.5 540.19 393.69 540.29"
          />
          <ellipse class="cls-55" cx="394.79" cy="542.97" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M411.59,520.45a4.21,4.21,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.41-.29-.51-.59-.1-.5-.3-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.11,0-.11,0-.11.1s-.1.49-.2.69-.5.3-.5.59.1.5,0,.7a1.5,1.5,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.19,0,.49.1.69a3.34,3.34,0,0,0,.51.69c.1.1.3.2.5.4l.1.6h.3l.1-.6c.1-.2.3-.2.5-.4a8.29,8.29,0,0,0,.51-.79c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.49-.2-.69a.56.56,0,0,0,.2-.6"
          />
          <polygon
            class="cls-58"
            points="410.08 533.25 410.68 533.25 410.58 531.36 409.88 531.46 410.08 533.25"
          />
          <path
            class="cls-58"
            d="M410.08,523.83c.1-.3.6-.5.7-.8s.1-.79.31-1.09a5.81,5.81,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.11-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.2.3,0,.8.1,1.09s.51.7.61,1-.2.7-.2,1.19c0,.3.3.7.3,1.1s-.51.69-.51,1,.11.79,0,1.09-.6.49-.8.79-.1.8-.3,1.09a9.48,9.48,0,0,0-1,1c-.3.19-.6.19-.8.49l-.4.79-.41-.09.1-.9c-.2-.29-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c0-.3.2-.69.2-1.19,0-.3-.3-.69-.3-1.09s.5-.7.5-1-.2-.8-.1-1.09"
          />
          <path
            class="cls-59"
            d="M409.88,523.23c-.1-.3-.6-.5-.71-.69s-.1-.7-.3-1a8.93,8.93,0,0,0-.9-.49c-.3-.2-.3-.7-.61-.8-.1,0-.1,0-.1-.09a1,1,0,0,0-1.2.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.51.6-.51.9.3.69.3,1-.3.69-.2,1,.41.6.51.89-.1.7.1,1,.6.4.7.7.1.69.3,1a7,7,0,0,0,1,.79c.3.2.5.2.8.4l.41.7.3-.1-.1-.8c.1-.3.4-.3.5-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.6-.5-.9.1-.79-.1-1"
          />
          <g class="cls-599">
            <polygon
              class="cls-600"
              points="405.05 524.92 415.31 518.67 422.35 530.07 412.09 536.22 405.05 524.92"
            />
          </g>
          <g class="cls-601">
            <polygon
              class="cls-602"
              points="404.75 518.97 415.31 524.72 408.77 536.32 398.21 530.67 404.75 518.97"
            />
          </g>
          <polygon
            class="cls-58"
            points="409.38 532.46 409.78 533.25 410.18 535.13 410.68 535.13 410.99 533.15 411.19 532.36 409.38 532.46"
          />
          <ellipse class="cls-55" cx="410.48" cy="535.13" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M192.33,435.15a4.21,4.21,0,0,1-.4-.69c-.11-.2.1-.5-.11-.7s-.4-.29-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.8.8,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.3-.5.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c0,.2.2.5.2.7s-.2.49-.1.69a4.68,4.68,0,0,1,.4.69c.1.2,0,.5.1.7a4.11,4.11,0,0,0,.5.69,5.91,5.91,0,0,1,.51.4l.1.6h.3l.1-.6c.1-.2.3-.2.5-.4a8.29,8.29,0,0,0,.51-.79c.1-.2-.1-.5,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.49-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="190.92 447.85 191.42 447.85 191.32 446.16 190.72 446.16 190.92 447.85"
          />
          <path
            class="cls-58"
            d="M190.92,438.43c.1-.3.6-.5.7-.8s.1-.79.31-1.09a5.81,5.81,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.11-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.51.7.61,1-.2.7-.2,1.19.3.7.3,1.1-.51.69-.51,1,.11.79,0,1.09-.6.49-.8.79-.1.8-.3,1.09a10.37,10.37,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.41-.1.1-.89c-.2-.3-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.7.2-1.19s-.3-.7-.3-1.09.5-.7.5-1-.3-.8-.1-1.09"
          />
          <path
            class="cls-59"
            d="M190.72,437.83c-.1-.3-.6-.5-.71-.69s-.1-.7-.3-1a8.93,8.93,0,0,0-.9-.49c-.3-.2-.3-.7-.61-.8-.1,0-.1,0-.1-.09a1,1,0,0,0-1.2.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.51.6-.51.9.3.69.3,1-.3.69-.2,1,.41.59.51.89-.1.7.1,1,.6.4.7.7.1.69.3,1a7,7,0,0,0,1,.79c.3.2.5.2.8.4l.41.69.3-.09-.1-.8c.1-.3.4-.3.5-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89,0-.59-.1-1"
          />
          <g class="cls-603">
            <polygon
              class="cls-604"
              points="185.79 439.62 196.05 433.37 203.19 444.77 192.83 450.92 185.79 439.62"
            />
          </g>
          <g class="cls-605">
            <polygon
              class="cls-606"
              points="185.49 433.47 196.05 439.12 189.61 450.82 178.95 445.17 185.49 433.47"
            />
          </g>
          <polygon
            class="cls-58"
            points="190.12 447.15 190.52 447.85 190.92 449.83 191.42 449.83 191.72 447.85 192.03 447.15 190.12 447.15"
          />
          <ellipse class="cls-55" cx="191.22" cy="449.83" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M206.91,444.28a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.31-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.51.3-.51.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c0,.2.2.49.2.69s-.2.5-.1.7a3.82,3.82,0,0,1,.4.69c.11.2,0,.5.11.69a4.23,4.23,0,0,0,.5.7c.1.1.3.2.5.4l.1.59h.3l.1-.59c.1-.2.31-.2.51-.4s.5-.7.5-.79-.1-.5,0-.7a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.2-.3.2-.59"
          />
          <polygon
            class="cls-58"
            points="205.4 457.07 205.91 457.07 205.81 455.29 205.2 455.29 205.4 457.07"
          />
          <path
            class="cls-58"
            d="M205.4,447.55c.1-.3.61-.5.71-.79s.1-.8.3-1.09a5.3,5.3,0,0,0,1-.6c.31-.2.31-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.69-.5,1,.1.8,0,1.09-.61.5-.81.8-.1.79-.3,1.09a9.29,9.29,0,0,0-1,1c-.31.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.51-.4-.51-.7a7.48,7.48,0,0,1-.5-1.39c-.1-.29.2-.69.2-1.19s-.3-.69-.3-1.09.5-.69.5-1a1.35,1.35,0,0,1-.1-1.09"
          />
          <path
            class="cls-59"
            d="M205.2,447.05c-.1-.29-.6-.49-.7-.69s-.1-.69-.3-1-.61-.3-.91-.5-.3-.69-.6-.79c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.69.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.6.4.7.69.11.7.31,1a7,7,0,0,0,1,.8c.3.2.5.2.81.39l.4.7.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.41-1.29-.21-.69-.21-1,.31-.69.21-1-.41-.6-.51-.89,0-.7-.1-1"
          />
          <g class="cls-607">
            <polygon
              class="cls-608"
              points="200.27 448.74 210.63 442.49 217.67 453.9 207.31 460.05 200.27 448.74"
            />
          </g>
          <g class="cls-609">
            <polygon
              class="cls-610"
              points="199.97 442.59 210.53 448.34 204.09 459.95 193.53 454.3 199.97 442.59"
            />
          </g>
          <polygon
            class="cls-58"
            points="204.7 456.28 205 457.07 205.4 458.96 205.91 458.96 206.21 457.07 206.51 456.28 204.7 456.28"
          />
          <ellipse class="cls-55" cx="205.81" cy="458.96" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M253,469a3.8,3.8,0,0,1-.41-.69c-.1-.2.1-.5-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c0,.2.2.5.2.7s-.2.5-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.19.3.19.51.39l.1.6h.3l.1-.6c.1-.2.3-.2.5-.39a9.22,9.22,0,0,0,.5-.8c.11-.2-.1-.49,0-.69a1.41,1.41,0,0,0,.31-.7c.1-.19-.2-.49-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="251.47 481.67 252.07 481.67 251.97 479.99 251.27 479.99 251.47 481.67"
          />
          <path
            class="cls-58"
            d="M251.47,472.25c.1-.3.6-.5.7-.8s.1-.79.3-1.09a4.57,4.57,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.09.1.19.2.3,0,.8.1,1.1s.5.69.61,1-.21.69-.21,1.19.31.69.31,1.09-.51.69-.51,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.3,1.1a8.49,8.49,0,0,0-1,1c-.3.2-.6.2-.8.49l-.41.8-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.69.2-1.19s-.3-.69-.3-1.09.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M251.27,471.65c-.1-.29-.61-.49-.71-.69s-.1-.7-.3-1a7.26,7.26,0,0,0-.9-.5c-.31-.2-.31-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.09.09,0,0,0-.1.09c-.1.3.1.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.5.9-.1.69.11,1,.6.39.7.69.1.7.3,1a3.54,3.54,0,0,0,1,.8c.3.19.5.19.8.39l.4.7.31-.1-.11-.8c.11-.29.41-.29.51-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.6-.5-.9.1-.69-.1-1"
          />
          <g class="cls-611">
            <polygon
              class="cls-612"
              points="246.44 473.34 256.7 467.19 263.74 478.6 253.48 484.75 246.44 473.34"
            />
          </g>
          <g class="cls-613">
            <polygon
              class="cls-614"
              points="246.04 467.19 256.7 472.94 250.16 484.65 239.6 478.99 246.04 467.19"
            />
          </g>
          <polygon
            class="cls-58"
            points="250.76 480.98 251.07 481.67 251.47 483.65 252.07 483.65 252.37 481.67 252.57 480.98 250.76 480.98"
          />
          <ellipse class="cls-55" cx="251.87" cy="483.65" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M269.27,476.91a4.68,4.68,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.41-.3-.51-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.51.29-.51.59.1.5,0,.7a1.41,1.41,0,0,0-.3.69c-.1.2.2.5.2.69s-.2.5-.1.7a4.68,4.68,0,0,1,.4.69c.1.2,0,.5.1.7a4.12,4.12,0,0,0,.51.69c.1.2.3.2.5.4l.1.59h.3l.1-.59c.1-.2.3-.2.51-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.41,1.41,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.2-.29.2-.59"
          />
          <polygon
            class="cls-58"
            points="267.76 489.61 268.26 489.61 268.16 487.92 267.56 487.92 267.76 489.61"
          />
          <path
            class="cls-58"
            d="M267.76,480.18c.1-.29.6-.49.71-.79s.1-.79.3-1.09a5.3,5.3,0,0,0,1-.6c.3-.2.3-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.21.3,0,.79.11,1.09s.5.69.6,1-.2.7-.2,1.19c0,.3.3.7.3,1.09s-.5.7-.5,1,.1.79,0,1.09-.61.49-.81.79-.1.79-.3,1.09a11.64,11.64,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.41-.1.11-.89c-.21-.3-.51-.4-.51-.69a8,8,0,0,1-.5-1.39c-.1-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.09s.5-.7.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M267.56,479.69c-.1-.3-.6-.5-.7-.7s-.1-.69-.31-1a7.26,7.26,0,0,0-.9-.5c-.3-.19-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.51.6-.51.89.31.7.31,1-.31.7-.2,1,.4.59.5.89-.1.69.1,1,.6.4.7.7.1.69.3,1a7.55,7.55,0,0,0,1,.79c.3.2.5.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.28-.2-.7-.2-1,.3-.69.2-1-.4-.59-.5-.89,0-.7-.1-1"
          />
          <g class="cls-615">
            <polygon
              class="cls-616"
              points="262.63 481.37 272.99 475.22 280.03 486.63 269.67 492.78 262.63 481.37"
            />
          </g>
          <g class="cls-617">
            <polygon
              class="cls-618"
              points="262.33 475.42 272.89 481.08 266.45 492.78 255.89 487.13 262.33 475.42"
            />
          </g>
          <polygon
            class="cls-58"
            points="267.06 488.91 267.36 489.61 267.76 491.59 268.37 491.59 268.57 489.61 268.87 488.91 267.06 488.91"
          />
          <ellipse class="cls-55" cx="268.16" cy="491.59" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M223.31,452.21a4.19,4.19,0,0,1-.41-.69c-.1-.2.1-.5-.1-.7s-.4-.29-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.8.8,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.3-.5.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.19,0,.49.1.69a4.11,4.11,0,0,0,.5.69c.1.2.3.2.51.4l.1.6h.3l.1-.6c.1-.2.3-.2.5-.4a7.93,7.93,0,0,0,.5-.79c.1-.2-.1-.5,0-.69a1.5,1.5,0,0,0,.31-.7c.1-.2-.21-.49-.21-.69s.31-.4.21-.6"
          />
          <polygon
            class="cls-58"
            points="221.8 464.91 222.4 464.91 222.3 463.12 221.7 463.12 221.8 464.91"
          />
          <path
            class="cls-58"
            d="M221.8,455.49c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.88,5.88,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.7.6,1-.2.7-.2,1.19c0,.3.3.7.3,1.1s-.5.69-.5,1,.1.79,0,1.09-.6.49-.8.79-.1.8-.3,1.09a9.36,9.36,0,0,0-1,1c-.3.2-.6.2-.8.5l-.41.7-.4-.1.1-.9c-.2-.29-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c-.11-.3.2-.69.2-1.19,0-.3-.31-.69-.31-1.09s.51-.7.51-1-.2-.7-.1-1"
          />
          <path
            class="cls-59"
            d="M221.7,455c-.1-.3-.61-.5-.71-.69s-.1-.7-.3-1a7.3,7.3,0,0,0-.9-.49c-.31-.2-.31-.7-.61-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.5.6-.5.9.3.69.3,1-.3.69-.2,1,.4.59.5.89-.1.7.11,1,.6.4.7.7.1.69.3,1a7,7,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.31-.1-.11-.79c.11-.3.41-.3.51-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89,0-.79-.1-1"
          />
          <g class="cls-619">
            <polygon
              class="cls-620"
              points="216.77 456.58 227.03 450.43 234.07 461.83 223.81 467.98 216.77 456.58"
            />
          </g>
          <g class="cls-621">
            <polygon
              class="cls-622"
              points="216.47 450.72 227.03 456.38 220.59 468.08 209.93 462.43 216.47 450.72"
            />
          </g>
          <polygon
            class="cls-58"
            points="221.09 464.12 221.5 464.91 221.9 466.89 222.4 466.89 222.7 464.91 223 464.12 221.09 464.12"
          />
          <ellipse class="cls-55" cx="222.2" cy="466.89" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M238,460.84a4.68,4.68,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.4-.29-.51-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.78.78,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.51.3-.51.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.68,4.68,0,0,1,.4.69c.1.2,0,.5.1.7a4.12,4.12,0,0,0,.51.69c.1.1.3.2.5.4l.1.59h.3l.1-.59c.1-.2.3-.2.51-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.5-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="236.48 473.54 237.09 473.54 236.99 471.65 236.28 471.75 236.48 473.54"
          />
          <path
            class="cls-58"
            d="M236.48,464.11c.1-.29.61-.49.71-.79s.1-.79.3-1.09a5.3,5.3,0,0,0,1-.6c.3-.19.3-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.21.3,0,.79.11,1.09s.5.7.6,1-.2.7-.2,1.19c0,.3.3.7.3,1.09s-.5.7-.5,1,.1.79,0,1.09-.61.49-.81.79-.1.79-.3,1.09a11.64,11.64,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.4-.1.1-.89c-.21-.3-.51-.39-.51-.69a7.75,7.75,0,0,1-.5-1.39c0-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.09s.5-.7.5-1-.2-.8-.1-1.1"
          />
          <path
            class="cls-59"
            d="M236.28,463.52c-.1-.3-.6-.5-.7-.69s-.1-.7-.31-1a7.3,7.3,0,0,0-.9-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.5.6-.5.9.3.69.3,1-.3.69-.2,1,.4.59.5.89-.1.7.1,1,.6.4.7.7.1.69.3,1a7.55,7.55,0,0,0,1,.79c.3.2.5.2.81.4l.4.69.3-.09-.1-.8c.1-.3.4-.3.5-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89.1-.79-.1-1"
          />
          <g class="cls-623">
            <polygon
              class="cls-624"
              points="231.45 465.21 241.71 458.96 248.75 470.36 238.49 476.51 231.45 465.21"
            />
          </g>
          <g class="cls-625">
            <polygon
              class="cls-626"
              points="231.15 459.25 241.71 465.01 235.17 476.61 224.61 470.96 231.15 459.25"
            />
          </g>
          <polygon
            class="cls-58"
            points="235.78 472.74 236.18 473.54 236.58 475.52 237.09 475.52 237.39 473.44 237.59 472.64 235.78 472.74"
          />
          <ellipse class="cls-55" cx="236.88" cy="475.52" rx="3.82" ry="1.69" />
          <polygon
            class="cls-40"
            points="171.51 421.27 379.3 538.41 431 511.73 222.9 394.39 171.51 421.27"
          />
          <polygon
            class="cls-54"
            points="380.81 537.51 380.81 544.46 428.28 518.97 428.28 513.01 380.81 537.51"
          />
          <path
            class="cls-57"
            d="M285.16,461.73a3.82,3.82,0,0,1-.4-.69c-.1-.2.1-.5-.1-.69s-.4-.3-.5-.6-.1-.5-.31-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.51.3-.51.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c0,.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.11.2,0,.49.11.69a4.23,4.23,0,0,0,.5.7c.1.19.3.19.5.39l.1.6h.3l.1-.6c.1-.2.31-.2.51-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.19-.2-.49-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="283.65 474.43 284.16 474.43 284.16 472.74 283.45 472.74 283.65 474.43"
          />
          <path
            class="cls-58"
            d="M283.65,465c.1-.3.61-.5.71-.8s.1-.79.3-1.09a5.23,5.23,0,0,0,1-.59c.31-.2.31-.7.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.2.3,0,.8.1,1.09s.5.7.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.69-.5,1,.1.79,0,1.09-.61.5-.81.79-.1.8-.3,1.1a8.44,8.44,0,0,0-1,1c-.31.2-.61.2-.81.49l-.4.8-.4-.1.1-.9c-.2-.29-.51-.39-.51-.69a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.69.2-1.19s-.3-.69-.3-1.09.5-.69.5-1-.2-.8-.1-1.09"
          />
          <path
            class="cls-59"
            d="M283.45,464.41c-.1-.3-.6-.49-.7-.69s-.1-.7-.3-1a8.27,8.27,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.5.89-.1.7.1,1,.6.39.7.69.1.69.31,1a7,7,0,0,0,1,.8c.3.19.5.19.81.39l.4.7.3-.1-.1-.8c.1-.29.4-.29.5-.69s.3-1,.41-1.29-.21-.69-.21-1,.31-.7.21-1-.41-.6-.51-.9.1-.69-.1-1"
          />
          <g class="cls-627">
            <polygon
              class="cls-628"
              points="278.62 466.1 288.88 459.95 295.92 471.36 285.66 477.5 278.62 466.1"
            />
          </g>
          <g class="cls-629">
            <polygon
              class="cls-630"
              points="278.22 459.95 288.88 465.7 282.35 477.41 271.79 471.75 278.22 459.95"
            />
          </g>
          <polygon
            class="cls-58"
            points="282.95 473.64 283.25 474.43 283.65 476.41 284.16 476.41 284.56 474.43 284.76 473.64 282.95 473.64"
          />
          <ellipse class="cls-55" cx="284.06" cy="476.41" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M299.64,470.86a4.68,4.68,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.4-.3-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.29-.5.59.1.5,0,.7a1.41,1.41,0,0,0-.3.69c0,.2.2.5.2.69s-.2.5-.1.7a4.21,4.21,0,0,1,.4.69c.1.2,0,.5.1.7a4.11,4.11,0,0,0,.5.69c.1.1.3.2.5.4l.1.59h.31l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.46,1.46,0,0,0,.3-.69c.11-.2-.2-.5-.2-.7a.53.53,0,0,0,.2-.59"
          />
          <polygon
            class="cls-58"
            points="298.14 483.56 298.74 483.56 298.64 481.87 298.04 481.87 298.14 483.56"
          />
          <path
            class="cls-58"
            d="M298.14,474.13c.1-.29.6-.49.7-.79s.1-.79.3-1.09a5.36,5.36,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.69.6,1-.2.7-.2,1.19.3.7.3,1.09-.5.7-.5,1,.1.8,0,1.1-.6.49-.8.79-.1.79-.31,1.09a9.29,9.29,0,0,0-1,1c-.3.2-.6.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.69a8.09,8.09,0,0,1-.51-1.39c-.1-.3.21-.7.21-1.19s-.31-.7-.31-1.09.51-.7.51-1a3.65,3.65,0,0,1-.1-1.09"
          />
          <path
            class="cls-59"
            d="M298,473.54c-.11-.3-.61-.5-.71-.7s-.1-.69-.3-1a5.83,5.83,0,0,0-.91-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.6-.5.89.3.7.3,1-.3.69-.2,1,.4.59.5.89-.1.69.1,1,.61.4.71.7.1.69.3,1a6.46,6.46,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.3-.1-.1-.79c.1-.3.41-.3.51-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.69.2-1-.4-.59-.5-.89,0-.6-.1-1"
          />
          <g class="cls-631">
            <polygon
              class="cls-632"
              points="293.11 475.32 303.37 469.07 310.41 480.48 300.15 486.63 293.11 475.32"
            />
          </g>
          <g class="cls-633">
            <polygon
              class="cls-634"
              points="292.81 469.17 303.37 474.93 296.83 486.53 286.27 480.88 292.81 469.17"
            />
          </g>
          <polygon
            class="cls-58"
            points="297.43 482.86 297.83 483.56 298.14 485.54 298.74 485.54 299.04 483.56 299.24 482.86 297.43 482.86"
          />
          <ellipse class="cls-55" cx="298.54" cy="485.54" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M379.1,510.24a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.31-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.51.3-.51.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c-.1.2.2.49.2.69s-.2.5-.1.7a3.82,3.82,0,0,1,.4.69c.11.2,0,.5.11.69a4.23,4.23,0,0,0,.5.7c.1.2.3.2.5.4l.1.59h.3l.1-.59c.1-.2.31-.2.51-.4s.5-.7.5-.79-.1-.5,0-.7a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7a.56.56,0,0,0,.2-.59"
          />
          <polygon
            class="cls-58"
            points="377.59 522.93 378.1 522.93 378.1 521.15 377.39 521.25 377.59 522.93"
          />
          <path
            class="cls-58"
            d="M377.59,513.51c.1-.3.61-.5.71-.79s.1-.8.3-1.09a5.3,5.3,0,0,0,1-.6c.31-.2.31-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19c0,.3.3.69.3,1.09s-.5.69-.5,1,.1.8,0,1.09-.61.5-.81.8-.1.79-.3,1.09a9.29,9.29,0,0,0-1,1c-.31.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.51-.4-.51-.7a7.48,7.48,0,0,1-.5-1.39c0-.29.2-.69.2-1.19,0-.29-.3-.69-.3-1.09s.5-.69.5-1-.2-.69-.1-1.09"
          />
          <path
            class="cls-59"
            d="M377.39,513c-.1-.29-.6-.49-.7-.69s-.1-.69-.3-1a8.27,8.27,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.69.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.6.39.7.69.11.7.31,1a7,7,0,0,0,1,.8c.3.2.5.2.81.39l.4.7.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.41-1.29-.21-.69-.21-1,.31-.69.21-1-.41-.6-.51-.89.1-.8-.1-1"
          />
          <g class="cls-635">
            <polygon
              class="cls-636"
              points="372.56 514.7 382.82 508.45 389.86 519.86 379.61 526.01 372.56 514.7"
            />
          </g>
          <g class="cls-637">
            <polygon
              class="cls-638"
              points="372.16 508.75 382.72 514.4 376.29 526.11 365.73 520.45 372.16 508.75"
            />
          </g>
          <polygon
            class="cls-58"
            points="376.89 522.24 377.19 522.93 377.69 524.92 378.2 524.92 378.5 522.93 378.7 522.14 376.89 522.24"
          />
          <ellipse class="cls-55" cx="378" cy="524.92" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M345.81,495.56a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.4-.3-.51-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.51.3-.51.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c0,.2.2.49.2.69s-.2.5-.1.7a3.82,3.82,0,0,1,.4.69c.1.2,0,.5.1.69a4.24,4.24,0,0,0,.51.7c.1.1.3.2.5.4l.1.59h.3l.1-.59c.1-.2.3-.2.51-.4s.5-.7.5-.79-.1-.5,0-.7a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.3-.39.2-.59"
          />
          <polygon
            class="cls-58"
            points="344.3 508.25 344.8 508.25 344.8 506.47 344.1 506.47 344.3 508.25"
          />
          <path
            class="cls-58"
            d="M344.3,498.83c.1-.3.61-.5.71-.79s.1-.8.3-1.09a5.3,5.3,0,0,0,1-.6c.3-.2.3-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.21.29,0,.79.11,1.09s.5.69.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.69-.5,1,.1.8,0,1.09-.61.5-.81.8-.1.79-.3,1.09a10.35,10.35,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.4-.1.1-.89c-.21-.3-.51-.4-.51-.7a7.48,7.48,0,0,1-.5-1.39c-.1-.29.2-.69.2-1.19s-.3-.69-.3-1.09.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M344.1,498.24c-.1-.3-.6-.5-.7-.7s-.1-.69-.31-1-.6-.3-.9-.5-.3-.69-.6-.79c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.51.59-.51.89.31.7.31,1-.31.7-.2,1,.4.6.5.9-.1.69.1,1,.6.4.7.69.1.7.3,1a8.47,8.47,0,0,0,1,.79c.3.2.5.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.6-.5-.89,0-.7-.1-1"
          />
          <g class="cls-639">
            <polygon
              class="cls-640"
              points="339.17 499.92 349.53 493.67 356.57 505.08 346.31 511.23 339.17 499.92"
            />
          </g>
          <g class="cls-641">
            <polygon
              class="cls-642"
              points="338.87 493.77 349.43 499.52 342.99 511.23 332.43 505.57 338.87 493.77"
            />
          </g>
          <polygon
            class="cls-58"
            points="343.6 507.46 343.9 508.25 344.3 510.24 344.8 510.24 345.11 508.25 345.41 507.46 343.6 507.46"
          />
          <ellipse class="cls-55" cx="344.7" cy="510.24" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M362,503.49a4.21,4.21,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.4-.29-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.8.8,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.3-.5.59.1.5,0,.7a1.37,1.37,0,0,0-.31.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.32,4.32,0,0,1,.41.7c.1.19,0,.49.1.69a4.11,4.11,0,0,0,.5.69c.1.1.3.2.5.4l.1.6h.31l.1-.6c.1-.2.3-.2.5-.4a7.93,7.93,0,0,0,.5-.79c.1-.2-.1-.5,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.49-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="360.6 516.19 361.1 516.19 361 514.5 360.39 514.5 360.6 516.19"
          />
          <path
            class="cls-58"
            d="M360.6,506.77c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.88,5.88,0,0,0,1-.59c.3-.3.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.7.6,1-.2.7-.2,1.19c0,.3.3.7.3,1.1s-.5.69-.5,1,.1.79,0,1.09-.6.49-.8.79-.11.8-.31,1.09a10.32,10.32,0,0,0-1,1c-.3.2-.61.2-.81.5l-.4.79-.4-.09.1-.9c-.2-.3-.5-.39-.5-.69a7.8,7.8,0,0,1-.51-1.39c-.1-.3.2-.69.2-1.19,0-.3-.3-.69-.3-1.09s.51-.7.51-1-.31-.8-.1-1.09"
          />
          <path
            class="cls-59"
            d="M360.39,506.27c-.1-.3-.6-.5-.7-.69s-.1-.7-.3-1a7.49,7.49,0,0,0-.91-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.5.6-.5.9.3.69.3,1-.3.69-.2,1,.4.59.5.89-.1.7.1,1,.61.4.71.7.1.69.3,1a3.46,3.46,0,0,0,1,.79c.31.2.51.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.51-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.51-.89,0-.79-.1-1"
          />
          <g class="cls-643">
            <polygon
              class="cls-644"
              points="355.47 507.96 365.73 501.81 372.87 513.11 362.51 519.26 355.47 507.96"
            />
          </g>
          <g class="cls-645">
            <polygon
              class="cls-646"
              points="355.16 502 365.73 507.66 359.29 519.36 348.73 513.71 355.16 502"
            />
          </g>
          <polygon
            class="cls-58"
            points="359.79 515.49 360.19 516.19 360.6 518.17 361.1 518.17 361.4 516.19 361.7 515.49 359.79 515.49"
          />
          <ellipse class="cls-55" cx="360.9" cy="518.17" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M316.14,478.79a3.82,3.82,0,0,1-.4-.69c-.1-.2.1-.5-.1-.69s-.41-.3-.51-.6-.1-.5-.3-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.21.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.24,4.24,0,0,0,.51.7c.1.1.3.19.5.39l.1.6h.3l.1-.6c.1-.2.3-.2.51-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.19-.2-.49-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="314.63 491.49 315.13 491.49 315.13 489.7 314.43 489.7 314.63 491.49"
          />
          <path
            class="cls-58"
            d="M314.63,482.07c.1-.3.6-.5.71-.8s.1-.79.3-1.09a5.23,5.23,0,0,0,1-.59c.3-.2.3-.7.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.09.1.19.21.3,0,.8.1,1.09s.51.7.61,1-.2.69-.2,1.19c0,.29.3.69.3,1.09s-.5.69-.5,1,.1.79,0,1.09-.61.5-.81.79-.1.8-.3,1.1a8.49,8.49,0,0,0-1,1c-.3.2-.6.2-.8.49l-.4.8-.41-.1.11-.9c-.21-.29-.51-.39-.51-.69a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.69.2-1.19,0-.3-.3-.69-.3-1.09s.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M314.43,481.57c-.1-.3-.6-.49-.7-.69s-.1-.7-.31-1a7.26,7.26,0,0,0-.9-.5c-.3-.2-.3-.69-.6-.79-.11,0-.11,0-.11-.1a1,1,0,0,0-1.2.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.51.6-.51.9.31.69.31,1-.31.69-.21,1,.41.6.51.89-.1.7.1,1,.6.39.7.69.1.69.3,1a7.67,7.67,0,0,0,1,.8c.3.19.5.19.8.39l.41.7.3-.1-.1-.8c.1-.29.4-.29.5-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9.1-.79-.1-1"
          />
          <g class="cls-647">
            <polygon
              class="cls-648"
              points="309.6 483.16 319.86 477.01 326.9 488.42 316.64 494.56 309.6 483.16"
            />
          </g>
          <g class="cls-649">
            <polygon
              class="cls-650"
              points="309.2 477.31 319.76 482.96 313.32 494.66 302.76 489.01 309.2 477.31"
            />
          </g>
          <polygon
            class="cls-58"
            points="313.93 490.7 314.23 491.49 314.73 493.47 315.23 493.47 315.54 491.49 315.74 490.7 313.93 490.7"
          />
          <ellipse class="cls-55" cx="315.03" cy="493.47" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M330.82,487.32a3.82,3.82,0,0,1-.4-.69c-.1-.2.1-.5-.1-.69s-.4-.3-.5-.6-.1-.5-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69-.31.4-.31.69.21.5.21.7-.21.49-.11.69a3.7,3.7,0,0,1,.41.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.1.3.19.5.39l.1.6h.31l.1-.6c.1-.2.3-.2.5-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.19-.2-.49-.2-.69a.56.56,0,0,0,.2-.6"
          />
          <polygon
            class="cls-58"
            points="329.31 500.02 329.82 500.02 329.82 498.24 329.11 498.33 329.31 500.02"
          />
          <path
            class="cls-58"
            d="M329.32,490.6c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.29,5.29,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.09.1.19.2.3,0,.8.1,1.09s.5.7.6,1-.2.69-.2,1.19c0,.29.3.69.3,1.09s-.5.69-.5,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.31,1.1a8.44,8.44,0,0,0-1,1c-.3.2-.61.2-.81.49l-.4.8-.4-.1.1-.9c-.2-.29-.5-.39-.5-.69A7.8,7.8,0,0,1,329,495c0-.3.2-.69.2-1.19,0-.3-.3-.69-.3-1.09s.51-.69.51-1-.21-.7-.1-1.09"
          />
          <path
            class="cls-59"
            d="M329.11,490.1c-.1-.3-.6-.49-.7-.69s-.1-.7-.3-1-.61-.3-.91-.5-.3-.69-.6-.79c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.5.6-.5.9.3.69.3,1-.3.69-.2,1,.4.6.5.89-.1.7.1,1,.61.39.71.69.1.69.3,1a7,7,0,0,0,1,.8c.31.19.51.19.81.39l.4.7.3-.1-.1-.8c.1-.29.4-.29.51-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.51-.9.11-.79-.1-1"
          />
          <g class="cls-651">
            <polygon
              class="cls-652"
              points="324.29 491.79 334.55 485.54 341.59 496.95 331.33 503.1 324.29 491.79"
            />
          </g>
          <g class="cls-653">
            <polygon
              class="cls-654"
              points="323.88 485.84 334.44 491.59 328.01 503.19 317.45 497.54 323.88 485.84"
            />
          </g>
          <polygon
            class="cls-58"
            points="328.61 499.33 328.91 500.02 329.42 502 329.92 502 330.22 500.02 330.42 499.23 328.61 499.33"
          />
          <ellipse class="cls-55" cx="329.72" cy="502" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M396.7,503.49a4.21,4.21,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.4-.29-.5-.59-.1-.5-.3-.7c-.11,0-.11,0-.11-.1a.78.78,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.51.3-.51.59.11.5,0,.7a1.46,1.46,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.32,4.32,0,0,1,.41.7c.1.19,0,.49.1.69a4.11,4.11,0,0,0,.5.69c.1.1.3.2.5.4l.1.6h.3l.11-.6c.1-.2.3-.2.5-.4a7.93,7.93,0,0,0,.5-.79c.1-.2-.1-.5,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.49-.2-.69s.2-.3.2-.6"
          />
          <polygon
            class="cls-58"
            points="395.19 516.29 395.7 516.29 395.6 514.4 394.99 514.5 395.19 516.29"
          />
          <path
            class="cls-58"
            d="M395.19,506.86c.1-.29.61-.49.71-.79s.1-.79.3-1.09a5.7,5.7,0,0,0,1-.6c.3-.19.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.7.6,1-.2.7-.2,1.19c0,.3.3.7.3,1.09s-.5.7-.5,1,.1.79,0,1.09-.6.49-.81.79-.1.79-.3,1.09a10.32,10.32,0,0,0-1,1c-.3.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.69a7.09,7.09,0,0,1-.51-1.39c0-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.09s.5-.7.5-1-.3-.8-.1-1.1"
          />
          <path
            class="cls-59"
            d="M395,506.27c-.1-.3-.6-.5-.7-.69s-.1-.7-.3-1a7.49,7.49,0,0,0-.91-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.5.6-.5.9.3.69.3,1-.3.69-.2,1,.4.59.5.89-.1.7.1,1,.61.4.71.7.1.69.3,1a6.9,6.9,0,0,0,1,.79c.3.2.51.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.5-.69s.31-1,.41-1.29-.2-.7-.2-1,.3-.7.2-1-.41-.59-.51-.89,0-.79-.1-1"
          />
          <g class="cls-655">
            <polygon
              class="cls-656"
              points="390.06 507.96 400.42 501.71 407.46 513.11 397.11 519.26 390.06 507.96"
            />
          </g>
          <g class="cls-657">
            <polygon
              class="cls-658"
              points="389.76 502 400.32 507.76 393.89 519.36 383.33 513.71 389.76 502"
            />
          </g>
          <polygon
            class="cls-58"
            points="394.39 515.49 394.79 516.29 395.19 518.17 395.7 518.17 396 516.19 396.3 515.39 394.39 515.49"
          />
          <ellipse class="cls-55" cx="395.6" cy="518.17" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M412.39,495.76a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.11,0-.11,0-.11-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.41,1.41,0,0,0-.31.7c-.1.19.2.49.2.69s-.2.5-.1.69a4.32,4.32,0,0,1,.41.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.2.3.2.5.39l.1.6h.3l.11-.6c.1-.19.3-.19.5-.39a9.22,9.22,0,0,0,.5-.8c.1-.19-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.19-.2-.49-.2-.69s.3-.4.2-.59"
          />
          <polygon
            class="cls-58"
            points="410.88 508.45 411.39 508.45 411.39 506.67 410.68 506.67 410.88 508.45"
          />
          <path
            class="cls-58"
            d="M410.88,499c.1-.3.61-.5.71-.79s.1-.8.3-1.1a5.08,5.08,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.19.2.3,0,.8.1,1.1s.5.69.6,1-.2.69-.2,1.19c0,.3.3.69.3,1.09s-.5.69-.5,1,.1.79,0,1.09-.6.5-.81.8-.1.79-.3,1.09a8.44,8.44,0,0,0-1,1c-.3.2-.61.2-.81.49l-.4.8-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.09,7.09,0,0,1-.51-1.39c0-.29.2-.69.2-1.19,0-.29-.3-.69-.3-1.09s.51-.69.51-1-.21-.79-.11-1.09"
          />
          <path
            class="cls-59"
            d="M410.68,498.43c-.1-.29-.6-.49-.7-.69s-.1-.7-.3-1a7.44,7.44,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.69.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.61.39.71.69.1.7.3,1a7,7,0,0,0,1,.8c.31.2.51.2.81.39l.4.7.3-.1-.1-.79c.1-.3.4-.3.5-.7s.31-1,.41-1.29-.2-.69-.2-1,.3-.69.2-1-.41-.6-.51-.89.1-.8-.1-1"
          />
          <g class="cls-659">
            <polygon
              class="cls-660"
              points="405.86 500.12 416.11 493.87 423.15 505.28 412.9 511.43 405.86 500.12"
            />
          </g>
          <g class="cls-661">
            <polygon
              class="cls-662"
              points="405.45 494.17 416.01 499.92 409.58 511.53 399.02 505.87 405.45 494.17"
            />
          </g>
          <polygon
            class="cls-58"
            points="410.18 507.66 410.48 508.45 410.99 510.44 411.49 510.44 411.79 508.35 411.99 507.56 410.18 507.66"
          />
          <ellipse class="cls-55" cx="411.29" cy="510.44" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M193.13,410.35a3.82,3.82,0,0,1-.4-.69c-.1-.2.1-.5-.1-.69s-.4-.3-.5-.6-.1-.49-.31-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.51.3-.51.6.11.49,0,.69a1.5,1.5,0,0,0-.3.69c0,.2.2.5.2.7s-.2.5-.1.69a4.32,4.32,0,0,1,.41.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.1.3.19.5.39l.1.6h.3l.1-.6c.11-.2.31-.2.51-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.19-.2-.49-.2-.69a.56.56,0,0,0,.2-.6"
          />
          <polygon
            class="cls-58"
            points="191.62 423.05 192.23 423.05 192.13 421.37 191.42 421.37 191.62 423.05"
          />
          <path
            class="cls-58"
            d="M191.62,413.63c.1-.3.61-.5.71-.8s.1-.79.3-1.09a5.08,5.08,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.09.1.19.2.3,0,.8.1,1.1s.5.69.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.69-.5,1,.1.79,0,1.09-.6.5-.81.79-.1.8-.3,1.1a8.44,8.44,0,0,0-1,1c-.31.2-.61.2-.81.49l-.4.8-.4-.1.1-.89c-.2-.3-.51-.4-.51-.7a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.69.2-1.19s-.3-.69-.3-1.09.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M191.42,413c-.1-.29-.6-.49-.7-.69s-.1-.7-.3-1a7.44,7.44,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.09.09,0,0,0-.1.09c-.1.3.1.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.5.9-.1.69.1,1,.6.39.71.69.1.7.3,1a7,7,0,0,0,1,.8c.3.2.51.2.81.39l.4.7.3-.1-.1-.79c.1-.3.4-.3.5-.7s.31-1,.41-1.29-.21-.69-.21-1,.31-.69.21-1-.41-.6-.51-.9.1-.59-.1-1"
          />
          <g class="cls-663">
            <polygon
              class="cls-664"
              points="186.59 414.82 196.85 408.57 203.89 419.98 193.63 426.13 186.59 414.82"
            />
          </g>
          <g class="cls-665">
            <polygon
              class="cls-666"
              points="186.19 408.67 196.85 414.42 190.32 426.03 179.76 420.37 186.19 408.67"
            />
          </g>
          <polygon
            class="cls-58"
            points="190.92 422.36 191.22 423.05 191.62 425.04 192.23 425.04 192.53 423.05 192.73 422.36 190.92 422.36"
          />
          <ellipse class="cls-55" cx="192.03" cy="425.03" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M207.62,419.48a4.66,4.66,0,0,1-.41-.69c-.1-.2.1-.5-.1-.7s-.4-.3-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.29-.5.59.1.5,0,.7a1.41,1.41,0,0,0-.3.69c0,.2.2.5.2.69s-.2.5-.1.7a4.68,4.68,0,0,1,.4.69c.1.2,0,.5.1.7a4.11,4.11,0,0,0,.5.69c.1.1.3.2.51.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.42,1.42,0,0,0,.31-.69c.1-.2-.21-.5-.21-.69a.55.55,0,0,0,.21-.6"
          />
          <polygon
            class="cls-58"
            points="206.21 432.27 206.71 432.27 206.61 430.49 206.01 430.49 206.21 432.27"
          />
          <path
            class="cls-58"
            d="M206.21,422.85c.1-.29.6-.49.7-.79s.1-.79.3-1.09a5.06,5.06,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.69.6,1-.2.7-.2,1.19.31.7.31,1.09-.51.7-.51,1,.1.8,0,1.1-.6.49-.8.79-.1.79-.3,1.09a8.51,8.51,0,0,0-1,1c-.3.2-.6.2-.8.5l-.41.79-.5-.2.1-.89c-.2-.3-.5-.4-.5-.69a7.75,7.75,0,0,1-.5-1.39c-.11-.3.2-.7.2-1.19s-.31-.7-.31-1.09.51-.7.51-1-.2-.69,0-1"
          />
          <path
            class="cls-59"
            d="M206,422.26c-.1-.3-.61-.5-.71-.7s-.1-.69-.3-1a6.17,6.17,0,0,0-.9-.49c-.31-.2-.31-.7-.61-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.6-.5.89.3.7.3,1-.3.7-.2,1,.4.59.5.89-.1.69.11,1,.6.4.7.7.1.69.3,1a3.49,3.49,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.31-.1-.11-.79c.11-.3.41-.3.51-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.69.2-1-.4-.59-.5-.89,0-.69-.1-1"
          />
          <g class="cls-667">
            <polygon
              class="cls-668"
              points="201.08 423.94 211.34 417.69 218.38 429.1 208.12 435.25 201.08 423.94"
            />
          </g>
          <g class="cls-669">
            <polygon
              class="cls-670"
              points="200.78 417.79 211.34 423.55 204.9 435.15 194.24 429.5 200.78 417.79"
            />
          </g>
          <polygon
            class="cls-58"
            points="205.4 431.48 205.81 432.27 206.21 434.16 206.71 434.16 207.01 432.27 207.31 431.48 205.4 431.48"
          />
          <ellipse class="cls-55" cx="206.51" cy="434.16" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M253.78,444.18a4.35,4.35,0,0,1-.4-.7c-.1-.19.1-.49-.1-.69s-.4-.3-.5-.6-.11-.49-.31-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.5-.2.69-.51.3-.51.6.1.5,0,.69a1.49,1.49,0,0,0-.3.7c0,.2.2.49.2.69s-.2.5-.1.7a3.82,3.82,0,0,1,.4.69c.1.2,0,.5.1.7a5.38,5.38,0,0,0,.51.69c.1.2.3.2.5.4l.1.59h.3l.1-.59c.1-.2.31-.2.51-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.3-.39.2-.59"
          />
          <polygon
            class="cls-58"
            points="252.27 456.87 252.78 456.87 252.78 455.19 252.07 455.19 252.27 456.87"
          />
          <path
            class="cls-58"
            d="M252.27,447.45c.1-.3.61-.49.71-.79s.1-.8.3-1.09a5.3,5.3,0,0,0,1-.6c.31-.2.31-.69.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.7-.5,1,.1.8,0,1.09-.61.5-.81.8-.1.79-.3,1.09a9.29,9.29,0,0,0-1,1c-.31.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.51-.4-.51-.7a7.65,7.65,0,0,1-.5-1.38c-.1-.3.2-.7.2-1.19s-.3-.7-.3-1.1.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M252.07,446.86c-.1-.3-.6-.5-.7-.7s-.1-.69-.3-1a8.27,8.27,0,0,0-.91-.5c-.3-.19-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.59-.5.89.3.7.3,1-.3.7-.2,1,.4.59.5.89-.1.69.1,1,.6.4.7.69.1.7.31,1a7.67,7.67,0,0,0,1,.79c.3.2.5.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.29-.2-.69-.2-1,.31-.69.2-1-.4-.59-.5-.89,0-.6-.1-1"
          />
          <g class="cls-671">
            <polygon
              class="cls-672"
              points="247.24 448.64 257.5 442.39 264.54 453.8 254.28 459.95 247.24 448.64"
            />
          </g>
          <g class="cls-673">
            <polygon
              class="cls-674"
              points="246.84 442.49 257.4 448.14 250.97 459.85 240.4 454.2 246.84 442.49"
            />
          </g>
          <polygon
            class="cls-58"
            points="251.57 456.18 251.87 456.87 252.27 458.86 252.78 458.86 253.18 456.87 253.38 456.18 251.57 456.18"
          />
          <ellipse class="cls-55" cx="252.67" cy="458.86" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M270.07,452.11a4.21,4.21,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.4-.29-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.09a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.09s-.1.5-.2.7-.5.3-.5.59.1.5,0,.7a1.5,1.5,0,0,0-.3.69c-.11.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.19,0,.49.1.69a3.74,3.74,0,0,0,.5.69c.1.1.3.2.5.4l.1.6h.31l.1-.6c.1-.2.3-.2.5-.4a7.93,7.93,0,0,0,.5-.79c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.11-.2-.2-.49-.2-.69s.2-.3.2-.6"
          />
          <polygon
            class="cls-58"
            points="268.57 464.81 269.07 464.81 268.97 463.12 268.37 463.12 268.57 464.81"
          />
          <path
            class="cls-58"
            d="M268.57,455.39c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.88,5.88,0,0,0,1-.59c.3-.2.3-.7.6-1a.09.09,0,0,0,.1-.09,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.2.3,0,.8.1,1.09s.5.7.6,1-.2.69-.2,1.19c0,.29.3.69.3,1.09s-.5.69-.5,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.31,1.09a9.43,9.43,0,0,0-1,1c-.3.19-.6.19-.81.49l-.4.8-.4-.1.1-.9c-.2-.29-.5-.39-.5-.69a7.8,7.8,0,0,1-.51-1.39c-.1-.3.21-.69.21-1.19,0-.3-.31-.69-.31-1.09s.51-.7.51-1-.31-.7-.1-1.09"
          />
          <path
            class="cls-59"
            d="M268.36,454.89c-.1-.3-.6-.5-.7-.69s-.1-.7-.3-1a8.18,8.18,0,0,0-.91-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.09a1,1,0,0,0-1.21.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.5.6-.5.9.3.69.3,1-.3.69-.2,1,.4.59.5.89-.1.7.1,1,.61.4.71.7.1.69.3,1a6.46,6.46,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.3-.09-.1-.8c.1-.3.41-.3.51-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89,0-.69-.11-1"
          />
          <g class="cls-675">
            <polygon
              class="cls-676"
              points="263.44 456.58 273.8 450.43 280.84 461.83 270.48 467.98 263.44 456.58"
            />
          </g>
          <g class="cls-677">
            <polygon
              class="cls-678"
              points="263.13 450.63 273.7 456.28 267.26 468.08 256.7 462.43 263.13 450.63"
            />
          </g>
          <polygon
            class="cls-58"
            points="267.86 464.12 268.16 464.81 268.57 466.79 269.07 466.79 269.37 464.81 269.67 464.12 267.86 464.12"
          />
          <ellipse class="cls-55" cx="268.97" cy="466.79" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M224.11,427.42a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.5-.1-.69s-.4-.3-.51-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.51.3-.51.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c-.1.19.2.49.2.69s-.2.5-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.24,4.24,0,0,0,.51.7c.1.1.3.2.5.39l.1.6h.3l.1-.6c.1-.19.3-.19.51-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.19-.2-.49-.2-.69s.3-.4.2-.59"
          />
          <polygon
            class="cls-58"
            points="222.6 440.11 223.1 440.11 223.1 438.43 222.4 438.43 222.6 440.11"
          />
          <path
            class="cls-58"
            d="M222.6,430.69c.1-.3.61-.5.71-.8s.1-.79.3-1.09a4.75,4.75,0,0,0,1-.59c.31-.2.31-.7.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.19.21.3,0,.8.11,1.1s.5.69.6,1-.2.69-.2,1.19c0,.3.3.69.3,1.09s-.5.69-.5,1,.1.79,0,1.09-.61.5-.81.8-.1.79-.3,1.09a9.31,9.31,0,0,0-1,1c-.3.2-.6.2-.8.49l-.4.8-.4-.1.1-.89c-.21-.3-.51-.4-.51-.7a7.75,7.75,0,0,1-.5-1.39c-.1-.29.2-.69.2-1.19,0-.3-.3-.69-.3-1.09s.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M222.4,430.19c-.1-.3-.6-.49-.7-.69s-.1-.7-.31-1-.6-.3-.9-.5-.3-.69-.6-.79c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.09.09,0,0,0-.1.09c-.1.3.1.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.5.89-.1.7.1,1,.6.39.7.69.1.7.31,1a7,7,0,0,0,1,.8c.3.19.5.19.81.39l.4.7.3-.1-.1-.8c.1-.29.4-.29.5-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9.1-.79-.1-1"
          />
          <g class="cls-679">
            <polygon
              class="cls-680"
              points="217.57 431.78 227.83 425.63 234.87 437.04 224.61 443.19 217.57 431.78"
            />
          </g>
          <g class="cls-681">
            <polygon
              class="cls-682"
              points="217.17 425.93 227.83 431.58 221.29 443.29 210.73 437.63 217.17 425.93"
            />
          </g>
          <polygon
            class="cls-58"
            points="221.9 439.42 222.2 440.11 222.7 442.1 223.21 442.1 223.51 440.11 223.71 439.42 221.9 439.42"
          />
          <ellipse class="cls-55" cx="223" cy="442.09" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M238.79,436a3.82,3.82,0,0,1-.4-.69c-.1-.2.1-.5-.1-.69s-.4-.3-.5-.6-.1-.5-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c-.11.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.1.3.19.5.39l.11.6h.3l.1-.6c.1-.2.3-.2.5-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.11-.19-.2-.49-.2-.69s.31-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="237.29 448.74 237.79 448.74 237.79 446.95 237.09 446.95 237.29 448.74"
          />
          <path
            class="cls-58"
            d="M237.29,439.32c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.29,5.29,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.09.1.19.2.3,0,.8.1,1.09s.5.7.6,1-.2.69-.2,1.19c0,.29.3.69.3,1.09s-.5.69-.5,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.31,1.1a8.44,8.44,0,0,0-1,1c-.3.2-.6.2-.81.49l-.4.8-.4-.1.1-.9c-.2-.29-.5-.39-.5-.69a7.8,7.8,0,0,1-.51-1.39c0-.3.21-.69.21-1.19,0-.3-.31-.69-.31-1.09s.51-.69.51-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M237.09,438.72c-.11-.29-.61-.49-.71-.69s-.1-.7-.3-1a6.76,6.76,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.09.09,0,0,0-.1.09c-.1.3.1.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.5.89-.1.7.1,1,.61.39.71.69.1.7.3,1a6.55,6.55,0,0,0,1,.8c.3.19.5.19.8.39l.4.7.3-.1-.1-.8c.1-.29.41-.29.51-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9.1-.79-.1-1"
          />
          <g class="cls-683">
            <polygon
              class="cls-684"
              points="232.26 440.41 242.52 434.16 249.56 445.57 239.3 451.72 232.26 440.41"
            />
          </g>
          <g class="cls-685">
            <polygon
              class="cls-686"
              points="231.85 434.46 242.42 440.21 235.98 451.81 225.42 446.16 231.85 434.46"
            />
          </g>
          <polygon
            class="cls-58"
            points="236.58 447.95 236.88 448.74 237.39 450.72 237.89 450.72 238.19 448.64 238.39 447.95 236.58 447.95"
          />
          <ellipse class="cls-55" cx="237.69" cy="450.72" rx="3.82" ry="1.69" />
          <polygon
            class="cls-40"
            points="170.3 395.28 378.1 512.42 431 485.14 221.7 368.4 170.3 395.28"
          />
          <polygon
            class="cls-54"
            points="380.71 511.13 380.71 518.07 428.18 492.58 428.18 486.63 380.71 511.13"
          />
          <path
            class="cls-57"
            d="M284,435.75a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.31.7c0,.2.21.49.21.69s-.21.5-.1.7a3.82,3.82,0,0,1,.4.69c.1.2,0,.5.1.69a4.23,4.23,0,0,0,.5.7c.1.1.3.2.5.4l.1.59h.31l.1-.59c.1-.2.3-.2.5-.4s.5-.7.5-.79-.1-.5,0-.7a1.5,1.5,0,0,0,.3-.69c.11-.2-.2-.5-.2-.7a.54.54,0,0,0,.2-.59"
          />
          <polygon
            class="cls-58"
            points="282.45 448.44 283.05 448.44 282.95 446.76 282.25 446.76 282.45 448.44"
          />
          <path
            class="cls-58"
            d="M282.45,439c.1-.3.6-.5.7-.79s.1-.8.3-1.09a5.36,5.36,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.69-.5,1,.1.8,0,1.09-.6.5-.8.8-.1.79-.31,1.09a9.29,9.29,0,0,0-1,1c-.3.2-.6.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.53,7.53,0,0,1-.51-1.39c-.1-.29.21-.69.21-1.19s-.31-.69-.31-1.09.51-.69.51-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M282.24,438.43c-.1-.3-.6-.5-.7-.7s-.1-.69-.3-1a6.76,6.76,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.7.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.61.4.71.69.1.7.3,1a7.67,7.67,0,0,0,1,.79c.31.2.51.2.81.4l.4.69.3-.1-.1-.79c.1-.3.41-.3.51-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.6-.5-.89.1-.6-.11-1"
          />
          <g class="cls-687">
            <polygon
              class="cls-688"
              points="277.42 440.21 287.68 433.96 294.72 445.37 284.46 451.52 277.42 440.21"
            />
          </g>
          <g class="cls-689">
            <polygon
              class="cls-690"
              points="277.12 434.06 287.68 439.81 281.14 451.42 270.58 445.76 277.12 434.06"
            />
          </g>
          <polygon
            class="cls-58"
            points="281.74 447.75 282.04 448.44 282.45 450.43 283.05 450.43 283.35 448.44 283.55 447.75 281.74 447.75"
          />
          <ellipse class="cls-55" cx="282.85" cy="450.43" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M298.44,444.87a4.21,4.21,0,0,1-.4-.69c-.11-.2.1-.5-.11-.7s-.4-.29-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.8.8,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.3-.5.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c0,.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.19,0,.49.1.69a4.11,4.11,0,0,0,.5.69c.11.2.31.2.51.4l.1.6h.3l.1-.6c.1-.2.3-.2.5-.4a8.29,8.29,0,0,0,.51-.79c.1-.2-.1-.5,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.49-.2-.69a.56.56,0,0,0,.2-.6"
          />
          <polygon
            class="cls-58"
            points="297.03 457.67 297.53 457.67 297.43 455.88 296.83 455.88 297.03 457.67"
          />
          <path
            class="cls-58"
            d="M297,448.24c.1-.29.6-.49.7-.79s.1-.79.31-1.09a5.3,5.3,0,0,0,1-.6c.3-.19.3-.69.6-1a.1.1,0,0,0,.11-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.51.7.61,1-.2.7-.2,1.19.3.7.3,1.09-.51.7-.51,1,.11.79,0,1.09-.6.49-.8.79-.1.79-.3,1.09a10.37,10.37,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.41-.1.1-.89c-.2-.3-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.7.2-1.19s-.3-.7-.3-1.09.5-.7.5-1-.3-.8-.1-1.1"
          />
          <path
            class="cls-59"
            d="M296.83,447.65c-.1-.3-.6-.5-.71-.69s-.1-.7-.3-1a7.3,7.3,0,0,0-.9-.49c-.3-.2-.3-.7-.61-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.3.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.51.6-.51.9.3.69.3,1-.3.69-.2,1,.41.59.51.89-.1.7.1,1,.6.4.7.7.1.69.3,1a7,7,0,0,0,1,.79c.3.2.5.2.8.4l.41.69.3-.09-.1-.8c.1-.3.4-.3.5-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89,0-.69-.1-1"
          />
          <g class="cls-691">
            <polygon
              class="cls-692"
              points="291.9 449.34 302.16 443.09 309.3 454.49 298.94 460.64 291.9 449.34"
            />
          </g>
          <g class="cls-693">
            <polygon
              class="cls-694"
              points="291.6 443.19 302.16 448.94 295.72 460.54 285.06 454.89 291.6 443.19"
            />
          </g>
          <polygon
            class="cls-58"
            points="296.23 456.87 296.63 457.67 297.03 459.55 297.53 459.55 297.83 457.67 298.14 456.87 296.23 456.87"
          />
          <ellipse class="cls-55" cx="297.33" cy="459.55" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M377.89,484.35a4.35,4.35,0,0,1-.4-.7c-.1-.19.1-.49-.1-.69s-.4-.3-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.29-.5.59.1.5,0,.69a1.49,1.49,0,0,0-.3.7c-.11.2.2.49.2.69s-.2.5-.1.7a4.21,4.21,0,0,1,.4.69c.1.2,0,.5.1.7a4.57,4.57,0,0,0,.5.69c.1.1.3.2.5.4l.1.59h.31l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.46,1.46,0,0,0,.3-.69c.11-.2-.2-.5-.2-.7s.31-.39.2-.59"
          />
          <polygon
            class="cls-58"
            points="376.39 497.05 376.99 497.05 376.89 495.26 376.19 495.26 376.39 497.05"
          />
          <path
            class="cls-58"
            d="M376.39,487.62c.1-.3.6-.49.7-.79s.1-.79.3-1.09a5.36,5.36,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.69.6,1-.2.7-.2,1.19c0,.3.3.7.3,1.09s-.5.7-.5,1,.1.8,0,1.1-.6.49-.8.79-.1.79-.31,1.09a9.29,9.29,0,0,0-1,1c-.3.2-.6.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.71,7.71,0,0,1-.51-1.38c0-.3.21-.7.21-1.19,0-.3-.31-.7-.31-1.09s.51-.7.51-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M376.18,487c-.1-.3-.6-.5-.7-.7s-.1-.69-.3-1-.6-.3-.91-.5-.3-.69-.6-.79c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.6-.5.89.3.7.3,1-.3.7-.2,1,.4.59.5.89-.1.69.1,1,.61.4.71.7.1.69.3,1a6.9,6.9,0,0,0,1,.79c.31.2.51.2.81.4l.4.69.3-.1-.1-.79c.1-.3.41-.3.51-.7s.3-1,.4-1.28-.2-.7-.2-1,.3-.69.2-1-.4-.59-.5-.89.1-.79-.11-1"
          />
          <g class="cls-695">
            <polygon
              class="cls-696"
              points="371.36 488.71 381.62 482.46 388.66 493.87 378.4 500.02 371.36 488.71"
            />
          </g>
          <g class="cls-697">
            <polygon
              class="cls-698"
              points="370.95 482.76 381.62 488.51 375.08 500.12 364.52 494.47 370.95 482.76"
            />
          </g>
          <polygon
            class="cls-58"
            points="375.68 496.25 375.98 497.05 376.49 499.03 376.99 499.03 377.29 496.95 377.49 496.15 375.68 496.25"
          />
          <ellipse class="cls-55" cx="376.79" cy="499.03" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M344.6,469.57a4.68,4.68,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.4-.3-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.29-.5.59.1.5,0,.7a1.34,1.34,0,0,0-.31.69c0,.2.2.5.2.69s-.2.5-.1.7a4.66,4.66,0,0,1,.41.69c.1.2,0,.5.1.7a4.11,4.11,0,0,0,.5.69c.1.1.3.2.5.4l.1.59h.31l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.41,1.41,0,0,0,.3-.69c.1-.2-.2-.5-.2-.69s.3-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="343.1 482.27 343.6 482.27 343.6 480.58 342.89 480.58 343.1 482.27"
          />
          <path
            class="cls-58"
            d="M343.09,472.84c.11-.29.61-.49.71-.79s.1-.79.3-1.09a5.7,5.7,0,0,0,1-.6c.3-.19.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.69.6,1-.2.7-.2,1.19.3.7.3,1.09-.5.7-.5,1,.1.79,0,1.09-.6.49-.81.79-.1.79-.3,1.09a10.32,10.32,0,0,0-1,1c-.3.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.69a8.09,8.09,0,0,1-.51-1.39c-.1-.3.2-.7.2-1.19s-.3-.7-.3-1.09.51-.7.51-1-.21-.79-.11-1.09"
          />
          <path
            class="cls-59"
            d="M342.89,472.25c-.1-.3-.6-.5-.7-.7s-.1-.69-.3-1a6.32,6.32,0,0,0-.91-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.6-.5.89.3.7.3,1-.3.69-.2,1,.4.59.5.89-.1.69.1,1,.61.4.71.7.1.69.3,1a6.9,6.9,0,0,0,1,.79c.31.2.51.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.5-.69s.31-1,.41-1.29-.2-.7-.2-1,.3-.69.2-1-.41-.59-.51-.89.1-.6-.1-1"
          />
          <g class="cls-699">
            <polygon
              class="cls-700"
              points="338.07 474.03 348.32 467.79 355.37 479.19 345.11 485.34 338.07 474.03"
            />
          </g>
          <g class="cls-701">
            <polygon
              class="cls-702"
              points="337.66 467.88 348.22 473.54 341.79 485.24 331.23 479.59 337.66 467.88"
            />
          </g>
          <polygon
            class="cls-58"
            points="342.39 481.57 342.69 482.27 343.1 484.25 343.6 484.25 344 482.27 344.2 481.57 342.39 481.57"
          />
          <ellipse class="cls-55" cx="343.5" cy="484.25" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M360.9,477.5a4.48,4.48,0,0,1-.41-.69c-.1-.2.11-.5-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.5-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.1.31.19.51.39l.1.6h.3l.1-.6c.1-.2.3-.2.5-.39s.51-.7.51-.8-.11-.49,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.19-.2-.49-.2-.69s.2-.3.2-.6"
          />
          <polygon
            class="cls-58"
            points="359.39 490.2 359.89 490.2 359.79 488.51 359.19 488.51 359.39 490.2"
          />
          <path
            class="cls-58"
            d="M359.39,480.78c.1-.3.6-.5.7-.8s.1-.79.3-1.09a4.57,4.57,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.09.1.19.2.3,0,.8.1,1.1s.5.69.61,1-.21.69-.21,1.19c0,.29.31.69.31,1.09s-.51.69-.51,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.3,1.1a8.49,8.49,0,0,0-1,1c-.3.2-.6.2-.8.49l-.41.8-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.69.2-1.19,0-.3-.3-.69-.3-1.09s.5-.69.5-1-.3-.7-.1-1.09"
          />
          <path
            class="cls-59"
            d="M359.19,480.28c-.1-.3-.61-.49-.71-.69s-.1-.7-.3-1a7.26,7.26,0,0,0-.9-.5c-.31-.2-.31-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.29.1.1,0,0,0-.11.1c-.1.3.11.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.51.89-.11.7.1,1,.6.39.7.69.1.69.3,1a7.06,7.06,0,0,0,1,.8c.3.19.5.19.8.39l.4.7.31-.1-.1-.8c.1-.29.4-.29.5-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9,0-.69-.1-1"
          />
          <g class="cls-703">
            <polygon
              class="cls-704"
              points="354.26 481.97 364.62 475.82 371.66 487.23 361.3 493.38 354.26 481.97"
            />
          </g>
          <g class="cls-705">
            <polygon
              class="cls-706"
              points="353.96 476.02 364.52 481.67 358.08 493.47 347.52 487.82 353.96 476.02"
            />
          </g>
          <polygon
            class="cls-58"
            points="358.68 489.51 358.99 490.2 359.39 492.19 359.99 492.19 360.19 490.2 360.5 489.51 358.68 489.51"
          />
          <ellipse class="cls-55" cx="359.79" cy="492.18" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M314.93,452.81a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.11,0-.11,0-.11-.1a.75.75,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.1.5-.2.69-.51.3-.51.6.11.49,0,.69a1.49,1.49,0,0,0-.3.7c-.1.2.2.49.2.69s-.2.5-.1.7a3.8,3.8,0,0,1,.41.69c.1.2,0,.5.1.69a4.23,4.23,0,0,0,.5.7c.1.2.3.2.5.4l.1.59h.3l.11-.59c.1-.2.3-.2.5-.4s.5-.7.5-.79-.1-.5,0-.7a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.3-.39.2-.59"
          />
          <polygon
            class="cls-58"
            points="313.42 465.5 313.93 465.5 313.93 463.82 313.22 463.82 313.42 465.5"
          />
          <path
            class="cls-58"
            d="M313.42,456.08c.1-.3.61-.5.71-.79s.1-.8.3-1.09a5.7,5.7,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19c0,.3.3.69.3,1.09s-.5.7-.5,1,.1.8,0,1.09-.6.5-.81.8-.1.79-.3,1.09a9.29,9.29,0,0,0-1,1c-.3.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a6.87,6.87,0,0,1-.51-1.39c-.1-.29.2-.69.2-1.19,0-.29-.3-.69-.3-1.09s.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M313.22,455.58c-.1-.29-.6-.49-.7-.69s-.1-.69-.3-1a7.44,7.44,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.69.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.6.4.71.69.1.7.3,1a7,7,0,0,0,1,.8c.3.2.51.2.81.39l.4.7.3-.1-.1-.79c.1-.3.4-.3.5-.7s.31-1,.41-1.29-.2-.69-.2-1,.3-.69.2-1-.41-.6-.51-.89.1-.8-.1-1"
          />
          <g class="cls-707">
            <polygon
              class="cls-708"
              points="308.39 457.17 318.65 451.02 325.69 462.43 315.44 468.58 308.39 457.17"
            />
          </g>
          <g class="cls-709">
            <polygon
              class="cls-710"
              points="307.99 451.32 318.65 456.97 312.12 468.68 301.56 463.02 307.99 451.32"
            />
          </g>
          <polygon
            class="cls-58"
            points="312.72 464.81 313.02 465.5 313.52 467.49 314.03 467.49 314.33 465.5 314.53 464.81 312.72 464.81"
          />
          <ellipse class="cls-55" cx="313.83" cy="467.49" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M329.62,461.44a5.2,5.2,0,0,1-.41-.7c-.1-.2.11-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c-.1.19.2.49.2.69s-.2.5-.1.7a3.82,3.82,0,0,1,.4.69c.1.2,0,.5.1.69a4.23,4.23,0,0,0,.5.7c.1.1.31.2.51.39l.1.6h.3l.1-.6c.1-.19.3-.19.5-.39a2.57,2.57,0,0,0,.51-.8c.1-.19-.11-.49,0-.69a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.3-.4.2-.59"
          />
          <polygon
            class="cls-58"
            points="328.11 474.13 328.61 474.13 328.61 472.35 327.91 472.35 328.11 474.13"
          />
          <path
            class="cls-58"
            d="M328.11,464.71c.1-.3.6-.5.7-.79s.1-.8.3-1.09a5.06,5.06,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.51.69.61,1-.21.69-.21,1.19c0,.3.31.69.31,1.09s-.51.69-.51,1,.1.8,0,1.09-.6.5-.8.8-.1.79-.3,1.09a9.34,9.34,0,0,0-1,1c-.3.2-.6.2-.8.5l-.41.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.48,7.48,0,0,1-.5-1.39c0-.29.2-.69.2-1.19,0-.29-.3-.69-.3-1.09s.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M327.91,464.11c-.1-.29-.61-.49-.71-.69s-.1-.69-.3-1a7.26,7.26,0,0,0-.9-.5c-.31-.2-.31-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.3.1.1,0,0,0-.11.1c-.1.29.11.69,0,1.09s-.5.59-.5.89.3.69.3,1-.3.7-.2,1,.4.6.51.9-.11.69.1,1,.6.4.7.69.1.7.3,1a3.54,3.54,0,0,0,1,.8c.3.2.5.2.8.4l.4.69.31-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.6-.5-.89.1-.8-.1-1"
          />
          <g class="cls-711">
            <polygon
              class="cls-712"
              points="323.08 465.8 333.34 459.55 340.38 470.96 330.12 477.11 323.08 465.8"
            />
          </g>
          <g class="cls-713">
            <polygon
              class="cls-714"
              points="322.68 459.85 333.34 465.6 326.8 477.21 316.24 471.55 322.68 459.85"
            />
          </g>
          <polygon
            class="cls-58"
            points="327.4 473.34 327.71 474.13 328.21 476.12 328.71 476.12 329.01 474.03 329.21 473.34 327.4 473.34"
          />
          <ellipse class="cls-55" cx="328.51" cy="476.12" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M395.5,477.6a3.8,3.8,0,0,1-.41-.69c-.1-.2.1-.5-.1-.69s-.4-.3-.5-.6-.1-.5-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.5,1.5,0,0,0-.3.69c-.1.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.1.19.3.19.51.39l.1.6h.3l.1-.6c.1-.2.3-.2.5-.39a9.22,9.22,0,0,0,.5-.8c.1-.2-.1-.49,0-.69a1.5,1.5,0,0,0,.31-.7c.1-.19-.21-.49-.21-.69s.21-.4.21-.6"
          />
          <polygon
            class="cls-58"
            points="393.99 490.3 394.49 490.3 394.39 488.51 393.79 488.61 393.99 490.3"
          />
          <path
            class="cls-58"
            d="M394,480.88c.1-.3.6-.5.7-.8s.1-.79.3-1.09a5.29,5.29,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.19c.1,0,.1.1.1.2.2.3,0,.8.1,1.09s.5.7.6,1-.2.69-.2,1.19c0,.29.3.69.3,1.09s-.5.69-.5,1,.1.79,0,1.09-.6.5-.8.79-.1.8-.3,1.1a7.8,7.8,0,0,0-1,1c-.3.2-.6.2-.8.49l-.41.8-.4-.1.1-.9c-.2-.29-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c0-.3.2-.69.2-1.19,0-.3-.31-.69-.31-1.09s.51-.69.51-1-.3-.8-.1-1.09"
          />
          <path
            class="cls-59"
            d="M393.79,480.28c-.1-.3-.61-.49-.71-.69s-.1-.7-.3-1a7.26,7.26,0,0,0-.9-.5c-.31-.2-.31-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.1s-.5.59-.5.89.3.69.3,1-.3.69-.2,1,.4.6.5.89-.1.7.1,1,.61.39.71.69.1.69.3,1a7.06,7.06,0,0,0,1,.8c.3.19.5.19.8.39l.4.7.3-.1-.1-.8c.1-.29.41-.29.51-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9,0-.69-.1-1"
          />
          <g class="cls-715">
            <polygon
              class="cls-716"
              points="388.86 481.97 399.22 475.82 406.26 487.23 395.9 493.38 388.86 481.97"
            />
          </g>
          <g class="cls-717">
            <polygon
              class="cls-718"
              points="388.56 476.02 399.12 481.77 392.68 493.38 382.12 487.72 388.56 476.02"
            />
          </g>
          <polygon
            class="cls-58"
            points="393.28 489.51 393.58 490.3 393.99 492.28 394.59 492.28 394.79 490.2 395.09 489.51 393.28 489.51"
          />
          <ellipse class="cls-55" cx="394.39" cy="492.28" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M411.19,469.77a4.32,4.32,0,0,1-.41-.7c-.1-.19.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.69-.5.3-.5.6.1.5,0,.69a1.49,1.49,0,0,0-.3.7c-.1.2.2.49.2.69s-.2.5-.1.7a4.21,4.21,0,0,1,.4.69c.1.2,0,.5.1.7a4.57,4.57,0,0,0,.5.69c.1.1.3.2.51.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7s.31-.39.31-.69-.21-.5-.21-.7.31-.39.21-.59"
          />
          <polygon
            class="cls-58"
            points="409.68 482.46 410.28 482.46 410.18 480.68 409.48 480.78 409.68 482.46"
          />
          <path
            class="cls-58"
            d="M409.68,473c.1-.3.6-.49.7-.79s.1-.8.3-1.09a5.36,5.36,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19c0,.3.31.7.31,1.09s-.51.7-.51,1,.1.8,0,1.09-.6.5-.8.8-.1.79-.3,1.09a8.51,8.51,0,0,0-1,1c-.3.2-.6.2-.8.5l-.41.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.65,7.65,0,0,1-.5-1.38c0-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.1s.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M409.48,472.45c-.1-.3-.61-.5-.71-.7s-.1-.69-.3-1-.6-.3-.9-.5-.31-.69-.61-.79c-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.59-.5.89.3.7.3,1-.3.7-.2,1,.4.59.5.89-.1.69.1,1,.61.4.71.69.1.7.3,1a7.74,7.74,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.31-.1-.11-.79c.11-.3.41-.3.51-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.59-.5-.89.1-.7-.1-1"
          />
          <g class="cls-719">
            <polygon
              class="cls-720"
              points="404.65 474.13 414.91 467.98 421.95 479.39 411.69 485.54 404.65 474.13"
            />
          </g>
          <g class="cls-721">
            <polygon
              class="cls-722"
              points="404.25 468.18 414.91 473.93 408.37 485.54 397.81 479.88 404.25 468.18"
            />
          </g>
          <polygon
            class="cls-58"
            points="408.97 481.77 409.27 482.46 409.78 484.45 410.28 484.45 410.58 482.37 410.78 481.67 408.97 481.77"
          />
          <ellipse class="cls-55" cx="410.08" cy="484.45" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M191.93,384.37a3.7,3.7,0,0,1-.41-.7c-.1-.19.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.69-.5.3-.5.6.1.5,0,.69a1.49,1.49,0,0,0-.3.7c0,.3.2.49.2.69s-.2.5-.1.7a3.82,3.82,0,0,1,.4.69c.1.2,0,.5.1.7a4.57,4.57,0,0,0,.5.69c.1.1.3.2.51.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7s.31-.4.31-.69-.21-.5-.21-.7a.55.55,0,0,0,.21-.59"
          />
          <polygon
            class="cls-58"
            points="190.42 397.06 191.02 397.06 190.92 395.38 190.22 395.38 190.42 397.06"
          />
          <path
            class="cls-58"
            d="M190.42,387.64c.1-.3.6-.49.7-.79s.1-.8.3-1.09a5.36,5.36,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19.3.69.3,1.09-.5.7-.5,1,.1.8,0,1.09-.6.5-.8.8-.1.79-.3,1.09a8.51,8.51,0,0,0-1,1c-.3.2-.6.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.65,7.65,0,0,1-.5-1.38c-.11-.3.2-.7.2-1.2s-.31-.69-.31-1.09.51-.69.51-1-.2-.69-.1-1.09"
          />
          <path
            class="cls-59"
            d="M190.22,387.15c-.1-.3-.61-.5-.71-.7s-.1-.69-.3-1a6.76,6.76,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.7.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.61.4.71.69.1.7.3,1a7.12,7.12,0,0,0,1,.79c.3.2.5.2.8.4l.4.69.3-.1-.1-.79c.1-.3.41-.3.51-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.6-.5-.89.1-.7-.1-1"
          />
          <g class="cls-723">
            <polygon
              class="cls-724"
              points="185.39 388.83 195.65 382.58 202.69 393.99 192.43 400.14 185.39 388.83"
            />
          </g>
          <g class="cls-725">
            <polygon
              class="cls-726"
              points="185.09 382.68 195.65 388.43 189.11 400.04 178.55 394.39 185.09 382.68"
            />
          </g>
          <polygon
            class="cls-58"
            points="189.71 396.37 190.12 397.06 190.42 399.05 191.02 399.05 191.32 397.06 191.52 396.37 189.71 396.37"
          />
          <ellipse class="cls-55" cx="190.82" cy="399.05" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M206.51,393.59a4.21,4.21,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.41-.29-.51-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.78.78,0,0,0-.9,0c-.1,0-.1,0-.1.1s-.11.5-.21.7-.5.3-.5.59.1.5,0,.7a1.46,1.46,0,0,0-.3.69c0,.2.2.5.2.7s-.2.49-.1.69a4.35,4.35,0,0,1,.4.7c.1.19,0,.49.1.69a4.12,4.12,0,0,0,.51.69c.1.2.3.2.5.4l.1.6h.3l.1-.6c.1-.2.3-.2.5-.4a6.69,6.69,0,0,0,.51-.79c.1-.2-.1-.5,0-.69a1.49,1.49,0,0,0,.3-.7c.1-.2-.2-.49-.2-.69s.2-.4.2-.6"
          />
          <polygon
            class="cls-58"
            points="205 406.29 205.5 406.29 205.4 404.6 204.8 404.6 205 406.29"
          />
          <path
            class="cls-58"
            d="M205,396.87c.1-.3.6-.5.7-.8s.11-.79.31-1.09a5.81,5.81,0,0,0,1-.59c.3-.2.3-.7.61-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.2.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.51.7.61,1-.2.7-.2,1.19.3.7.3,1.1-.5.69-.5,1,.1.79,0,1.09-.61.49-.81.79-.1.8-.3,1.09a9.48,9.48,0,0,0-1,1c-.3.19-.6.19-.8.49l-.4.79-.41-.09.1-.9c-.2-.29-.5-.39-.5-.69a7.75,7.75,0,0,1-.5-1.39c-.1-.3.2-.69.2-1.19s-.3-.69-.3-1.09.5-.7.5-1-.3-.8-.1-1.09"
          />
          <path
            class="cls-59"
            d="M204.8,396.27c-.1-.3-.6-.5-.7-.69s-.11-.7-.31-1a8.93,8.93,0,0,0-.9-.49c-.3-.2-.3-.7-.6-.8-.11,0-.11,0-.11-.09a1,1,0,0,0-1.2.29.1.1,0,0,0-.1.1c-.1.3.1.7,0,1.09s-.51.6-.51.9.31.69.31,1-.31.69-.21,1,.41.59.51.89-.1.7.1,1,.6.4.7.7.1.69.3,1a7.55,7.55,0,0,0,1,.79c.3.2.5.2.8.4l.41.7.3-.1-.1-.8c.1-.3.4-.3.5-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.7.2-1-.4-.59-.5-.89,0-.69-.1-1"
          />
          <g class="cls-727">
            <polygon
              class="cls-728"
              points="199.87 397.96 210.23 391.81 217.27 403.11 206.91 409.26 199.87 397.96"
            />
          </g>
          <g class="cls-729">
            <polygon
              class="cls-730"
              points="199.57 391.81 210.13 397.56 203.69 409.26 193.13 403.61 199.57 391.81"
            />
          </g>
          <polygon
            class="cls-58"
            points="204.2 405.5 204.6 406.29 205 408.27 205.5 408.27 205.81 406.29 206.11 405.5 204.2 405.5"
          />
          <ellipse class="cls-55" cx="205.4" cy="408.27" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M252.57,418.19a4.68,4.68,0,0,1-.4-.69c-.1-.2.1-.5-.1-.7s-.4-.3-.5-.59-.1-.5-.3-.7c-.1,0-.1,0-.1-.1a.8.8,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.7-.5.29-.5.59.1.5,0,.7a1.42,1.42,0,0,0-.31.69c0,.2.21.5.21.7s-.21.49-.1.69a4.68,4.68,0,0,1,.4.69c.1.2,0,.5.1.7a4.11,4.11,0,0,0,.5.69c.1.1.3.2.5.4l.1.59h.31l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.41,1.41,0,0,0,.3-.69c.1-.2-.2-.5-.2-.69a.56.56,0,0,0,.2-.6"
          />
          <polygon
            class="cls-58"
            points="251.07 430.89 251.57 430.89 251.57 429.2 250.86 429.2 251.07 430.89"
          />
          <path
            class="cls-58"
            d="M251.07,421.46c.1-.29.6-.49.7-.79s.1-.79.3-1.09a5.36,5.36,0,0,0,1-.6c.3-.19.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.3,0,.79.1,1.09s.5.7.6,1-.2.7-.2,1.19.3.7.3,1.09-.5.7-.5,1,.1.79,0,1.09-.6.49-.8.79-.1.79-.31,1.09a10.32,10.32,0,0,0-1,1c-.3.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.69a7.8,7.8,0,0,1-.51-1.39c-.1-.3.2-.7.2-1.19s-.3-.7-.3-1.09.51-.7.51-1-.21-.7-.1-1.1"
          />
          <path
            class="cls-59"
            d="M250.86,421c-.1-.3-.6-.5-.7-.7s-.1-.69-.3-1a5.83,5.83,0,0,0-.91-.49c-.3-.2-.3-.7-.6-.8-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.3.1.69,0,1.09s-.5.6-.5.89.3.7.3,1-.3.69-.2,1,.4.59.5.89-.1.69.1,1,.61.4.71.7.1.69.3,1a6.9,6.9,0,0,0,1,.79c.31.2.51.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.51-.69s.3-1,.4-1.29-.2-.7-.2-1,.3-.69.2-1-.4-.59-.51-.89.11-.69-.1-1"
          />
          <g class="cls-731">
            <polygon
              class="cls-732"
              points="246.04 422.65 256.3 416.4 263.34 427.81 253.08 433.96 246.04 422.65"
            />
          </g>
          <g class="cls-733">
            <polygon
              class="cls-734"
              points="245.63 416.5 256.19 422.26 249.76 433.86 239.2 428.21 245.63 416.5"
            />
          </g>
          <polygon
            class="cls-58"
            points="250.36 430.19 250.66 430.89 251.07 432.87 251.57 432.87 251.97 430.89 252.17 430.19 250.36 430.19"
          />
          <ellipse class="cls-55" cx="251.47" cy="432.87" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M268.87,426.13a4.35,4.35,0,0,1-.4-.7c-.11-.2.1-.49-.11-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.49-.2.69-.5.3-.5.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c-.1.19.2.49.2.69s-.2.5-.1.69a4.35,4.35,0,0,1,.4.7c.1.2,0,.49.1.69a4.23,4.23,0,0,0,.5.7c.11.2.31.2.51.39l.1.6h.3l.1-.6c.1-.19.3-.19.5-.39s.51-.7.51-.8-.1-.49,0-.69a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.2-.3.2-.59"
          />
          <polygon
            class="cls-58"
            points="267.36 438.92 267.86 438.92 267.76 437.14 267.16 437.14 267.36 438.92"
          />
          <path
            class="cls-58"
            d="M267.36,429.4c.1-.3.6-.5.7-.79s.1-.8.3-1.1a4.57,4.57,0,0,0,1-.59c.3-.2.3-.7.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.19.2.3,0,.8.1,1.1s.51.69.61,1-.2.69-.2,1.19c0,.3.3.69.3,1.09s-.51.69-.51,1,.1.79,0,1.09-.6.5-.8.8-.1.79-.3,1.09a9.34,9.34,0,0,0-1,1c-.3.2-.6.2-.8.49l-.41.8-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.75,7.75,0,0,1-.5-1.39c-.1-.29.2-.69.2-1.19,0-.29-.3-.69-.3-1.09s.5-.69.5-1-.3-.69-.1-1.09"
          />
          <path
            class="cls-59"
            d="M267.16,429c-.1-.3-.61-.49-.71-.69s-.1-.7-.3-1a7.26,7.26,0,0,0-.9-.5c-.3-.2-.3-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.29.1.1,0,0,0-.1.1c-.11.3.1.7,0,1.1s-.51.59-.51.89.3.69.3,1-.3.69-.2,1,.41.6.51.89-.1.7.1,1,.6.39.7.69.1.69.3,1a7.06,7.06,0,0,0,1,.8c.3.19.5.19.8.39l.41.7.3-.1-.1-.8c.1-.29.4-.29.5-.69s.3-1,.4-1.29-.2-.69-.2-1,.3-.7.2-1-.4-.6-.5-.9,0-.79-.1-1"
          />
          <g class="cls-735">
            <polygon
              class="cls-736"
              points="262.23 430.59 272.59 424.44 279.63 435.85 269.27 442 262.23 430.59"
            />
          </g>
          <g class="cls-737">
            <polygon
              class="cls-738"
              points="261.93 424.74 272.49 430.39 266.05 442.1 255.49 436.44 261.93 424.74"
            />
          </g>
          <polygon
            class="cls-58"
            points="266.65 438.13 266.96 438.92 267.36 440.81 267.96 440.81 268.16 438.92 268.47 438.13 266.65 438.13"
          />
          <ellipse class="cls-55" cx="267.76" cy="440.81" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M222.9,401.43a4.35,4.35,0,0,1-.4-.7c-.1-.19.1-.49-.1-.69s-.4-.3-.5-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.69-.5.3-.5.6.1.5,0,.69a1.5,1.5,0,0,0-.31.7c-.1.2.21.49.21.69s-.21.5-.11.7a3.59,3.59,0,0,1,.41.69c.1.2,0,.5.1.7a4.57,4.57,0,0,0,.5.69c.1.1.3.2.5.4l.1.59h.31l.1-.59c.1-.2.3-.2.5-.4a9.28,9.28,0,0,0,.5-.79c.1-.2-.1-.5,0-.7a1.46,1.46,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7a.55.55,0,0,0,.2-.59"
          />
          <polygon
            class="cls-58"
            points="221.4 414.12 222 414.12 221.9 412.44 221.19 412.44 221.4 414.12"
          />
          <path
            class="cls-58"
            d="M221.39,404.7c.11-.3.61-.49.71-.79s.1-.8.3-1.09a5.7,5.7,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.5.69.6,1-.2.69-.2,1.19c0,.3.3.69.3,1.09s-.5.7-.5,1,.1.8,0,1.09-.6.5-.8.8-.11.79-.31,1.09a9.29,9.29,0,0,0-1,1c-.3.2-.61.2-.81.5l-.4.79-.4-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.71,7.71,0,0,1-.51-1.38c-.1-.3.2-.7.2-1.19,0-.3-.3-.7-.3-1.1s.51-.69.51-1-.21-.79-.11-1.09"
          />
          <path
            class="cls-59"
            d="M221.19,404.21c-.1-.3-.6-.5-.7-.7s-.1-.69-.3-1a7.44,7.44,0,0,0-.91-.5c-.3-.2-.3-.69-.6-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.21.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.5.59-.5.89.3.7.3,1-.3.7-.2,1,.4.6.5.9-.1.69.1,1,.61.4.71.69.1.7.3,1a3.64,3.64,0,0,0,1,.79c.31.2.51.2.81.4l.4.69.3-.1-.1-.79c.1-.3.4-.3.5-.7s.31-1,.41-1.29-.2-.69-.2-1,.3-.69.2-1-.41-.6-.51-.89.1-.7-.1-1"
          />
          <g class="cls-739">
            <polygon
              class="cls-740"
              points="216.37 405.89 226.63 399.74 233.66 411.15 223.41 417.3 216.37 405.89"
            />
          </g>
          <g class="cls-741">
            <polygon
              class="cls-742"
              points="216.06 399.94 226.63 405.59 220.09 417.3 209.53 411.64 216.06 399.94"
            />
          </g>
          <polygon
            class="cls-58"
            points="220.69 413.43 220.99 414.12 221.5 416.11 222 416.11 222.3 414.12 222.5 413.43 220.69 413.43"
          />
          <ellipse class="cls-55" cx="221.8" cy="416.11" rx="3.82" ry="1.69" />
          <path
            class="cls-57"
            d="M237.59,410.06a4.35,4.35,0,0,1-.4-.7c-.1-.2.1-.49-.1-.69s-.41-.3-.51-.6-.1-.49-.3-.69c-.1,0-.1,0-.1-.1a.77.77,0,0,0-.91,0c-.1,0-.1,0-.1.1s-.1.5-.2.69-.5.3-.5.6.1.49,0,.69a1.49,1.49,0,0,0-.3.7c-.1.2.2.49.2.69s-.2.5-.1.7a3.82,3.82,0,0,1,.4.69c.1.2,0,.5.1.69a4.23,4.23,0,0,0,.5.7c.11.2.31.2.51.4l.1.59h.3l.1-.59c.1-.2.3-.2.5-.4s.51-.7.51-.79-.1-.5,0-.7a1.5,1.5,0,0,0,.3-.69c.1-.2-.2-.5-.2-.7s.3-.39.2-.59"
          />
          <polygon
            class="cls-58"
            points="236.08 422.75 236.68 422.75 236.58 420.97 235.88 421.07 236.08 422.75"
          />
          <path
            class="cls-58"
            d="M236.08,413.33c.1-.3.6-.5.7-.79s.1-.8.31-1.09a5.3,5.3,0,0,0,1-.6c.3-.2.3-.69.6-1a.1.1,0,0,0,.1-.1,1,1,0,0,1,1.21.2c.1,0,.1.1.1.2.2.29,0,.79.1,1.09s.51.69.61,1-.2.69-.2,1.19c0,.3.3.69.3,1.09s-.51.7-.51,1,.1.8,0,1.09-.6.5-.8.8-.1.79-.3,1.09a9.34,9.34,0,0,0-1,1c-.3.2-.6.2-.8.5l-.4.79-.41-.1.1-.89c-.2-.3-.5-.4-.5-.7a7.48,7.48,0,0,1-.5-1.39c0-.29.2-.69.2-1.19,0-.29-.3-.69-.3-1.09s.5-.69.5-1-.2-.79-.1-1.09"
          />
          <path
            class="cls-59"
            d="M235.88,412.74c-.1-.3-.61-.5-.71-.7s-.1-.69-.3-1a7.26,7.26,0,0,0-.9-.5c-.3-.2-.3-.69-.61-.79-.1,0-.1,0-.1-.1a1,1,0,0,0-1.2.3.1.1,0,0,0-.1.1c-.1.29.1.69,0,1.09s-.51.59-.51.89.3.7.3,1-.3.7-.2,1,.41.6.51.9-.1.69.1,1,.6.4.7.69.1.7.3,1a7.74,7.74,0,0,0,1,.79c.3.2.5.2.8.4l.41.69.3-.1-.1-.79c.1-.3.4-.3.5-.7s.3-1,.4-1.29-.2-.69-.2-1,.3-.69.2-1-.4-.6-.5-.89.1-.7-.1-1"
          />
          <g class="cls-743">
            <polygon
              class="cls-744"
              points="231.05 414.52 241.31 408.27 248.35 419.68 238.09 425.83 231.05 414.52"
            />
          </g>
          <g class="cls-745">
            <polygon
              class="cls-746"
              points="230.65 408.47 241.31 414.22 234.77 425.83 224.21 420.17 230.65 408.47"
            />
          </g>
          <polygon
            class="cls-58"
            points="235.38 422.06 235.68 422.75 236.18 424.74 236.68 424.74 236.99 422.65 237.19 421.96 235.38 422.06"
          />
          <ellipse class="cls-55" cx="236.48" cy="424.74" rx="3.82" ry="1.69" />
          <polygon
            class="cls-54"
            points="375.08 510.73 375.08 517.58 172.82 402.32 172.82 395.58 375.08 510.73"
          />
          <polygon
            class="cls-54"
            points="377.19 562.21 377.19 570.15 174.83 454.89 174.83 448.14 377.19 562.21"
          />
          <polygon
            class="cls-54"
            points="172.82 376.73 377.89 493.67 377.89 487.82 172.82 372.27 172.82 376.73"
          />
          <polygon
            class="cls-54"
            points="375.08 535.53 375.08 542.37 172.82 427.12 172.82 420.37 375.08 535.53"
          />
          <polygon
            class="cls-747"
            points="428.18 461.93 425.37 460.35 425.37 560.13 428.18 562.31 428.18 461.93"
          />
          <polygon
            class="cls-229"
            points="377.89 487.82 377.89 492.48 431 466.1 431 460.44 377.89 487.82"
          />
          <polygon
            class="cls-229"
            points="428.18 562.61 431 560.72 431 460.35 428.18 461.93 428.18 562.61"
          />
          <polygon
            class="cls-747"
            points="172.82 372.27 170.1 370.78 170.1 470.26 172.82 472.55 172.82 372.27"
          />
          <polygon
            class="cls-229"
            points="377.89 588 380.71 585.92 381.21 486.13 377.89 487.82 377.89 588"
          />
          <polygon
            class="cls-747"
            points="377.89 487.82 375.08 486.23 375.08 585.82 377.89 588 377.89 487.82"
          />
          <polygon
            class="cls-229"
            points="172.82 472.55 175.63 470.36 175.63 373.9 172.82 372.27 172.82 472.55"
          />
          <polygon
            class="cls-40"
            points="170.1 370.78 377.89 487.82 431 460.44 221.5 343.8 170.1 370.78"
          />
          <g class="cls-748">
            <polygon
              class="cls-13"
              points="867.17 362.86 775.55 415.76 775.55 241.91 867.17 189.01 867.17 362.86"
            />
          </g>
          <path
            class="cls-14"
            d="M772.26,413.9a1.23,1.23,0,0,1-.62-.17,1.25,1.25,0,0,1-.63-1.08V240.39a1.26,1.26,0,0,1,.63-1.09l91.62-52.9a1.26,1.26,0,0,1,1.88,1.09V359.75a1.25,1.25,0,0,1-.63,1.08l-91.62,52.9A1.29,1.29,0,0,1,772.26,413.9Zm1.25-172.79V410.48L862.64,359V189.65Zm90.38,118.64h0Z"
          />
          <path
            class="cls-15"
            d="M776.29,418.46a3.12,3.12,0,0,1-3.12-3.13V243.07a3.1,3.1,0,0,1,1.56-2.7l91.62-52.9a3.13,3.13,0,0,1,4.69,2.7V362.43a3.14,3.14,0,0,1-1.56,2.71L777.85,418A3.1,3.1,0,0,1,776.29,418.46Zm3.12-173.58v165l85.38-49.29v-165Zm88.51,117.55h0Z"
          />
          <g id="FanFlow">
            <path
              class="cls-749"
              d="M585.7,237.5l22.7-7.8a14.06,14.06,0,0,1,16.3,5.8h0a12.53,12.53,0,0,1-5.1,17.7L600,262.8Z"
            />
            <path
              class="cls-750"
              d="M591.8,262.6c-5.7-3.3-10.3-11.3-10.3-17.9s4.6-9.3,10.3-5.9,10.3,11.3,10.3,17.9S597.6,265.9,591.8,262.6Z"
            />
            <path
              class="cls-751"
              d="M589.2,239.3h0l-.4.2v.1l-.1.1c-1.7,2.4,1.4,7,1.4,7s3.7,2.5,3.8,2.3c.7-1.2,2.1-.8,3-1h0l.2-.1a.52.52,0,0,0,.2-.4C598.3,244,591.6,238,589.2,239.3Z"
            />
            <path
              class="cls-752"
              d="M589.8,246.9s-3.1-4.8-1.4-7c1.8-2.6,9.6,4,8.9,7.8-.2,1.2-2.5-.2-3.6,1.4C593.5,249.4,589.8,246.9,589.8,246.9Z"
            />
            <path
              class="cls-751"
              d="M592.1,253.2s-1.7-4.8-2-4.9c-2.3-1.2-3.3-4.2-4.5-4.3a1.72,1.72,0,0,0-.8.1l-.4.2v.1c-1.5,1.9.7,9.6,3.8,11.3a2.6,2.6,0,0,0,2,.4h0l.4-.2C591.8,255.2,592.1,253.2,592.1,253.2Z"
            />
            <path
              class="cls-752"
              d="M591.8,253.5s-.5,4.3-3.8,2.5c-3.7-2-6.2-12.2-2.7-11.8,1.1.1,2.3,3.1,4.5,4.3C590.2,248.7,591.8,253.5,591.8,253.5Z"
            />
            <path
              class="cls-751"
              d="M595.2,250.6s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1-.2-.4.7-2.4,1.2-3.1Z"
            />
            <path
              class="cls-752"
              d="M594.9,250.8s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1C593.2,253.5,594.9,250.8,594.9,250.8Z"
            />
            <path
              class="cls-753"
              d="M595.4,252.3c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.45,7.45,0,0,1,595.4,252.3Z"
            />
            <polygon
              class="cls-753"
              points="589.9 246.5 589.4 246.7 589.6 247.2 590.3 246.9 589.9 246.5"
            />
            <polygon
              class="cls-753"
              points="594 254.8 594.6 254.4 594.1 253.3 593.6 253.7 594 254.8"
            />
            <path
              class="cls-754"
              d="M594.9,252.6c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.14,7.14,0,0,1,594.9,252.6Z"
            />
            <polygon
              class="cls-40"
              points="583.2 240.2 583 240.2 583.6 240.8 600.1 250.1 600.9 250.5 601 250.5 583.2 240.2"
            />
            <polygon
              class="cls-755"
              points="600.1 250.4 583.6 241 583.6 240.8 600.1 250.1 600.1 250.4"
            />
            <polygon
              class="cls-754"
              points="600.9 250.7 600.1 250.4 600.1 250.1 600.9 250.5 600.9 250.7"
            />
            <polygon
              class="cls-754"
              points="583.6 241 583 240.4 583 240.2 583.6 240.8 583.6 241"
            />
            <polygon
              class="cls-753"
              points="601 250.7 600.9 250.7 600.9 250.5 601 250.5 601 250.7"
            />
            <polygon
              class="cls-40"
              points="581.9 248 581.7 248.1 582.5 248.6 600.5 259 601.5 259.4 601.5 259.4 581.9 248"
            />
            <polygon
              class="cls-755"
              points="600.5 259.3 582.5 248.8 582.5 248.6 600.5 259 600.5 259.3"
            />
            <polygon
              class="cls-754"
              points="601.5 259.6 600.5 259.3 600.5 259 601.5 259.4 601.5 259.6"
            />
            <polygon
              class="cls-754"
              points="582.5 248.8 581.7 248.4 581.7 248.1 582.5 248.6 582.5 248.8"
            />
            <polygon
              class="cls-40"
              points="583.6 253.3 583.5 253.3 584.1 253.8 598.5 262.1 599.3 262.5 599.5 262.5 583.6 253.3"
            />
            <polygon
              class="cls-755"
              points="598.5 262.4 584.1 254.1 584.1 253.8 598.5 262.1 598.5 262.4"
            />
            <polygon
              class="cls-754"
              points="599.3 262.7 598.5 262.4 598.5 262.1 599.3 262.5 599.3 262.7"
            />
            <polygon
              class="cls-754"
              points="584.1 254.1 583.5 253.6 583.5 253.3 584.1 253.8 584.1 254.1"
            />
            <polygon
              class="cls-753"
              points="599.5 262.7 599.3 262.7 599.3 262.5 599.5 262.5 599.5 262.7"
            />
            <polygon
              class="cls-40"
              points="581.7 243.6 581.6 243.7 582.3 244.2 601 255 601.8 255.4 602 255.4 581.7 243.6"
            />
            <polygon
              class="cls-755"
              points="601 255.2 582.3 244.4 582.3 244.2 601 255 601 255.2"
            />
            <polygon
              class="cls-754"
              points="601.8 255.6 601 255.2 601 255 601.8 255.4 601.8 255.6"
            />
            <polygon
              class="cls-754"
              points="582.3 244.4 581.6 244 581.6 243.7 582.3 244.2 582.3 244.4"
            />
            <polygon
              class="cls-753"
              points="602 255.6 601.8 255.6 601.8 255.4 602 255.4 602 255.6"
            />
            <path
              class="cls-756"
              d="M596,237.8h0a1.08,1.08,0,0,1-.8-1.1l.5-3.7a.67.67,0,0,1,.5-.7l7.6-3.4a1.15,1.15,0,0,1,1,.1l2.4,2c.4.4.5,1,.1,1.3h0c-.4.4-1,.5-1.3.1l-1.4-1.3a1.1,1.1,0,0,0-1-.1l-5.6,2.5a.94.94,0,0,0-.5.7l-.4,2.6C597,237.5,596.5,237.9,596,237.8Z"
            />
            <path
              class="cls-749"
              d="M374.7,355.5l22.7-7.8a14.06,14.06,0,0,1,16.3,5.8h0a12.53,12.53,0,0,1-5.1,17.7L389,380.8Z"
            />
            <path
              class="cls-750"
              d="M380.8,380.6c-5.7-3.3-10.3-11.3-10.3-17.9s4.6-9.3,10.3-5.9,10.3,11.3,10.3,17.9S386.6,383.9,380.8,380.6Z"
            />
            <path
              class="cls-751"
              d="M378.2,357.3h0l-.4.2v.1l-.1.1c-1.7,2.4,1.4,7,1.4,7s3.7,2.5,3.8,2.3c.7-1.2,2.1-.8,3-1h0l.2-.1a.52.52,0,0,0,.2-.4C387.3,362,380.6,356,378.2,357.3Z"
            />
            <path
              class="cls-752"
              d="M378.8,364.9s-3.1-4.8-1.4-7c1.8-2.6,9.6,4,8.9,7.8-.2,1.2-2.5-.2-3.6,1.4C382.5,367.4,378.8,364.9,378.8,364.9Z"
            />
            <path
              class="cls-751"
              d="M381.1,371.2s-1.7-4.8-2-4.9c-2.3-1.2-3.3-4.2-4.5-4.3a1.72,1.72,0,0,0-.8.1l-.4.2v.1c-1.5,1.9.7,9.6,3.8,11.3a2.6,2.6,0,0,0,2,.4h0l.4-.2C380.8,373.2,381.1,371.2,381.1,371.2Z"
            />
            <path
              class="cls-752"
              d="M380.8,371.5s-.5,4.3-3.8,2.5c-3.7-2-6.2-12.2-2.7-11.8,1.1.1,2.3,3.1,4.5,4.3C379.2,366.7,380.8,371.5,380.8,371.5Z"
            />
            <path
              class="cls-751"
              d="M384.2,368.6s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1-.2-.4.7-2.4,1.2-3.1Z"
            />
            <path
              class="cls-752"
              d="M383.9,368.8s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1C382.2,371.5,383.9,368.8,383.9,368.8Z"
            />
            <path
              class="cls-753"
              d="M384.4,370.3c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.45,7.45,0,0,1,384.4,370.3Z"
            />
            <polygon
              class="cls-753"
              points="378.9 364.5 378.4 364.7 378.6 365.2 379.3 364.9 378.9 364.5"
            />
            <polygon
              class="cls-753"
              points="383 372.8 383.6 372.4 383.1 371.3 382.6 371.7 383 372.8"
            />
            <path
              class="cls-754"
              d="M383.9,370.6c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.14,7.14,0,0,1,383.9,370.6Z"
            />
            <polygon
              class="cls-40"
              points="372.2 358.2 372 358.2 372.6 358.8 389.1 368.1 389.9 368.5 390 368.5 372.2 358.2"
            />
            <polygon
              class="cls-755"
              points="389.1 368.4 372.6 359 372.6 358.8 389.1 368.1 389.1 368.4"
            />
            <polygon
              class="cls-754"
              points="389.9 368.7 389.1 368.4 389.1 368.1 389.9 368.5 389.9 368.7"
            />
            <polygon
              class="cls-754"
              points="372.6 359 372 358.4 372 358.2 372.6 358.8 372.6 359"
            />
            <polygon
              class="cls-753"
              points="390 368.7 389.9 368.7 389.9 368.5 390 368.5 390 368.7"
            />
            <polygon
              class="cls-40"
              points="370.9 366 370.7 366.1 371.5 366.6 389.5 377 390.5 377.4 390.5 377.4 370.9 366"
            />
            <polygon
              class="cls-755"
              points="389.5 377.3 371.5 366.8 371.5 366.6 389.5 377 389.5 377.3"
            />
            <polygon
              class="cls-754"
              points="390.5 377.6 389.5 377.3 389.5 377 390.5 377.4 390.5 377.6"
            />
            <polygon
              class="cls-754"
              points="371.5 366.8 370.7 366.4 370.7 366.1 371.5 366.6 371.5 366.8"
            />
            <polygon
              class="cls-40"
              points="372.6 371.3 372.5 371.3 373.1 371.8 387.5 380.1 388.3 380.5 388.5 380.5 372.6 371.3"
            />
            <polygon
              class="cls-755"
              points="387.5 380.4 373.1 372.1 373.1 371.8 387.5 380.1 387.5 380.4"
            />
            <polygon
              class="cls-754"
              points="388.3 380.7 387.5 380.4 387.5 380.1 388.3 380.5 388.3 380.7"
            />
            <polygon
              class="cls-754"
              points="373.1 372.1 372.5 371.6 372.5 371.3 373.1 371.8 373.1 372.1"
            />
            <polygon
              class="cls-753"
              points="388.5 380.7 388.3 380.7 388.3 380.5 388.5 380.5 388.5 380.7"
            />
            <polygon
              class="cls-40"
              points="370.7 361.6 370.6 361.7 371.3 362.2 390 373 390.8 373.4 391 373.4 370.7 361.6"
            />
            <polygon
              class="cls-755"
              points="390 373.2 371.3 362.4 371.3 362.2 390 373 390 373.2"
            />
            <polygon
              class="cls-754"
              points="390.8 373.6 390 373.2 390 373 390.8 373.4 390.8 373.6"
            />
            <polygon
              class="cls-754"
              points="371.3 362.4 370.6 362 370.6 361.7 371.3 362.2 371.3 362.4"
            />
            <polygon
              class="cls-753"
              points="391 373.6 390.8 373.6 390.8 373.4 391 373.4 391 373.6"
            />
            <path
              class="cls-756"
              d="M385,355.8h0a1.08,1.08,0,0,1-.8-1.1l.5-3.7a.67.67,0,0,1,.5-.7l7.6-3.4a1.15,1.15,0,0,1,1,.1l2.4,2c.4.4.5,1,.1,1.3h0c-.4.4-1,.5-1.3.1l-1.4-1.3a1.1,1.1,0,0,0-1-.1l-5.6,2.5a.94.94,0,0,0-.5.7l-.4,2.6C386,355.5,385.5,355.9,385,355.8Z"
            />
            <path
              class="cls-749"
              d="M403.7,213.5l22.7-7.8a14.06,14.06,0,0,1,16.3,5.8h0a12.53,12.53,0,0,1-5.1,17.7L418,238.8Z"
            />
            <path
              class="cls-750"
              d="M409.8,238.6c-5.7-3.3-10.3-11.3-10.3-17.9s4.6-9.3,10.3-5.9,10.3,11.3,10.3,17.9S415.6,241.9,409.8,238.6Z"
            />
            <path
              class="cls-751"
              d="M407.2,215.3h0l-.4.2v.1l-.1.1c-1.7,2.4,1.4,7,1.4,7s3.7,2.5,3.8,2.3c.7-1.2,2.1-.8,3-1h0l.2-.1a.52.52,0,0,0,.2-.4C416.3,220,409.6,214,407.2,215.3Z"
            />
            <path
              class="cls-752"
              d="M407.8,222.9s-3.1-4.8-1.4-7c1.8-2.6,9.6,4,8.9,7.8-.2,1.2-2.5-.2-3.6,1.4C411.5,225.4,407.8,222.9,407.8,222.9Z"
            />
            <path
              class="cls-751"
              d="M410.1,229.2s-1.7-4.8-2-4.9c-2.3-1.2-3.3-4.2-4.5-4.3a1.72,1.72,0,0,0-.8.1l-.4.2v.1c-1.5,1.9.7,9.6,3.8,11.3a2.6,2.6,0,0,0,2,.4h0l.4-.2C409.8,231.2,410.1,229.2,410.1,229.2Z"
            />
            <path
              class="cls-752"
              d="M409.8,229.5s-.5,4.3-3.8,2.5c-3.7-2-6.2-12.2-2.7-11.8,1.1.1,2.3,3.1,4.5,4.3C408.2,224.7,409.8,229.5,409.8,229.5Z"
            />
            <path
              class="cls-751"
              d="M413.2,226.6s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1-.2-.4.7-2.4,1.2-3.1Z"
            />
            <path
              class="cls-752"
              d="M412.9,226.8s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1C411.2,229.5,412.9,226.8,412.9,226.8Z"
            />
            <path
              class="cls-753"
              d="M413.4,228.3c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.45,7.45,0,0,1,413.4,228.3Z"
            />
            <polygon
              class="cls-753"
              points="407.9 222.5 407.4 222.7 407.6 223.2 408.3 222.9 407.9 222.5"
            />
            <polygon
              class="cls-753"
              points="412 230.8 412.6 230.4 412.1 229.3 411.6 229.7 412 230.8"
            />
            <path
              class="cls-754"
              d="M412.9,228.6c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.14,7.14,0,0,1,412.9,228.6Z"
            />
            <polygon
              class="cls-40"
              points="401.2 216.2 401 216.2 401.6 216.8 418.1 226.1 418.9 226.5 419 226.5 401.2 216.2"
            />
            <polygon
              class="cls-755"
              points="418.1 226.4 401.6 217 401.6 216.8 418.1 226.1 418.1 226.4"
            />
            <polygon
              class="cls-754"
              points="418.9 226.7 418.1 226.4 418.1 226.1 418.9 226.5 418.9 226.7"
            />
            <polygon
              class="cls-754"
              points="401.6 217 401 216.4 401 216.2 401.6 216.8 401.6 217"
            />
            <polygon
              class="cls-753"
              points="419 226.7 418.9 226.7 418.9 226.5 419 226.5 419 226.7"
            />
            <polygon
              class="cls-40"
              points="399.9 224 399.7 224.1 400.5 224.6 418.5 235 419.5 235.4 419.5 235.4 399.9 224"
            />
            <polygon
              class="cls-755"
              points="418.5 235.3 400.5 224.8 400.5 224.6 418.5 235 418.5 235.3"
            />
            <polygon
              class="cls-754"
              points="419.5 235.6 418.5 235.3 418.5 235 419.5 235.4 419.5 235.6"
            />
            <polygon
              class="cls-754"
              points="400.5 224.8 399.7 224.4 399.7 224.1 400.5 224.6 400.5 224.8"
            />
            <polygon
              class="cls-40"
              points="401.6 229.3 401.5 229.3 402.1 229.8 416.5 238.1 417.3 238.5 417.5 238.5 401.6 229.3"
            />
            <polygon
              class="cls-755"
              points="416.5 238.4 402.1 230.1 402.1 229.8 416.5 238.1 416.5 238.4"
            />
            <polygon
              class="cls-754"
              points="417.3 238.7 416.5 238.4 416.5 238.1 417.3 238.5 417.3 238.7"
            />
            <polygon
              class="cls-754"
              points="402.1 230.1 401.5 229.6 401.5 229.3 402.1 229.8 402.1 230.1"
            />
            <polygon
              class="cls-753"
              points="417.5 238.7 417.3 238.7 417.3 238.5 417.5 238.5 417.5 238.7"
            />
            <polygon
              class="cls-40"
              points="399.7 219.6 399.6 219.7 400.3 220.2 419 231 419.8 231.4 420 231.4 399.7 219.6"
            />
            <polygon
              class="cls-755"
              points="419 231.2 400.3 220.4 400.3 220.2 419 231 419 231.2"
            />
            <polygon
              class="cls-754"
              points="419.8 231.6 419 231.2 419 231 419.8 231.4 419.8 231.6"
            />
            <polygon
              class="cls-754"
              points="400.3 220.4 399.6 220 399.6 219.7 400.3 220.2 400.3 220.4"
            />
            <polygon
              class="cls-753"
              points="420 231.6 419.8 231.6 419.8 231.4 420 231.4 420 231.6"
            />
            <path
              class="cls-756"
              d="M414,213.8h0a1.08,1.08,0,0,1-.8-1.1l.5-3.7a.67.67,0,0,1,.5-.7l7.6-3.4a1.15,1.15,0,0,1,1,.1l2.4,2c.4.4.5,1,.1,1.3h0c-.4.4-1,.5-1.3.1l-1.4-1.3a1.1,1.1,0,0,0-1-.1l-5.6,2.5a.94.94,0,0,0-.5.7l-.4,2.6C415,213.5,414.5,213.9,414,213.8Z"
            />
            <path
              class="cls-749"
              d="M593.69,354.08l22.7-7.8a14.06,14.06,0,0,1,16.3,5.8h0a12.53,12.53,0,0,1-5.1,17.7l-19.6,9.6Z"
            />
            <path
              class="cls-750"
              d="M599.79,379.18c-5.7-3.3-10.3-11.3-10.3-17.9s4.6-9.3,10.3-5.9,10.3,11.3,10.3,17.9S605.59,382.48,599.79,379.18Z"
            />
            <path
              class="cls-751"
              d="M597.19,355.88h0l-.4.2v.1l-.1.1c-1.7,2.4,1.4,7,1.4,7s3.7,2.5,3.8,2.3c.7-1.2,2.1-.8,3-1h0l.2-.1a.52.52,0,0,0,.2-.4C606.29,360.58,599.59,354.58,597.19,355.88Z"
            />
            <path
              class="cls-752"
              d="M597.79,363.48s-3.1-4.8-1.4-7c1.8-2.6,9.6,4,8.9,7.8-.2,1.2-2.5-.2-3.6,1.4C601.49,366,597.79,363.48,597.79,363.48Z"
            />
            <path
              class="cls-751"
              d="M600.09,369.78s-1.7-4.8-2-4.9c-2.3-1.2-3.3-4.2-4.5-4.3a1.72,1.72,0,0,0-.8.1l-.4.2v.1c-1.5,1.9.7,9.6,3.8,11.3a2.6,2.6,0,0,0,2,.4h0l.4-.2C599.79,371.78,600.09,369.78,600.09,369.78Z"
            />
            <path
              class="cls-752"
              d="M599.79,370.08s-.5,4.3-3.8,2.5c-3.7-2-6.2-12.2-2.7-11.8,1.1.1,2.3,3.1,4.5,4.3C598.19,365.28,599.79,370.08,599.79,370.08Z"
            />
            <path
              class="cls-751"
              d="M603.19,367.18s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1-.2-.4.7-2.4,1.2-3.1Z"
            />
            <path
              class="cls-752"
              d="M602.89,367.38s3.6,0,5.5,4.2c2.1,4.6-2.6,9.3-5.7,5-1-1.3,0-3.2-1.3-6.1C601.19,370.08,602.89,367.38,602.89,367.38Z"
            />
            <path
              class="cls-753"
              d="M603.39,368.88c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.45,7.45,0,0,1,603.39,368.88Z"
            />
            <polygon
              class="cls-753"
              points="597.89 363.08 597.39 363.28 597.59 363.78 598.29 363.48 597.89 363.08"
            />
            <polygon
              class="cls-753"
              points="601.99 371.38 602.59 370.98 602.09 369.88 601.59 370.28 601.99 371.38"
            />
            <path
              class="cls-754"
              d="M602.89,369.18c0,2.1-1.4,3-3.3,1.9a7.41,7.41,0,0,1-3.3-5.7c0-2.1,1.4-3,3.3-1.9A7.14,7.14,0,0,1,602.89,369.18Z"
            />
            <polygon
              class="cls-40"
              points="591.19 356.78 590.99 356.78 591.59 357.38 608.09 366.68 608.89 367.08 608.99 367.08 591.19 356.78"
            />
            <polygon
              class="cls-755"
              points="608.09 366.98 591.59 357.58 591.59 357.38 608.09 366.68 608.09 366.98"
            />
            <polygon
              class="cls-754"
              points="608.89 367.28 608.09 366.98 608.09 366.68 608.89 367.08 608.89 367.28"
            />
            <polygon
              class="cls-754"
              points="591.59 357.58 590.99 356.98 590.99 356.78 591.59 357.38 591.59 357.58"
            />
            <polygon
              class="cls-753"
              points="608.99 367.28 608.89 367.28 608.89 367.08 608.99 367.08 608.99 367.28"
            />
            <polygon
              class="cls-40"
              points="589.89 364.58 589.69 364.68 590.49 365.18 608.49 375.58 609.49 375.98 609.49 375.98 589.89 364.58"
            />
            <polygon
              class="cls-755"
              points="608.49 375.88 590.49 365.38 590.49 365.18 608.49 375.58 608.49 375.88"
            />
            <polygon
              class="cls-754"
              points="609.49 376.18 608.49 375.88 608.49 375.58 609.49 375.98 609.49 376.18"
            />
            <polygon
              class="cls-754"
              points="590.49 365.38 589.69 364.98 589.69 364.68 590.49 365.18 590.49 365.38"
            />
            <polygon
              class="cls-40"
              points="591.59 369.88 591.49 369.88 592.09 370.38 606.49 378.68 607.29 379.08 607.49 379.08 591.59 369.88"
            />
            <polygon
              class="cls-755"
              points="606.49 378.98 592.09 370.68 592.09 370.38 606.49 378.68 606.49 378.98"
            />
            <polygon
              class="cls-754"
              points="607.29 379.28 606.49 378.98 606.49 378.68 607.29 379.08 607.29 379.28"
            />
            <polygon
              class="cls-754"
              points="592.09 370.68 591.49 370.18 591.49 369.88 592.09 370.38 592.09 370.68"
            />
            <polygon
              class="cls-753"
              points="607.49 379.28 607.29 379.28 607.29 379.08 607.49 379.08 607.49 379.28"
            />
            <polygon
              class="cls-40"
              points="589.69 360.18 589.59 360.28 590.29 360.78 608.99 371.58 609.79 371.98 609.99 371.98 589.69 360.18"
            />
            <polygon
              class="cls-755"
              points="608.99 371.78 590.29 360.98 590.29 360.78 608.99 371.58 608.99 371.78"
            />
            <polygon
              class="cls-754"
              points="609.79 372.18 608.99 371.78 608.99 371.58 609.79 371.98 609.79 372.18"
            />
            <polygon
              class="cls-754"
              points="590.29 360.98 589.59 360.58 589.59 360.28 590.29 360.78 590.29 360.98"
            />
            <polygon
              class="cls-753"
              points="609.99 372.18 609.79 372.18 609.79 371.98 609.99 371.98 609.99 372.18"
            />
            <path
              class="cls-756"
              d="M604,354.38h0a1.08,1.08,0,0,1-.8-1.1l.5-3.7a.67.67,0,0,1,.5-.7l7.6-3.4a1.15,1.15,0,0,1,1,.1l2.4,2c.4.4.5,1,.1,1.3h0c-.4.4-1,.5-1.3.1l-1.4-1.3a1.1,1.1,0,0,0-1-.1l-5.6,2.5a.94.94,0,0,0-.5.7l-.4,2.6C605,354.08,604.49,354.48,604,354.38Z"
            />
          </g>
          <g class="cls-7">
            <path
              class="cls-5"
              d="M728.58,131.9l0,9.18a6.12,6.12,0,0,0,0,.76h0a3.31,3.31,0,0,0,0,.33.17.17,0,0,0,0,.07,2.34,2.34,0,0,0,0,.26l0,.07a1.84,1.84,0,0,0,0,.25l0,.06a4.91,4.91,0,0,0,.18.58v0l.1.24,0,.06c0,.06.07.12.1.19l0,.06c0,.06.07.12.11.17l0,.06.14.19v0l.16.2.06.06.11.11.08.09.08.06a.9.9,0,0,0,.19.15s0,0,0,0l.26.17-68.07-39.6-.24-.15-.11-.09-.12-.09,0,0-.09-.08,0,0a3.44,3.44,0,0,1-.51-.62h0l-.12-.22,0,0a2.12,2.12,0,0,0-.11-.21v0a4.25,4.25,0,0,1-.3-.85l0,0-.06-.25v-.08a2,2,0,0,1,0-.26l0-.06,0-.33h0c0-.21,0-.43,0-.65h0v-.1l0-9.18Z"
            />
            <path
              class="cls-757"
              d="M662.69,105.36l-.2-.13-.07,0,0,0-.11-.09,0,0s0,0,0-.05l-.05,0a3.34,3.34,0,0,1-.44-.54v0l-.11-.19,0,0c0-.06-.07-.13-.1-.2v0a4.69,4.69,0,0,1-.28-.77v0a2,2,0,0,1,0-.24l0-.06c0-.08,0-.16,0-.24v-.07c0-.1,0-.2,0-.31s0-.41,0-.61L660.81,99,728,138.06l0,0,.17,3a7,7,0,0,0,0,.8c0,.12,0,.23,0,.34v.08c0,.09,0,.18,0,.27v.08a2.68,2.68,0,0,0,.07.27V143c0,.19.11.37.17.55l.06.16ZM661,99.24l.16,2.35q0,.3,0,.6a2.43,2.43,0,0,0,0,.3v.07a1.57,1.57,0,0,0,0,.23v.07a1.89,1.89,0,0,1,0,.23l0,0a5.51,5.51,0,0,0,.26.75l0,0,.09.19,0,0,.11.18v0a3,3,0,0,0,.42.51l.06.06,0,0,0,0,.1.07,0,0,0,0,.2.13,65.61,38.17c0-.13-.08-.26-.11-.39l0-.07-.06-.27,0-.08c0-.1,0-.19,0-.28v-.08c0-.11,0-.23,0-.35a7.2,7.2,0,0,1,0-.81l-.16-2.93Z"
            />
            <polygon
              class="cls-40"
              points="742.94 115.98 674.87 76.38 667.13 80.85 735.2 120.45 742.94 115.98"
            />
            <polygon
              class="cls-2"
              points="740.37 117.46 672.3 77.87 671.47 78.34 739.54 117.94 740.37 117.46"
            />
            <g class="cls-7">
              <path
                class="cls-6"
                d="M735.2,120.45l-68.08-39.6a14.61,14.61,0,0,0-6.61,11.46l68.07,39.59A14.56,14.56,0,0,1,735.2,120.45Z"
              />
              <g class="cls-758">
                <g class="cls-7">
                  <path
                    class="cls-2"
                    d="M735.2,120.45l-68.08-39.6a13.05,13.05,0,0,0-4,3.9l68.07,39.59a12.82,12.82,0,0,1,4-3.89Z"
                  />
                  <path
                    class="cls-5"
                    d="M731.17,124.34,663.1,84.75a16,16,0,0,0-1.51,2.75l68.07,39.59a16.75,16.75,0,0,1,1.51-2.75Z"
                  />
                  <path
                    class="cls-5"
                    d="M729.66,127.09,661.59,87.5a12.31,12.31,0,0,0-1.08,4.81l68.07,39.59a12.57,12.57,0,0,1,1.08-4.81Z"
                  />
                </g>
              </g>
            </g>
            <path
              class="cls-3"
              d="M728.59,131.9v9.18c0,4.22,3,5.92,6.66,3.8l4.28-2.47.83-.48,2.63-1.52L742.94,116l-2.57,1.48-.83.48-4.34,2.51A14.52,14.52,0,0,0,728.59,131.9Z"
            />
          </g>
          <polygon
            class="cls-43"
            points="662.05 101.39 662.05 104.4 726.89 142.12 726.89 139.1 662.97 101.93 662.51 101.66 662.05 101.39"
          />
          <polygon
            class="cls-759"
            points="662.97 101.93 662.97 104.15 726.89 141.33 726.89 139.1 662.97 101.93"
          />
          <polygon
            class="cls-757"
            points="739.54 117.94 739.54 142.41 740.37 141.93 740.37 117.46 739.54 117.94"
          />
          <polygon
            class="cls-3"
            points="726.89 139.44 726.88 140.04 724.87 141.25 724.87 140.65 726.89 139.44"
          />
          <path class="cls-44" d="M663,102.43l63.92,37-2,1.21-63.91-37Z" />
          <polygon
            class="cls-45"
            points="724.87 140.65 724.87 141.25 660.95 104.24 660.96 103.64 724.87 140.65"
          />
          <polygon
            class="cls-3"
            points="665.86 91.89 665.86 99.69 673.04 103.83 673.04 96.03 666.32 92.15 665.86 91.89"
          />
          <polygon
            class="cls-760"
            points="666.32 92.15 666.32 99.43 673.04 103.31 673.04 96.03 666.32 92.15"
          />
          <path
            class="cls-5"
            d="M670.56,100.88a.14.14,0,0,0,.11.1h.09v.14a.11.11,0,0,0,.06.09s.06,0,.06,0V101H671v.26h0s0,0,0,.08a.17.17,0,0,0,.06.06.18.18,0,0,0,0,.07s.05,0,.05,0v0l.2,0v.16h-.16s0,0,0,.08a.09.09,0,0,0,.08.07h.1v.12a.19.19,0,0,0,.08.15.05.05,0,0,0,.08,0v-.13l.1.13s.06,0,.08,0a.1.1,0,0,0,0-.1l-.16-.2v-.15l.19.23v0a.13.13,0,0,0,.06.1s0,0,0,0,0,0,0,0,0-.07,0-.1l0,0v-.25l.07.09h0l0,.05v.21a.13.13,0,0,0,.06.1,0,0,0,0,0,.06,0v-.13l.09.11s.09.06.11,0,0-.1,0-.15l-.09-.11h.1s0,0,0-.08-.05-.07-.08-.07l-.15,0-.12-.15.19,0,0,0s.06,0,.07,0,0,0,0-.07a.06.06,0,0,0,0-.07.1.1,0,0,0-.07-.07h0l-.19-.23H672l.15.2s.06,0,.08,0a.1.1,0,0,0,0-.1l-.1-.13h.09s.06-.06,0-.12a.14.14,0,0,0-.11-.1H672v-.13a.13.13,0,0,0-.06-.1,0,0,0,0,0-.06,0v.21h-.11v-.25h0s0,0,0-.07a.13.13,0,0,0,0-.07.15.15,0,0,0,0-.06s-.06,0-.06,0v0h-.19v-.15l.16,0s0,0,0-.07,0-.07-.08-.07h-.1v-.13a.2.2,0,0,0-.08-.14s-.08,0-.08.05v.12l-.1-.12s-.07-.05-.08,0,0,.06,0,.1l.16.19v.16l-.2-.24v0a.11.11,0,0,0-.05-.09,0,0,0,0,0,0,0,0,0,0,0,0-.06,0,.14.14,0,0,0,0,.1l0,0v.26l-.07-.1h0l0-.05v-.21a.15.15,0,0,0-.06-.1s-.06,0-.06,0v.13l-.09-.12s-.09-.06-.11,0,0,.1,0,.15l.09.12h-.1s0,0,0,.07a.09.09,0,0,0,.08.07h.15l.12.14-.19,0,0,0s-.06,0-.08,0,0,0,0,.07,0,0,0,.06,0,.08.08.07h0l.19.24h-.12l-.15-.19s-.07,0-.08,0,0,.07,0,.11l.1.12h-.09S670.53,100.82,670.56,100.88Zm1,0h.2l.19.23-.19,0Zm-.08.12.19.24v.25l-.19-.23Zm0-.59h.19v.25l-.19,0Zm-.16.16-.2-.23v-.26l.2.24Zm-.2.35.2,0v.26l-.2,0Zm-.27-.45.19,0,.19.24-.19,0Z"
          />
          <g id="wind">
            <path
              class="cls-5"
              d="M667,97.86l.1.08c.07.06.09.17,0,.2s0,0,0,0h0l0,0s0,0-.1,0A.37.37,0,0,1,667,97.86Z"
            />
            <path
              class="cls-5"
              d="M668.6,99.65l0,.06s.05,0,.12,0a.52.52,0,0,1,.12.32l-.13-.08a.25.25,0,0,1-.12-.25s0,0,0,0S668.59,99.65,668.6,99.65Z"
            />
            <path
              class="cls-5"
              d="M668.08,97.7a.05.05,0,0,0,0,0l0,0,0,0a.17.17,0,0,1,0,.14c0,.09-.2,0-.2,0a.68.68,0,0,0,0-.12C667.93,97.63,668,97.64,668.08,97.7Z"
            />
            <path
              class="cls-5"
              d="M667.12,98.44l0,0,0,0a.22.22,0,0,1,.16,0,.35.35,0,0,1,.2,0,2,2,0,0,1,.39.32c.12.12.22.25.32.37l.15.17.14.15.27.21.2.12a1.11,1.11,0,0,0,.18.09h0l-.19-.08-.21-.12-.27-.2-.15-.15-.15-.17-.32-.36a1.58,1.58,0,0,0-.36-.29.3.3,0,0,0-.18,0,.24.24,0,0,0-.14,0l0,0,0,0a.25.25,0,0,0,0,.07.44.44,0,0,0,0,.2.92.92,0,0,0,.17.44.78.78,0,0,0,.31.27l.07,0h.07a.11.11,0,0,0,.1,0,.31.31,0,0,0,0-.27.51.51,0,0,0-.13-.22.16.16,0,0,0-.12,0h0s.07,0,.13,0a.32.32,0,0,1,.1.1,1.09,1.09,0,0,1,.08.15.57.57,0,0,1,0,.18.21.21,0,0,1,0,.16.19.19,0,0,1-.12.07h-.08l-.09,0a.67.67,0,0,1-.19-.12.41.41,0,0,1-.1-.09.44.44,0,0,1-.08-.11,1.08,1.08,0,0,1-.2-.52.55.55,0,0,1,0-.23A.25.25,0,0,1,667.12,98.44Z"
            />
            <path
              class="cls-5"
              d="M668,98.14l.06,0a.37.37,0,0,1,.27.08.68.68,0,0,1,.12.12.42.42,0,0,1,.09.14.3.3,0,0,1,0,.15.25.25,0,0,1,0,.12s0,0,0,0l0,0h-.06l-.09,0,0,0h0l.08,0s0,0,0,0h0s0,0,0,0v-.08s0,0,0-.06,0,0,0,0l0-.06a.36.36,0,0,0-.07-.1.41.41,0,0,0-.1-.09.25.25,0,0,0-.21,0c-.06,0-.09.08-.09.18v.11a.06.06,0,0,0,0,0,1,1,0,0,0,0,.16,1.27,1.27,0,0,0,.2.31,2.77,2.77,0,0,0,.25.24l.24.17.22.09a.37.37,0,0,0,.17,0l.1-.06a.12.12,0,0,0,0-.08v0h0a.08.08,0,0,1,0,0,.16.16,0,0,1,0,.08.23.23,0,0,1-.1.07.28.28,0,0,1-.18,0l-.22-.09a1.22,1.22,0,0,1-.26-.16,2,2,0,0,1-.26-.24,1.36,1.36,0,0,1-.23-.34.68.68,0,0,1-.07-.2.06.06,0,0,1,0,0v-.14a.41.41,0,0,1,0-.16Z"
            />
            <polygon
              class="cls-5"
              points="667.8 98.49 667.8 98.49 667.8 98.49 667.8 98.49"
            />
            <path class="cls-5" d="M667.42,98Z" />
            <path
              class="cls-5"
              d="M667.39,97.74a.15.15,0,0,1,.13,0,.33.33,0,0,1,.17.1.7.7,0,0,1,.13.17.61.61,0,0,1,.09.18.92.92,0,0,1,0,.16l0,.1,0,.06,0,0h0s0,0,0,0a.37.37,0,0,0,0-.16.36.36,0,0,0,0-.14l0-.08-.05-.08a.53.53,0,0,0-.12-.14.23.23,0,0,0-.12-.06.12.12,0,0,0-.1,0,.21.21,0,0,0,0,.12h0V98a.64.64,0,0,0,0,.07.41.41,0,0,0,.07.11l.08.06h.13v0s0,0,0,0a.08.08,0,0,1-.07,0,.19.19,0,0,1-.12-.06.42.42,0,0,1-.12-.16.38.38,0,0,1,0-.1.43.43,0,0,0,0,0v0h0A.19.19,0,0,1,667.39,97.74Z"
            />
          </g>
          <polygon
            class="cls-761"
            points="671.21 94.97 673.04 98.31 673.04 100.15 669.74 94.12 671.21 94.97"
          />
          <polygon
            class="cls-761"
            points="666.32 92.15 668.23 93.25 673.04 102.03 673.04 103.31 671.14 102.22 666.32 93.41 666.32 92.15"
          />
          <g class="cls-7">
            <path
              class="cls-5"
              d="M828.58,189.9l0,9.18a6.12,6.12,0,0,0,0,.76h0a3.31,3.31,0,0,0,0,.33.17.17,0,0,0,0,.07,2.34,2.34,0,0,0,0,.26l0,.07a1.84,1.84,0,0,0,0,.25l0,.06a4.91,4.91,0,0,0,.18.58v0l.1.24,0,.06c0,.06.07.12.1.19l0,.06c0,.06.07.12.11.17l0,.06.14.19v0l.16.2.06.06.11.11.08.09.08.06a.9.9,0,0,0,.19.15s0,0,0,0l.26.17-68.07-39.6-.24-.15-.11-.09-.12-.09,0,0-.09-.08,0,0a3.44,3.44,0,0,1-.51-.62h0l-.12-.22,0,0a2.12,2.12,0,0,0-.11-.21v0a4.25,4.25,0,0,1-.3-.85l0-.05-.06-.25v-.08a2,2,0,0,1,0-.26l0-.06,0-.33h0c0-.21,0-.43,0-.65h0v-.1l0-9.18Z"
            />
            <path
              class="cls-757"
              d="M762.69,163.36l-.2-.13-.07,0,0,0-.11-.09,0,0,0,0-.05,0a3.34,3.34,0,0,1-.44-.54v0l-.11-.19,0,0c0-.06-.07-.13-.1-.2v0a4.69,4.69,0,0,1-.28-.77v0a2,2,0,0,1,0-.24l0-.06c0-.08,0-.16,0-.24v-.07c0-.1,0-.2,0-.31s0-.41,0-.61l-.17-2.58L828,196.06l0,0,.17,3a7,7,0,0,0,0,.8c0,.12,0,.23,0,.34v.08c0,.09,0,.18,0,.27v.08a2.68,2.68,0,0,0,.07.27V201c0,.19.11.37.17.55l.06.16ZM761,157.24l.16,2.35q0,.3,0,.6a2.43,2.43,0,0,0,0,.3v.07a1.57,1.57,0,0,0,0,.23v.07a1.89,1.89,0,0,1,0,.23l0,0a5.51,5.51,0,0,0,.26.75l0,0,.09.19,0,0,.11.18v0a3,3,0,0,0,.42.51l.06.06,0,0,0,0,.1.07,0,0,0,0,.2.13,65.61,38.17c0-.13-.08-.26-.11-.39l0-.07-.06-.27,0-.08c0-.1,0-.19,0-.28v-.08c0-.11,0-.23,0-.35a7.2,7.2,0,0,1,0-.81l-.16-2.93Z"
            />
            <polygon
              class="cls-40"
              points="842.94 173.98 774.87 134.38 767.13 138.85 835.2 178.45 842.94 173.98"
            />
            <polygon
              class="cls-2"
              points="840.37 175.46 772.3 135.87 771.47 136.34 839.54 175.94 840.37 175.46"
            />
            <g class="cls-7">
              <path
                class="cls-6"
                d="M835.2,178.45l-68.08-39.6a14.61,14.61,0,0,0-6.61,11.46l68.07,39.59A14.56,14.56,0,0,1,835.2,178.45Z"
              />
              <g class="cls-762">
                <g class="cls-7">
                  <path
                    class="cls-2"
                    d="M835.2,178.45l-68.08-39.6a13.05,13.05,0,0,0-4,3.9l68.07,39.59a12.82,12.82,0,0,1,4-3.89Z"
                  />
                  <path
                    class="cls-5"
                    d="M831.17,182.34,763.1,142.75a16,16,0,0,0-1.51,2.75l68.07,39.59a16.75,16.75,0,0,1,1.51-2.75Z"
                  />
                  <path
                    class="cls-5"
                    d="M829.66,185.09,761.59,145.5a12.31,12.31,0,0,0-1.08,4.81l68.07,39.59a12.57,12.57,0,0,1,1.08-4.81Z"
                  />
                </g>
              </g>
            </g>
            <path
              class="cls-3"
              d="M828.59,189.9v9.18c0,4.22,3,5.92,6.66,3.8l4.28-2.47.83-.48,2.63-1.52L842.94,174l-2.57,1.48-.83.48-4.34,2.51A14.52,14.52,0,0,0,828.59,189.9Z"
            />
          </g>
          <polygon
            class="cls-43"
            points="762.05 159.39 762.05 162.4 826.89 200.12 826.89 197.1 762.97 159.93 762.51 159.66 762.05 159.39"
          />
          <polygon
            class="cls-759"
            points="762.97 159.93 762.97 162.15 826.89 199.33 826.89 197.1 762.97 159.93"
          />
          <polygon
            class="cls-757"
            points="839.54 175.94 839.54 200.41 840.37 199.93 840.37 175.46 839.54 175.94"
          />
          <polygon
            class="cls-3"
            points="826.89 197.44 826.88 198.04 824.87 199.25 824.87 198.65 826.89 197.44"
          />
          <path class="cls-44" d="M763,160.43l63.92,37-2,1.21-63.91-37Z" />
          <polygon
            class="cls-45"
            points="824.87 198.65 824.87 199.25 760.95 162.24 760.96 161.64 824.87 198.65"
          />
          <polygon
            class="cls-3"
            points="765.86 149.88 765.86 157.69 773.04 161.83 773.04 154.03 766.32 150.15 765.86 149.88"
          />
          <polygon
            class="cls-760"
            points="766.32 150.15 766.32 157.43 773.04 161.31 773.04 154.03 766.32 150.15"
          />
          <path
            class="cls-5"
            d="M770.56,158.88a.14.14,0,0,0,.11.1h.09v.14a.11.11,0,0,0,.06.09s.06,0,.06,0V159H771v.26h0s0,0,0,.08a.17.17,0,0,0,.06.06.18.18,0,0,0,0,.07s.05,0,.05,0v0l.2,0v.16h-.16s0,0,0,.08a.09.09,0,0,0,.08.07h.1v.12a.19.19,0,0,0,.08.15.05.05,0,0,0,.08,0v-.13l.1.13s.06,0,.08,0a.1.1,0,0,0,0-.1l-.16-.2v-.15l.19.23v0a.13.13,0,0,0,.06.1s0,0,0,0,0,0,0,0,0-.07,0-.1l0,0v-.25l.07.09h0l0,0v.21a.13.13,0,0,0,.06.1,0,0,0,0,0,.06,0v-.13l.09.11s.09.06.11,0,0-.1,0-.15l-.09-.11h.1s0,0,0-.08-.05-.07-.08-.07l-.15,0-.12-.15.19,0,0,0s.06,0,.07,0,0,0,0-.07a.06.06,0,0,0,0-.07.1.1,0,0,0-.07-.07h0l-.19-.23H772l.15.2s.06,0,.08,0a.1.1,0,0,0,0-.1l-.1-.13h.09s.06-.06,0-.12a.14.14,0,0,0-.11-.1H772v-.13a.13.13,0,0,0-.06-.1,0,0,0,0,0-.06,0v.21h-.11v-.25h0s0,0,0-.07a.13.13,0,0,0,0-.07.15.15,0,0,0,0-.06s-.06,0-.06,0v0h-.19v-.15l.16,0s0,0,0-.07,0-.07-.08-.07h-.1v-.13a.2.2,0,0,0-.08-.14s-.08,0-.08,0v.12l-.1-.12s-.07,0-.08,0,0,.06,0,.1l.16.19v.16l-.2-.24v0a.11.11,0,0,0-.05-.09,0,0,0,0,0,0,0,0,0,0,0,0-.06,0,.14.14,0,0,0,0,.1l0,0v.26l-.07-.1h0l0-.05v-.21a.15.15,0,0,0-.06-.1s-.06,0-.06,0v.13l-.09-.12c0-.05-.09-.06-.11,0s0,.1,0,.15l.09.12h-.1s0,0,0,.07a.09.09,0,0,0,.08.07h.15l.12.14-.19,0,0,0s-.06,0-.08,0,0,0,0,.07,0,0,0,.06,0,.08.08.07h0l.19.24h-.12l-.15-.19s-.07-.05-.08,0,0,.07,0,.11l.1.12h-.09S770.53,158.82,770.56,158.88Zm1,0h.2l.19.23-.19,0Zm-.08.12.19.24v.25l-.19-.23Zm0-.59h.19v.25l-.19,0Zm-.16.16-.2-.23v-.26l.2.24Zm-.2.35.2,0v.26l-.2,0Zm-.27-.45.19,0,.19.24-.19,0Z"
          />
          <g id="wind-2" data-name="wind">
            <path
              class="cls-5"
              d="M767,155.86l.1.08c.07.06.09.17,0,.2s0,0,0,0h0l0-.05s0,0-.1,0A.37.37,0,0,1,767,155.86Z"
            />
            <path
              class="cls-5"
              d="M768.6,157.65l0,.06s.05,0,.12,0a.52.52,0,0,1,.12.32l-.13-.08a.25.25,0,0,1-.12-.25s0-.05,0-.05S768.59,157.65,768.6,157.65Z"
            />
            <path
              class="cls-5"
              d="M768.08,155.7a.05.05,0,0,0,0,0l0,0,0,0a.17.17,0,0,1,0,.14c0,.09-.2,0-.2,0a.68.68,0,0,0,0-.12C767.93,155.63,768,155.64,768.08,155.7Z"
            />
            <path
              class="cls-5"
              d="M767.12,156.44l0,0,0,0a.22.22,0,0,1,.16,0,.35.35,0,0,1,.2,0,2,2,0,0,1,.39.32c.12.12.22.25.32.37l.15.17.14.15.27.21.2.12a1.11,1.11,0,0,0,.18.09h0l-.19-.08-.21-.12-.27-.2-.15-.15-.15-.17-.32-.36a1.58,1.58,0,0,0-.36-.29.3.3,0,0,0-.18,0,.24.24,0,0,0-.14.05l0,0s0,0,0,0a.25.25,0,0,0,0,.07.44.44,0,0,0,0,.2.92.92,0,0,0,.17.44.78.78,0,0,0,.31.27l.07,0h.07a.11.11,0,0,0,.1,0,.31.31,0,0,0,0-.27.51.51,0,0,0-.13-.22.16.16,0,0,0-.12-.05h0s.07,0,.13,0a.32.32,0,0,1,.1.1,1.09,1.09,0,0,1,.08.15.57.57,0,0,1,0,.18.21.21,0,0,1,0,.16.19.19,0,0,1-.12.07h-.08l-.09,0a.67.67,0,0,1-.19-.12.41.41,0,0,1-.1-.09.44.44,0,0,1-.08-.11,1.08,1.08,0,0,1-.2-.52.55.55,0,0,1,0-.23A.25.25,0,0,1,767.12,156.44Z"
            />
            <path
              class="cls-5"
              d="M768,156.14l.06,0a.37.37,0,0,1,.27.08.68.68,0,0,1,.12.12.42.42,0,0,1,.09.14.3.3,0,0,1,0,.15.25.25,0,0,1,0,.12v0l0,0h-.06l-.09,0,0,0h0l.08,0h0l0,0v-.08s0,0,0-.06,0,0,0,0l0-.06a.36.36,0,0,0-.07-.1.41.41,0,0,0-.1-.09.25.25,0,0,0-.21-.05c-.06,0-.09.08-.09.18v.11a.06.06,0,0,0,0,0,1,1,0,0,0,0,.16,1.27,1.27,0,0,0,.2.31,2.77,2.77,0,0,0,.25.24l.24.17.22.09a.37.37,0,0,0,.17,0,.29.29,0,0,0,.1-.06.12.12,0,0,0,0-.08v0h0v0a.16.16,0,0,1,0,.08.23.23,0,0,1-.1.07.28.28,0,0,1-.18,0l-.22-.09a1.22,1.22,0,0,1-.26-.16,2,2,0,0,1-.26-.24,1.36,1.36,0,0,1-.23-.34.68.68,0,0,1-.07-.2.06.06,0,0,1,0,0v-.14a.41.41,0,0,1,0-.16Z"
            />
            <polygon
              class="cls-5"
              points="767.8 156.49 767.8 156.49 767.8 156.49 767.8 156.49"
            />
            <path class="cls-5" d="M767.42,156Z" />
            <path
              class="cls-5"
              d="M767.39,155.74a.15.15,0,0,1,.13,0,.33.33,0,0,1,.17.1.7.7,0,0,1,.13.17.61.61,0,0,1,.09.18.92.92,0,0,1,0,.16l0,.1,0,.06,0,0h0s0,0,0,0a.37.37,0,0,0,0-.16.36.36,0,0,0,0-.14l0-.08-.05-.08a.53.53,0,0,0-.12-.14.23.23,0,0,0-.12-.06.12.12,0,0,0-.1,0,.21.21,0,0,0,0,.12h0v0a.64.64,0,0,0,0,.07.41.41,0,0,0,.07.11l.08.06h.13v0s0,0,0,0a.08.08,0,0,1-.07,0,.19.19,0,0,1-.12-.06.42.42,0,0,1-.12-.16.38.38,0,0,1,0-.1.43.43,0,0,0,0-.05v0h0A.19.19,0,0,1,767.39,155.74Z"
            />
          </g>
          <polygon
            class="cls-761"
            points="771.21 152.97 773.04 156.31 773.04 158.15 769.74 152.12 771.21 152.97"
          />
          <polygon
            class="cls-761"
            points="766.32 150.15 768.23 151.25 773.04 160.03 773.04 161.31 771.14 160.22 766.32 151.41 766.32 150.15"
          />
          <g class="cls-7">
            <path
              class="cls-5"
              d="M633.58,76.9l0,9.18a6.12,6.12,0,0,0,0,.76h0a3.31,3.31,0,0,0,0,.33.17.17,0,0,0,0,.07,2.34,2.34,0,0,0,0,.26l0,.07a1.84,1.84,0,0,0,0,.25l0,.06a4.91,4.91,0,0,0,.18.58v0l.1.24,0,.06c0,.06.07.12.1.19l0,.06c0,.06.07.12.11.17l0,.06.14.19v0l.16.2.06.06.11.11.08.09.08.06a.9.9,0,0,0,.19.15l0,0,.26.17-68.07-39.6-.24-.15-.11-.09-.12-.09s0,0,0-.05l-.09-.08,0,0a3.44,3.44,0,0,1-.51-.62h0l-.12-.22,0,0a2.12,2.12,0,0,0-.11-.21v0a4.25,4.25,0,0,1-.3-.85l0-.05-.06-.25V47.9a2,2,0,0,1,0-.26l0-.06,0-.33h0c0-.21,0-.43,0-.65h0v-.1l0-9.18Z"
            />
            <path
              class="cls-757"
              d="M567.69,50.36l-.2-.13-.07,0,0,0-.11-.09,0,0,0,0-.05,0a3.34,3.34,0,0,1-.44-.54v0l-.11-.19,0,0c0-.06-.07-.13-.1-.2v0a4.69,4.69,0,0,1-.28-.77v-.05a2,2,0,0,1,0-.24l0-.06c0-.08,0-.16,0-.24v-.07c0-.1,0-.2,0-.31s0-.41,0-.61L565.81,44,633,83.06l0,0,.17,3a7,7,0,0,0,0,.8c0,.12,0,.23,0,.34v.08c0,.09,0,.18,0,.27v.08a2.68,2.68,0,0,0,.07.27V88c0,.19.11.37.17.55l.06.16ZM566,44.24l.16,2.35q0,.3,0,.6a2.43,2.43,0,0,0,0,.3v.07a1.57,1.57,0,0,0,0,.23v.07a1.89,1.89,0,0,1,0,.23l0,0a5.51,5.51,0,0,0,.26.75l0,0,.09.19,0,0,.11.18v0a3,3,0,0,0,.42.51l.06.06,0,0,0,0,.1.07,0,0,0,0,.2.13,65.61,38.17c0-.13-.08-.26-.11-.39l0-.07-.06-.27,0-.08c0-.1,0-.19,0-.28v-.08c0-.11,0-.23,0-.35a7.2,7.2,0,0,1,0-.81l-.16-2.93Z"
            />
            <polygon
              class="cls-40"
              points="647.94 60.98 579.87 21.38 572.13 25.85 640.2 65.45 647.94 60.98"
            />
            <polygon
              class="cls-2"
              points="645.37 62.46 577.3 22.87 576.47 23.34 644.54 62.94 645.37 62.46"
            />
            <g class="cls-7">
              <path
                class="cls-6"
                d="M640.2,65.45l-68.08-39.6a14.61,14.61,0,0,0-6.61,11.46L633.58,76.9A14.56,14.56,0,0,1,640.2,65.45Z"
              />
              <g class="cls-763">
                <g class="cls-7">
                  <path
                    class="cls-2"
                    d="M640.2,65.45l-68.08-39.6a13.05,13.05,0,0,0-4,3.9l68.07,39.59a12.82,12.82,0,0,1,4-3.89Z"
                  />
                  <path
                    class="cls-5"
                    d="M636.17,69.34,568.1,29.75a16,16,0,0,0-1.51,2.75l68.07,39.59a16.75,16.75,0,0,1,1.51-2.75Z"
                  />
                  <path
                    class="cls-5"
                    d="M634.66,72.09,566.59,32.5a12.31,12.31,0,0,0-1.08,4.81L633.58,76.9a12.57,12.57,0,0,1,1.08-4.81Z"
                  />
                </g>
              </g>
            </g>
            <path
              class="cls-3"
              d="M633.59,76.9v9.18c0,4.22,3,5.92,6.66,3.8l4.28-2.47.83-.48L648,85.41,647.94,61l-2.57,1.48-.83.48-4.34,2.51A14.52,14.52,0,0,0,633.59,76.9Z"
            />
          </g>
          <polygon
            class="cls-43"
            points="567.05 46.39 567.05 49.4 631.89 87.12 631.89 84.1 567.97 46.93 567.51 46.66 567.05 46.39"
          />
          <polygon
            class="cls-759"
            points="567.97 46.93 567.97 49.15 631.89 86.33 631.89 84.1 567.97 46.93"
          />
          <polygon
            class="cls-757"
            points="644.54 62.94 644.54 87.41 645.37 86.93 645.37 62.46 644.54 62.94"
          />
          <polygon
            class="cls-3"
            points="631.89 84.44 631.88 85.04 629.87 86.25 629.87 85.65 631.89 84.44"
          />
          <path class="cls-44" d="M568,47.43l63.92,37-2,1.21L566,48.64Z" />
          <polygon
            class="cls-45"
            points="629.87 85.65 629.87 86.25 565.95 49.24 565.96 48.64 629.87 85.65"
          />
          <polygon
            class="cls-3"
            points="570.86 36.88 570.86 44.69 578.04 48.83 578.04 41.03 571.32 37.15 570.86 36.88"
          />
          <polygon
            class="cls-760"
            points="571.32 37.15 571.32 44.43 578.04 48.31 578.04 41.03 571.32 37.15"
          />
          <path
            class="cls-5"
            d="M575.56,45.88a.14.14,0,0,0,.11.1h.09v.14a.11.11,0,0,0,.06.09s.06,0,.06,0V46H576v.26h0s0,0,0,.08a.17.17,0,0,0,.06.06.18.18,0,0,0,0,.07s.05,0,.05,0v0l.2,0v.16h-.16s0,0,0,.08a.09.09,0,0,0,.08.07h.1v.12a.19.19,0,0,0,.08.15.05.05,0,0,0,.08,0v-.13l.1.13s.06,0,.08,0a.1.1,0,0,0,0-.1l-.16-.2v-.15l.19.23v0a.13.13,0,0,0,.06.1s0,0,0,0,0,0,0,0,0-.07,0-.1l0,0V46.4l.07.09h0l0,0v.21a.13.13,0,0,0,.06.1,0,0,0,0,0,.06,0v-.13l.09.11c0,.05.09.06.11,0s0-.1,0-.15l-.09-.11h.1s0,0,0-.08-.05-.07-.08-.07l-.15,0-.12-.15.19,0,0,0s.06,0,.07,0,0,0,0-.07a.06.06,0,0,0,0-.07.1.1,0,0,0-.07-.07h0l-.19-.23H577l.15.2s.06,0,.08,0a.1.1,0,0,0,0-.1l-.1-.13h.09s.06-.06,0-.12a.14.14,0,0,0-.11-.1H577v-.13a.13.13,0,0,0-.06-.1,0,0,0,0,0-.06,0v.21h-.11v-.25h0s0,0,0-.07a.13.13,0,0,0,0-.07.15.15,0,0,0,0-.06s-.06,0-.06,0v0h-.19v-.15l.16,0s0,0,0-.07,0-.07-.08-.07h-.1v-.13a.2.2,0,0,0-.08-.14s-.08,0-.08,0v.12l-.1-.12s-.07,0-.08,0,0,.06,0,.1l.16.19v.16l-.2-.24v0a.11.11,0,0,0-.05-.09,0,0,0,0,0,0,0,0,0,0,0,0-.06,0,.14.14,0,0,0,0,.1l0,0v.26l-.07-.1h0l0,0v-.21a.15.15,0,0,0-.06-.1s-.06,0-.06,0v.13l-.09-.12c0-.05-.09-.06-.11,0s0,.1,0,.15l.09.12h-.1s0,0,0,.07a.09.09,0,0,0,.08.07h.15l.12.14-.19,0,0,0s-.06,0-.08,0,0,0,0,.07,0,0,0,.06,0,.08.08.07h0l.19.24h-.12l-.15-.19s-.07-.05-.08,0,0,.07,0,.11l.1.12h-.09S575.53,45.82,575.56,45.88Zm1,0h.2l.19.23-.19,0Zm-.08.12.19.24v.25l-.19-.23Zm0-.59h.19v.25l-.19,0Zm-.16.16-.2-.23V45.1l.2.24Zm-.2.35.2,0v.26l-.2,0Zm-.27-.45.19,0,.19.24-.19,0Z"
          />
          <g id="wind-3" data-name="wind">
            <path
              class="cls-5"
              d="M572,42.86l.1.08c.07.06.09.17,0,.2s0,0,0,0h0l0,0s0,0-.1,0A.37.37,0,0,1,572,42.86Z"
            />
            <path
              class="cls-5"
              d="M573.6,44.65l0,.06s.05,0,.12,0a.52.52,0,0,1,.12.32l-.13-.08a.25.25,0,0,1-.12-.25s0,0,0,0S573.59,44.65,573.6,44.65Z"
            />
            <path
              class="cls-5"
              d="M573.08,42.7a.05.05,0,0,0,0,0l0,0,0,0a.17.17,0,0,1,0,.14c0,.09-.2,0-.2,0a.68.68,0,0,0,0-.12C572.93,42.63,573,42.64,573.08,42.7Z"
            />
            <path
              class="cls-5"
              d="M572.12,43.44l0,0,0,0a.22.22,0,0,1,.16-.05.35.35,0,0,1,.2.05,2,2,0,0,1,.39.32c.12.12.22.25.32.37l.15.17.14.15.27.21.2.12a1.11,1.11,0,0,0,.18.09h0l-.19-.08-.21-.12-.27-.2-.15-.15-.15-.17-.32-.36a1.58,1.58,0,0,0-.36-.29.3.3,0,0,0-.18,0,.24.24,0,0,0-.14.05l0,0s0,0,0,0a.25.25,0,0,0,0,.07.44.44,0,0,0,0,.2.92.92,0,0,0,.17.44.78.78,0,0,0,.31.27l.07,0h.07a.11.11,0,0,0,.1,0,.31.31,0,0,0,0-.27.51.51,0,0,0-.13-.22.16.16,0,0,0-.12,0h0s.07,0,.13,0a.32.32,0,0,1,.1.1,1.09,1.09,0,0,1,.08.15.57.57,0,0,1,0,.18.21.21,0,0,1,0,.16.19.19,0,0,1-.12.07h-.08l-.09,0a.67.67,0,0,1-.19-.12.41.41,0,0,1-.1-.09.44.44,0,0,1-.08-.11,1.08,1.08,0,0,1-.2-.52.55.55,0,0,1,0-.23A.25.25,0,0,1,572.12,43.44Z"
            />
            <path
              class="cls-5"
              d="M573,43.14l.06,0a.37.37,0,0,1,.27.08.68.68,0,0,1,.12.12.42.42,0,0,1,.09.14.3.3,0,0,1,0,.15.25.25,0,0,1,0,.12v0l0,0h-.06l-.09,0,0,0h0l.08,0h0l0,0v-.08s0,0,0-.06,0,0,0,0l0-.06a.36.36,0,0,0-.07-.1.41.41,0,0,0-.1-.09.25.25,0,0,0-.21-.05c-.06,0-.09.08-.09.18v.11a.06.06,0,0,0,0,0,1,1,0,0,0,0,.16,1.27,1.27,0,0,0,.2.31,2.77,2.77,0,0,0,.25.24l.24.17.22.09a.37.37,0,0,0,.17,0,.29.29,0,0,0,.1-.06.12.12,0,0,0,0-.08.08.08,0,0,0,0,0h0v0a.16.16,0,0,1,0,.08.23.23,0,0,1-.1.07.28.28,0,0,1-.18,0l-.22-.09a1.22,1.22,0,0,1-.26-.16,2,2,0,0,1-.26-.24,1.36,1.36,0,0,1-.23-.34.68.68,0,0,1-.07-.2.06.06,0,0,1,0,0v-.14a.41.41,0,0,1,0-.16Z"
            />
            <polygon
              class="cls-5"
              points="572.8 43.49 572.8 43.49 572.8 43.49 572.8 43.49"
            />
            <path class="cls-5" d="M572.42,43Z" />
            <path
              class="cls-5"
              d="M572.39,42.74a.15.15,0,0,1,.13,0,.33.33,0,0,1,.17.1.7.7,0,0,1,.13.17.61.61,0,0,1,.09.18.92.92,0,0,1,0,.16l0,.1,0,.06,0,0h0s0,0,0,0a.37.37,0,0,0,0-.16.36.36,0,0,0,0-.14l0-.08-.05-.08a.53.53,0,0,0-.12-.14.23.23,0,0,0-.12-.06.12.12,0,0,0-.1,0,.21.21,0,0,0,0,.12h0v0a.64.64,0,0,0,0,.07.41.41,0,0,0,.07.11l.08.06h.13v0s0,0,0,0a.08.08,0,0,1-.07,0,.19.19,0,0,1-.12-.06.42.42,0,0,1-.12-.16.38.38,0,0,1,0-.1.43.43,0,0,0,0-.05v0h0A.19.19,0,0,1,572.39,42.74Z"
            />
          </g>
          <polygon
            class="cls-761"
            points="576.21 39.97 578.04 43.31 578.04 45.15 574.74 39.12 576.21 39.97"
          />
          <polygon
            class="cls-761"
            points="571.32 37.15 573.23 38.25 578.04 47.02 578.04 48.31 576.14 47.22 571.32 38.41 571.32 37.15"
          />
          <path
            class="cls-764"
            d="M810.46,284.81l33.86-19.55a4.93,4.93,0,0,0,2.38-3.75V227.65c0-1.31-1.07-1.77-2.38-1l-33.86,19.55a5,5,0,0,0-2.38,3.75v33.87C808.08,285.12,809.15,285.57,810.46,284.81Z"
          />
          <path
            class="cls-765"
            d="M807.75,244.63l2.71,1.56a5,5,0,0,0-2.38,3.75l-2.71-1.56A5,5,0,0,1,807.75,244.63Z"
          />
          <path
            class="cls-766"
            d="M808.08,249.94v33.87a1.29,1.29,0,0,0,.58,1.2h0l-2.7-1.55v0a1.3,1.3,0,0,1-.59-1.2V248.38Z"
          />
          <path
            class="cls-767"
            d="M841.62,225.08a1.81,1.81,0,0,1,1.79-.2h0l2.71,1.56h0a1.81,1.81,0,0,0-1.79.2l-33.86,19.55-2.71-1.56Z"
          />
          <ellipse
            class="cls-768"
            cx="827.39"
            cy="255.73"
            rx="22.02"
            ry="12.46"
            transform="translate(125.67 763.23) rotate(-53.05)"
          />
          <path
            class="cls-769"
            d="M842.71,230.66c0,.57.47.77,1,.44a2.15,2.15,0,0,0,1-1.64c0-.58-.46-.78-1-.44A2.16,2.16,0,0,0,842.71,230.66Z"
          />
          <ellipse
            class="cls-770"
            cx="811.48"
            cy="248.69"
            rx="1.38"
            ry="0.78"
            transform="translate(124.96 747.73) rotate(-53.05)"
          />
          <path
            class="cls-771"
            d="M842.71,262.62c0,.57.47.77,1,.44a2.15,2.15,0,0,0,1-1.64c0-.58-.46-.78-1-.44A2.16,2.16,0,0,0,842.71,262.62Z"
          />
          <path
            class="cls-772"
            d="M810.44,281.25c0,.57.47.77,1,.44a2.15,2.15,0,0,0,1-1.64c0-.58-.46-.78-1-.44A2.16,2.16,0,0,0,810.44,281.25Z"
          />
          <path
            class="cls-764"
            d="M817.44,257.13a3.38,3.38,0,0,1,3-.53c1.11.47,2.67.12,4.25-.79l.79-.46-1.63-6.57v-.5c0-2.31,1.91-5.29,4.24-6.57,2.16-1.19,4-.42,4,1.72a6.93,6.93,0,0,1-1.21,3.71,10.13,10.13,0,0,0-1.67,5.21v.79s7.85-6.15,8-6.25c2.32-1.34,4.19-.51,4.13,1.86a8.75,8.75,0,0,1-4,6.34,3.47,3.47,0,0,1-3,.53c-1.11-.48-2.67-.13-4.24.78l-.8.46s1.63,6.9,1.63,7.07c0,2.32-1.91,5.29-4.24,6.57-2.16,1.19-4,.42-4-1.71a6.94,6.94,0,0,1,1.21-3.72,10,10,0,0,0,1.67-5.21v-.79s-7.84,6.16-8,6.25c-2.32,1.34-4.19.51-4.13-1.86A8.72,8.72,0,0,1,817.44,257.13Z"
          />
          <path
            class="cls-773"
            d="M837.24,246.89c-.16.1-8,6.25-8,6.25v-.73c1.77-1.4,7.32-5.75,7.46-5.83,1.4-.81,2.63-.82,3.38-.19A3.43,3.43,0,0,0,837.24,246.89Z"
          />
          <path
            class="cls-774"
            d="M816.89,256.81a3.43,3.43,0,0,1,3-.52c1.11.47,2.67.12,4.25-.79L825,255l-1.63-6.57V248c0-2.31,1.91-5.29,4.24-6.57,1.33-.73,2.52-.72,3.26-.11a3.33,3.33,0,0,0-2.72.42c-2.33,1.28-4.24,4.26-4.24,6.57v.5l1.63,6.57-.79.46c-1.58.91-3.14,1.26-4.25.79a3.38,3.38,0,0,0-3,.53,8.72,8.72,0,0,0-4,6.33,2.49,2.49,0,0,0,.76,2.06,2.24,2.24,0,0,1-1.3-2.37A8.77,8.77,0,0,1,816.89,256.81Z"
          />
          <path
            class="cls-775"
            d="M825,259.55v-.05l.54-.43v.79a10,10,0,0,1-1.67,5.21,6.94,6.94,0,0,0-1.21,3.72,2.36,2.36,0,0,0,.76,1.82,2.15,2.15,0,0,1-1.3-2.14,6.93,6.93,0,0,1,1.21-3.71A10,10,0,0,0,825,259.55Z"
          />
          <path
            class="cls-776"
            d="M826.85,257.69a3.93,3.93,0,0,0,1.89-3,1.21,1.21,0,0,0-.23-.76,1,1,0,0,1,.77,1.07,3.93,3.93,0,0,1-1.89,3c-.72.42-1.34.37-1.66,0A1.75,1.75,0,0,0,826.85,257.69Z"
          />
          <path
            class="cls-768"
            d="M827.39,254.21a1.74,1.74,0,0,1,1.12-.27,1.21,1.21,0,0,1,.23.76,3.93,3.93,0,0,1-1.89,3,1.75,1.75,0,0,1-1.12.27,1.15,1.15,0,0,1-.24-.76A3.93,3.93,0,0,1,827.39,254.21Z"
          />
          <path
            class="cls-777"
            d="M840.14,237.81c2.67,1.37,4.35,4.3,4.35,8.53,0,10.57-7.53,21-16.68,26.33a16.86,16.86,0,0,1-8.15,2.5,8.26,8.26,0,0,1-4.48-1.21,8.3,8.3,0,0,0,3.94.9,17,17,0,0,0,8.27-2.57c9.14-5.28,16.56-17,16.56-26.13C844,242.15,842.52,239.3,840.14,237.81Z"
          />
          <polygon
            class="cls-767"
            points="832.28 237.07 832.82 237.38 823.04 243.03 822.5 242.72 832.28 237.07"
          />
          <path
            class="cls-765"
            d="M834.27,236.69l.54.31-2,.38-.54-.31A13.37,13.37,0,0,1,834.27,236.69Z"
          />
          <path
            class="cls-766"
            d="M822.5,242.72l.54.31c-.14.12-1.86,1.79-2,1.91l-.54-.31C821.15,244,821.81,243.33,822.5,242.72Z"
          />
          <polygon
            class="cls-767"
            points="836.81 236.66 837.35 236.98 818.51 247.85 817.97 247.54 836.81 236.66"
          />
          <path
            class="cls-765"
            d="M837.82,236.84l.54.31c-.06,0-1-.17-1-.17l-.54-.32C837.15,236.71,837.49,236.76,837.82,236.84Z"
          />
          <path
            class="cls-766"
            d="M818,247.54l.54.31c-.07.08-1,1.27-1,1.35l-.54-.31Q817.45,248.2,818,247.54Z"
          />
          <path
            class="cls-767"
            d="M839.38,237.38c.24.12.47.24.69.37l.54.31-.69-.36-24,13.85-.54-.31Z"
          />
          <path class="cls-766" d="M815.39,251.24l.54.31-.68,1.16-.54-.32Z" />
          <path
            class="cls-766"
            d="M813.62,254.47l.54.31-.48,1-.54-.31C813.29,255.16,813.45,254.81,813.62,254.47Z"
          />
          <polygon
            class="cls-767"
            points="841.15 238.57 841.7 238.88 814.16 254.78 813.62 254.47 841.15 238.57"
          />
          <path class="cls-766" d="M812.37,257.39l.54.31-.33,1-.54-.31Z" />
          <polygon
            class="cls-767"
            points="842.4 240.06 842.94 240.37 812.91 257.7 812.38 257.39 842.4 240.06"
          />
          <path
            class="cls-766"
            d="M811.53,260.09l.54.31-.21.88-.54-.31C811.38,260.68,811.45,260.38,811.53,260.09Z"
          />
          <polygon
            class="cls-767"
            points="843.24 241.78 843.78 242.09 812.07 260.4 811.53 260.09 843.24 241.78"
          />
          <path
            class="cls-766"
            d="M811,262.58l.55.32c0,.05-.1.77-.11.82l-.54-.32C811,263.13,811,262.86,811,262.58Z"
          />
          <polygon
            class="cls-767"
            points="843.75 243.69 844.29 244 811.57 262.9 811.02 262.58 843.75 243.69"
          />
          <path
            class="cls-766"
            d="M810.83,264.9l.54.31V266l-.54-.32c0-.12,0-.24,0-.37S810.83,265,810.83,264.9Z"
          />
          <polygon
            class="cls-767"
            points="843.94 245.79 844.48 246.1 811.37 265.21 810.83 264.9 843.94 245.79"
          />
          <polygon
            class="cls-767"
            points="843.85 248.05 844.39 248.36 811.47 267.37 810.92 267.06 843.85 248.05"
          />
          <path
            class="cls-766"
            d="M811.46,267.37s.1.66.11.7l-.55-.31c0-.23-.07-.46-.1-.7Z"
          />
          <polygon
            class="cls-767"
            points="843.45 250.48 843.99 250.79 811.86 269.35 811.32 269.04 843.45 250.48"
          />
          <path
            class="cls-766"
            d="M811.86,269.35l.21.64-.54-.31c-.08-.21-.15-.43-.21-.64Z"
          />
          <polygon
            class="cls-767"
            points="842.73 253.11 843.27 253.42 812.58 271.14 812.04 270.82 842.73 253.11"
          />
          <path
            class="cls-766"
            d="M812.58,271.14s.32.53.33.57l-.54-.32-.33-.57Z"
          />
          <polygon
            class="cls-767"
            points="841.63 255.95 842.17 256.26 813.68 272.71 813.14 272.4 841.63 255.95"
          />
          <path
            class="cls-766"
            d="M813.68,272.71l.48.49-.54-.32a5.44,5.44,0,0,1-.48-.48Z"
          />
          <path
            class="cls-767"
            d="M840.07,259.06l.54.31L815.25,274a5.79,5.79,0,0,1-.54-.31Z"
          />
          <polygon
            class="cls-767"
            points="837.82 262.56 838.36 262.87 817.49 274.92 816.95 274.61 837.82 262.56"
          />
          <polygon
            class="cls-767"
            points="834.26 266.82 834.81 267.13 821.05 275.08 820.51 274.76 834.26 266.82"
          />
          <path
            class="cls-765"
            d="M822.64,243.4l.4-.37,9.78-5.65.4-.09a13.35,13.35,0,0,1,1.59-.29l-13.76,7.94C821.56,244.41,822.1,243.9,822.64,243.4Z"
          />
          <path
            class="cls-765"
            d="M818.32,248.1c.07-.08.12-.17.19-.25L837.35,237l.18,0c.28,0,.56.08.83.14l-20.87,12C817.76,248.83,818,248.46,818.32,248.1Z"
          />
          <path
            class="cls-765"
            d="M815.81,251.76l.12-.21,24-13.85.13.06c.19.1.38.19.56.3l-25.36,14.65C815.43,252.39,815.62,252.07,815.81,251.76Z"
          />
          <path
            class="cls-765"
            d="M814.07,255l.09-.19L841.55,239l.15-.09c.16.15.32.32.47.49l-28.49,16.45C813.8,255.53,813.94,255.25,814.07,255Z"
          />
          <path
            class="cls-765"
            d="M812.85,257.88a1.27,1.27,0,0,0,.06-.18l29.76-17.18.27-.15a5.3,5.3,0,0,1,.33.57l-30.69,17.72Z"
          />
          <path
            class="cls-765"
            d="M812,260.56a1.24,1.24,0,0,0,0-.16l31.35-18.1.36-.21c.08.21.15.42.21.64l-32.13,18.55C811.91,261,812,260.8,812,260.56Z"
          />
          <path
            class="cls-765"
            d="M811.55,263.05a.77.77,0,0,1,0-.15l32.26-18.63.46-.27c0,.23.07.47.1.71l-32.93,19Z"
          />
          <path
            class="cls-765"
            d="M811.37,265.35v-.14l32.57-18.8.54-.31c0,.12,0,.25,0,.37s0,.26,0,.39L811.37,266c0-.13,0-.25,0-.38S811.37,265.44,811.37,265.35Z"
          />
          <path
            class="cls-765"
            d="M844.39,248.36c0,.27-.06.54-.1.82l-32.72,18.89c0-.19-.06-.38-.09-.57a.51.51,0,0,0,0-.13l32.31-18.65Z"
          />
          <path
            class="cls-765"
            d="M844,250.79c-.06.3-.13.59-.21.89L812.07,270c-.06-.17-.12-.35-.17-.53s0-.07,0-.11l31.42-18.14Z"
          />
          <path
            class="cls-765"
            d="M843.27,253.42c-.1.32-.21.63-.33,1l-30,17.34-.27-.47-.06-.1,29.88-17.25Z"
          />
          <path
            class="cls-765"
            d="M842.17,256.26c-.15.35-.31.69-.47,1l-27.54,15.9a4.89,4.89,0,0,1-.39-.4l-.09-.09,27.56-15.91Z"
          />
          <path
            class="cls-765"
            d="M839.51,260l1.1-.64c-.22.39-.45.77-.69,1.16l-24,13.85a6.42,6.42,0,0,1-.68-.37h0Z"
          />
          <path
            class="cls-765"
            d="M837,263.67l1.37-.8c-.33.46-.67.91-1,1.35L818.51,275.1a8.35,8.35,0,0,1-1-.18l.29-.16Z"
          />
          <path
            class="cls-765"
            d="M832.68,268.36l2.13-1.23c-.65.67-1.31,1.31-2,1.91L823,274.69a15.49,15.49,0,0,1-2,.39l1.05-.61Z"
          />
          <path
            class="cls-765"
            d="M836.2,236.91c4.95,0,8.29,3.43,8.29,9.56,0,9.15-7.42,20.85-16.56,26.13a17,17,0,0,1-8.27,2.57c-5,0-8.3-3.43-8.3-9.57,0-9.15,7.42-20.84,16.57-26.13a16.87,16.87,0,0,1,8.27-2.56Zm0-.54a17.52,17.52,0,0,0-8.54,2.64c-9.29,5.36-16.84,17.29-16.84,26.59,0,6.24,3.39,10.11,8.84,10.11a17.55,17.55,0,0,0,8.54-2.64c9.28-5.36,16.83-17.29,16.83-26.6,0-6.23-3.38-10.1-8.83-10.1Z"
          />
          <path
            class="cls-778"
            d="M827.12,238.69a17.6,17.6,0,0,1,8.54-2.63h0a8.84,8.84,0,0,1,4.77,1.28,9.07,9.07,0,0,0-4.23-1h0a17.52,17.52,0,0,0-8.54,2.64l-.16.09-.11.06c-.32.18-.62.38-.93.58-8.72,5.66-15.64,17-15.64,25.86,0,4.12,1.49,7.2,4.06,8.82-2.91-1.51-4.6-4.73-4.6-9.13C810.28,256,817.83,244.05,827.12,238.69Z"
          />
          <path
            id="setAir1"
            :class="[
              getRealTime.environment.Air[0].On ? 'statusOn' : 'statusOff',
              getAccess.role != 'User' ? 'pointer' : '',
            ]"
            d="M614,20.48A14.63,14.63,0,1,1,628.58,35,14.67,14.67,0,0,1,614,20.48"
          />
          <path
            id="setAir1"
            class="cls-780"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            d="M636.17,21.48c0-.29.15-.72.15-1a2.37,2.37,0,0,0-.15-1l2.15-1.72a.62.62,0,0,0,.15-.71l-2-3.59a.57.57,0,0,0-.57-.28l-2.58,1a10.6,10.6,0,0,0-1.72-1l-.43-2.73c0-.28-.29-.43-.58-.43h-4.15c-.29,0-.43.15-.58.43l-.43,2.73a10.6,10.6,0,0,0-1.72,1l-2.58-1c-.28-.15-.43,0-.57.28l-2,3.59c-.14.28-.14.43.14.71l2.15,1.72c0,.29-.14.72-.14,1a2.5,2.5,0,0,0,.14,1l-2.15,1.72a.65.65,0,0,0-.14.72l2,3.58a.57.57,0,0,0,.57.29l2.58-1a11.39,11.39,0,0,0,1.72,1l.43,2.72c0,.29.29.43.58.43h4.15c.29,0,.43-.14.58-.43l.43-2.72a11.39,11.39,0,0,0,1.72-1l2.58,1c.28.14.43,0,.57-.29l2-3.58c.14-.29.14-.43-.15-.72Zm-7.59,2.58a3.73,3.73,0,1,1,3.72-3.73A3.8,3.8,0,0,1,628.58,24.06Z"
          />
          <path
            id="setAir2"
            :class="[
              getRealTime.environment.Air[1].On ? 'statusOn' : 'statusOff',
              getAccess.role != 'User' ? 'pointer' : '',
            ]"
            d="M704,73.48A14.63,14.63,0,1,1,718.58,88,14.67,14.67,0,0,1,704,73.48"
          />
          <path
            id="setAir2"
            class="cls-780"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            d="M726.17,74.48c0-.29.15-.72.15-1a2.37,2.37,0,0,0-.15-1l2.15-1.72a.62.62,0,0,0,.15-.71l-2-3.59a.57.57,0,0,0-.57-.28l-2.58,1a10.6,10.6,0,0,0-1.72-1l-.43-2.73c0-.28-.29-.43-.58-.43h-4.15c-.29,0-.43.15-.58.43l-.43,2.73a10.6,10.6,0,0,0-1.72,1l-2.58-1c-.28-.15-.43,0-.57.28l-2,3.59c-.14.28-.14.43.14.71l2.15,1.72c0,.29-.14.72-.14,1a2.5,2.5,0,0,0,.14,1l-2.15,1.72a.65.65,0,0,0-.14.72l2,3.58a.57.57,0,0,0,.57.29l2.58-1a11.39,11.39,0,0,0,1.72,1l.43,2.72c0,.29.29.43.58.43h4.15c.29,0,.43-.14.58-.43l.43-2.72a11.39,11.39,0,0,0,1.72-1l2.58,1c.28.14.43,0,.57-.29l2-3.58c.14-.29.14-.43-.15-.72Zm-7.59,2.58a3.73,3.73,0,1,1,3.72-3.73A3.8,3.8,0,0,1,718.58,77.06Z"
          />
          <path
            id="setAir3"
            :class="[
              getRealTime.environment.Air[2].On ? 'statusOn' : 'statusOff',
              getAccess.role != 'User' ? 'pointer' : '',
            ]"
            d="M805,131.48A14.63,14.63,0,1,1,819.58,146,14.67,14.67,0,0,1,805,131.48"
          />
          <path
            id="setAir3"
            class="cls-780"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            d="M827.17,132.48c0-.29.15-.72.15-1a2.37,2.37,0,0,0-.15-1l2.15-1.72a.62.62,0,0,0,.15-.71l-2-3.59a.57.57,0,0,0-.57-.28l-2.58,1a10.6,10.6,0,0,0-1.72-1l-.43-2.73c0-.28-.29-.43-.58-.43h-4.15c-.29,0-.43.15-.58.43l-.43,2.73a10.6,10.6,0,0,0-1.72,1l-2.58-1c-.28-.15-.43,0-.57.28l-2,3.59c-.14.28-.14.43.14.71l2.15,1.72c0,.29-.14.72-.14,1a2.5,2.5,0,0,0,.14,1l-2.15,1.72a.65.65,0,0,0-.14.72l2,3.58a.57.57,0,0,0,.57.29l2.58-1a11.39,11.39,0,0,0,1.72,1l.43,2.72c0,.29.29.43.58.43h4.15c.29,0,.43-.14.58-.43l.43-2.72a11.39,11.39,0,0,0,1.72-1l2.58,1c.28.14.43,0,.57-.29l2-3.58c.14-.29.14-.43-.15-.72Zm-7.59,2.58a3.73,3.73,0,1,1,3.72-3.73A3.8,3.8,0,0,1,819.58,135.06Z"
          />
          <path
            id="setFFU"
            :class="[
              getRealTime.environment.FFU.On ? 'statusOn' : 'statusOff',
              getAccess.role != 'User' ? 'pointer' : '',
            ]"
            d="M849,218.48A14.63,14.63,0,1,1,863.58,233,14.67,14.67,0,0,1,849,218.48"
          />
          <path
            id="setFFU"
            class="cls-780"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            d="M871.17,219.48c0-.29.15-.72.15-1a2.37,2.37,0,0,0-.15-1l2.15-1.72a.62.62,0,0,0,.15-.71l-2-3.59a.57.57,0,0,0-.57-.28l-2.58,1a10.6,10.6,0,0,0-1.72-1l-.43-2.73c0-.28-.29-.43-.58-.43h-4.15c-.29,0-.43.15-.58.43l-.43,2.73a10.6,10.6,0,0,0-1.72,1l-2.58-1c-.28-.15-.43,0-.57.28l-2,3.59c-.14.28-.14.43.14.71l2.15,1.72c0,.29-.14.72-.14,1a2.5,2.5,0,0,0,.14,1l-2.15,1.72a.65.65,0,0,0-.14.72l2,3.58a.57.57,0,0,0,.57.29l2.58-1a11.39,11.39,0,0,0,1.72,1l.43,2.72c0,.29.29.43.58.43h4.15c.29,0,.43-.14.58-.43l.43-2.72a11.39,11.39,0,0,0,1.72-1l2.58,1c.28.14.43,0,.57-.29l2-3.58c.14-.29.14-.43-.15-.72Zm-7.59,2.58a3.73,3.73,0,1,1,3.72-3.73A3.8,3.8,0,0,1,863.58,222.06Z"
          />
          <path
            id="setFanFlow"
            :class="[
              getRealTime.environment.FanFlow[0].On ? 'statusOn' : 'statusOff',
              getAccess.role != 'User' ? 'pointer' : '',
            ]"
            d="M398,187.48A14.63,14.63,0,1,1,412.58,202,14.67,14.67,0,0,1,398,187.48"
          />
          <path
            id="setFanFlow"
            class="cls-780"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            d="M420.17,188.48c0-.29.15-.72.15-1a2.37,2.37,0,0,0-.15-1l2.15-1.72a.62.62,0,0,0,.15-.71l-2-3.59a.57.57,0,0,0-.57-.28l-2.58,1a10.6,10.6,0,0,0-1.72-1l-.43-2.73c0-.28-.29-.43-.58-.43h-4.15c-.29,0-.43.15-.58.43l-.43,2.73a10.6,10.6,0,0,0-1.72,1l-2.58-1c-.28-.15-.43,0-.57.28l-2,3.59c-.14.28-.14.43.14.71l2.15,1.72c0,.29-.14.72-.14,1a2.5,2.5,0,0,0,.14,1l-2.15,1.72a.65.65,0,0,0-.14.72l2,3.58a.57.57,0,0,0,.57.29l2.58-1a11.39,11.39,0,0,0,1.72,1l.43,2.72c0,.29.29.43.58.43h4.15c.29,0,.43-.14.58-.43l.43-2.72a11.39,11.39,0,0,0,1.72-1l2.58,1c.28.14.43,0,.57-.29l2-3.58c.14-.29.14-.43-.15-.72Zm-7.59,2.58a3.73,3.73,0,1,1,3.72-3.73A3.8,3.8,0,0,1,412.58,191.06Z"
          />
          <path
            id="setHumidity"
            :class="[
              getRealTime.environment.humidity.On ? 'statusOn' : 'statusOff',
              getAccess.role != 'User' ? 'pointer' : '',
            ]"
            d="M545,109.48A14.63,14.63,0,1,1,559.58,124,14.67,14.67,0,0,1,545,109.48"
          />
          <path
            class="cls-780"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="setHumidity"
            d="M567.17,110.48c0-.29.15-.72.15-1a2.37,2.37,0,0,0-.15-1l2.15-1.72a.62.62,0,0,0,.15-.71l-2-3.59a.57.57,0,0,0-.57-.28l-2.58,1a10.6,10.6,0,0,0-1.72-1l-.43-2.73c0-.28-.29-.43-.58-.43h-4.15c-.29,0-.43.15-.58.43l-.43,2.73a10.6,10.6,0,0,0-1.72,1l-2.58-1c-.28-.15-.43,0-.57.28l-2,3.59c-.14.28-.14.43.14.71l2.15,1.72c0,.29-.14.72-.14,1a2.5,2.5,0,0,0,.14,1l-2.15,1.72a.65.65,0,0,0-.14.72l2,3.58a.57.57,0,0,0,.57.29l2.58-1a11.39,11.39,0,0,0,1.72,1l.43,2.72c0,.29.29.43.58.43h4.15c.29,0,.43-.14.58-.43l.43-2.72a11.39,11.39,0,0,0,1.72-1l2.58,1c.28.14.43,0,.57-.29l2-3.58c.14-.29.14-.43-.15-.72Zm-7.59,2.58a3.73,3.73,0,1,1,3.72-3.73A3.8,3.8,0,0,1,559.58,113.06Z"
          />
          <g class="cls-782">
            <g class="cls-783">
              <path
                v-if="getRealTime.environment.Air[1].On"
                class="cls-784"
                d="M692,165c-17.32-7.65-32.28-16.94-43.79-24.57C637,133,626,122,626,122l35-18,64,37s-.35,2-8.8,8.2C708.2,155.22,699.6,162.77,692,165Z"
              />
            </g>
          </g>
          <g class="cls-785">
            <g class="cls-783">
              <path
                v-if="getRealTime.environment.Air[0].On"
                class="cls-784"
                d="M597,111c-17.32-7.65-32.28-16.94-43.79-24.57C542,79,531,68,531,68l35-18,64,37s-.35,2-8.8,8.2C613.2,101.22,604.6,108.77,597,111Z"
              />
            </g>
          </g>
          <g class="cls-786">
            <g class="cls-783">
              <path
                v-if="getRealTime.environment.Air[2].On"
                class="cls-784"
                d="M792,224c-17.32-7.65-32.28-16.94-43.79-24.57C737,192,726,181,726,181l35-18,64,37s-.35,2-8.8,8.2C808.2,214.22,799.6,221.77,792,224Z"
              />
            </g>
          </g>
          <g id="co2v1">
            <circle class="cls-789" cx="827.5" cy="309.5" r="20" />
            <path
              class="cls-40"
              d="M818,301.7c-1.6,0-2.9,1.3-2.9,2.9v8.7c0,1.6,1.3,2.9,2.9,2.9h4.3v-2.9H818v-8.7h4.3v-2.9H818 M826.7,301.7   c-1.6,0-2.9,1.3-2.9,2.9v8.7c0,1.6,1.3,2.9,2.9,2.9h2.9c1.6,0,2.9-1.3,2.9-2.9v-8.7c0-1.6-1.3-2.9-2.9-2.9H826.7 M826.7,304.6h2.9   v8.7h-2.9V304.6 M834,306.7v2.2h4.3v2.2h-2.2c-1.2,0-2.2,1-2.2,2.2v4.3h6.5v-2.2h-4.3v-2.2h2.2c1.2,0,2.2-1,2.2-2.2v-2.2   c0-1.2-1-2.2-2.2-2.2H834z"
            />
            <g>
              <g>
                <path
                  class="cls-40"
                  d="M882,373H772c-5.5,0-10-4.5-10-10v-18c0-5.5,4.5-10,10-10h110c5.5,0,10,4.5,10,10v18    C892,368.5,887.5,373,882,373z"
                />
              </g>
              <text transform="matrix(1 0 0 1 771 360)" class="cls-789 cls-790">
                {{ getRealTime.environment.CO2.Value1 }} ppm
              </text>
            </g>
          </g>
          <g id="co2v2">
            <circle class="cls-789" cx="490" cy="290" r="20" />
            <path
              class="cls-40"
              d="M 480 284 c -1.6 0 -2.9 1.3 -2.9 2.9 v 8.7 c 0 1.6 1.3 2.9 2.9 2.9 h 4.3 v -2.9 h -4.3 v -8.7 h 4.3 v -2.9 h -4.3 m 8.7 0 c -1.6 0 -2.9 1.3 -2.9 2.9 v 8.7 c 0 1.6 1.3 2.9 2.9 2.9 h 2.9 c 1.6 0 2.9 -1.3 2.9 -2.9 v -8.7 c 0 -1.6 -1.3 -2.9 -2.9 -2.9 h -2.9 m 0 2.9 h 2.9 v 8.7 h -2.9 v -8.7 m 7.3 2.1 v 2.2 h 4.3 v 2.2 h -2.2 c -1.2 0 -2.2 1 -2.2 2.2 v 4.3 h 6.5 v -2.2 h -4.3 v -2.2 h 2.2 c 1.2 0 2.2 -1 2.2 -2.2 v -2.2 c 0 -1.2 -1 -2.2 -2.2 -2.2 h -4.3 z"
            />
            <g>
              <g>
                <path
                  class="cls-40"
                  d="M 555 350 h -105 c -5.5 0 -10 -4.5 -10 -10 v -18 c 0 -5.5 4.5 -10 10 -10 h 110 c 5.5 0 10 4.5 10 10 v 18 c 0 5.5 -4.5 10 -10 10 z"
                />
              </g>
              <text transform="matrix(1 0 0 1 442 340)" class="cls-789 cls-790">
                {{ getRealTime.environment.CO2.Value2 }} ppm
              </text>
            </g>
          </g>
          <g id="temp1">
            <circle
              id="temp1"
              class="cls-789 pointer"
              cx="372"
              cy="267"
              r="20"
            />
            <path
              id="temp1"
              class="cls-40 pointer"
              d="M 375 268.2 v -9.6 c 0 -2 -1.6 -3.6 -3.6 -3.6 s -3.6 1.6 -3.6 3.6 v 9.6 c -2.7 2 -3.2 5.7 -1.2 8.4 c 2 2.7 5.7 3.2 8.4 1.2 c 2.7 -2 3.2 -5.7 1.2 -8.4 c -0.3 -0.5 -0.7 -0.9 -1.2 -1.2 m -3.6 -10.8 c 0.7 0 1.2 0.5 1.2 1.2 v 3.6 h -2.4 v -3.6 c 0 -0.7 0.5 -1.2 1.2 -1.2 z"
            />
            <g>
              <g>
                <path
                  class="cls-40"
                  d="M 382 325 h -65 c -5.5 0 -10 -4.5 -10 -10 v -13 c 0 -5.5 4.5 -10 10 -10 h 100 c 5.5 0 10 4.5 10 10 v 13 c 0 5.5 -4.5 10 -10 10 z"
                />
              </g>
              <text transform="matrix(1 0 0 1 314 315)" class="cls-789 cls-790">
                {{ getRealTime.environment.temperature.Value1.toFixed(2) }} °C
              </text>
            </g>
            <g id="temp1RH" style="visibility: hidden">
              <path
                class="cls-40"
                d="M 489 240 H 337 c -5.5 0 -10 -4.5 -10 -10 v -57 c 0 -5.5 4.5 -10 10 -10 h 164 c 5.5 0 10 4.5 10 10 v 57 c 0 5.5 -4.5 10 -10 10 z"
              />
              <g>
                <text
                  transform="matrix(1 0 0 1 355.5913 193.7666)"
                  class="cls-789 cls-790"
                >
                  T1
                  {{ getRealTime.environment.temperature.Value1.toFixed(2) }} °C
                </text>
                <path
                  class="cls-789"
                  d="M349,188v-8c0-1.7-1.3-3-3-3s-3,1.3-3,3v8c-2.2,1.7-2.7,4.8-1,7s4.8,2.7,7,1s2.7-4.8,1-7    C349.7,188.6,349.4,188.3,349,188 M346,179c0.6,0,1,0.4,1,1v3h-2v-3C345,179.4,345.4,179,346,179z"
                />
              </g>
              <g>
                <path
                  class="cls-789"
                  d="M346,207.5c0,0-6.8,7.7-6.8,12.2c0,3.8,3.1,6.8,6.8,6.8c3.8,0,6.8-3,6.8-6.8    C352.8,215.2,346,207.5,346,207.5 M348.8,215.1l1.2,1.2l-6.8,6.8l-1.2-1.2 M343.4,215.2c0.8,0,1.4,0.6,1.4,1.4    c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4C342,215.8,342.7,215.2,343.4,215.2 M348.6,220.3c0.8,0,1.4,0.6,1.4,1.4    c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4C347.1,220.9,347.8,220.3,348.6,220.3z"
                />

                <text
                  transform="matrix(1 0 0 1 356.6489 224.7904)"
                  class="cls-789 cls-790"
                >
                  RH1
                  {{ getRealTime.environment.humidity.Value1.toFixed(2) }} %
                </text>
              </g>
            </g>
          </g>
          <g id="temp2">
            <circle
              id="temp2"
              class="cls-789 pointer"
              cx="653"
              cy="254"
              r="20"
            />
            <path
              id="temp2"
              class="cls-40 pointer"
              d="M656.6,255.2v-9.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6v9.6c-2.7,2-3.2,5.7-1.2,8.4   c2,2.7,5.7,3.2,8.4,1.2c2.7-2,3.2-5.7,1.2-8.4C657.5,255.9,657.1,255.5,656.6,255.2 M653,244.4c0.7,0,1.2,0.5,1.2,1.2v3.6h-2.4   v-3.6C651.8,244.9,652.3,244.4,653,244.4z"
            />
            <g>
              <path
                class="cls-40"
                d="M 670 312 h -65 c -5.5 0 -10 -4.5 -10 -10 v -13 c 0 -5.5 4.5 -10 10 -10 h 100 c 5.5 0 10 4.5 10 10 v 13 c 0 5.5 -4.5 10 -10 10 z"
              />
            </g>
            <text
              transform="matrix(1 0 0 1 610 301.3184)"
              class="cls-789 cls-790"
            >
              {{ getRealTime.environment.temperature.Value2.toFixed(2) }} °C
            </text>
            <g id="temp2RH" style="visibility: hidden">
              <path
                class="cls-40"
                d="M 729 226 h -152 c -5.5 0 -10 -4.5 -10 -10 v -57 c 0 -5.5 4.5 -10 10 -10 h 164 c 5.5 0 10 4.5 10 10 v 57 c 0 5.5 -4.5 10 -10 10 z"
              />
              <g>
                <text
                  transform="matrix(1 0 0 1 595.5913 179.7666)"
                  class="cls-789 cls-790"
                >
                  T2
                  {{ getRealTime.environment.temperature.Value2.toFixed(2) }} °C
                </text>
                <path
                  class="cls-789"
                  d="M589,174v-8c0-1.7-1.3-3-3-3s-3,1.3-3,3v8c-2.2,1.7-2.7,4.8-1,7s4.8,2.7,7,1s2.7-4.8,1-7    C589.7,174.6,589.4,174.3,589,174 M586,165c0.6,0,1,0.4,1,1v3h-2v-3C585,165.4,585.4,165,586,165z"
                />
              </g>
              <g>
                <path
                  class="cls-789"
                  d="M586,193.5c0,0-6.8,7.7-6.8,12.2c0,3.8,3.1,6.8,6.8,6.8c3.8,0,6.8-3,6.8-6.8    C592.8,201.2,586,193.5,586,193.5 M588.8,201.1l1.2,1.2l-6.8,6.8l-1.2-1.2 M583.4,201.2c0.8,0,1.4,0.6,1.4,1.4    c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4C582,201.8,582.7,201.2,583.4,201.2 M588.6,206.3c0.8,0,1.4,0.6,1.4,1.4    c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4C587.1,206.9,587.8,206.3,588.6,206.3z"
                />
                <text
                  transform="matrix(1 0 0 1 596.6489 210.7904)"
                  class="cls-789 cls-790"
                >
                  RH2
                  {{ getRealTime.environment.humidity.Value2.toFixed(2) }} %
                </text>
              </g>
            </g>
          </g>
          <g id="temp3">
            <circle
              id="temp3"
              class="cls-789 pointer"
              cx="568"
              cy="383"
              r="20"
            />
            <path
              id="temp3"
              class="cls-40 pointer"
              d="M571.6,383.2v-9.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6v9.6c-2.7,2-3.2,5.7-1.2,8.4   c2,2.7,5.7,3.2,8.4,1.2c2.7-2,3.2-5.7,1.2-8.4C572.5,383.9,572.1,383.5,571.6,383.2 M568,372.4c0.7,0,1.2,0.5,1.2,1.2v3.6h-2.4   v-3.6C566.8,372.9,567.3,372.4,568,372.4z"
            />
            <g>
              <path
                class="cls-40"
                d="M 586 441 h -65 c -5.5 0 -10 -4.5 -10 -10 v -13 c 0 -5.5 4.5 -10 10 -10 h 100 c 5.5 0 10 4.5 10 10 v 13 c 0 5.5 -4.5 10 -10 10 z"
              />
              <text transform="matrix(1 0 0 1 518 435)" class="cls-789 cls-790">
                {{ getRealTime.environment.temperature.Value3.toFixed(2) }} °C
              </text>
            </g>
            <g id="temp3RH" style="visibility: hidden">
              <path
                class="cls-40"
                d="M 643 356 H 491 c -5.5 0 -10 -4.5 -10 -10 v -57 c 0 -5.5 4.5 -10 10 -10 h 164 c 5.5 0 10 4.5 10 10 v 57 c 0 5.5 -4.5 10 -10 10 z"
              />
              <g>
                <text
                  transform="matrix(1 0 0 1 509.5913 309.7666)"
                  class="cls-789 cls-790"
                >
                  T3
                  {{ getRealTime.environment.temperature.Value3.toFixed(2) }} °C
                </text>
                <path
                  class="cls-789"
                  d="M503,304v-8c0-1.7-1.3-3-3-3s-3,1.3-3,3v8c-2.2,1.7-2.7,4.8-1,7s4.8,2.7,7,1s2.7-4.8,1-7    C503.7,304.6,503.4,304.3,503,304 M500,295c0.6,0,1,0.4,1,1v3h-2v-3C499,295.4,499.4,295,500,295z"
                />
              </g>
              <g>
                <path
                  class="cls-789"
                  d="M500,323.5c0,0-6.8,7.7-6.8,12.2c0,3.8,3.1,6.8,6.8,6.8c3.8,0,6.8-3,6.8-6.8    C506.8,331.2,500,323.5,500,323.5 M502.8,331.1l1.2,1.2l-6.8,6.8l-1.2-1.2 M497.4,331.2c0.8,0,1.4,0.6,1.4,1.4    c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4C496,331.8,496.7,331.2,497.4,331.2 M502.6,336.3c0.8,0,1.4,0.6,1.4,1.4    s-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4S501.8,336.3,502.6,336.3z"
                />
                <text
                  transform="matrix(1 0 0 1 510.6489 340.7904)"
                  class="cls-789 cls-790"
                >
                  RH3 {{ getRealTime.environment.humidity.Value3.toFixed(2) }} %
                </text>
              </g>
            </g>
          </g>
          <g id="temp4">
            <circle
              id="temp4"
              class="cls-789 pointer"
              cx="324"
              cy="399"
              r="20"
            />
            <path
              id="temp4"
              class="cls-40 pointer"
              d="M327.6,399.2v-9.6c0-2-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6v9.6c-2.7,2-3.2,5.7-1.2,8.4c2,2.7,5.7,3.2,8.4,1.2   c2.7-2,3.2-5.7,1.2-8.4C328.5,399.9,328.1,399.5,327.6,399.2 M324,388.4c0.7,0,1.2,0.5,1.2,1.2v3.6h-2.4v-3.6   C322.8,388.9,323.3,388.4,324,388.4z"
            />
            <path
              class="cls-40"
              d="M 345 459 h -65 c -5.5 0 -10 -4.5 -10 -10 v -13 c 0 -5.5 4.5 -10 10 -10 h 100 c 5.5 0 10 4.5 10 10 v 13 c 0 10 -10 10 -10 10 z"
            />
            <text
              transform="matrix(1 0 0 1 280 448.3184)"
              class="cls-789 cls-790"
            >
              {{ getRealTime.environment.temperature.Value4.toFixed(2) }} °C
            </text>
            <g id="temp4RH" style="visibility: hidden">
              <path
                class="cls-40"
                d="M 399 372 H 247 c -5.5 0 -10 -4.5 -10 -10 v -57 c 0 -5.5 4.5 -10 10 -10 h 164 c 5.5 0 10 4.5 10 10 v 57 c 0 5.5 -4.5 10 -10 10 z"
              />
              <g>
                <text
                  transform="matrix(1 0 0 1 265.5913 325.7666)"
                  class="cls-789 cls-790"
                >
                  T4
                  {{ getRealTime.environment.temperature.Value4.toFixed(2) }} °C
                </text>
                <path
                  class="cls-789"
                  d="M259,320v-8c0-1.7-1.3-3-3-3s-3,1.3-3,3v8c-2.2,1.7-2.7,4.8-1,7s4.8,2.7,7,1s2.7-4.8,1-7    C259.7,320.6,259.4,320.3,259,320 M256,311c0.6,0,1,0.4,1,1v3h-2v-3C255,311.4,255.4,311,256,311z"
                />
              </g>
              <g>
                <path
                  class="cls-789"
                  d="M256,339.5c0,0-6.8,7.7-6.8,12.2c0,3.8,3.1,6.8,6.8,6.8c3.8,0,6.8-3,6.8-6.8    C262.8,347.2,256,339.5,256,339.5 M258.8,347.1l1.2,1.2l-6.8,6.8l-1.2-1.2 M253.4,347.2c0.8,0,1.4,0.6,1.4,1.4    c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4C252,347.8,252.7,347.2,253.4,347.2 M258.6,352.3c0.8,0,1.4,0.6,1.4,1.4    s-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4S257.8,352.3,258.6,352.3z"
                />
                <text
                  transform="matrix(1 0 0 1 266.6489 356.7904)"
                  class="cls-789 cls-790"
                >
                  RH4
                  {{ getRealTime.environment.humidity.Value4.toFixed(2) }} %
                </text>
              </g>
            </g>
          </g>
          <g>
            <path
              id="Tower"
              class="cls-789 pointer"
              d="M221,354H118c-5.5,0-10-4.5-10-10v-42c0-5.5,4.5-10,10-10h103c5.5,0,10,4.5,10,10v42     C231,349.5,226.5,354,221,354z"
            />
            <polygon
              id="Tower"
              class="cls-789 pointer"
              points="158.5,354 182.7,354 170.4,371 "
            />
            <text
              id="Tower"
              transform="matrix(1 0 0 1 120.8232 332.5054)"
              class="cls-788 cls-780 pointer blink"
            >
              Tower
            </text>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import "d3";
import * as d3 from "d3";
export default {
  name: "FarmCom",
  computed: {
    getAccess() {
      return this.$store.state.auth.access;
    },
    getRealTime() {
      return this.$store.getters.realTime;
    },
    getFarm() {
      return this.$store.getters.OneFarm;
    },
    getTower() {
      return this.$store.getters.allTower;
    },
  },
  async mounted() {
    d3.select("#svgFarm").on("click", function (event) {
      let id = event.target.id;
      let position = id.search("temp");
      if (position == 0) {
        id = id + "RH";
        if (document.getElementById(id)) {
          if (document.getElementById(id).style.visibility == "hidden") {
            document.getElementById(id).style.visibility = "visible";
          } else {
            document.getElementById(id).style.visibility = "hidden";
          }
        }
      }
    });
  },
  data() {
    return {};
  },
};
</script>
<style type="text/css">
.pointer {
  cursor: pointer;
}
.animation {
  animation: pulse 5s ease-out infinite;
}
.blink {
  animation: blinking 1s infinite;
}
@keyframes blinking {
  0% {
    background-color: #06c3d1;
  }
  100% {
    background-color: #270da6;
  }
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@keyframes pulse {
  0% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
.cls-1 {
  fill: #333;
}
.cls-2 {
  fill: #f2f2f2;
}
.cls-3 {
  fill: #b3b3b3;
}
.cls-4 {
  fill: none;
}
.cls-5 {
  fill: #d9d9d9;
}
.cls-6 {
  fill: #e1e4ea;
}
.cls-7 {
  isolation: isolate;
}
.cls-8 {
  fill: #ffb268;
}
.cls-9 {
  fill: #b0d169;
}
.cls-10 {
  fill: #7a5632;
}
.cls-11 {
  fill: #cfcfcf;
}
.cls-12 {
  mask: url(#mask);
}
.cls-13 {
  fill: #8fffd2;
}
.cls-14 {
  fill: #d5dbb4;
}
.cls-15 {
  fill: #7a7a7a;
}
.cls-16 {
  mask: url(#mask-2);
}
.cls-17 {
  mask: url(#mask-3);
}
.cls-18 {
  mask: url(#mask-4);
}
.cls-19 {
  mask: url(#mask-5);
}
.cls-20 {
  fill: #595959;
}
.cls-21 {
  fill: #b1b8d1;
}
.cls-22 {
  fill: #9096ad;
}
.cls-23 {
  fill: #d0d5e3;
}
.cls-24 {
  mask: url(#mask-6);
}
.cls-25 {
  fill: #adadad;
}
.cls-26 {
  fill: #8d8d8d;
}
.cls-27 {
  fill: #282828;
}
.cls-28 {
  fill: #1a1a1a;
}
.cls-29 {
  fill: #262626;
}
.cls-30 {
  clip-path: url(#clip-path);
}
.cls-31 {
  clip-path: url(#clip-path-2);
}
.cls-32 {
  clip-path: url(#clip-path-3);
}
.cls-33 {
  fill: #b5b5b5;
}
.cls-34 {
  fill: #c3c3c3;
}
.cls-35 {
  clip-path: url(#clip-path-4);
}
.cls-36 {
  clip-path: url(#clip-path-5);
}
.cls-37 {
  clip-path: url(#clip-path-6);
}
.cls-38 {
  clip-path: url(#clip-path-7);
}
.cls-39 {
  fill: #ababab;
}
.cls-40 {
  fill: #fff;
}
.cls-41 {
  clip-path: url(#clip-path-8);
}
.cls-42 {
  clip-path: url(#clip-path-9);
}
.cls-43 {
  fill: #515151;
}
.cls-44 {
  fill: #f2f0ed;
}
.cls-45 {
  fill: #cacaca;
}
.cls-46 {
  fill: #444;
}
.cls-47 {
  fill: #0f0f0f;
}
.cls-48 {
  fill: #929292;
}
.cls-48,
.cls-761 {
  opacity: 0.2;
  mix-blend-mode: screen;
}
.cls-49 {
  fill: #e1e1e1;
}
.cls-50 {
  clip-path: url(#clip-path-10);
}
.cls-51 {
  fill: #17171e;
}
.cls-52 {
  fill: #2a2a2a;
}
.cls-53 {
  clip-path: url(#clip-path-11);
}
.cls-54 {
  fill: #e8e9eb;
}
.cls-55 {
  fill: #855525;
}
.cls-56 {
  fill: #f7f7f7;
}
.cls-57 {
  fill: #9cc666;
}
.cls-58 {
  fill: #709941;
}
.cls-59 {
  fill: #5f8231;
}
.cls-60 {
  clip-path: url(#clip-path-12);
}
.cls-61 {
  fill: url(#linear-gradient);
}
.cls-62 {
  clip-path: url(#clip-path-13);
}
.cls-63 {
  fill: url(#linear-gradient-2);
}
.cls-64 {
  clip-path: url(#clip-path-14);
}
.cls-65 {
  fill: url(#linear-gradient-3);
}
.cls-66 {
  clip-path: url(#clip-path-15);
}
.cls-67 {
  fill: url(#linear-gradient-4);
}
.cls-68 {
  clip-path: url(#clip-path-16);
}
.cls-69 {
  fill: url(#linear-gradient-5);
}
.cls-70 {
  clip-path: url(#clip-path-17);
}
.cls-71 {
  fill: url(#linear-gradient-6);
}
.cls-72 {
  clip-path: url(#clip-path-18);
}
.cls-73 {
  fill: url(#linear-gradient-7);
}
.cls-74 {
  clip-path: url(#clip-path-19);
}
.cls-75 {
  fill: url(#linear-gradient-8);
}
.cls-76 {
  clip-path: url(#clip-path-20);
}
.cls-77 {
  fill: url(#linear-gradient-9);
}
.cls-78 {
  clip-path: url(#clip-path-21);
}
.cls-79 {
  fill: url(#linear-gradient-10);
}
.cls-80 {
  clip-path: url(#clip-path-22);
}
.cls-81 {
  fill: url(#linear-gradient-11);
}
.cls-82 {
  clip-path: url(#clip-path-23);
}
.cls-83 {
  fill: url(#linear-gradient-12);
}
.cls-84 {
  clip-path: url(#clip-path-24);
}
.cls-85 {
  fill: url(#linear-gradient-13);
}
.cls-86 {
  clip-path: url(#clip-path-25);
}
.cls-87 {
  fill: url(#linear-gradient-14);
}
.cls-88 {
  clip-path: url(#clip-path-26);
}
.cls-89 {
  fill: url(#linear-gradient-15);
}
.cls-90 {
  clip-path: url(#clip-path-27);
}
.cls-91 {
  fill: url(#linear-gradient-16);
}
.cls-92 {
  clip-path: url(#clip-path-28);
}
.cls-93 {
  fill: url(#linear-gradient-17);
}
.cls-94 {
  clip-path: url(#clip-path-29);
}
.cls-95 {
  fill: url(#linear-gradient-18);
}
.cls-96 {
  clip-path: url(#clip-path-30);
}
.cls-97 {
  fill: url(#linear-gradient-19);
}
.cls-98 {
  clip-path: url(#clip-path-31);
}
.cls-99 {
  fill: url(#linear-gradient-20);
}
.cls-100 {
  clip-path: url(#clip-path-32);
}
.cls-101 {
  fill: url(#linear-gradient-21);
}
.cls-102 {
  clip-path: url(#clip-path-33);
}
.cls-103 {
  fill: url(#linear-gradient-22);
}
.cls-104 {
  clip-path: url(#clip-path-34);
}
.cls-105 {
  fill: url(#linear-gradient-23);
}
.cls-106 {
  clip-path: url(#clip-path-35);
}
.cls-107 {
  fill: url(#linear-gradient-24);
}
.cls-108 {
  clip-path: url(#clip-path-36);
}
.cls-109 {
  fill: url(#linear-gradient-25);
}
.cls-110 {
  clip-path: url(#clip-path-37);
}
.cls-111 {
  fill: url(#linear-gradient-26);
}
.cls-112 {
  clip-path: url(#clip-path-38);
}
.cls-113 {
  fill: url(#linear-gradient-27);
}
.cls-114 {
  clip-path: url(#clip-path-39);
}
.cls-115 {
  fill: url(#linear-gradient-28);
}
.cls-116 {
  clip-path: url(#clip-path-40);
}
.cls-117 {
  fill: url(#linear-gradient-29);
}
.cls-118 {
  clip-path: url(#clip-path-41);
}
.cls-119 {
  fill: url(#linear-gradient-30);
}
.cls-120 {
  clip-path: url(#clip-path-42);
}
.cls-121 {
  fill: url(#linear-gradient-31);
}
.cls-122 {
  clip-path: url(#clip-path-43);
}
.cls-123 {
  fill: url(#linear-gradient-32);
}
.cls-124 {
  clip-path: url(#clip-path-44);
}
.cls-125 {
  fill: url(#linear-gradient-33);
}
.cls-126 {
  clip-path: url(#clip-path-45);
}
.cls-127 {
  fill: url(#linear-gradient-34);
}
.cls-128 {
  clip-path: url(#clip-path-46);
}
.cls-129 {
  fill: url(#linear-gradient-35);
}
.cls-130 {
  clip-path: url(#clip-path-47);
}
.cls-131 {
  fill: url(#linear-gradient-36);
}
.cls-132 {
  clip-path: url(#clip-path-48);
}
.cls-133 {
  fill: url(#linear-gradient-37);
}
.cls-134 {
  clip-path: url(#clip-path-49);
}
.cls-135 {
  fill: url(#linear-gradient-38);
}
.cls-136 {
  clip-path: url(#clip-path-50);
}
.cls-137 {
  fill: url(#linear-gradient-39);
}
.cls-138 {
  clip-path: url(#clip-path-51);
}
.cls-139 {
  fill: url(#linear-gradient-40);
}
.cls-140 {
  clip-path: url(#clip-path-52);
}
.cls-141 {
  fill: url(#linear-gradient-41);
}
.cls-142 {
  clip-path: url(#clip-path-53);
}
.cls-143 {
  fill: url(#linear-gradient-42);
}
.cls-144 {
  clip-path: url(#clip-path-54);
}
.cls-145 {
  fill: url(#linear-gradient-43);
}
.cls-146 {
  clip-path: url(#clip-path-55);
}
.cls-147 {
  fill: url(#linear-gradient-44);
}
.cls-148 {
  clip-path: url(#clip-path-56);
}
.cls-149 {
  fill: url(#linear-gradient-45);
}
.cls-150 {
  clip-path: url(#clip-path-57);
}
.cls-151 {
  fill: url(#linear-gradient-46);
}
.cls-152 {
  clip-path: url(#clip-path-58);
}
.cls-153 {
  fill: url(#linear-gradient-47);
}
.cls-154 {
  clip-path: url(#clip-path-59);
}
.cls-155 {
  fill: url(#linear-gradient-48);
}
.cls-156 {
  clip-path: url(#clip-path-60);
}
.cls-157 {
  fill: url(#linear-gradient-49);
}
.cls-158 {
  clip-path: url(#clip-path-61);
}
.cls-159 {
  fill: url(#linear-gradient-50);
}
.cls-160 {
  clip-path: url(#clip-path-62);
}
.cls-161 {
  fill: url(#linear-gradient-51);
}
.cls-162 {
  clip-path: url(#clip-path-63);
}
.cls-163 {
  fill: url(#linear-gradient-52);
}
.cls-164 {
  clip-path: url(#clip-path-64);
}
.cls-165 {
  fill: url(#linear-gradient-53);
}
.cls-166 {
  clip-path: url(#clip-path-65);
}
.cls-167 {
  fill: url(#linear-gradient-54);
}
.cls-168 {
  clip-path: url(#clip-path-66);
}
.cls-169 {
  fill: url(#linear-gradient-55);
}
.cls-170 {
  clip-path: url(#clip-path-67);
}
.cls-171 {
  fill: url(#linear-gradient-56);
}
.cls-172 {
  clip-path: url(#clip-path-68);
}
.cls-173 {
  fill: url(#linear-gradient-57);
}
.cls-174 {
  clip-path: url(#clip-path-69);
}
.cls-175 {
  fill: url(#linear-gradient-58);
}
.cls-176 {
  clip-path: url(#clip-path-70);
}
.cls-177 {
  fill: url(#linear-gradient-59);
}
.cls-178 {
  clip-path: url(#clip-path-71);
}
.cls-179 {
  fill: url(#linear-gradient-60);
}
.cls-180 {
  clip-path: url(#clip-path-72);
}
.cls-181 {
  fill: url(#linear-gradient-61);
}
.cls-182 {
  clip-path: url(#clip-path-73);
}
.cls-183 {
  fill: url(#linear-gradient-62);
}
.cls-184 {
  clip-path: url(#clip-path-74);
}
.cls-185 {
  fill: url(#linear-gradient-63);
}
.cls-186 {
  clip-path: url(#clip-path-75);
}
.cls-187 {
  fill: url(#linear-gradient-64);
}
.cls-188 {
  clip-path: url(#clip-path-76);
}
.cls-189 {
  fill: url(#linear-gradient-65);
}
.cls-190 {
  clip-path: url(#clip-path-77);
}
.cls-191 {
  fill: url(#linear-gradient-66);
}
.cls-192 {
  clip-path: url(#clip-path-78);
}
.cls-193 {
  fill: url(#linear-gradient-67);
}
.cls-194 {
  clip-path: url(#clip-path-79);
}
.cls-195 {
  fill: url(#linear-gradient-68);
}
.cls-196 {
  clip-path: url(#clip-path-80);
}
.cls-197 {
  fill: url(#linear-gradient-69);
}
.cls-198 {
  clip-path: url(#clip-path-81);
}
.cls-199 {
  fill: url(#linear-gradient-70);
}
.cls-200 {
  clip-path: url(#clip-path-82);
}
.cls-201 {
  fill: url(#linear-gradient-71);
}
.cls-202 {
  clip-path: url(#clip-path-83);
}
.cls-203 {
  fill: url(#linear-gradient-72);
}
.cls-204 {
  clip-path: url(#clip-path-84);
}
.cls-205 {
  fill: url(#linear-gradient-73);
}
.cls-206 {
  clip-path: url(#clip-path-85);
}
.cls-207 {
  fill: url(#linear-gradient-74);
}
.cls-208 {
  clip-path: url(#clip-path-86);
}
.cls-209 {
  fill: url(#linear-gradient-75);
}
.cls-210 {
  clip-path: url(#clip-path-87);
}
.cls-211 {
  fill: url(#linear-gradient-76);
}
.cls-212 {
  clip-path: url(#clip-path-88);
}
.cls-213 {
  fill: url(#linear-gradient-77);
}
.cls-214 {
  clip-path: url(#clip-path-89);
}
.cls-215 {
  fill: url(#linear-gradient-78);
}
.cls-216 {
  clip-path: url(#clip-path-90);
}
.cls-217 {
  fill: url(#linear-gradient-79);
}
.cls-218 {
  clip-path: url(#clip-path-91);
}
.cls-219 {
  fill: url(#linear-gradient-80);
}
.cls-220 {
  clip-path: url(#clip-path-92);
}
.cls-221 {
  fill: url(#linear-gradient-81);
}
.cls-222 {
  clip-path: url(#clip-path-93);
}
.cls-223 {
  fill: url(#linear-gradient-82);
}
.cls-224 {
  clip-path: url(#clip-path-94);
}
.cls-225 {
  fill: url(#linear-gradient-83);
}
.cls-226 {
  clip-path: url(#clip-path-95);
}
.cls-227 {
  fill: url(#linear-gradient-84);
}
.cls-228 {
  fill: #ced1d8;
}
.cls-229 {
  fill: #8399a7;
}
.cls-230 {
  fill: #dbdbe3;
}
.cls-231 {
  clip-path: url(#clip-path-96);
}
.cls-232 {
  fill: url(#linear-gradient-85);
}
.cls-233 {
  clip-path: url(#clip-path-97);
}
.cls-234 {
  fill: url(#linear-gradient-86);
}
.cls-235 {
  clip-path: url(#clip-path-98);
}
.cls-236 {
  fill: url(#linear-gradient-87);
}
.cls-237 {
  clip-path: url(#clip-path-99);
}
.cls-238 {
  fill: url(#linear-gradient-88);
}
.cls-239 {
  clip-path: url(#clip-path-100);
}
.cls-240 {
  fill: url(#linear-gradient-89);
}
.cls-241 {
  clip-path: url(#clip-path-101);
}
.cls-242 {
  fill: url(#linear-gradient-90);
}
.cls-243 {
  clip-path: url(#clip-path-102);
}
.cls-244 {
  fill: url(#linear-gradient-91);
}
.cls-245 {
  clip-path: url(#clip-path-103);
}
.cls-246 {
  fill: url(#linear-gradient-92);
}
.cls-247 {
  clip-path: url(#clip-path-104);
}
.cls-248 {
  fill: url(#linear-gradient-93);
}
.cls-249 {
  clip-path: url(#clip-path-105);
}
.cls-250 {
  fill: url(#linear-gradient-94);
}
.cls-251 {
  clip-path: url(#clip-path-106);
}
.cls-252 {
  fill: url(#linear-gradient-95);
}
.cls-253 {
  clip-path: url(#clip-path-107);
}
.cls-254 {
  fill: url(#linear-gradient-96);
}
.cls-255 {
  clip-path: url(#clip-path-108);
}
.cls-256 {
  fill: url(#linear-gradient-97);
}
.cls-257 {
  clip-path: url(#clip-path-109);
}
.cls-258 {
  fill: url(#linear-gradient-98);
}
.cls-259 {
  clip-path: url(#clip-path-110);
}
.cls-260 {
  fill: url(#linear-gradient-99);
}
.cls-261 {
  clip-path: url(#clip-path-111);
}
.cls-262 {
  fill: url(#linear-gradient-100);
}
.cls-263 {
  clip-path: url(#clip-path-112);
}
.cls-264 {
  fill: url(#linear-gradient-101);
}
.cls-265 {
  clip-path: url(#clip-path-113);
}
.cls-266 {
  fill: url(#linear-gradient-102);
}
.cls-267 {
  clip-path: url(#clip-path-114);
}
.cls-268 {
  fill: url(#linear-gradient-103);
}
.cls-269 {
  clip-path: url(#clip-path-115);
}
.cls-270 {
  fill: url(#linear-gradient-104);
}
.cls-271 {
  clip-path: url(#clip-path-116);
}
.cls-272 {
  fill: url(#linear-gradient-105);
}
.cls-273 {
  clip-path: url(#clip-path-117);
}
.cls-274 {
  fill: url(#linear-gradient-106);
}
.cls-275 {
  clip-path: url(#clip-path-118);
}
.cls-276 {
  fill: url(#linear-gradient-107);
}
.cls-277 {
  clip-path: url(#clip-path-119);
}
.cls-278 {
  fill: url(#linear-gradient-108);
}
.cls-279 {
  clip-path: url(#clip-path-120);
}
.cls-280 {
  fill: url(#linear-gradient-109);
}
.cls-281 {
  clip-path: url(#clip-path-121);
}
.cls-282 {
  fill: url(#linear-gradient-110);
}
.cls-283 {
  clip-path: url(#clip-path-122);
}
.cls-284 {
  fill: url(#linear-gradient-111);
}
.cls-285 {
  clip-path: url(#clip-path-123);
}
.cls-286 {
  fill: url(#linear-gradient-112);
}
.cls-287 {
  clip-path: url(#clip-path-124);
}
.cls-288 {
  fill: url(#linear-gradient-113);
}
.cls-289 {
  clip-path: url(#clip-path-125);
}
.cls-290 {
  fill: url(#linear-gradient-114);
}
.cls-291 {
  clip-path: url(#clip-path-126);
}
.cls-292 {
  fill: url(#linear-gradient-115);
}
.cls-293 {
  clip-path: url(#clip-path-127);
}
.cls-294 {
  fill: url(#linear-gradient-116);
}
.cls-295 {
  clip-path: url(#clip-path-128);
}
.cls-296 {
  fill: url(#linear-gradient-117);
}
.cls-297 {
  clip-path: url(#clip-path-129);
}
.cls-298 {
  fill: url(#linear-gradient-118);
}
.cls-299 {
  clip-path: url(#clip-path-130);
}
.cls-300 {
  fill: url(#linear-gradient-119);
}
.cls-301 {
  clip-path: url(#clip-path-131);
}
.cls-302 {
  fill: url(#linear-gradient-120);
}
.cls-303 {
  clip-path: url(#clip-path-132);
}
.cls-304 {
  fill: url(#linear-gradient-121);
}
.cls-305 {
  clip-path: url(#clip-path-133);
}
.cls-306 {
  fill: url(#linear-gradient-122);
}
.cls-307 {
  clip-path: url(#clip-path-134);
}
.cls-308 {
  fill: url(#linear-gradient-123);
}
.cls-309 {
  clip-path: url(#clip-path-135);
}
.cls-310 {
  fill: url(#linear-gradient-124);
}
.cls-311 {
  clip-path: url(#clip-path-136);
}
.cls-312 {
  fill: url(#linear-gradient-125);
}
.cls-313 {
  clip-path: url(#clip-path-137);
}
.cls-314 {
  fill: url(#linear-gradient-126);
}
.cls-315 {
  clip-path: url(#clip-path-138);
}
.cls-316 {
  fill: url(#linear-gradient-127);
}
.cls-317 {
  clip-path: url(#clip-path-139);
}
.cls-318 {
  fill: url(#linear-gradient-128);
}
.cls-319 {
  clip-path: url(#clip-path-140);
}
.cls-320 {
  fill: url(#linear-gradient-129);
}
.cls-321 {
  clip-path: url(#clip-path-141);
}
.cls-322 {
  fill: url(#linear-gradient-130);
}
.cls-323 {
  clip-path: url(#clip-path-142);
}
.cls-324 {
  fill: url(#linear-gradient-131);
}
.cls-325 {
  clip-path: url(#clip-path-143);
}
.cls-326 {
  fill: url(#linear-gradient-132);
}
.cls-327 {
  clip-path: url(#clip-path-144);
}
.cls-328 {
  fill: url(#linear-gradient-133);
}
.cls-329 {
  clip-path: url(#clip-path-145);
}
.cls-330 {
  fill: url(#linear-gradient-134);
}
.cls-331 {
  clip-path: url(#clip-path-146);
}
.cls-332 {
  fill: url(#linear-gradient-135);
}
.cls-333 {
  clip-path: url(#clip-path-147);
}
.cls-334 {
  fill: url(#linear-gradient-136);
}
.cls-335 {
  clip-path: url(#clip-path-148);
}
.cls-336 {
  fill: url(#linear-gradient-137);
}
.cls-337 {
  clip-path: url(#clip-path-149);
}
.cls-338 {
  fill: url(#linear-gradient-138);
}
.cls-339 {
  clip-path: url(#clip-path-150);
}
.cls-340 {
  fill: url(#linear-gradient-139);
}
.cls-341 {
  clip-path: url(#clip-path-151);
}
.cls-342 {
  fill: url(#linear-gradient-140);
}
.cls-343 {
  clip-path: url(#clip-path-152);
}
.cls-344 {
  fill: url(#linear-gradient-141);
}
.cls-345 {
  clip-path: url(#clip-path-153);
}
.cls-346 {
  fill: url(#linear-gradient-142);
}
.cls-347 {
  clip-path: url(#clip-path-154);
}
.cls-348 {
  fill: url(#linear-gradient-143);
}
.cls-349 {
  clip-path: url(#clip-path-155);
}
.cls-350 {
  fill: url(#linear-gradient-144);
}
.cls-351 {
  clip-path: url(#clip-path-156);
}
.cls-352 {
  fill: url(#linear-gradient-145);
}
.cls-353 {
  clip-path: url(#clip-path-157);
}
.cls-354 {
  fill: url(#linear-gradient-146);
}
.cls-355 {
  clip-path: url(#clip-path-158);
}
.cls-356 {
  fill: url(#linear-gradient-147);
}
.cls-357 {
  clip-path: url(#clip-path-159);
}
.cls-358 {
  fill: url(#linear-gradient-148);
}
.cls-359 {
  clip-path: url(#clip-path-160);
}
.cls-360 {
  fill: url(#linear-gradient-149);
}
.cls-361 {
  clip-path: url(#clip-path-161);
}
.cls-362 {
  fill: url(#linear-gradient-150);
}
.cls-363 {
  clip-path: url(#clip-path-162);
}
.cls-364 {
  fill: url(#linear-gradient-151);
}
.cls-365 {
  clip-path: url(#clip-path-163);
}
.cls-366 {
  fill: url(#linear-gradient-152);
}
.cls-367 {
  clip-path: url(#clip-path-164);
}
.cls-368 {
  fill: url(#linear-gradient-153);
}
.cls-369 {
  clip-path: url(#clip-path-165);
}
.cls-370 {
  fill: url(#linear-gradient-154);
}
.cls-371 {
  clip-path: url(#clip-path-166);
}
.cls-372 {
  fill: url(#linear-gradient-155);
}
.cls-373 {
  clip-path: url(#clip-path-167);
}
.cls-374 {
  fill: url(#linear-gradient-156);
}
.cls-375 {
  clip-path: url(#clip-path-168);
}
.cls-376 {
  fill: url(#linear-gradient-157);
}
.cls-377 {
  clip-path: url(#clip-path-169);
}
.cls-378 {
  fill: url(#linear-gradient-158);
}
.cls-379 {
  clip-path: url(#clip-path-170);
}
.cls-380 {
  fill: url(#linear-gradient-159);
}
.cls-381 {
  clip-path: url(#clip-path-171);
}
.cls-382 {
  fill: url(#linear-gradient-160);
}
.cls-383 {
  clip-path: url(#clip-path-172);
}
.cls-384 {
  fill: url(#linear-gradient-161);
}
.cls-385 {
  clip-path: url(#clip-path-173);
}
.cls-386 {
  fill: url(#linear-gradient-162);
}
.cls-387 {
  clip-path: url(#clip-path-174);
}
.cls-388 {
  fill: url(#linear-gradient-163);
}
.cls-389 {
  clip-path: url(#clip-path-175);
}
.cls-390 {
  fill: url(#linear-gradient-164);
}
.cls-391 {
  clip-path: url(#clip-path-176);
}
.cls-392 {
  fill: url(#linear-gradient-165);
}
.cls-393 {
  clip-path: url(#clip-path-177);
}
.cls-394 {
  fill: url(#linear-gradient-166);
}
.cls-395 {
  clip-path: url(#clip-path-178);
}
.cls-396 {
  fill: url(#linear-gradient-167);
}
.cls-397 {
  clip-path: url(#clip-path-179);
}
.cls-398 {
  fill: url(#linear-gradient-168);
}
.cls-399 {
  clip-path: url(#clip-path-180);
}
.cls-400 {
  fill: url(#linear-gradient-169);
}
.cls-401 {
  clip-path: url(#clip-path-181);
}
.cls-402 {
  fill: url(#linear-gradient-170);
}
.cls-403 {
  clip-path: url(#clip-path-182);
}
.cls-404 {
  fill: url(#linear-gradient-171);
}
.cls-405 {
  clip-path: url(#clip-path-183);
}
.cls-406 {
  fill: url(#linear-gradient-172);
}
.cls-407 {
  clip-path: url(#clip-path-184);
}
.cls-408 {
  fill: url(#linear-gradient-173);
}
.cls-409 {
  clip-path: url(#clip-path-185);
}
.cls-410 {
  fill: url(#linear-gradient-174);
}
.cls-411 {
  clip-path: url(#clip-path-186);
}
.cls-412 {
  fill: url(#linear-gradient-175);
}
.cls-413 {
  clip-path: url(#clip-path-187);
}
.cls-414 {
  fill: url(#linear-gradient-176);
}
.cls-415 {
  clip-path: url(#clip-path-188);
}
.cls-416 {
  fill: url(#linear-gradient-177);
}
.cls-417 {
  clip-path: url(#clip-path-189);
}
.cls-418 {
  fill: url(#linear-gradient-178);
}
.cls-419 {
  clip-path: url(#clip-path-190);
}
.cls-420 {
  fill: url(#linear-gradient-179);
}
.cls-421 {
  clip-path: url(#clip-path-191);
}
.cls-422 {
  fill: url(#linear-gradient-180);
}
.cls-423 {
  clip-path: url(#clip-path-192);
}
.cls-424 {
  fill: url(#linear-gradient-181);
}
.cls-425 {
  clip-path: url(#clip-path-193);
}
.cls-426 {
  fill: url(#linear-gradient-182);
}
.cls-427 {
  clip-path: url(#clip-path-194);
}
.cls-428 {
  fill: url(#linear-gradient-183);
}
.cls-429 {
  clip-path: url(#clip-path-195);
}
.cls-430 {
  fill: url(#linear-gradient-184);
}
.cls-431 {
  clip-path: url(#clip-path-196);
}
.cls-432 {
  fill: url(#linear-gradient-185);
}
.cls-433 {
  clip-path: url(#clip-path-197);
}
.cls-434 {
  fill: url(#linear-gradient-186);
}
.cls-435 {
  clip-path: url(#clip-path-198);
}
.cls-436 {
  fill: url(#linear-gradient-187);
}
.cls-437 {
  clip-path: url(#clip-path-199);
}
.cls-438 {
  fill: url(#linear-gradient-188);
}
.cls-439 {
  clip-path: url(#clip-path-200);
}
.cls-440 {
  fill: url(#linear-gradient-189);
}
.cls-441 {
  clip-path: url(#clip-path-201);
}
.cls-442 {
  fill: url(#linear-gradient-190);
}
.cls-443 {
  clip-path: url(#clip-path-202);
}
.cls-444 {
  fill: url(#linear-gradient-191);
}
.cls-445 {
  clip-path: url(#clip-path-203);
}
.cls-446 {
  fill: url(#linear-gradient-192);
}
.cls-447 {
  clip-path: url(#clip-path-204);
}
.cls-448 {
  fill: url(#linear-gradient-193);
}
.cls-449 {
  clip-path: url(#clip-path-205);
}
.cls-450 {
  fill: url(#linear-gradient-194);
}
.cls-451 {
  clip-path: url(#clip-path-206);
}
.cls-452 {
  fill: url(#linear-gradient-195);
}
.cls-453 {
  clip-path: url(#clip-path-207);
}
.cls-454 {
  fill: url(#linear-gradient-196);
}
.cls-455 {
  clip-path: url(#clip-path-208);
}
.cls-456 {
  fill: url(#linear-gradient-197);
}
.cls-457 {
  clip-path: url(#clip-path-209);
}
.cls-458 {
  fill: url(#linear-gradient-198);
}
.cls-459 {
  clip-path: url(#clip-path-210);
}
.cls-460 {
  fill: url(#linear-gradient-199);
}
.cls-461 {
  clip-path: url(#clip-path-211);
}
.cls-462 {
  fill: url(#linear-gradient-200);
}
.cls-463 {
  clip-path: url(#clip-path-212);
}
.cls-464 {
  fill: url(#linear-gradient-201);
}
.cls-465 {
  clip-path: url(#clip-path-213);
}
.cls-466 {
  fill: url(#linear-gradient-202);
}
.cls-467 {
  clip-path: url(#clip-path-214);
}
.cls-468 {
  fill: url(#linear-gradient-203);
}
.cls-469 {
  clip-path: url(#clip-path-215);
}
.cls-470 {
  fill: url(#linear-gradient-204);
}
.cls-471 {
  clip-path: url(#clip-path-216);
}
.cls-472 {
  fill: url(#linear-gradient-205);
}
.cls-473 {
  clip-path: url(#clip-path-217);
}
.cls-474 {
  fill: url(#linear-gradient-206);
}
.cls-475 {
  clip-path: url(#clip-path-218);
}
.cls-476 {
  fill: url(#linear-gradient-207);
}
.cls-477 {
  clip-path: url(#clip-path-219);
}
.cls-478 {
  fill: url(#linear-gradient-208);
}
.cls-479 {
  clip-path: url(#clip-path-220);
}
.cls-480 {
  fill: url(#linear-gradient-209);
}
.cls-481 {
  clip-path: url(#clip-path-221);
}
.cls-482 {
  fill: url(#linear-gradient-210);
}
.cls-483 {
  clip-path: url(#clip-path-222);
}
.cls-484 {
  fill: url(#linear-gradient-211);
}
.cls-485 {
  clip-path: url(#clip-path-223);
}
.cls-486 {
  fill: url(#linear-gradient-212);
}
.cls-487 {
  clip-path: url(#clip-path-224);
}
.cls-488 {
  fill: url(#linear-gradient-213);
}
.cls-489 {
  clip-path: url(#clip-path-225);
}
.cls-490 {
  fill: url(#linear-gradient-214);
}
.cls-491 {
  clip-path: url(#clip-path-226);
}
.cls-492 {
  fill: url(#linear-gradient-215);
}
.cls-493 {
  clip-path: url(#clip-path-227);
}
.cls-494 {
  fill: url(#linear-gradient-216);
}
.cls-495 {
  clip-path: url(#clip-path-228);
}
.cls-496 {
  fill: url(#linear-gradient-217);
}
.cls-497 {
  clip-path: url(#clip-path-229);
}
.cls-498 {
  fill: url(#linear-gradient-218);
}
.cls-499 {
  clip-path: url(#clip-path-230);
}
.cls-500 {
  fill: url(#linear-gradient-219);
}
.cls-501 {
  clip-path: url(#clip-path-231);
}
.cls-502 {
  fill: url(#linear-gradient-220);
}
.cls-503 {
  clip-path: url(#clip-path-232);
}
.cls-504 {
  fill: url(#linear-gradient-221);
}
.cls-505 {
  clip-path: url(#clip-path-233);
}
.cls-506 {
  fill: url(#linear-gradient-222);
}
.cls-507 {
  clip-path: url(#clip-path-234);
}
.cls-508 {
  fill: url(#linear-gradient-223);
}
.cls-509 {
  clip-path: url(#clip-path-235);
}
.cls-510 {
  fill: url(#linear-gradient-224);
}
.cls-511 {
  clip-path: url(#clip-path-236);
}
.cls-512 {
  fill: url(#linear-gradient-225);
}
.cls-513 {
  clip-path: url(#clip-path-237);
}
.cls-514 {
  fill: url(#linear-gradient-226);
}
.cls-515 {
  clip-path: url(#clip-path-238);
}
.cls-516 {
  fill: url(#linear-gradient-227);
}
.cls-517 {
  clip-path: url(#clip-path-239);
}
.cls-518 {
  fill: url(#linear-gradient-228);
}
.cls-519 {
  clip-path: url(#clip-path-240);
}
.cls-520 {
  fill: url(#linear-gradient-229);
}
.cls-521 {
  clip-path: url(#clip-path-241);
}
.cls-522 {
  fill: url(#linear-gradient-230);
}
.cls-523 {
  clip-path: url(#clip-path-242);
}
.cls-524 {
  fill: url(#linear-gradient-231);
}
.cls-525 {
  clip-path: url(#clip-path-243);
}
.cls-526 {
  fill: url(#linear-gradient-232);
}
.cls-527 {
  clip-path: url(#clip-path-244);
}
.cls-528 {
  fill: url(#linear-gradient-233);
}
.cls-529 {
  clip-path: url(#clip-path-245);
}
.cls-530 {
  fill: url(#linear-gradient-234);
}
.cls-531 {
  clip-path: url(#clip-path-246);
}
.cls-532 {
  fill: url(#linear-gradient-235);
}
.cls-533 {
  clip-path: url(#clip-path-247);
}
.cls-534 {
  fill: url(#linear-gradient-236);
}
.cls-535 {
  clip-path: url(#clip-path-248);
}
.cls-536 {
  fill: url(#linear-gradient-237);
}
.cls-537 {
  clip-path: url(#clip-path-249);
}
.cls-538 {
  fill: url(#linear-gradient-238);
}
.cls-539 {
  clip-path: url(#clip-path-250);
}
.cls-540 {
  fill: url(#linear-gradient-239);
}
.cls-541 {
  clip-path: url(#clip-path-251);
}
.cls-542 {
  fill: url(#linear-gradient-240);
}
.cls-543 {
  clip-path: url(#clip-path-252);
}
.cls-544 {
  fill: url(#linear-gradient-241);
}
.cls-545 {
  clip-path: url(#clip-path-253);
}
.cls-546 {
  fill: url(#linear-gradient-242);
}
.cls-547 {
  clip-path: url(#clip-path-254);
}
.cls-548 {
  fill: url(#linear-gradient-243);
}
.cls-549 {
  clip-path: url(#clip-path-255);
}
.cls-550 {
  fill: url(#linear-gradient-244);
}
.cls-551 {
  clip-path: url(#clip-path-256);
}
.cls-552 {
  fill: url(#linear-gradient-245);
}
.cls-553 {
  clip-path: url(#clip-path-257);
}
.cls-554 {
  fill: url(#linear-gradient-246);
}
.cls-555 {
  clip-path: url(#clip-path-258);
}
.cls-556 {
  fill: url(#linear-gradient-247);
}
.cls-557 {
  clip-path: url(#clip-path-259);
}
.cls-558 {
  fill: url(#linear-gradient-248);
}
.cls-559 {
  clip-path: url(#clip-path-260);
}
.cls-560 {
  fill: url(#linear-gradient-249);
}
.cls-561 {
  clip-path: url(#clip-path-261);
}
.cls-562 {
  fill: url(#linear-gradient-250);
}
.cls-563 {
  clip-path: url(#clip-path-262);
}
.cls-564 {
  fill: url(#linear-gradient-251);
}
.cls-565 {
  clip-path: url(#clip-path-263);
}
.cls-566 {
  fill: url(#linear-gradient-252);
}
.cls-567 {
  clip-path: url(#clip-path-264);
}
.cls-568 {
  fill: url(#linear-gradient-253);
}
.cls-569 {
  clip-path: url(#clip-path-265);
}
.cls-570 {
  fill: url(#linear-gradient-254);
}
.cls-571 {
  clip-path: url(#clip-path-266);
}
.cls-572 {
  fill: url(#linear-gradient-255);
}
.cls-573 {
  clip-path: url(#clip-path-267);
}
.cls-574 {
  fill: url(#linear-gradient-256);
}
.cls-575 {
  clip-path: url(#clip-path-268);
}
.cls-576 {
  fill: url(#linear-gradient-257);
}
.cls-577 {
  clip-path: url(#clip-path-269);
}
.cls-578 {
  fill: url(#linear-gradient-258);
}
.cls-579 {
  clip-path: url(#clip-path-270);
}
.cls-580 {
  fill: url(#linear-gradient-259);
}
.cls-581 {
  clip-path: url(#clip-path-271);
}
.cls-582 {
  fill: url(#linear-gradient-260);
}
.cls-583 {
  clip-path: url(#clip-path-272);
}
.cls-584 {
  fill: url(#linear-gradient-261);
}
.cls-585 {
  clip-path: url(#clip-path-273);
}
.cls-586 {
  fill: url(#linear-gradient-262);
}
.cls-587 {
  clip-path: url(#clip-path-274);
}
.cls-588 {
  fill: url(#linear-gradient-263);
}
.cls-589 {
  clip-path: url(#clip-path-275);
}
.cls-590 {
  fill: url(#linear-gradient-264);
}
.cls-591 {
  clip-path: url(#clip-path-276);
}
.cls-592 {
  fill: url(#linear-gradient-265);
}
.cls-593 {
  clip-path: url(#clip-path-277);
}
.cls-594 {
  fill: url(#linear-gradient-266);
}
.cls-595 {
  clip-path: url(#clip-path-278);
}
.cls-596 {
  fill: url(#linear-gradient-267);
}
.cls-597 {
  clip-path: url(#clip-path-279);
}
.cls-598 {
  fill: url(#linear-gradient-268);
}
.cls-599 {
  clip-path: url(#clip-path-280);
}
.cls-600 {
  fill: url(#linear-gradient-269);
}
.cls-601 {
  clip-path: url(#clip-path-281);
}
.cls-602 {
  fill: url(#linear-gradient-270);
}
.cls-603 {
  clip-path: url(#clip-path-282);
}
.cls-604 {
  fill: url(#linear-gradient-271);
}
.cls-605 {
  clip-path: url(#clip-path-283);
}
.cls-606 {
  fill: url(#linear-gradient-272);
}
.cls-607 {
  clip-path: url(#clip-path-284);
}
.cls-608 {
  fill: url(#linear-gradient-273);
}
.cls-609 {
  clip-path: url(#clip-path-285);
}
.cls-610 {
  fill: url(#linear-gradient-274);
}
.cls-611 {
  clip-path: url(#clip-path-286);
}
.cls-612 {
  fill: url(#linear-gradient-275);
}
.cls-613 {
  clip-path: url(#clip-path-287);
}
.cls-614 {
  fill: url(#linear-gradient-276);
}
.cls-615 {
  clip-path: url(#clip-path-288);
}
.cls-616 {
  fill: url(#linear-gradient-277);
}
.cls-617 {
  clip-path: url(#clip-path-289);
}
.cls-618 {
  fill: url(#linear-gradient-278);
}
.cls-619 {
  clip-path: url(#clip-path-290);
}
.cls-620 {
  fill: url(#linear-gradient-279);
}
.cls-621 {
  clip-path: url(#clip-path-291);
}
.cls-622 {
  fill: url(#linear-gradient-280);
}
.cls-623 {
  clip-path: url(#clip-path-292);
}
.cls-624 {
  fill: url(#linear-gradient-281);
}
.cls-625 {
  clip-path: url(#clip-path-293);
}
.cls-626 {
  fill: url(#linear-gradient-282);
}
.cls-627 {
  clip-path: url(#clip-path-294);
}
.cls-628 {
  fill: url(#linear-gradient-283);
}
.cls-629 {
  clip-path: url(#clip-path-295);
}
.cls-630 {
  fill: url(#linear-gradient-284);
}
.cls-631 {
  clip-path: url(#clip-path-296);
}
.cls-632 {
  fill: url(#linear-gradient-285);
}
.cls-633 {
  clip-path: url(#clip-path-297);
}
.cls-634 {
  fill: url(#linear-gradient-286);
}
.cls-635 {
  clip-path: url(#clip-path-298);
}
.cls-636 {
  fill: url(#linear-gradient-287);
}
.cls-637 {
  clip-path: url(#clip-path-299);
}
.cls-638 {
  fill: url(#linear-gradient-288);
}
.cls-639 {
  clip-path: url(#clip-path-300);
}
.cls-640 {
  fill: url(#linear-gradient-289);
}
.cls-641 {
  clip-path: url(#clip-path-301);
}
.cls-642 {
  fill: url(#linear-gradient-290);
}
.cls-643 {
  clip-path: url(#clip-path-302);
}
.cls-644 {
  fill: url(#linear-gradient-291);
}
.cls-645 {
  clip-path: url(#clip-path-303);
}
.cls-646 {
  fill: url(#linear-gradient-292);
}
.cls-647 {
  clip-path: url(#clip-path-304);
}
.cls-648 {
  fill: url(#linear-gradient-293);
}
.cls-649 {
  clip-path: url(#clip-path-305);
}
.cls-650 {
  fill: url(#linear-gradient-294);
}
.cls-651 {
  clip-path: url(#clip-path-306);
}
.cls-652 {
  fill: url(#linear-gradient-295);
}
.cls-653 {
  clip-path: url(#clip-path-307);
}
.cls-654 {
  fill: url(#linear-gradient-296);
}
.cls-655 {
  clip-path: url(#clip-path-308);
}
.cls-656 {
  fill: url(#linear-gradient-297);
}
.cls-657 {
  clip-path: url(#clip-path-309);
}
.cls-658 {
  fill: url(#linear-gradient-298);
}
.cls-659 {
  clip-path: url(#clip-path-310);
}
.cls-660 {
  fill: url(#linear-gradient-299);
}
.cls-661 {
  clip-path: url(#clip-path-311);
}
.cls-662 {
  fill: url(#linear-gradient-300);
}
.cls-663 {
  clip-path: url(#clip-path-312);
}
.cls-664 {
  fill: url(#linear-gradient-301);
}
.cls-665 {
  clip-path: url(#clip-path-313);
}
.cls-666 {
  fill: url(#linear-gradient-302);
}
.cls-667 {
  clip-path: url(#clip-path-314);
}
.cls-668 {
  fill: url(#linear-gradient-303);
}
.cls-669 {
  clip-path: url(#clip-path-315);
}
.cls-670 {
  fill: url(#linear-gradient-304);
}
.cls-671 {
  clip-path: url(#clip-path-316);
}
.cls-672 {
  fill: url(#linear-gradient-305);
}
.cls-673 {
  clip-path: url(#clip-path-317);
}
.cls-674 {
  fill: url(#linear-gradient-306);
}
.cls-675 {
  clip-path: url(#clip-path-318);
}
.cls-676 {
  fill: url(#linear-gradient-307);
}
.cls-677 {
  clip-path: url(#clip-path-319);
}
.cls-678 {
  fill: url(#linear-gradient-308);
}
.cls-679 {
  clip-path: url(#clip-path-320);
}
.cls-680 {
  fill: url(#linear-gradient-309);
}
.cls-681 {
  clip-path: url(#clip-path-321);
}
.cls-682 {
  fill: url(#linear-gradient-310);
}
.cls-683 {
  clip-path: url(#clip-path-322);
}
.cls-684 {
  fill: url(#linear-gradient-311);
}
.cls-685 {
  clip-path: url(#clip-path-323);
}
.cls-686 {
  fill: url(#linear-gradient-312);
}
.cls-687 {
  clip-path: url(#clip-path-324);
}
.cls-688 {
  fill: url(#linear-gradient-313);
}
.cls-689 {
  clip-path: url(#clip-path-325);
}
.cls-690 {
  fill: url(#linear-gradient-314);
}
.cls-691 {
  clip-path: url(#clip-path-326);
}
.cls-692 {
  fill: url(#linear-gradient-315);
}
.cls-693 {
  clip-path: url(#clip-path-327);
}
.cls-694 {
  fill: url(#linear-gradient-316);
}
.cls-695 {
  clip-path: url(#clip-path-328);
}
.cls-696 {
  fill: url(#linear-gradient-317);
}
.cls-697 {
  clip-path: url(#clip-path-329);
}
.cls-698 {
  fill: url(#linear-gradient-318);
}
.cls-699 {
  clip-path: url(#clip-path-330);
}
.cls-700 {
  fill: url(#linear-gradient-319);
}
.cls-701 {
  clip-path: url(#clip-path-331);
}
.cls-702 {
  fill: url(#linear-gradient-320);
}
.cls-703 {
  clip-path: url(#clip-path-332);
}
.cls-704 {
  fill: url(#linear-gradient-321);
}
.cls-705 {
  clip-path: url(#clip-path-333);
}
.cls-706 {
  fill: url(#linear-gradient-322);
}
.cls-707 {
  clip-path: url(#clip-path-334);
}
.cls-708 {
  fill: url(#linear-gradient-323);
}
.cls-709 {
  clip-path: url(#clip-path-335);
}
.cls-710 {
  fill: url(#linear-gradient-324);
}
.cls-711 {
  clip-path: url(#clip-path-336);
}
.cls-712 {
  fill: url(#linear-gradient-325);
}
.cls-713 {
  clip-path: url(#clip-path-337);
}
.cls-714 {
  fill: url(#linear-gradient-326);
}
.cls-715 {
  clip-path: url(#clip-path-338);
}
.cls-716 {
  fill: url(#linear-gradient-327);
}
.cls-717 {
  clip-path: url(#clip-path-339);
}
.cls-718 {
  fill: url(#linear-gradient-328);
}
.cls-719 {
  clip-path: url(#clip-path-340);
}
.cls-720 {
  fill: url(#linear-gradient-329);
}
.cls-721 {
  clip-path: url(#clip-path-341);
}
.cls-722 {
  fill: url(#linear-gradient-330);
}
.cls-723 {
  clip-path: url(#clip-path-342);
}
.cls-724 {
  fill: url(#linear-gradient-331);
}
.cls-725 {
  clip-path: url(#clip-path-343);
}
.cls-726 {
  fill: url(#linear-gradient-332);
}
.cls-727 {
  clip-path: url(#clip-path-344);
}
.cls-728 {
  fill: url(#linear-gradient-333);
}
.cls-729 {
  clip-path: url(#clip-path-345);
}
.cls-730 {
  fill: url(#linear-gradient-334);
}
.cls-731 {
  clip-path: url(#clip-path-346);
}
.cls-732 {
  fill: url(#linear-gradient-335);
}
.cls-733 {
  clip-path: url(#clip-path-347);
}
.cls-734 {
  fill: url(#linear-gradient-336);
}
.cls-735 {
  clip-path: url(#clip-path-348);
}
.cls-736 {
  fill: url(#linear-gradient-337);
}
.cls-737 {
  clip-path: url(#clip-path-349);
}
.cls-738 {
  fill: url(#linear-gradient-338);
}
.cls-739 {
  clip-path: url(#clip-path-350);
}
.cls-740 {
  fill: url(#linear-gradient-339);
}
.cls-741 {
  clip-path: url(#clip-path-351);
}
.cls-742 {
  fill: url(#linear-gradient-340);
}
.cls-743 {
  clip-path: url(#clip-path-352);
}
.cls-744 {
  fill: url(#linear-gradient-341);
}
.cls-745 {
  clip-path: url(#clip-path-353);
}
.cls-746 {
  fill: url(#linear-gradient-342);
}
.cls-747 {
  fill: #aab9c1;
}
.cls-748 {
  mask: url(#mask-7);
}
.cls-749 {
  fill: #9fa2a3;
}
.cls-750 {
  fill: #003552;
}
.cls-751 {
  fill: #295e87;
}
.cls-752 {
  fill: #659ec9;
}
.cls-753 {
  fill: #b4caed;
}
.cls-754 {
  fill: #dae5f8;
}
.cls-755 {
  fill: #e9f1ff;
}
.cls-756 {
  fill: #475165;
}
.cls-757 {
  fill: #a8a8a8;
}
.cls-758 {
  clip-path: url(#clip-path-354);
}
.cls-759 {
  fill: #757575;
}
.cls-760 {
  fill: #1e1e1e;
}
.cls-761 {
  fill: #828282;
}
.cls-762 {
  clip-path: url(#clip-path-355);
}
.cls-763 {
  clip-path: url(#clip-path-356);
}
.cls-764 {
  fill: #dbdef1;
}
.cls-765 {
  fill: #c3cae6;
}
.cls-766 {
  fill: #a2a8c2;
}
.cls-767 {
  fill: #e3e9f8;
}
.cls-768 {
  fill: #404040;
}
.cls-769 {
  fill: url(#SVGID_19);
}
.cls-770 {
  fill: url(#SVGID_19-2);
}
.cls-771 {
  fill: url(#SVGID_19-3);
}
.cls-772 {
  fill: url(#SVGID_19-4);
}
.cls-773 {
  fill: url(#SVGID_8);
}
.cls-774 {
  fill: url(#SVGID_8-2);
}
.cls-775 {
  fill: url(#SVGID_8-3);
}
.cls-776 {
  fill: url(#SVGID_9);
}
.cls-777 {
  fill: url(#SVGID_9-2);
}
.cls-778 {
  fill: url(#SVGID_8-4);
}
.statusOn {
  fill: #30b54c;
}
.cls-780 {
  fill: #f9f4f4;
}
.statusOff {
  fill: #db2626;
}
.cls-782 {
  mask: url(#mask-8);
}
.cls-783 {
  opacity: 0.6;
}
.cls-784 {
  fill: #7ed9ed;
}
.cls-785 {
  mask: url(#mask-9);
}
.cls-786 {
  mask: url(#mask-10);
}

.cls-787 {
  stroke: #000;
  stroke-miterlimit: 10;
}
.cls-788 {
  font-size: 32px;
  font-family: Poppins;
  font-weight: bold;
}
.cls-789 {
  fill: #383874;
}
.cls-790 {
  font-size: 25px;
  font-family: Poppins;
  font-weight: bold;
}
</style>
